import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { HeroRestRaw } from '../types/hero';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AbTest = {
  __typename?: 'ABTest';
  variant?: Maybe<Scalars['String']['output']>;
  variantTestName: Scalars['String']['output'];
  variantValue?: Maybe<Scalars['JSON']['output']>;
};

export type AbTestVariantsResponse = {
  __typename?: 'ABTestVariantsResponse';
  experiments: Array<Maybe<AbTest>>;
  success: Scalars['Boolean']['output'];
};

export type AbTestsVariantEntry = {
  __typename?: 'ABTestsVariantEntry';
  variant?: Maybe<Scalars['String']['output']>;
  variantTestName?: Maybe<Scalars['String']['output']>;
  variantValue?: Maybe<Scalars['JSON']['output']>;
};

export type AbTestsVariantsInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  billingVendor?: InputMaybe<Scalars['String']['input']>;
  clientUserGuid: Scalars['String']['input'];
  extraParams?: InputMaybe<Scalars['JSON']['input']>;
  isMasterProfile?: InputMaybe<Scalars['Boolean']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  userProfileType?: InputMaybe<Scalars['String']['input']>;
  userRegistrationCountry?: InputMaybe<Scalars['String']['input']>;
  userStatus: Scalars['String']['input'];
  variantUserId?: InputMaybe<Scalars['String']['input']>;
};

export type AbTestsVariantsResponse = {
  __typename?: 'ABTestsVariantsResponse';
  experiments?: Maybe<Array<Maybe<AbTestsVariantEntry>>>;
  success: Scalars['Boolean']['output'];
};

export type AccountPageAttribute = {
  __typename?: 'AccountPageAttribute';
  aa_checkbox_promo_copy_with_no_free_trial_copy_forever: Scalars['String']['output'];
  aa_order_summary_title?: Maybe<Scalars['String']['output']>;
  coupon_checkbox_disclaimer?: Maybe<Scalars['String']['output']>;
  coupon_legal_cta_disclaimer?: Maybe<Scalars['String']['output']>;
  coupon_redemption_cta_disclaimer: Scalars['String']['output'];
  coupon_redemption_multi_cadence_promo: Scalars['String']['output'];
  coupon_redemption_single_cadence_promo: Scalars['String']['output'];
  coupon_summary_cta?: Maybe<Scalars['String']['output']>;
  coupon_summary_header?: Maybe<Scalars['String']['output']>;
  coupon_summary_subheader?: Maybe<Scalars['String']['output']>;
};

export type AccountPageAttributeQueryResponse = {
  __typename?: 'AccountPageAttributeQueryResponse';
  pageAttribute?: Maybe<AccountPageAttribute>;
  variantsForTracking: Array<Scalars['String']['output']>;
};

export type AccountZipStateInfo = {
  __typename?: 'AccountZipStateInfo';
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ActiveCoupon = {
  __typename?: 'ActiveCoupon';
  balanceInCents?: Maybe<Scalars['Int']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<ActiveCouponDiscount>;
  discountPercent?: Maybe<Scalars['Int']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  freeTrialAmount?: Maybe<Scalars['Int']['output']>;
  freeTrialUnit?: Maybe<Scalars['String']['output']>;
  temporalAmount?: Maybe<Scalars['Int']['output']>;
  temporalUnit?: Maybe<Scalars['String']['output']>;
};

export type ActiveCouponCurrency = {
  __typename?: 'ActiveCouponCurrency';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type ActiveCouponDiscount = {
  __typename?: 'ActiveCouponDiscount';
  currencies?: Maybe<Array<Maybe<ActiveCouponCurrency>>>;
  percent?: Maybe<Scalars['Int']['output']>;
  trial?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AllMoviesMockParams = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type AllMoviesMockResponse = {
  __typename?: 'AllMoviesMockResponse';
  items: Array<CarouselItem>;
  pageNumber: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ApiParams = {
  __typename?: 'ApiParams';
  _clientRegion?: Maybe<Scalars['String']['output']>;
  carouselId?: Maybe<Scalars['String']['output']>;
  configUniqueName?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platformType?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userProfileType?: Maybe<Scalars['String']['output']>;
};

export type ApiRegionalRating = {
  __typename?: 'ApiRegionalRating';
  consumerAdvice?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingIcon?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondaryDescriptors?: Maybe<Scalars['String']['output']>;
  subratings?: Maybe<Array<Maybe<Subratings>>>;
};

export type ApiVideoItem = {
  __typename?: 'ApiVideoItem';
  _airDate?: Maybe<Scalars['String']['output']>;
  _airDateISO?: Maybe<Scalars['String']['output']>;
  _editDate?: Maybe<Scalars['String']['output']>;
  _firstIngestDate?: Maybe<Scalars['String']['output']>;
  _ingestDate?: Maybe<Scalars['String']['output']>;
  _lastModifiedDate?: Maybe<Scalars['String']['output']>;
  _pubDate?: Maybe<Scalars['String']['output']>;
  _pubDateISO?: Maybe<Scalars['String']['output']>;
  addOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  airDate?: Maybe<Scalars['Float']['output']>;
  amazonESTURL?: Maybe<Scalars['String']['output']>;
  appleWatchListShowKey?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<Scalars['String']['output']>;
  availableForProfileTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brand?: Maybe<Scalars['String']['output']>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbsShowId?: Maybe<Scalars['Int']['output']>;
  childContentId?: Maybe<Scalars['String']['output']>;
  closedCaptionUrl?: Maybe<Scalars['String']['output']>;
  cmsAccountId?: Maybe<Scalars['String']['output']>;
  contentId: Scalars['String']['output'];
  copyright?: Maybe<Scalars['String']['output']>;
  daistreamKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  downloadCountrySet?: Maybe<Array<Maybe<DownloadCountry>>>;
  duration?: Maybe<Scalars['Int']['output']>;
  editDate?: Maybe<Scalars['Float']['output']>;
  embeddable?: Maybe<Scalars['String']['output']>;
  endCreditsChapterTime?: Maybe<Scalars['String']['output']>;
  episodeNum?: Maybe<Scalars['String']['output']>;
  excludeNielsenTracking?: Maybe<Scalars['Boolean']['output']>;
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  firstIngestDate?: Maybe<Scalars['Float']['output']>;
  fullEpisode?: Maybe<Scalars['Boolean']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  ingestDate?: Maybe<Scalars['Float']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isProductPlacement?: Maybe<Scalars['Boolean']['output']>;
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  itunesESTURL?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['Float']['output']>;
  liveStreamingUrl?: Maybe<Scalars['String']['output']>;
  mediaAvailableDate?: Maybe<Scalars['String']['output']>;
  mediaAvailableDateEpoch?: Maybe<Scalars['Float']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  playbackEvents?: Maybe<PlaybackEvents>;
  playerLocUrl?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryCategory?: Maybe<Scalars['String']['output']>;
  primaryCategoryName?: Maybe<Scalars['String']['output']>;
  pubDate?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  regionalAudioExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  regionalRatings?: Maybe<Array<Maybe<ApiRegionalRating>>>;
  regionalTextExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  sizzleId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streamingUrl: Scalars['String']['output'];
  subscriptionLevel?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailSet?: Maybe<Array<Maybe<Thumbnail>>>;
  thumbnailSheetSet?: Maybe<Array<Maybe<Thumbnail>>>;
  title?: Maybe<Scalars['String']['output']>;
  tmsprogramID?: Maybe<Scalars['String']['output']>;
  tmsseriesID?: Maybe<Scalars['String']['output']>;
  topLevelCategory?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vTag?: Maybe<Scalars['String']['output']>;
  videoPageUrl?: Maybe<Scalars['String']['output']>;
  videoProperties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AssociatedContentVideo = {
  __typename?: 'AssociatedContentVideo';
  actors?: Maybe<Array<Scalars['String']['output']>>;
  contentId?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isVodAvailable?: Maybe<Scalars['Boolean']['output']>;
  originalContentDurationInSecs?: Maybe<Scalars['Int']['output']>;
  originalReleaseYear?: Maybe<Scalars['Int']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
};

export type AutocompleteSuggestion = {
  __typename?: 'AutocompleteSuggestion';
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  showId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AvailableVideoSeason = {
  __typename?: 'AvailableVideoSeason';
  clipsCount?: Maybe<Scalars['Int']['output']>;
  delayCount?: Maybe<Scalars['Int']['output']>;
  premiumCount?: Maybe<Scalars['Int']['output']>;
  seasonFinaleDate?: Maybe<Scalars['String']['output']>;
  seasonFinaleDateEpoch?: Maybe<Scalars['Int']['output']>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  seasonPremiereDate?: Maybe<Scalars['String']['output']>;
  seasonPremiereDateEpoch?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AvailableVideoSeasons = {
  __typename?: 'AvailableVideoSeasons';
  clipsCount?: Maybe<Scalars['Int']['output']>;
  delayCount?: Maybe<Scalars['Int']['output']>;
  premiumCount?: Maybe<Scalars['Int']['output']>;
  seasonFinaleDate?: Maybe<Scalars['String']['output']>;
  seasonFinaleDateEpoch?: Maybe<Scalars['String']['output']>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  seasonPremiereDate?: Maybe<Scalars['String']['output']>;
  seasonPremiereDateEpoch?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AvailableVideoSeasonsData = {
  __typename?: 'AvailableVideoSeasonsData';
  itemList?: Maybe<Array<AvailableVideoSeasons>>;
};

export type Avatar = {
  __typename?: 'Avatar';
  availableProfileTypes: Array<Maybe<ProfileType>>;
  avatarMedium: Scalars['String']['output'];
  avatarSmall: Scalars['String']['output'];
  filepath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  region: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type AvatarGroup = {
  __typename?: 'AvatarGroup';
  avatars: Array<Avatar>;
  id: Scalars['ID']['output'];
  region: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type BillingInfoResponse = {
  __typename?: 'BillingInfoResponse';
  billingInfo?: Maybe<AccountZipStateInfo>;
  recurlyInstance?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type BindMvpdFields = {
  authSuiteToken: Scalars['String']['input'];
};

export type BindMvpdResponse = {
  __typename?: 'BindMvpdResponse';
  success: Scalars['Boolean']['output'];
};

export type BindPartnerFields = {
  subscriptionId: Scalars['String']['input'];
};

export type BindPartnerResponse = {
  __typename?: 'BindPartnerResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Brand = {
  __typename?: 'Brand';
  applyGradient?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  endHexColor?: Maybe<Scalars['String']['output']>;
  filePathLogoHover?: Maybe<Scalars['String']['output']>;
  filepathAnimatedBackground?: Maybe<Scalars['String']['output']>;
  filepathAppHero?: Maybe<Scalars['String']['output']>;
  filepathAppHeroPortrait?: Maybe<Scalars['String']['output']>;
  filepathDefaultHero?: Maybe<Scalars['String']['output']>;
  filepathDefaultHeroPortrait?: Maybe<Scalars['String']['output']>;
  filepathGradient?: Maybe<Scalars['String']['output']>;
  filepathLogo?: Maybe<Scalars['String']['output']>;
  filepathLogoCompactApp?: Maybe<Scalars['String']['output']>;
  filepathLogoCompactWeb?: Maybe<Scalars['String']['output']>;
  filepathLogoOtt?: Maybe<Scalars['String']['output']>;
  filepathLogoRegularApp?: Maybe<Scalars['String']['output']>;
  filepathLogoRegularWeb?: Maybe<Scalars['String']['output']>;
  hubSlug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isHideFromBrandCarousel?: Maybe<Scalars['Boolean']['output']>;
  isPlayerAttributionVisible?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  startHexColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BrandCarouselItem = CarouselItem & {
  __typename?: 'BrandCarouselItem';
  animatedBackground?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  endHexColor: Scalars['String']['output'];
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  logoImage: Scalars['String']['output'];
  orientation?: Maybe<Scalars['String']['output']>;
  startHexColor: Scalars['String']['output'];
  thumb?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type BrandItem = {
  __typename?: 'BrandItem';
  applyGradient?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  endHexColor?: Maybe<Scalars['String']['output']>;
  filePathLogoHover?: Maybe<Scalars['String']['output']>;
  filepathAnimatedBackground?: Maybe<Scalars['String']['output']>;
  filepathAppHero?: Maybe<Scalars['String']['output']>;
  filepathAppHeroPortrait?: Maybe<Scalars['String']['output']>;
  filepathDefaultHero?: Maybe<Scalars['String']['output']>;
  filepathDefaultHeroPortrait?: Maybe<Scalars['String']['output']>;
  filepathGradient?: Maybe<Scalars['String']['output']>;
  filepathLogo: Scalars['String']['output'];
  filepathLogoCompactApp?: Maybe<Scalars['String']['output']>;
  filepathLogoCompactWeb?: Maybe<Scalars['String']['output']>;
  filepathLogoOtt?: Maybe<Scalars['String']['output']>;
  filepathLogoRegularApp?: Maybe<Scalars['String']['output']>;
  filepathLogoRegularWeb: Scalars['String']['output'];
  hubSlug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isHideFromBrandCarousel?: Maybe<Scalars['Boolean']['output']>;
  isPlayerAttributionVisible?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  startHexColor: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Button = {
  __typename?: 'Button';
  episode?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  play?: Maybe<Scalars['Boolean']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CanContext = {
  __typename?: 'CANContext';
  displayText?: Maybe<Scalars['String']['output']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum Cadence {
  Annual = 'annual',
  Monthly = 'monthly'
}

export type CampaignData = {
  __typename?: 'CampaignData';
  CouponOfferCode1?: Maybe<Scalars['String']['output']>;
  CouponOfferCode2?: Maybe<Scalars['String']['output']>;
  CouponOfferCode3?: Maybe<Scalars['String']['output']>;
  CouponOfferCode4?: Maybe<Scalars['String']['output']>;
  ProductOfferCode1?: Maybe<Scalars['String']['output']>;
  ProductOfferCode2?: Maybe<Scalars['String']['output']>;
  ProductOfferCode3?: Maybe<Scalars['String']['output']>;
  ProductOfferCode4?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type CampaignPageAttributesResponse = {
  __typename?: 'CampaignPageAttributesResponse';
  campaignAttributes?: Maybe<CampaignData>;
  planPageAttributes?: Maybe<PlanPageAttributesResponse>;
  products?: Maybe<ProductsResponse>;
  variantsForTracking?: Maybe<Array<Scalars['String']['output']>>;
};


export type CampaignPageAttributesResponseProductsArgs = {
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type CanModel = {
  __typename?: 'CanModel';
  _airDate?: Maybe<Scalars['String']['output']>;
  _airDateISO?: Maybe<Scalars['String']['output']>;
  _editDate?: Maybe<Scalars['String']['output']>;
  _expirationDate?: Maybe<Scalars['String']['output']>;
  _firstIngestDate?: Maybe<Scalars['String']['output']>;
  _ingestDate?: Maybe<Scalars['String']['output']>;
  _lastModifiedDate?: Maybe<Scalars['String']['output']>;
  _pubDate?: Maybe<Scalars['String']['output']>;
  _pubDateISO?: Maybe<Scalars['String']['output']>;
  addOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  airDate?: Maybe<Scalars['Int']['output']>;
  amazonESTURL?: Maybe<Scalars['String']['output']>;
  appleWatchListShowKey?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<Scalars['String']['output']>;
  availableForProfileTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbsShowId?: Maybe<Scalars['Int']['output']>;
  childContentId?: Maybe<Scalars['String']['output']>;
  closedCaptionUrl?: Maybe<Scalars['String']['output']>;
  cmsAccountId?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  downloadCountrySet?: Maybe<Array<Maybe<DownloadCountrySet>>>;
  duration: Scalars['Int']['output'];
  editDate?: Maybe<Scalars['Int']['output']>;
  embeddable?: Maybe<Scalars['String']['output']>;
  endCreditsChapterTime?: Maybe<Scalars['String']['output']>;
  episodeNum?: Maybe<Scalars['String']['output']>;
  excludeNielsenTracking?: Maybe<Scalars['Boolean']['output']>;
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['Int']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstIngestDate?: Maybe<Scalars['Int']['output']>;
  fullEpisode?: Maybe<Scalars['Boolean']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  ingestDate?: Maybe<Scalars['Int']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isProductPlacement?: Maybe<Scalars['Boolean']['output']>;
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  itunesESTURL?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['Int']['output']>;
  mediaAvailableDate?: Maybe<Scalars['String']['output']>;
  mediaAvailableDateEpoch?: Maybe<Scalars['Int']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  playbackEvents?: Maybe<PlaybackEvents>;
  playerLocUrl?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryCategory?: Maybe<Scalars['String']['output']>;
  primaryCategoryName?: Maybe<Scalars['String']['output']>;
  pubDate?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  regionalAudioExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  regionalRatings?: Maybe<Array<Maybe<RegionalRatings>>>;
  regionalTextExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  sizzleId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  subscriptionLevel?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailSet?: Maybe<Array<Maybe<ThumbnailSet>>>;
  thumbnailSheetSet?: Maybe<Array<Maybe<ThumbnailSheetSet>>>;
  title?: Maybe<Scalars['String']['output']>;
  tmsprogramID?: Maybe<Scalars['String']['output']>;
  tmsseriesID?: Maybe<Scalars['String']['output']>;
  topLevelCategory?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vTag?: Maybe<Scalars['String']['output']>;
  videoPageUrl?: Maybe<Scalars['String']['output']>;
  videoProperties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CancelSaveCarouselItem = {
  __typename?: 'CancelSaveCarouselItem';
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  tileTracking?: Maybe<CarouselItemTracking>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CancelSavePageAttribute = {
  __typename?: 'CancelSavePageAttribute';
  carouselTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  carousels?: Maybe<Array<Maybe<Array<Maybe<CancelSaveCarouselItem>>>>>;
  web_cancel_save_back_to_account_cta_text: Scalars['String']['output'];
  web_cancel_save_cancel_cta_text: Scalars['String']['output'];
  web_cancel_save_carousel_header?: Maybe<Scalars['String']['output']>;
  web_cancel_save_header: Scalars['String']['output'];
  web_cancel_save_legal_copy: Scalars['String']['output'];
  web_cancel_save_subheader1: Scalars['String']['output'];
};

export type CarazCta = {
  __typename?: 'CarazCta';
  ctaActionType: Scalars['String']['output'];
  ctaActionValue: Scalars['String']['output'];
  ctaText: Scalars['String']['output'];
};

export type CarazImageAssets = {
  __typename?: 'CarazImageAssets';
  brandLogoImage?: Maybe<Scalars['String']['output']>;
  heroCompactImage?: Maybe<Scalars['String']['output']>;
  heroMiniImage?: Maybe<Scalars['String']['output']>;
  heroRegularImage?: Maybe<Scalars['String']['output']>;
  pageHeaderImage?: Maybe<Scalars['String']['output']>;
  posterImage?: Maybe<Scalars['String']['output']>;
  thumbnailImage?: Maybe<Scalars['String']['output']>;
  titleLogoCenterImage?: Maybe<Scalars['String']['output']>;
  titleLogoCompactImage?: Maybe<Scalars['String']['output']>;
  titleLogoLeftImage?: Maybe<Scalars['String']['output']>;
};

export type CarazPromoData = {
  __typename?: 'CarazPromoData';
  linkedContentId?: Maybe<Scalars['String']['output']>;
  linkedContentType?: Maybe<Scalars['String']['output']>;
  liveCTAActionType?: Maybe<Scalars['String']['output']>;
  liveCTAText?: Maybe<Scalars['String']['output']>;
  promoListingId?: Maybe<Scalars['String']['output']>;
  promoType?: Maybe<Scalars['String']['output']>;
};

export type CarazRating = {
  __typename?: 'CarazRating';
  icon?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CarazTrackingData = {
  __typename?: 'CarazTrackingData';
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  pvrModel?: Maybe<Scalars['String']['output']>;
};

export type CarouselApiResponse = {
  __typename?: 'CarouselApiResponse';
  AtoZ?: Maybe<Array<Maybe<Trending>>>;
  brands: Array<BrandItem>;
  carousel?: Maybe<Array<Maybe<MediaItem>>>;
  carouselPEM?: Maybe<Scalars['JSON']['output']>;
  carouselPresentationStyle: Scalars['String']['output'];
  collections?: Maybe<Array<Maybe<Collections>>>;
  count?: Maybe<Scalars['Int']['output']>;
  displayShowTitle?: Maybe<Scalars['Boolean']['output']>;
  hash?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pagePEM?: Maybe<Scalars['JSON']['output']>;
  pvrModel?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
  section?: Maybe<Array<Maybe<Section>>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  surrogateKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total: Scalars['Int']['output'];
  trending?: Maybe<Array<Maybe<Trending>>>;
};

export type CarouselInfo = {
  apiBaseUrl: Scalars['String']['input'];
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  carouselId?: InputMaybe<Scalars['String']['input']>;
  carouselPresentationStyle?: InputMaybe<Scalars['String']['input']>;
  isContentHighlightEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  model: Scalars['String']['input'];
  orientation?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  promotionalSpot?: InputMaybe<PromotionalSpot>;
  rankModel?: InputMaybe<Scalars['String']['input']>;
  recoId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CarouselItem = {
  contentType?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type CarouselItemTracking = {
  __typename?: 'CarouselItemTracking';
  carouselContentType?: Maybe<Scalars['String']['output']>;
  carouselId?: Maybe<Scalars['String']['output']>;
  carouselLink?: Maybe<Scalars['String']['output']>;
  carouselModel?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  isHighlightEnabled?: Maybe<Scalars['String']['output']>;
  movieId?: Maybe<Scalars['String']['output']>;
  movieTitle?: Maybe<Scalars['String']['output']>;
  posColNum?: Maybe<Scalars['String']['output']>;
  posRowNum?: Maybe<Scalars['String']['output']>;
  showSeriesId?: Maybe<Scalars['String']['output']>;
  showSeriesTitle?: Maybe<Scalars['String']['output']>;
};

export type CarouselParams = {
  _clientRegion?: InputMaybe<Scalars['String']['input']>;
  adSessionId?: InputMaybe<Scalars['String']['input']>;
  carouselId?: InputMaybe<Scalars['String']['input']>;
  carouselPresentationStyle?: InputMaybe<Scalars['String']['input']>;
  carouselType?: InputMaybe<Scalars['String']['input']>;
  displayTitle?: InputMaybe<Scalars['Boolean']['input']>;
  dma?: InputMaybe<Scalars['Int']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  includeVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isContentHighlightEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMarquee?: InputMaybe<Scalars['Boolean']['input']>;
  isMyList?: InputMaybe<Scalars['Boolean']['input']>;
  isSubscriber?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maxCarouselItems?: InputMaybe<Scalars['Int']['input']>;
  minCarouselItems?: InputMaybe<Scalars['Int']['input']>;
  minProximity?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  promotionalSpot?: InputMaybe<PromotionalSpot>;
  pvrModel?: InputMaybe<Scalars['String']['input']>;
  rankModel?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileType?: InputMaybe<Scalars['String']['input']>;
  userRegistrationCountry?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselResponse = {
  __typename?: 'CarouselResponse';
  result?: Maybe<Result>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CastApiParams = {
  __typename?: 'CastApiParams';
  _clientRegion?: Maybe<Scalars['String']['output']>;
  currentState?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platformType?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CastConfig = {
  __typename?: 'CastConfig';
  apiBaseUrl?: Maybe<Scalars['String']['output']>;
  apiParams?: Maybe<CastApiParams>;
  apiUrl?: Maybe<Scalars['String']['output']>;
  carouselId?: Maybe<Scalars['String']['output']>;
  carouselPresentationStyle?: Maybe<Scalars['String']['output']>;
  isContentHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  promotionalSpot?: Maybe<Scalars['JSON']['output']>;
  rankModel?: Maybe<Scalars['String']['output']>;
  recoId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CastConfigurationResponse = {
  __typename?: 'CastConfigurationResponse';
  config?: Maybe<Array<Maybe<CastConfig>>>;
  hash?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CastItem = {
  __typename?: 'CastItem';
  bio_type?: Maybe<Scalars['String']['output']>;
  character_name?: Maybe<Scalars['String']['output']>;
  filepath?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  k?: Maybe<Scalars['String']['output']>;
  show_id?: Maybe<Scalars['Int']['output']>;
  show_title?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Channel = {
  __typename?: 'Channel';
  assetURL?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Brand>;
  callSignId?: Maybe<Scalars['String']['output']>;
  cbsPackages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channelCategorySlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channelName?: Maybe<Scalars['String']['output']>;
  channelTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  city?: Maybe<Scalars['String']['output']>;
  currentListing?: Maybe<Array<Maybe<ChannelListing>>>;
  description?: Maybe<Scalars['String']['output']>;
  displayMetadata?: Maybe<Scalars['Boolean']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  displayStyle?: Maybe<Scalars['String']['output']>;
  dma?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  entitlementCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePathLogo?: Maybe<Scalars['String']['output']>;
  filePathLogoSelected?: Maybe<Scalars['String']['output']>;
  filePathSmallLogo?: Maybe<Scalars['String']['output']>;
  filePathSmallLogoSelected?: Maybe<Scalars['String']['output']>;
  filepathDefaultBackground?: Maybe<Scalars['String']['output']>;
  filepathFallbackImage?: Maybe<Scalars['String']['output']>;
  filepathLiveEndCardImage?: Maybe<Scalars['String']['output']>;
  filepathPromoThumbnail?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isLTSEnabled?: Maybe<Scalars['Boolean']['output']>;
  isLocalPlaybackChannel?: Maybe<Scalars['Boolean']['output']>;
  isMultiCam?: Maybe<Scalars['Boolean']['output']>;
  isOptinRequired?: Maybe<Scalars['Boolean']['output']>;
  local?: Maybe<Scalars['Boolean']['output']>;
  originId?: Maybe<Scalars['Int']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  prgSvcId?: Maybe<Scalars['Int']['output']>;
  promoContentId?: Maybe<Scalars['Int']['output']>;
  promoContentType?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resolvedfilePathLogo?: Maybe<Scalars['String']['output']>;
  resolvedfilePathLogoSelected?: Maybe<Scalars['String']['output']>;
  resolvedfilepathDefaultBackground?: Maybe<Scalars['String']['output']>;
  resolvedfilepathFallbackImage?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sortTheme?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stationId?: Maybe<Scalars['String']['output']>;
  stitched?: Maybe<Stitched>;
  streamType?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  tokenExpirationTime?: Maybe<Scalars['Int']['output']>;
  totalNumberOfCurrentListings?: Maybe<Scalars['Int']['output']>;
  totalNumberOfUpcomingListings?: Maybe<Scalars['Int']['output']>;
  upcomingListing?: Maybe<Array<Maybe<ChannelListing>>>;
  videoContentId?: Maybe<Scalars['String']['output']>;
};

export type ChannelCategoriesParams = {
  billingVendor?: InputMaybe<Scalars['String']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  userProfileType?: InputMaybe<Scalars['String']['input']>;
  userRegistrationCountry?: InputMaybe<Scalars['String']['input']>;
  userState?: InputMaybe<Scalars['String']['input']>;
  vendorCode?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelCategoriesResponse = {
  __typename?: 'ChannelCategoriesResponse';
  channelCategories?: Maybe<Array<Maybe<ChannelCategory>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ChannelCategory = {
  __typename?: 'ChannelCategory';
  cbsPackages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ChannelData = {
  __typename?: 'ChannelData';
  channelDescription?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  channelOriginId?: Maybe<Scalars['String']['output']>;
  channelSlug?: Maybe<Scalars['String']['output']>;
  contentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
};

export type ChannelListing = {
  __typename?: 'ChannelListing';
  alternateStreamLabel?: Maybe<Scalars['String']['output']>;
  alternativeContentCANVideos?: Maybe<Array<Maybe<ContentCanVideo>>>;
  alternativeVideoContentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  associatedContentVideo?: Maybe<ContentCanVideo>;
  channelSlug?: Maybe<Scalars['String']['output']>;
  channelTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentCANVideo?: Maybe<ContentCanVideo>;
  contentImageUrls?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  dma?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  durationMins?: Maybe<Scalars['Int']['output']>;
  endTimeFormatted?: Maybe<Scalars['String']['output']>;
  endTimestamp?: Maybe<Scalars['Float']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  episodeId?: Maybe<Scalars['String']['output']>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  fallbackEnabled?: Maybe<Scalars['Boolean']['output']>;
  fallbackStreamType?: Maybe<Scalars['String']['output']>;
  fallbackVideContentId?: Maybe<Scalars['String']['output']>;
  filePathThumb?: Maybe<Scalars['String']['output']>;
  filepathFallbackImage?: Maybe<Scalars['String']['output']>;
  filepathMovieThumbnail?: Maybe<Scalars['String']['output']>;
  filepathVideoEndcardShowImage?: Maybe<Scalars['String']['output']>;
  gameEndTimestamp?: Maybe<Scalars['Float']['output']>;
  gameId?: Maybe<Scalars['String']['output']>;
  gameStartTimestamp?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLTSEnabled?: Maybe<Scalars['Boolean']['output']>;
  isListingLive?: Maybe<Scalars['Boolean']['output']>;
  isVodAvailable?: Maybe<Scalars['Boolean']['output']>;
  modalContentImageUrls?: Maybe<Array<Scalars['String']['output']>>;
  movieId?: Maybe<Scalars['String']['output']>;
  originalAirDate?: Maybe<Scalars['Float']['output']>;
  originalAirDateFormatted?: Maybe<Scalars['String']['output']>;
  provideType?: Maybe<Scalars['String']['output']>;
  ptvId?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  resolvedfilePathThumb?: Maybe<Scalars['String']['output']>;
  seasonId?: Maybe<Scalars['String']['output']>;
  seasonNumber?: Maybe<Scalars['Int']['output']>;
  showId?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  startTimeFormatted?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['Float']['output']>;
  streamEndTimeFormatted?: Maybe<Scalars['String']['output']>;
  streamEndTimestamp?: Maybe<Scalars['Float']['output']>;
  streamStartTimeFormatted?: Maybe<Scalars['String']['output']>;
  streamStartTimestamp?: Maybe<Scalars['Float']['output']>;
  streamType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tmsProgramId?: Maybe<Scalars['String']['output']>;
  tmsSeriesId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  videoContentId?: Maybe<Scalars['String']['output']>;
  videoPageUrl?: Maybe<Scalars['String']['output']>;
};

export type ChannelListingCarouselItem = CarouselItem & CommonContentFields & {
  __typename?: 'ChannelListingCarouselItem';
  addOns?: Maybe<Scalars['String']['output']>;
  badgeLabel?: Maybe<Scalars['String']['output']>;
  bundleLocked?: Maybe<Scalars['Boolean']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  channelName?: Maybe<Scalars['String']['output']>;
  channelOriginId?: Maybe<Scalars['String']['output']>;
  channelSlug?: Maybe<Scalars['String']['output']>;
  contentCANVideo?: Maybe<CanModel>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  ctaActionType?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  durationMins?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['String']['output']>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  highlightImage?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isChannelLocked?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isContentHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isOnNow?: Maybe<Scalars['Boolean']['output']>;
  isVodAvailable: Scalars['Boolean']['output'];
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  listingContentId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoCenter?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  numericLabel?: Maybe<Scalars['Int']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  progressText?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingBadge?: Maybe<Scalars['String']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  runtime?: Maybe<Scalars['Int']['output']>;
  scheduleBadgeText?: Maybe<Scalars['String']['output']>;
  seasonNumber?: Maybe<Scalars['Int']['output']>;
  showId?: Maybe<Scalars['String']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  startTimeFormatted?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['String']['output']>;
  streamEndTimestamp?: Maybe<Scalars['Float']['output']>;
  streamStartTimeFormatted?: Maybe<Scalars['String']['output']>;
  streamStartTimestamp?: Maybe<Scalars['Float']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbLandscape?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type ChannelListingData = {
  __typename?: 'ChannelListingData';
  channelData: ChannelData;
  listingData: ListingData;
};

export type ChannelListingNormalized = {
  __typename?: 'ChannelListingNormalized';
  channelName: Scalars['String']['output'];
  channelOriginId?: Maybe<Scalars['Int']['output']>;
  channelSlug: Scalars['String']['output'];
  contentImageUrls: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  endTimestamp?: Maybe<Scalars['Float']['output']>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodeTitle: Scalars['String']['output'];
  genre: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isListingLive: Scalars['Boolean']['output'];
  isShow: Scalars['Boolean']['output'];
  isVodAvailable: Scalars['Boolean']['output'];
  logo: Scalars['String']['output'];
  movieId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rating: Scalars['String']['output'];
  seasonNumber?: Maybe<Scalars['Int']['output']>;
  showSeriesId?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['Float']['output']>;
  thumbLandscape: Scalars['String']['output'];
  videoContentId?: Maybe<Scalars['String']['output']>;
  vodContentId?: Maybe<Scalars['String']['output']>;
  watchlistContentId?: Maybe<Scalars['String']['output']>;
};

export type ChannelListingResponse = {
  __typename?: 'ChannelListingResponse';
  channel?: Maybe<Array<Maybe<Channel>>>;
  listing?: Maybe<Array<Maybe<ChannelListing>>>;
  previousListings?: Maybe<Array<Maybe<ChannelListing>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ChannelParams = {
  billingVendor?: InputMaybe<Scalars['String']['input']>;
  channelCategorySlug?: InputMaybe<Scalars['String']['input']>;
  channelOriginId?: InputMaybe<Scalars['Int']['input']>;
  channelSlug?: InputMaybe<Scalars['String']['input']>;
  dma?: InputMaybe<Scalars['Int']['input']>;
  edgeCacheKey?: InputMaybe<Scalars['String']['input']>;
  filterLockedChannels?: InputMaybe<Scalars['Boolean']['input']>;
  hideChannelsWithoutListings?: InputMaybe<Scalars['Boolean']['input']>;
  isPreviewMode?: InputMaybe<Scalars['Boolean']['input']>;
  mvpdId?: InputMaybe<Scalars['String']['input']>;
  numOfUpcomingListings?: InputMaybe<Scalars['Int']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  showListing?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  stationId?: InputMaybe<Scalars['Int']['input']>;
  userProfileType?: InputMaybe<Scalars['String']['input']>;
  userRegistrationCountry?: InputMaybe<Scalars['String']['input']>;
  userState?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelResponse = ChannelResponseError | ChannelResponseMany | ChannelResponseOne;

export type ChannelResponseError = {
  __typename?: 'ChannelResponseError';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChannelResponseMany = {
  __typename?: 'ChannelResponseMany';
  channels?: Maybe<Array<Maybe<Channel>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ChannelResponseOne = {
  __typename?: 'ChannelResponseOne';
  channel?: Maybe<Channel>;
  rows?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CharacterApiResponse = {
  __typename?: 'CharacterApiResponse';
  changedDate?: Maybe<Scalars['String']['output']>;
  characterCarouselId?: Maybe<Scalars['Int']['output']>;
  characterCarouselItems?: Maybe<Array<Maybe<CharacterItem>>>;
  createdDate?: Maybe<Scalars['String']['output']>;
  displayShowTitle?: Maybe<Scalars['Boolean']['output']>;
  excludeProfileSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  parentCharacterCarouselId?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeTextField?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CharacterCarouselItem = CarouselItem & {
  __typename?: 'CharacterCarouselItem';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  characterImage: Scalars['String']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type CharacterItem = {
  __typename?: 'CharacterItem';
  characterCarouselId?: Maybe<Scalars['Int']['output']>;
  characterCarouselItemId?: Maybe<Scalars['Int']['output']>;
  characterId?: Maybe<Scalars['Int']['output']>;
  characterTitle: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  filepathBackgroundRoundedImage?: Maybe<Scalars['String']['output']>;
  filepathBackgroundStraightEdgedImage?: Maybe<Scalars['String']['output']>;
  filepathBackgroundTallImage?: Maybe<Scalars['String']['output']>;
  filepathCharacterImage?: Maybe<Scalars['String']['output']>;
  hubSlug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  movieContentId?: Maybe<Scalars['String']['output']>;
  pathValue?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CmpConsentTokenResponse = {
  __typename?: 'CmpConsentTokenResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  /** Hashed privacy ID from the `sub` claim of the CMP consent token, never the raw token. */
  token?: Maybe<Scalars['String']['output']>;
};

export type CodeActivateSuccessResponse = {
  __typename?: 'CodeActivateSuccessResponse';
  activationCode?: Maybe<Scalars['String']['output']>;
  activationScreen?: Maybe<Scalars['String']['output']>;
  device?: Maybe<DeviceInfo>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Collection = {
  __typename?: 'Collection';
  heroToken?: Maybe<Scalars['String']['output']>;
  hubCarousels?: Maybe<Array<Maybe<CollectionCarousel>>>;
  hubId?: Maybe<Scalars['Int']['output']>;
  hubSlug?: Maybe<Scalars['String']['output']>;
  liveOnDate?: Maybe<Scalars['Float']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  marqueeToken?: Maybe<Scalars['String']['output']>;
  pageType?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userState?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CollectionApiResponse = {
  __typename?: 'CollectionApiResponse';
  hub?: Maybe<Hub>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollectionCarousel = {
  __typename?: 'CollectionCarousel';
  carouselId?: Maybe<Scalars['String']['output']>;
  carouselPresentationStyle?: Maybe<Scalars['String']['output']>;
  carouselType: Scalars['String']['output'];
  displayTitle?: Maybe<Scalars['Boolean']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  isContentHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type CollectionEntity = MovieCollectionEntity | ShowCollectionEntity;

export type Collections = {
  __typename?: 'Collections';
  collectionEntity?: Maybe<CollectionEntity>;
  collectionType?: Maybe<Scalars['String']['output']>;
};

export type CommonApiParams = {
  _clientRegion?: InputMaybe<Scalars['String']['input']>;
  billingVendor?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  userProfileType?: InputMaybe<Scalars['String']['input']>;
  userRegistrationCountry?: InputMaybe<Scalars['String']['input']>;
  userState?: InputMaybe<Scalars['String']['input']>;
};

export type CommonContentFields = {
  addOns?: Maybe<Scalars['String']['output']>;
  badgeLabel?: Maybe<Scalars['String']['output']>;
  bundleLocked?: Maybe<Scalars['Boolean']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  contentCANVideo?: Maybe<CanModel>;
  contentId?: Maybe<Scalars['String']['output']>;
  ctaActionType?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  highlightImage?: Maybe<Scalars['String']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isContentHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoCenter?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  numericLabel?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  progressText?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  runtime?: Maybe<Scalars['Int']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  thumbLandscape?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type CommonData = {
  __typename?: 'CommonData';
  badgeLabel?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  genre: Scalars['String']['output'];
  isContentLocked: Scalars['Boolean']['output'];
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['String']['output'];
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  itemType: Scalars['String']['output'];
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  rating: CarazRating;
  releaseYear: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  tuneInText: Scalars['String']['output'];
  videoPreviewURL: Scalars['String']['output'];
};

/**
 * Community Data Service feedback: `feedbackId` is server-generated, and a resubmission is
 * idempotent through the upsert on profile + target + feedbackType. Backed by the api-web
 * `user/feedback` endpoints through `data-source-apis/feedbackConfig/feedback-api.ts`.
 */
export type CommunityFeedback = {
  __typename?: 'CommunityFeedback';
  /** Server-generated ULID, stable for the life of the row. */
  feedbackId: Scalars['String']['output'];
  /** `reaction` | `review`. */
  feedbackType: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  /** Emoji token for a reaction (e.g. `thumbs_up`), or the review body. */
  value: Scalars['String']['output'];
};

export type CommunityFeedbackReadResponse = {
  __typename?: 'CommunityFeedbackReadResponse';
  feedback: Array<CommunityFeedbackTarget>;
  success: Scalars['Boolean']['output'];
};

export type CommunityFeedbackRemoveResponse = {
  __typename?: 'CommunityFeedbackRemoveResponse';
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<CommunityFeedbackRemoved>;
  status?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Echoes back what was cleared, mirroring `RemovedFeedback.java`. */
export type CommunityFeedbackRemoved = {
  __typename?: 'CommunityFeedbackRemoved';
  feedbackType: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
};

export type CommunityFeedbackTarget = {
  __typename?: 'CommunityFeedbackTarget';
  /**
   * What the profile holds for this target. With `feedbackType` omitted a target can carry both
   * a reaction and a review, so this stays a list.
   */
  feedback: Array<CommunityFeedback>;
  /**
   * Convenience projection of the current `reaction`, or null when unset, so a thumbs control
   * rehydrates without the caller filtering `feedback` itself.
   */
  reaction?: Maybe<CommunityFeedback>;
  targetId: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
};

/**
 * Failure fields mirror api-web's flat `ApiErrorResponse` — `errorCode`, `error`, `message` — not
 * a nested error object. `status` carries the HTTP status the REST endpoint would have returned,
 * since a GraphQL response cannot; clients branch on it rather than on `success`.
 */
export type CommunityFeedbackWriteResponse = {
  __typename?: 'CommunityFeedbackWriteResponse';
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<CommunityFeedback>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ConcurrencyDeniedPlaybackReason = {
  __typename?: 'ConcurrencyDeniedPlaybackReason';
  code?: Maybe<Scalars['String']['output']>;
  eligibleForUpsell?: Maybe<Scalars['Boolean']['output']>;
  paymentSource?: Maybe<Scalars['String']['output']>;
};

export type ConcurrencyParams = {
  billingVendor?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  userProfileType?: InputMaybe<Scalars['String']['input']>;
  userRegistrationCountry?: InputMaybe<Scalars['String']['input']>;
  userState?: InputMaybe<Scalars['String']['input']>;
};

export type ConcurrencyResponse = {
  __typename?: 'ConcurrencyResponse';
  concurrentStreamCount?: Maybe<Scalars['Int']['output']>;
  deniedPlaybackReason?: Maybe<ConcurrencyDeniedPlaybackReason>;
  overThreshold?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Config = {
  __typename?: 'Config';
  apiBaseUrl?: Maybe<Scalars['String']['output']>;
  apiParams?: Maybe<ApiParams>;
  apiUrl?: Maybe<Scalars['String']['output']>;
  carouselId?: Maybe<Scalars['String']['output']>;
  carouselPresentationStyle: Scalars['String']['output'];
  carouselType: Scalars['String']['output'];
  displayTitle?: Maybe<Scalars['Boolean']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includeVersion?: Maybe<Scalars['Boolean']['output']>;
  isContentHighlightEnabled: Scalars['Boolean']['output'];
  isMarquee?: Maybe<Scalars['Boolean']['output']>;
  isMyList?: Maybe<Scalars['Boolean']['output']>;
  model: Scalars['String']['output'];
  orientation?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  promotionalSpot?: Maybe<Scalars['JSON']['output']>;
  promotionalTile?: Maybe<HubCarouselItem>;
  pvrModel?: Maybe<Scalars['String']['output']>;
  rankModel?: Maybe<Scalars['String']['output']>;
  recoId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  token: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type ContentCanVideo = {
  __typename?: 'ContentCANVideo';
  _airDate?: Maybe<Scalars['String']['output']>;
  _airDateISO?: Maybe<Scalars['String']['output']>;
  _editDate?: Maybe<Scalars['String']['output']>;
  _firstIngestDate?: Maybe<Scalars['String']['output']>;
  _ingestDate?: Maybe<Scalars['String']['output']>;
  _lastModifiedDate?: Maybe<Scalars['String']['output']>;
  _pubDate?: Maybe<Scalars['String']['output']>;
  _pubDateISO?: Maybe<Scalars['String']['output']>;
  actors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  addOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  airDate?: Maybe<Scalars['Float']['output']>;
  amazonESTURL?: Maybe<Scalars['String']['output']>;
  appleWatchListShowKey?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<Scalars['String']['output']>;
  availableForProfileTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brand?: Maybe<Scalars['String']['output']>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbsShowId?: Maybe<Scalars['Int']['output']>;
  childContentId?: Maybe<Scalars['String']['output']>;
  closedCaptionUrl?: Maybe<Scalars['String']['output']>;
  cmsAccountId?: Maybe<Scalars['String']['output']>;
  contentId: Scalars['String']['output'];
  copyright?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use daistreamKey */
  daiStreamKey?: Maybe<Scalars['String']['output']>;
  daistreamKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  downloadCountrySet?: Maybe<Array<Maybe<DownloadCountry>>>;
  duration?: Maybe<Scalars['Int']['output']>;
  editDate?: Maybe<Scalars['Float']['output']>;
  embeddable?: Maybe<Scalars['String']['output']>;
  endCreditsChapterTime?: Maybe<Scalars['String']['output']>;
  episodeNum?: Maybe<Scalars['String']['output']>;
  excludeNielsenTracking?: Maybe<Scalars['Boolean']['output']>;
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  firstIngestDate?: Maybe<Scalars['Float']['output']>;
  fullEpisode?: Maybe<Scalars['Boolean']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  ingestDate?: Maybe<Scalars['Float']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isProductPlacement?: Maybe<Scalars['Boolean']['output']>;
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  isVodAvailable?: Maybe<Scalars['Boolean']['output']>;
  itunesESTURL?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['Float']['output']>;
  liveStreamingUrl?: Maybe<Scalars['String']['output']>;
  mediaAvailableDate?: Maybe<Scalars['String']['output']>;
  mediaAvailableDateEpoch?: Maybe<Scalars['Float']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  playbackEvents?: Maybe<PlaybackEvents>;
  playerLocUrl?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryCategory?: Maybe<Scalars['String']['output']>;
  primaryCategoryName?: Maybe<Scalars['String']['output']>;
  pubDate?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  regionalAudioExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  regionalRatings?: Maybe<Array<Maybe<ApiRegionalRating>>>;
  regionalTextExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showId?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  showTitle?: Maybe<Scalars['String']['output']>;
  sizzleID?: Maybe<Scalars['String']['output']>;
  sizzleId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streamingUrl: Scalars['String']['output'];
  subscriptionLevel?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailSet?: Maybe<Array<Maybe<Thumbnail>>>;
  thumbnailSheetSet?: Maybe<Array<Maybe<Thumbnail>>>;
  title?: Maybe<Scalars['String']['output']>;
  tmsProgramID?: Maybe<Scalars['String']['output']>;
  tmsprogramID?: Maybe<Scalars['String']['output']>;
  tmsseriesID?: Maybe<Scalars['String']['output']>;
  topLevelCategory?: Maybe<Scalars['String']['output']>;
  topLevelCatgeory?: Maybe<Scalars['String']['output']>;
  trailerContentId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vTag?: Maybe<Scalars['String']['output']>;
  videoPageUrl?: Maybe<Scalars['String']['output']>;
  videoProperties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Fields used by the content highlight banner / metadata strip (minimal payload vs detail pages). */
export type ContentHighlightMetadata = {
  __typename?: 'ContentHighlightMetadata';
  /** ISO-ish air date for movies (carousel `airDate`). */
  airDate?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  contentType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  movieDuration?: Maybe<Scalars['Int']['output']>;
  numSeasons?: Maybe<Scalars['Int']['output']>;
  premiereDate?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  tvAgeRating?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
};

export type ContentHighlightMetadataInput = {
  kind: VodContentHighlightKind;
  /** Movie document id (same as `/movies/{id}` and carousel `movieContentId`). Required when kind is MOVIE. */
  movieId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Show id (numeric or hexadecimal/ObjectId). Fallback for kind SHOW when no slug is available
   * (e.g. Continue Watching). One of showSlug or showId is required when kind is SHOW.
   */
  showId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Show slug or path fragment (e.g. `power-las` or `shows/power-las/`). Preferred over `showId`
   * when kind is SHOW.
   */
  showSlug?: InputMaybe<Scalars['String']['input']>;
};

export type Context = {
  __typename?: 'Context';
  displayText?: Maybe<Scalars['String']['output']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CreativeAdData = {
  __typename?: 'CreativeAdData';
  adFormat?: Maybe<Scalars['String']['output']>;
  advertiserId?: Maybe<Scalars['String']['output']>;
  creativeId?: Maybe<Scalars['String']['output']>;
  linkedId?: Maybe<Scalars['String']['output']>;
  linkedType?: Maybe<Scalars['String']['output']>;
};

export type CreativeCarouselItem = CarouselItem & {
  __typename?: 'CreativeCarouselItem';
  adFormat?: Maybe<Scalars['String']['output']>;
  advertiserId?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  clickPixels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentType?: Maybe<Scalars['String']['output']>;
  creativeId?: Maybe<Scalars['String']['output']>;
  ctaActionType?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  impressionPixels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  linkedId?: Maybe<Scalars['String']['output']>;
  linkedType?: Maybe<Scalars['String']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type CreativeCommonData = {
  __typename?: 'CreativeCommonData';
  itemId?: Maybe<Scalars['String']['output']>;
  itemIndex?: Maybe<Scalars['Int']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
};

export type CreativeCta = {
  __typename?: 'CreativeCta';
  ctaActionType?: Maybe<Scalars['String']['output']>;
  ctaActionValue?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
};

export type CreativeImageAssets = {
  __typename?: 'CreativeImageAssets';
  bannerAdImage?: Maybe<Scalars['String']['output']>;
};

export type CreativeTrackingData = {
  __typename?: 'CreativeTrackingData';
  clickPixels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  impressionPixels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DaiParams = {
  __typename?: 'DAIParams';
  adTagParameters?: Maybe<Scalars['JSON']['output']>;
  daiExcl?: Maybe<Scalars['String']['output']>;
  streamKey?: Maybe<Scalars['String']['output']>;
  videoId?: Maybe<Scalars['String']['output']>;
};

export type DebugInfo = {
  __typename?: 'DebugInfo';
  ipAddress?: Maybe<Scalars['String']['output']>;
  isNFLEnabled?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  userState?: Maybe<Scalars['String']['output']>;
};

export type DetailCta = {
  __typename?: 'DetailCta';
  actionType?: Maybe<Scalars['String']['output']>;
  actionValue?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type DetailHero = {
  airDate?: Maybe<Scalars['Float']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  brandUrl?: Maybe<Scalars['String']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  cast?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  detailCta?: Maybe<DetailCta>;
  duration?: Maybe<Scalars['Int']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  heroType?: Maybe<HeroType>;
  logo?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  progress?: Maybe<Scalars['Int']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  srcSetLandscape?: Maybe<Scalars['String']['output']>;
  srcSetPortrait?: Maybe<Scalars['String']['output']>;
  standardImgForAllScreens?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type DeviceInfo = {
  __typename?: 'DeviceInfo';
  city?: Maybe<Scalars['String']['output']>;
  cookieHash?: Maybe<Scalars['String']['output']>;
  deviceDescription?: Maybe<Scalars['String']['output']>;
  ecid?: Maybe<Scalars['String']['output']>;
  isCurrentDevice?: Maybe<Scalars['Boolean']['output']>;
  isMasterProfile?: Maybe<Scalars['Boolean']['output']>;
  lastLogin?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  lastLoginMillis?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['ID']['output']>;
  profilePic?: Maybe<Scalars['String']['output']>;
  profilePicPath?: Maybe<Scalars['String']['output']>;
  profilePicSmall?: Maybe<Scalars['String']['output']>;
  profileType?: Maybe<Scalars['String']['output']>;
  referenceProfileId?: Maybe<Scalars['ID']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  subregion?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type DeviceListResponse = {
  __typename?: 'DeviceListResponse';
  loginDeviceInfoList?: Maybe<Array<Maybe<DeviceInfo>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DmaItem = {
  __typename?: 'DmaItem';
  baseChannelId?: Maybe<Scalars['String']['output']>;
  callSign?: Maybe<Scalars['String']['output']>;
  callSignId?: Maybe<Scalars['String']['output']>;
  dma?: Maybe<Scalars['String']['output']>;
  dmaName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stationId?: Maybe<Scalars['String']['output']>;
  tokenDetails?: Maybe<DmaTokenDetails>;
};

export type DmaParams = {
  DEBUG: Scalars['String']['input'];
  billingVendor?: InputMaybe<Scalars['String']['input']>;
  getToken?: InputMaybe<Scalars['String']['input']>;
  isFPS60?: InputMaybe<Scalars['String']['input']>;
  isLTSEnabled: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mvpdId: Scalars['String']['input'];
  packageCode: Scalars['String']['input'];
  userProfileType: Scalars['String']['input'];
  userRegistrationCountry: Scalars['String']['input'];
  userState: Scalars['String']['input'];
  vendorCode?: InputMaybe<Scalars['String']['input']>;
};

export type DmaResponse = {
  __typename?: 'DmaResponse';
  debugInfo?: Maybe<DebugInfo>;
  dmas?: Maybe<Array<Maybe<DmaItem>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DmaTokenDetails = {
  __typename?: 'DmaTokenDetails';
  playback_url?: Maybe<Scalars['String']['output']>;
  syncBackAuth_url?: Maybe<Scalars['String']['output']>;
  syncBackToken?: Maybe<Scalars['String']['output']>;
  tokenExpirationTime?: Maybe<Scalars['Int']['output']>;
};

export type DownloadCountry = {
  __typename?: 'DownloadCountry';
  code?: Maybe<Scalars['String']['output']>;
  downloadable?: Maybe<Scalars['Boolean']['output']>;
};

export type DownloadCountrySet = {
  __typename?: 'DownloadCountrySet';
  code?: Maybe<Scalars['String']['output']>;
  downloadable?: Maybe<Scalars['Boolean']['output']>;
};

export type DrmSession = {
  __typename?: 'DrmSession';
  daiParams?: Maybe<Scalars['JSON']['output']>;
  ls_session?: Maybe<Scalars['String']['output']>;
  rulesMatched?: Maybe<Scalars['Boolean']['output']>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DynamicPlayResponse = {
  __typename?: 'DynamicPlayResponse';
  dynamicVideoModel?: Maybe<DynamicVideoModel>;
  success?: Maybe<Scalars['Boolean']['output']>;
  watchedAnEpisode?: Maybe<Scalars['Boolean']['output']>;
};

export type DynamicVideoModel = {
  __typename?: 'DynamicVideoModel';
  continuousPlaybackMode?: Maybe<Scalars['String']['output']>;
  currentListingsSize?: Maybe<Scalars['Int']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  listings?: Maybe<Array<LiveChannelListing>>;
  medTime?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<VideoModel>;
  playbackModeCTA?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Scalars['String']['output']>>;
  showAssets?: Maybe<ShowAssets>;
  showId: Scalars['Int']['output'];
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
  videoStartingPoint?: Maybe<Scalars['String']['output']>;
  watchedAnEpisode?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailCheckpointResponse = {
  __typename?: 'EmailCheckpointResponse';
  result: EmailCheckpointResult;
};

export enum EmailCheckpointResult {
  IdentityLinkedToTenant = 'IDENTITY_LINKED_TO_TENANT',
  IdentityNeedsActivation = 'IDENTITY_NEEDS_ACTIVATION',
  NotFound = 'NOT_FOUND'
}

export type Entitlement = {
  __typename?: 'Entitlement';
  addOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  multiPackageTracking?: Maybe<Scalars['String']['output']>;
  packageInfo?: Maybe<EntitlementPackageInfo>;
  productInfo?: Maybe<EntitlementProductInfo>;
};

export type EntitlementPackageInfo = {
  __typename?: 'EntitlementPackageInfo';
  adFree?: Maybe<Scalars['Boolean']['output']>;
  packageCode?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['Int']['output']>;
  packageSource?: Maybe<Scalars['String']['output']>;
  packageStatus?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  searchKey?: Maybe<Scalars['String']['output']>;
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorUserType?: Maybe<Scalars['String']['output']>;
};

export type EntitlementProductInfo = {
  __typename?: 'EntitlementProductInfo';
  billingCadence?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
};

export type Episode = {
  __typename?: 'Episode';
  /**
   * Raw upstream Pluto API item, surfaced uncurated for downstream consumers (Smart Tag, MOPS)
   * that need fields TN Web doesn't expose as first-class normalized fields. Mirrors the
   * channels passthrough doctrine in apps/video/src/components/SmartTagPlayer/utils/stitcherParams.ts.
   * Populated only on the episode whose contentId matches `fullEpisodes(apiRawContentId:)`;
   * null for every other episode in the list (avoids per-season SSR payload multiplier).
   */
  _apiRaw?: Maybe<Scalars['JSON']['output']>;
  airDateISO?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  episodeNum?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  isEpisodeless?: Maybe<Scalars['Boolean']['output']>;
  isSeasonless?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** Episode + show-level accessibility and format badges (e.g. closedCaption, audioDescription). */
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  regionalRating?: Maybe<RegionalRatings>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EpisodeData = {
  __typename?: 'EpisodeData';
  episodeAirDate: Scalars['DateTimeISO']['output'];
  episodeContentId: Scalars['String']['output'];
  episodeDescription: Scalars['String']['output'];
  episodeNumber: Scalars['Int']['output'];
  episodeTitle: Scalars['String']['output'];
  seasonNumber: Scalars['Int']['output'];
};

export type EpisodeResumeTime = {
  __typename?: 'EpisodeResumeTime';
  contentId: Scalars['String']['output'];
  resumeTime: Scalars['Int']['output'];
};

export type EpisodesApiResponse = {
  __typename?: 'EpisodesApiResponse';
  results?: Maybe<Array<Results>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FmsQueryParams = {
  billingVendor: Scalars['String']['input'];
  coppa?: InputMaybe<Scalars['String']['input']>;
  emailhash?: InputMaybe<Scalars['String']['input']>;
  fallbackUserId?: InputMaybe<Scalars['String']['input']>;
  googledai?: InputMaybe<Scalars['String']['input']>;
  idfv?: InputMaybe<Scalars['String']['input']>;
  ifa?: InputMaybe<Scalars['String']['input']>;
  ifatype?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  limitAdTracking?: InputMaybe<Scalars['String']['input']>;
  packageCode: Scalars['String']['input'];
  subscriberid?: InputMaybe<Scalars['String']['input']>;
  ua?: InputMaybe<Scalars['String']['input']>;
  userProfileType: Scalars['String']['input'];
  userRegistrationCountry: Scalars['String']['input'];
  userState: Scalars['String']['input'];
  webhost?: InputMaybe<Scalars['String']['input']>;
};

export type FmsResponse = {
  __typename?: 'FMSResponse';
  fmsResponse?: Maybe<FmsInfo>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Faq = {
  __typename?: 'Faq';
  ctaEvent?: Maybe<Scalars['String']['output']>;
  faqLinkTarget?: Maybe<Scalars['String']['output']>;
  faqLinkText?: Maybe<Scalars['String']['output']>;
  faqLinkUrl?: Maybe<Scalars['String']['output']>;
  faqQuestion?: Maybe<Scalars['String']['output']>;
  faqQuestionHide?: Maybe<Scalars['Boolean']['output']>;
};

export type FavoriteChannelItem = {
  __typename?: 'FavoriteChannelItem';
  channelName?: Maybe<Scalars['String']['output']>;
  currentListing?: Maybe<Array<Maybe<LiveChannelListing>>>;
  description?: Maybe<Scalars['String']['output']>;
  filePathFeaturedChannelImage?: Maybe<Scalars['String']['output']>;
  filePathLogo?: Maybe<Scalars['String']['output']>;
  filePathLogoSelected?: Maybe<Scalars['String']['output']>;
  filepathDefaultBackground?: Maybe<Scalars['String']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  originId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type FmsInfo = {
  __typename?: 'FmsInfo';
  fms_id_ttl?: Maybe<Scalars['Int']['output']>;
  fms_params?: Maybe<FmsParams>;
};

export type FmsParams = {
  __typename?: 'FmsParams';
  _fw_3P_UID?: Maybe<Scalars['String']['output']>;
  _fw_vcid2?: Maybe<Scalars['String']['output']>;
  fms_bididtype?: Maybe<Scalars['String']['output']>;
  fms_connectid?: Maybe<Scalars['String']['output']>;
  fms_emailhash?: Maybe<Scalars['String']['output']>;
  fms_hh_ramp_id?: Maybe<Scalars['String']['output']>;
  fms_ramp_envelope?: Maybe<Scalars['String']['output']>;
  fms_ramp_id?: Maybe<Scalars['String']['output']>;
  fms_ruleid?: Maybe<Scalars['String']['output']>;
  fms_subscriberid?: Maybe<Scalars['String']['output']>;
  fms_uid2?: Maybe<Scalars['String']['output']>;
  fms_userid?: Maybe<Scalars['String']['output']>;
  fms_vcid2type?: Maybe<Scalars['String']['output']>;
  imafw__fw_3P_UID?: Maybe<Scalars['String']['output']>;
  imafw__fw_vcid2?: Maybe<Scalars['String']['output']>;
  imafw_fms_bididtype?: Maybe<Scalars['String']['output']>;
  imafw_fms_emailhash?: Maybe<Scalars['String']['output']>;
  imafw_fms_hh_ramp_id?: Maybe<Scalars['String']['output']>;
  imafw_fms_ramp_id?: Maybe<Scalars['String']['output']>;
  imafw_fms_ruleid?: Maybe<Scalars['String']['output']>;
  imafw_fms_subscriberid?: Maybe<Scalars['String']['output']>;
  imafw_fms_userid?: Maybe<Scalars['String']['output']>;
  imafw_fms_vcid2type?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export enum FooterHubType {
  LiveTv = 'LIVE_TV',
  Movies = 'MOVIES',
  Shows = 'SHOWS'
}

export type FooterLink = {
  __typename?: 'FooterLink';
  href: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type FooterLinksData = {
  __typename?: 'FooterLinksData';
  hubType: FooterHubType;
  links: Array<FooterLink>;
};

export type FormRendezvousFields = {
  activationCode: Scalars['String']['input'];
  lookupOnly?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FormSignUpFields = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/**
 * A generic content section (e.g. originals, live TV, kids, devices).
 * Sorted by `position` ascending when rendered.
 */
export type FrontDoorBucket = {
  __typename?: 'FrontDoorBucket';
  backgroundDesktop?: Maybe<Scalars['String']['output']>;
  backgroundMobile?: Maybe<Scalars['String']['output']>;
  /** CMS prefix identifier (e.g. "originals", "live", "devices"). */
  bucketName: Scalars['String']['output'];
  ctaHide?: Maybe<Scalars['Boolean']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  logoDesktop?: Maybe<Scalars['String']['output']>;
  logoMobile?: Maybe<Scalars['String']['output']>;
  logos: Array<FrontDoorLogo>;
  /** CMS-driven display order (lower = higher on page). */
  position?: Maybe<Scalars['Int']['output']>;
  /** Sequential index across all rendered sections, used for scroll-tracking analytics. */
  rowHeaderPosition?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/**
 * Maps a CMS generic bucket (bucketName) to its carousel config, if any.
 * When the upstream source is unavailable in a region, carousel is null and the UI omits the row.
 */
export type FrontDoorBucketCarousel = {
  __typename?: 'FrontDoorBucketCarousel';
  /** CMS bucket identifier (e.g. custom, live, kids, favorites) */
  bucketName: Scalars['String']['output'];
  carousel?: Maybe<FrontDoorCarousel>;
};

export type FrontDoorCarousel = {
  __typename?: 'FrontDoorCarousel';
  /** Unique identifier for the carousel */
  carouselId: Scalars['String']['output'];
  /** Presentation style (e.g., 'default', '16x9_carousel', 'grid') */
  carouselPresentationStyle: Scalars['String']['output'];
  /** Type of carousel content */
  carouselType: Scalars['String']['output'];
  /** Whether to display the carousel title */
  displayTitle?: Maybe<Scalars['Boolean']['output']>;
  /** Optional link for the carousel */
  href?: Maybe<Scalars['String']['output']>;
  /** Whether to include API version in the request path */
  includeVersion?: Maybe<Scalars['Boolean']['output']>;
  /** Whether content highlight is enabled */
  isContentHighlightEnabled: Scalars['Boolean']['output'];
  /** Carousel model type (e.g., 'movie', 'show', 'channel') */
  model: Scalars['String']['output'];
  /** Tile orientation (e.g. landscape for On Now) */
  orientation?: Maybe<Scalars['String']['output']>;
  /** Position/order of the carousel on the page */
  position: Scalars['Int']['output'];
  /** Display title for the carousel */
  title: Scalars['String']['output'];
  /** Encrypted token containing API endpoint and params */
  token: Scalars['String']['output'];
};

/** Root type for all CMS-driven front door content sections. */
export type FrontDoorContentData = {
  __typename?: 'FrontDoorContentData';
  faqBucket?: Maybe<FrontDoorFaqBucket>;
  genericBuckets: Array<FrontDoorBucket>;
  header?: Maybe<FrontDoorHeader>;
  hero?: Maybe<FrontDoorHero>;
  /** Total number of rendered sections, used for scroll-tracking analytics. */
  rowHeaderTotal?: Maybe<Scalars['Int']['output']>;
};

/** Call-to-action button content. May appear on hero or FAQ sections. */
export type FrontDoorCta = {
  __typename?: 'FrontDoorCta';
  className?: Maybe<Scalars['String']['output']>;
  colorScheme?: Maybe<Scalars['String']['output']>;
  ctaEvent?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export type FrontDoorData = {
  __typename?: 'FrontDoorData';
  /** Per-bucket carousel assignments keyed by CMS bucketName */
  bucketCarousels: Array<FrontDoorBucketCarousel>;
  /** Locale code */
  locale?: Maybe<Scalars['String']['output']>;
  /** Region code */
  region?: Maybe<Scalars['String']['output']>;
  /** Indicates whether at least one bucket carousel was successfully fetched */
  success: Scalars['Boolean']['output'];
};

/**
 * FAQ / "It's On" section combining a CTA area with collapsible FAQ items.
 * Pluto's FAQ accordion is hardcoded client-side; this bucket carries the CMS
 * heading, background, and any future CMS-driven FAQ items.
 */
export type FrontDoorFaqBucket = {
  __typename?: 'FrontDoorFaqBucket';
  backgroundDesktop?: Maybe<Scalars['String']['output']>;
  backgroundMobile?: Maybe<Scalars['String']['output']>;
  bucketName: Scalars['String']['output'];
  ctas: Array<FrontDoorCta>;
  faqItems: Array<FrontDoorFaqItem>;
  heading?: Maybe<Scalars['String']['output']>;
  /** CMS-driven display order (lower = higher on page). */
  position?: Maybe<Scalars['Int']['output']>;
  /** Sequential index across all rendered sections, used for scroll-tracking analytics. */
  rowHeaderPosition?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Individual FAQ entry with an optional link. */
export type FrontDoorFaqItem = {
  __typename?: 'FrontDoorFaqItem';
  faqLinkTarget?: Maybe<Scalars['String']['output']>;
  faqLinkText?: Maybe<Scalars['String']['output']>;
  faqLinkUrl?: Maybe<Scalars['String']['output']>;
  faqQuestion: Scalars['String']['output'];
  faqQuestionHide?: Maybe<Scalars['Boolean']['output']>;
};

/** Top-of-page header bar content: sign-in link and optional promotional banner. */
export type FrontDoorHeader = {
  __typename?: 'FrontDoorHeader';
  bannerHide?: Maybe<Scalars['Boolean']['output']>;
  bannerText1?: Maybe<Scalars['String']['output']>;
  bannerText2?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  signInText?: Maybe<Scalars['String']['output']>;
  signInUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Hero section at the top of the front door page.
 * Contains the primary heading, background imagery, and call-to-action.
 */
export type FrontDoorHero = {
  __typename?: 'FrontDoorHero';
  backgroundDesktop?: Maybe<Scalars['String']['output']>;
  backgroundMobile?: Maybe<Scalars['String']['output']>;
  /**
   * Array of CTAs for the hero. Currently 0 or 1 entries;
   * modeled as a list for forward compatibility with secondary CTAs.
   */
  ctas: Array<FrontDoorCta>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoAlt?: Maybe<Scalars['String']['output']>;
  /** CMS-driven display order (lower = higher on page). */
  position?: Maybe<Scalars['Int']['output']>;
  /** Sequential index across all rendered sections, used for scroll-tracking analytics. */
  rowHeaderPosition?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Brand or partner logo displayed within a bucket section. */
export type FrontDoorLogo = {
  __typename?: 'FrontDoorLogo';
  alt?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FullEpisodesData = {
  __typename?: 'FullEpisodesData';
  /** Season numbers present for this show (from show-home), sorted ascending. */
  availableSeasonNums?: Maybe<Array<Scalars['String']['output']>>;
  episodes?: Maybe<Array<Episode>>;
  /**
   * Derived server-side from upstream sectionItems.itemCount (season total).
   * When itemCount is absent, true when this batch returned a full page (50 rows).
   */
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type FullUser = {
  __typename?: 'FullUser';
  accountProfiles?: Maybe<Array<Maybe<UserProfile>>>;
  activeProfile?: Maybe<UserProfile>;
  adsRegion?: Maybe<Scalars['String']['output']>;
  ageGroup?: Maybe<Scalars['Int']['output']>;
  allRatings?: Maybe<Scalars['String']['output']>;
  bundleStatusTracking?: Maybe<Scalars['String']['output']>;
  cbsPackageInfo?: Maybe<Array<Maybe<PackageInfo>>>;
  email?: Maybe<Scalars['String']['output']>;
  entitlement?: Maybe<Entitlement>;
  gender?: Maybe<Scalars['String']['output']>;
  isLoggedIn?: Maybe<Scalars['Boolean']['output']>;
  kidsProfileButton?: Maybe<Scalars['Boolean']['output']>;
  nflLTSOptIn?: Maybe<Scalars['Boolean']['output']>;
  nflLTSOptInTime?: Maybe<Scalars['Float']['output']>;
  optIn?: Maybe<Scalars['Boolean']['output']>;
  packageStatusTracking?: Maybe<Scalars['String']['output']>;
  paramountStreamingId?: Maybe<Scalars['String']['output']>;
  parentalControl?: Maybe<Scalars['Boolean']['output']>;
  parentalControlLivetvPinEnabled?: Maybe<Scalars['Boolean']['output']>;
  parentalControlPIN?: Maybe<Scalars['String']['output']>;
  parentalControlRestrictions?: Maybe<Scalars['String']['output']>;
  ppid?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  requirePinSwitchProfileEnabled?: Maybe<Scalars['Boolean']['output']>;
  sha256EmailHash?: Maybe<Scalars['String']['output']>;
  sl?: Maybe<Scalars['String']['output']>;
  userRegistrationCountry?: Maybe<Scalars['String']['output']>;
  userStatus?: Maybe<FullUserStatus>;
};

export type FullUserStatus = {
  __typename?: 'FullUserStatus';
  description?: Maybe<Scalars['String']['output']>;
};

export type GameListingParams = {
  addOns?: InputMaybe<Scalars['String']['input']>;
  dma?: InputMaybe<Scalars['Int']['input']>;
  isPreviewMode?: InputMaybe<Scalars['Boolean']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
};

export type Genre = {
  __typename?: 'Genre';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type GlobalMenu = {
  __typename?: 'GlobalMenu';
  footerNav: Array<NavItem>;
  movieBrowseNav?: Maybe<Array<NavItem>>;
  showBrowseNav?: Maybe<Array<NavItem>>;
  topNav: Array<NavItem>;
};

export type GlobalMenuData = {
  __typename?: 'GlobalMenuData';
  footer?: Maybe<Array<GlobalMenuFooterSection>>;
  hub_browse?: Maybe<Array<GlobalMenuItem>>;
  movie_browse?: Maybe<Array<GlobalMenuItem>>;
  pre_search?: Maybe<Array<GlobalMenuItem>>;
  show_browse?: Maybe<Array<GlobalMenuItem>>;
  top_nav?: Maybe<Array<GlobalMenuItem>>;
};

export type GlobalMenuFooterSection = {
  __typename?: 'GlobalMenuFooterSection';
  globalMenu?: Maybe<Array<GlobalMenuItem>>;
  global_menu_link?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  link_type?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GlobalMenuItem = {
  __typename?: 'GlobalMenuItem';
  global_menu_link?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  link_type?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Hero = {
  __typename?: 'Hero';
  contentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  landscapeSrcSet?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  logoImage?: Maybe<Scalars['String']['output']>;
  portraitSrcSet?: Maybe<Scalars['String']['output']>;
  standardRegularImage?: Maybe<Scalars['String']['output']>;
  streamType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HeroApiInfo = {
  apiBaseUrl: Scalars['String']['input'];
};

export type HeroApiResponse = {
  __typename?: 'HeroApiResponse';
  hero: Array<Hero>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum HeroType {
  Live = 'LIVE',
  Movie = 'MOVIE',
  Show = 'SHOW'
}

export type History = {
  __typename?: 'History';
  canModel: CanModel;
  contentId: Scalars['String']['output'];
  contentTitle: Scalars['String']['output'];
  hasWatched: Scalars['Boolean']['output'];
  medTime: Scalars['Int']['output'];
  timestamp: Scalars['Int']['output'];
  unifiedGenre: Array<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type HistoryApiResponse = {
  __typename?: 'HistoryApiResponse';
  count?: Maybe<Scalars['Int']['output']>;
  history: Array<History>;
  rows?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  totalCountInHistory?: Maybe<Scalars['Int']['output']>;
};

export type HomeConfig = {
  __typename?: 'HomeConfig';
  config: Array<Config>;
  hash?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['String']['output']>;
  skipped?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type HomeParams = {
  _clientRegion?: InputMaybe<Scalars['String']['input']>;
  billingVendor?: InputMaybe<Scalars['String']['input']>;
  dma?: InputMaybe<Scalars['Int']['input']>;
  excludeConfig?: InputMaybe<Scalars['Int']['input']>;
  isDynamic?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maxCarouselItems?: InputMaybe<Scalars['String']['input']>;
  minCarouselItems?: InputMaybe<Scalars['String']['input']>;
  minProximity?: InputMaybe<Scalars['Int']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  stationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileType?: InputMaybe<Scalars['String']['input']>;
  userRegistrationCountry?: InputMaybe<Scalars['String']['input']>;
  userState?: InputMaybe<Scalars['String']['input']>;
};

export type HreflangConfigObj = {
  __typename?: 'HreflangConfigObj';
  countryCode?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
};

export type Hub = {
  __typename?: 'Hub';
  hubId?: Maybe<Scalars['Int']['output']>;
  hubItems: Array<HubItem>;
  hubSlug?: Maybe<Scalars['String']['output']>;
  liveOnDate?: Maybe<Scalars['Int']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  pageType?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userState?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HubCarouselItem = CarouselItem & {
  __typename?: 'HubCarouselItem';
  contentType?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isContentHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbLandscape?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type HubItem = {
  __typename?: 'HubItem';
  carouselPresentationStyle?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  entityUrl?: Maybe<Scalars['String']['output']>;
  isContentHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type HubMarquee = {
  __typename?: 'HubMarquee';
  amazonBuyLink?: Maybe<Scalars['String']['output']>;
  autorotate?: Maybe<Scalars['Int']['output']>;
  changedDate?: Maybe<Scalars['Float']['output']>;
  configType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Float']['output']>;
  deviceAppId?: Maybe<Scalars['String']['output']>;
  deviceAppSecret?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itunesBuyLink?: Maybe<Scalars['String']['output']>;
  k?: Maybe<Scalars['String']['output']>;
  liveDate?: Maybe<Scalars['Float']['output']>;
  profileSlugs?: Maybe<Array<Scalars['String']['output']>>;
  region?: Maybe<Scalars['String']['output']>;
  showId?: Maybe<Scalars['Int']['output']>;
  slideNids?: Maybe<Array<Scalars['Int']['output']>>;
  slides: Array<HubMarqueeSlide>;
  title?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeTextField?: Maybe<Array<Scalars['String']['output']>>;
  variant?: Maybe<Scalars['String']['output']>;
  vuduBuyLink?: Maybe<Scalars['String']['output']>;
};

export type HubMarqueeSlide = {
  __typename?: 'HubMarqueeSlide';
  allLocales?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allSubregions?: Maybe<Scalars['String']['output']>;
  altTag?: Maybe<Scalars['String']['output']>;
  amazonBuyLink?: Maybe<Scalars['String']['output']>;
  appsActionUrl?: Maybe<Scalars['String']['output']>;
  appsSlideCopy?: Maybe<Scalars['String']['output']>;
  appsTarget?: Maybe<Scalars['String']['output']>;
  billingVendorList?: Maybe<Scalars['String']['output']>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  changedDate?: Maybe<Scalars['Float']['output']>;
  classicTrailerContentId?: Maybe<Scalars['String']['output']>;
  copy?: Maybe<Scalars['String']['output']>;
  copyTitle?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  entitlementCodes?: Maybe<Array<Scalars['String']['output']>>;
  episodeTitle1?: Maybe<Scalars['String']['output']>;
  episodeTitle2?: Maybe<Scalars['String']['output']>;
  filepath?: Maybe<Scalars['String']['output']>;
  filepathHeroLandscape?: Maybe<Scalars['String']['output']>;
  filepathHeroPortrait?: Maybe<Scalars['String']['output']>;
  filepathPartnerBrandLogo?: Maybe<Scalars['String']['output']>;
  filepathPoster?: Maybe<Scalars['String']['output']>;
  filepathSlideCompact?: Maybe<Scalars['String']['output']>;
  filepathSlideRegular?: Maybe<Scalars['String']['output']>;
  filepathTitleLogo?: Maybe<Scalars['String']['output']>;
  filepathTitleLogoCompact?: Maybe<Scalars['String']['output']>;
  filepathTitleLogoRegular?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isUpsell: Scalars['Boolean']['output'];
  itunesBuyLink?: Maybe<Scalars['String']['output']>;
  k?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  movie?: Maybe<MovieItem>;
  movieId?: Maybe<Scalars['Int']['output']>;
  platformType?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondarySlideActionTitle?: Maybe<Scalars['String']['output']>;
  secondarySlideActionUrl?: Maybe<Scalars['String']['output']>;
  show?: Maybe<ShowItem>;
  showId?: Maybe<Scalars['Int']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  slideActionTitle?: Maybe<Scalars['String']['output']>;
  slideActionUrl?: Maybe<Scalars['String']['output']>;
  slideActionUrlType?: Maybe<Scalars['String']['output']>;
  slideContentId?: Maybe<Scalars['String']['output']>;
  slideTitle1?: Maybe<Scalars['String']['output']>;
  slideTitle2?: Maybe<Scalars['String']['output']>;
  slideWeight?: Maybe<Scalars['Int']['output']>;
  subregion?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tuneInTimeOverride?: Maybe<Scalars['String']['output']>;
  tuneInTimeOverride2?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeTextField?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  upsell: Scalars['Boolean']['output'];
  userState?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
  vuduBuyLink?: Maybe<Scalars['String']['output']>;
};

export type IdentityLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type IdentityLoginResponse = {
  __typename?: 'IdentityLoginResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type IdentityRegisterFieldError = {
  __typename?: 'IdentityRegisterFieldError';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Expected failures come back in the payload: the error-sanitization plugin rewrites thrown errors in prod. */
export type IdentityRegisterResponse = {
  __typename?: 'IdentityRegisterResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<IdentityRegisterFieldError>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type IngestCommunityFeedbackInput = {
  feedbackType: Scalars['String']['input'];
  input: Scalars['String']['input'];
  targetId: Scalars['String']['input'];
  targetType: Scalars['String']['input'];
};

export type InputDeviceInfo = {
  city?: InputMaybe<Scalars['String']['input']>;
  cookieHash?: InputMaybe<Scalars['String']['input']>;
  deviceDescription?: InputMaybe<Scalars['String']['input']>;
  ecid?: InputMaybe<Scalars['String']['input']>;
  isCurrentDevice?: InputMaybe<Scalars['Boolean']['input']>;
  isMasterProfile?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lastLoginMillis?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  profilePic?: InputMaybe<Scalars['String']['input']>;
  profilePicPath?: InputMaybe<Scalars['String']['input']>;
  profilePicSmall?: InputMaybe<Scalars['String']['input']>;
  profileType?: InputMaybe<Scalars['String']['input']>;
  referenceProfileId?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  subregion?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ItemList = {
  __typename?: 'ItemList';
  _airDate?: Maybe<Scalars['String']['output']>;
  _airDateISO?: Maybe<Scalars['String']['output']>;
  _editDate?: Maybe<Scalars['String']['output']>;
  _expirationDate?: Maybe<Scalars['String']['output']>;
  _firstIngestDate?: Maybe<Scalars['String']['output']>;
  _ingestDate?: Maybe<Scalars['String']['output']>;
  _lastModifiedDate?: Maybe<Scalars['String']['output']>;
  _pubDate?: Maybe<Scalars['String']['output']>;
  _pubDateISO?: Maybe<Scalars['String']['output']>;
  about?: Maybe<Scalars['String']['output']>;
  addOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  airDate?: Maybe<Scalars['Float']['output']>;
  amazonESTURL?: Maybe<Scalars['String']['output']>;
  appleWatchListShowKey?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<Scalars['String']['output']>;
  availableForProfileTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availableVideoSeasons?: Maybe<Array<Maybe<AvailableVideoSeasons>>>;
  brand?: Maybe<Scalars['String']['output']>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  category?: Maybe<Scalars['String']['output']>;
  cbsShowId?: Maybe<Scalars['Int']['output']>;
  childContentId?: Maybe<Scalars['String']['output']>;
  closedCaptionUrl?: Maybe<Scalars['String']['output']>;
  cmsAccountId?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  downloadCountrySet?: Maybe<Array<Maybe<DownloadCountrySet>>>;
  duration?: Maybe<Scalars['Int']['output']>;
  editDate?: Maybe<Scalars['String']['output']>;
  embeddable?: Maybe<Scalars['String']['output']>;
  endCreditsChapterTime?: Maybe<Scalars['String']['output']>;
  episodeNum?: Maybe<Scalars['String']['output']>;
  excludeNielsenTracking?: Maybe<Scalars['Boolean']['output']>;
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstIngestDate?: Maybe<Scalars['String']['output']>;
  fullEpisode?: Maybe<Scalars['Boolean']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  ingestDate?: Maybe<Scalars['String']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isProductPlacement?: Maybe<Scalars['Boolean']['output']>;
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  itunesESTURL?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['String']['output']>;
  mediaAvailableDate?: Maybe<Scalars['String']['output']>;
  mediaAvailableDateEpoch?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  movieAssets?: Maybe<MovieAssets>;
  movieTitle?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  playbackEvents?: Maybe<PlaybackEvents>;
  playerLocUrl?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryCategory?: Maybe<Scalars['String']['output']>;
  primaryCategoryName?: Maybe<Scalars['String']['output']>;
  pubDate?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  regionalAudioExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  regionalRatings?: Maybe<Array<Maybe<RegionalRatings>>>;
  regionalTextExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showAbout?: Maybe<Scalars['String']['output']>;
  showAssets?: Maybe<ShowAssets>;
  showId?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  showPremiereDateStr?: Maybe<Scalars['String']['output']>;
  showSlug?: Maybe<Scalars['String']['output']>;
  showTitle?: Maybe<Scalars['String']['output']>;
  sizzleId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  subscriptionLevel?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailSet?: Maybe<Array<Maybe<ThumbnailSet>>>;
  thumbnailSheetSet?: Maybe<Array<Maybe<ThumbnailSheetSet>>>;
  title?: Maybe<Scalars['String']['output']>;
  tmsprogramID?: Maybe<Scalars['String']['output']>;
  tmsseriesID?: Maybe<Scalars['String']['output']>;
  topLevelCategory?: Maybe<Scalars['String']['output']>;
  trailerContentId?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  url?: Maybe<Scalars['String']['output']>;
  vTag?: Maybe<Scalars['String']['output']>;
  videoPageUrl?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
  videoProperties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type KeepWatchingItem = {
  __typename?: 'KeepWatchingItem';
  contentId: Scalars['String']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  currentEpisodeCANModel?: Maybe<CanModel>;
  entitlementCodes?: Maybe<Array<Scalars['String']['output']>>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS: Scalars['Boolean']['output'];
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isMovieAvailable: Scalars['Boolean']['output'];
  medTime?: Maybe<Scalars['Int']['output']>;
  movieAssets?: Maybe<MovieAssets>;
  movieId: Scalars['String']['output'];
  movieTitle?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Scalars['String']['output']>>;
  showAssets?: Maybe<ShowAssets>;
  showId: Scalars['String']['output'];
  showPath?: Maybe<Scalars['String']['output']>;
  showTitle?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  url?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type ListingData = {
  __typename?: 'ListingData';
  durationMins?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  gameEndTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  gameStartTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  isListingLive: Scalars['Boolean']['output'];
  isVodAvailable: Scalars['Boolean']['output'];
  linkedId?: Maybe<Scalars['String']['output']>;
  linkedType?: Maybe<Scalars['String']['output']>;
  listingContentId?: Maybe<Scalars['String']['output']>;
  listingId?: Maybe<Scalars['String']['output']>;
  listingTitle?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  streamEndTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  streamStartTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  streamType?: Maybe<Scalars['String']['output']>;
};

export type ListingNormalizedResponse = {
  __typename?: 'ListingNormalizedResponse';
  listing?: Maybe<ChannelListingNormalized>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ListingParams = {
  billingVendor?: InputMaybe<Scalars['String']['input']>;
  dma?: InputMaybe<Scalars['Int']['input']>;
  edgeCacheKey?: InputMaybe<Scalars['String']['input']>;
  isPreviewMode?: InputMaybe<Scalars['Boolean']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  stationId?: InputMaybe<Scalars['String']['input']>;
  userProfileType?: InputMaybe<Scalars['String']['input']>;
  userRegistrationCountry?: InputMaybe<Scalars['String']['input']>;
  userState?: InputMaybe<Scalars['String']['input']>;
};

export type ListingsResponse = {
  __typename?: 'ListingsResponse';
  channel?: Maybe<Array<Maybe<Channel>>>;
  listing?: Maybe<Array<Maybe<ChannelListing>>>;
  previousListings?: Maybe<Array<Maybe<ChannelListing>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LiveCarouselApiResponse = {
  __typename?: 'LiveCarouselApiResponse';
  channel: LiveChannel;
  displayShowTitle?: Maybe<Scalars['Boolean']['output']>;
  filePathLogo?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LiveCarouselItem = CarouselItem & CommonContentFields & {
  __typename?: 'LiveCarouselItem';
  addOns?: Maybe<Scalars['String']['output']>;
  airDate?: Maybe<Scalars['String']['output']>;
  airDateISO?: Maybe<Scalars['String']['output']>;
  badgeLabel?: Maybe<Scalars['String']['output']>;
  bundleLocked?: Maybe<Scalars['Boolean']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  channelName?: Maybe<Scalars['String']['output']>;
  channelOriginId?: Maybe<Scalars['String']['output']>;
  channelSlug?: Maybe<Scalars['String']['output']>;
  cmsId?: Maybe<Scalars['String']['output']>;
  contentCANVideo?: Maybe<CanModel>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  ctaActionType?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  durationMins?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['String']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  filePathLogoSelected?: Maybe<Scalars['String']['output']>;
  gameEndTimestamp?: Maybe<Scalars['Float']['output']>;
  gameStartTimestamp?: Maybe<Scalars['Float']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<Scalars['String']['output']>;
  heroCompact?: Maybe<Scalars['String']['output']>;
  highlightImage?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isChannelLocked?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isContentHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEpisodeLess?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isOnNow?: Maybe<Scalars['Boolean']['output']>;
  isSeasonLess?: Maybe<Scalars['Boolean']['output']>;
  isVodAvailable: Scalars['Boolean']['output'];
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoCenter?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  numericLabel?: Maybe<Scalars['Int']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  progressText?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingBadge?: Maybe<Scalars['String']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  runtime?: Maybe<Scalars['Int']['output']>;
  scheduleBadgeText?: Maybe<Scalars['String']['output']>;
  showId?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  startTimeFormatted?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['String']['output']>;
  streamEndTimestamp?: Maybe<Scalars['Float']['output']>;
  streamStartTimeFormatted?: Maybe<Scalars['String']['output']>;
  streamStartTimestamp?: Maybe<Scalars['Float']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbLandscape?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type LiveChannel = {
  __typename?: 'LiveChannel';
  brand?: Maybe<Brand>;
  cbsPackages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channelCategorySlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channelName?: Maybe<Scalars['String']['output']>;
  channelTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  city?: Maybe<Scalars['String']['output']>;
  currentListing?: Maybe<Array<Maybe<LiveChannelListing>>>;
  description?: Maybe<Scalars['String']['output']>;
  displayMetadata?: Maybe<Scalars['Boolean']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  dma?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  entitlementCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePathFeaturedChannelImage?: Maybe<Scalars['String']['output']>;
  filePathLogo?: Maybe<Scalars['String']['output']>;
  filePathLogoSelected?: Maybe<Scalars['String']['output']>;
  filePathSmallLogo?: Maybe<Scalars['String']['output']>;
  filePathSmallLogoSelected?: Maybe<Scalars['String']['output']>;
  filepathDefaultBackground?: Maybe<Scalars['String']['output']>;
  filepathFallbackImage?: Maybe<Scalars['String']['output']>;
  filepathLiveEndCardImage?: Maybe<Scalars['String']['output']>;
  filepathPromoThumbnail?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<Scalars['String']['output']>;
  heroCompact?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isLTSEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMultiCam?: Maybe<Scalars['Boolean']['output']>;
  isOptinRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  local?: Maybe<Scalars['Boolean']['output']>;
  logoCenter?: Maybe<Scalars['String']['output']>;
  originId?: Maybe<Scalars['Int']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  prgSvcId?: Maybe<Scalars['Int']['output']>;
  promoContentId?: Maybe<Scalars['Int']['output']>;
  promoContentType?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streamType?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  totalNumberOfCurrentListings?: Maybe<Scalars['Int']['output']>;
  totalNumberOfUpcomingListings?: Maybe<Scalars['Int']['output']>;
  upcomingListing?: Maybe<Array<Maybe<LiveChannelListing>>>;
  videoContentId?: Maybe<Scalars['String']['output']>;
};

export type LiveChannelListing = {
  __typename?: 'LiveChannelListing';
  addOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  associatedContentVideo?: Maybe<AssociatedContentVideo>;
  channelName?: Maybe<Scalars['String']['output']>;
  channelSlug?: Maybe<Scalars['String']['output']>;
  contentCANVideo?: Maybe<CanModel>;
  description?: Maybe<Scalars['String']['output']>;
  durationMins?: Maybe<Scalars['Int']['output']>;
  endTimeFormatted?: Maybe<Scalars['String']['output']>;
  endTimestamp?: Maybe<Scalars['Float']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  filePathLogo?: Maybe<Scalars['String']['output']>;
  filePathLogoSelected?: Maybe<Scalars['String']['output']>;
  filePathThumb?: Maybe<Scalars['String']['output']>;
  filepathPageHeader?: Maybe<Scalars['String']['output']>;
  gameEndTimestamp?: Maybe<Scalars['Float']['output']>;
  gameStartTimestamp?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isListingLive?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seasonNumber?: Maybe<Scalars['Int']['output']>;
  showId?: Maybe<Scalars['String']['output']>;
  startTimeFormatted?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['Float']['output']>;
  streamEndTimeFormatted?: Maybe<Scalars['String']['output']>;
  streamEndTimestamp?: Maybe<Scalars['Float']['output']>;
  streamStartTimeFormatted?: Maybe<Scalars['String']['output']>;
  streamStartTimestamp?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoContentId?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type LiveDetailHero = DetailHero & {
  __typename?: 'LiveDetailHero';
  airDate?: Maybe<Scalars['Float']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  brandUrl?: Maybe<Scalars['String']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  cast?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  detailCta?: Maybe<DetailCta>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['Float']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  heroType?: Maybe<HeroType>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  listingDescription?: Maybe<Scalars['String']['output']>;
  listingTitle?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  progress?: Maybe<Scalars['Int']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  srcSetLandscape?: Maybe<Scalars['String']['output']>;
  srcSetPortrait?: Maybe<Scalars['String']['output']>;
  standardImgForAllScreens?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type LiveEvent = {
  __typename?: 'LiveEvent';
  channelName?: Maybe<Scalars['String']['output']>;
  /** Numeric/string id used for live TV channel playback URLs (hash target). */
  channelOriginId?: Maybe<Scalars['String']['output']>;
  channelSlug?: Maybe<Scalars['String']['output']>;
  durationMins?: Maybe<Scalars['String']['output']>;
  endTimeFormatted?: Maybe<Scalars['String']['output']>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  fallbackEnabled?: Maybe<Scalars['Boolean']['output']>;
  fallbackStreamType?: Maybe<Scalars['String']['output']>;
  fallbackVideoContentId?: Maybe<Scalars['String']['output']>;
  filePathLogoSelected?: Maybe<Scalars['String']['output']>;
  filePathThumb?: Maybe<Scalars['String']['output']>;
  filepathFallbackImage?: Maybe<Scalars['String']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isListingLive?: Maybe<Scalars['Boolean']['output']>;
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  listingId?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingIcon?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seasonNumber?: Maybe<Scalars['Int']['output']>;
  showId?: Maybe<Scalars['String']['output']>;
  startTimeFormatted?: Maybe<Scalars['String']['output']>;
  stationCode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoContentId?: Maybe<Scalars['String']['output']>;
};

export type LiveItem = {
  __typename?: 'LiveItem';
  badgeLabel?: Maybe<Scalars['String']['output']>;
  brandSlug: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  channelSlug: Scalars['String']['output'];
  contentCANVideo?: Maybe<CanModel>;
  contentType?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  durationMins: Scalars['Int']['output'];
  endTimestamp: Scalars['Float']['output'];
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  filePathLogoSelected: Scalars['String']['output'];
  filePathThumb: Scalars['String']['output'];
  gameEndTimestamp?: Maybe<Scalars['Float']['output']>;
  gameStartTimestamp?: Maybe<Scalars['Float']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS: Scalars['Boolean']['output'];
  isContentHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEpisodeLess?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isListingLive: Scalars['Boolean']['output'];
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isSeasonLess?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  numericLabel?: Maybe<Scalars['Int']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  progressText?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  runtime?: Maybe<Scalars['Int']['output']>;
  scheduleBadgeText?: Maybe<Scalars['String']['output']>;
  seasonNumber?: Maybe<Scalars['Int']['output']>;
  showId: Scalars['String']['output'];
  showPath?: Maybe<Scalars['String']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  startTimeFormatted?: Maybe<Scalars['String']['output']>;
  startTimestamp: Scalars['Float']['output'];
  streamEndTimeFormatted?: Maybe<Scalars['String']['output']>;
  streamEndTimestamp?: Maybe<Scalars['Float']['output']>;
  streamStartTimeFormatted?: Maybe<Scalars['String']['output']>;
  streamStartTimestamp?: Maybe<Scalars['Float']['output']>;
  streamTimeFormatted?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbLandscape?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
};

export type LiveShowCarouselItem = CarouselItem & CommonContentFields & {
  __typename?: 'LiveShowCarouselItem';
  addOns?: Maybe<Scalars['String']['output']>;
  airDate?: Maybe<Scalars['String']['output']>;
  airDateISO?: Maybe<Scalars['String']['output']>;
  badgeLabel?: Maybe<Scalars['String']['output']>;
  bundleLocked?: Maybe<Scalars['Boolean']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  channelName?: Maybe<Scalars['String']['output']>;
  channelOriginId?: Maybe<Scalars['String']['output']>;
  channelSlug?: Maybe<Scalars['String']['output']>;
  contentCANVideo?: Maybe<CanModel>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  ctaActionType?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  durationMins?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['String']['output']>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  filePathLogoSelected?: Maybe<Scalars['String']['output']>;
  gameEndTimestamp?: Maybe<Scalars['Float']['output']>;
  gameStartTimestamp?: Maybe<Scalars['Float']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  highlightImage?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isChannelLocked?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isContentHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEpisodeLess?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isOnNow?: Maybe<Scalars['Boolean']['output']>;
  isSeasonLess?: Maybe<Scalars['Boolean']['output']>;
  isVodAvailable: Scalars['Boolean']['output'];
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  listingContentId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoCenter?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  numericLabel?: Maybe<Scalars['Int']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  progressText?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingBadge?: Maybe<Scalars['String']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  runtime?: Maybe<Scalars['Int']['output']>;
  scheduleBadgeText?: Maybe<Scalars['String']['output']>;
  seasonNumber?: Maybe<Scalars['Int']['output']>;
  showId?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  startTimeFormatted?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['String']['output']>;
  streamEndTimestamp?: Maybe<Scalars['Float']['output']>;
  streamStartTimeFormatted?: Maybe<Scalars['String']['output']>;
  streamStartTimestamp?: Maybe<Scalars['Float']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbLandscape?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type LocalPlaybackParams = {
  DEBUG: Scalars['String']['input'];
  billingVendor?: InputMaybe<Scalars['String']['input']>;
  dma: Scalars['String']['input'];
  isLTSEnabled: Scalars['String']['input'];
  mvpdId: Scalars['String']['input'];
  packageCode: Scalars['String']['input'];
  userProfileType: Scalars['String']['input'];
  userRegistrationCountry: Scalars['String']['input'];
  userState: Scalars['String']['input'];
  vendorCode?: InputMaybe<Scalars['String']['input']>;
};

export type LocalStation = {
  __typename?: 'LocalStation';
  callSignId: Scalars['String']['output'];
};

export type LogOutResponse = {
  __typename?: 'LogOutResponse';
  errors?: Maybe<Scalars['String']['output']>;
  isLoggedIn?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ManageDevicesPageAttribute = {
  __typename?: 'ManageDevicesPageAttribute';
  web_manage_devices_active_subheader1: Scalars['String']['output'];
  web_manage_devices_active_subheader2: Scalars['String']['output'];
  web_manage_devices_handheld: Scalars['String']['output'];
  web_manage_devices_header: Scalars['String']['output'];
  web_manage_devices_ott: Scalars['String']['output'];
  web_manage_devices_subheader1: Scalars['String']['output'];
  web_manage_devices_subheader2: Scalars['String']['output'];
};

export type MarqueeApiInfo = {
  apiBaseUrl: Scalars['String']['input'];
};

export type MarqueeApiResponse = {
  __typename?: 'MarqueeApiResponse';
  hubMarquee?: Maybe<HubMarquee>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MarqueeContent = {
  __typename?: 'MarqueeContent';
  data: Array<CarouselItem>;
  id?: Maybe<Scalars['String']['output']>;
};

export type MarqueeItem = {
  __typename?: 'MarqueeItem';
  amazonBuyLink?: Maybe<Scalars['String']['output']>;
  autorotate?: Maybe<Scalars['Int']['output']>;
  changedDate?: Maybe<Scalars['Float']['output']>;
  configType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Float']['output']>;
  deviceAppId?: Maybe<Scalars['String']['output']>;
  deviceAppSecret?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  itunesBuyLink?: Maybe<Scalars['String']['output']>;
  k?: Maybe<Scalars['String']['output']>;
  liveDate?: Maybe<Scalars['Float']['output']>;
  profileSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  region?: Maybe<Scalars['String']['output']>;
  showId?: Maybe<Scalars['Int']['output']>;
  slideNids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  slides?: Maybe<Array<HubMarqueeSlide>>;
  title?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeTextField?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
  vuduBuyLink?: Maybe<Scalars['String']['output']>;
};

export type MarqueeMovieAssets = {
  __typename?: 'MarqueeMovieAssets';
  filepathBrandLogo?: Maybe<Scalars['String']['output']>;
  filepathMovieHero?: Maybe<Scalars['String']['output']>;
  filepathMovieHeroCompact?: Maybe<Scalars['String']['output']>;
  filepathMovieHeroRegular?: Maybe<Scalars['String']['output']>;
  filepathMovieKeepWatching?: Maybe<Scalars['String']['output']>;
  filepathMovieLogo?: Maybe<Scalars['String']['output']>;
  filepathMoviePoster?: Maybe<Scalars['String']['output']>;
  filepathTitleLogoCompact?: Maybe<Scalars['String']['output']>;
  filepathTitleLogoLeft?: Maybe<Scalars['String']['output']>;
  filepathTitleLogoRegular?: Maybe<Scalars['String']['output']>;
};

export type MarqueeShowAssets = {
  __typename?: 'MarqueeShowAssets';
  filepathPartnerBrandLogo?: Maybe<Scalars['String']['output']>;
  filepathShowBrowsePoster?: Maybe<Scalars['String']['output']>;
  filepathShowHeroCompact?: Maybe<Scalars['String']['output']>;
  filepathShowHeroRegular?: Maybe<Scalars['String']['output']>;
  filepathShowPageHeader?: Maybe<Scalars['String']['output']>;
  filepathTitleLogoCenter?: Maybe<Scalars['String']['output']>;
  filepathTitleLogoLeft?: Maybe<Scalars['String']['output']>;
  filepathTitleLogoRegular?: Maybe<Scalars['String']['output']>;
  filepathVideoEndcardShowImage?: Maybe<Scalars['String']['output']>;
};

export type MarqueeSlide = {
  __typename?: 'MarqueeSlide';
  allSubregions?: Maybe<Scalars['String']['output']>;
  all_locales?: Maybe<Array<Scalars['String']['output']>>;
  alt_tag?: Maybe<Scalars['String']['output']>;
  amazon_buy_link?: Maybe<Scalars['String']['output']>;
  apps_action_url?: Maybe<Scalars['String']['output']>;
  apps_slide_copy?: Maybe<Scalars['String']['output']>;
  apps_target?: Maybe<Scalars['String']['output']>;
  billingVendorList?: Maybe<Scalars['String']['output']>;
  brand_slug?: Maybe<Scalars['String']['output']>;
  changed_date?: Maybe<Scalars['Float']['output']>;
  classic_trailer_content_id?: Maybe<Scalars['String']['output']>;
  copy?: Maybe<Scalars['String']['output']>;
  copy_title?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  entitlement_codes?: Maybe<Array<Scalars['String']['output']>>;
  episode_title_1?: Maybe<Scalars['String']['output']>;
  episode_title_2?: Maybe<Scalars['String']['output']>;
  filepath?: Maybe<Scalars['String']['output']>;
  filepathPoster?: Maybe<Scalars['String']['output']>;
  filepath_hero_landscape?: Maybe<Scalars['String']['output']>;
  filepath_hero_portrait?: Maybe<Scalars['String']['output']>;
  filepath_partner_brand_logo?: Maybe<Scalars['String']['output']>;
  filepath_slide_compact?: Maybe<Scalars['String']['output']>;
  filepath_slide_regular?: Maybe<Scalars['String']['output']>;
  filepath_title_logo?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_compact?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_regular?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isUpsell: Scalars['Boolean']['output'];
  itunes_buy_link?: Maybe<Scalars['String']['output']>;
  k?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  movie?: Maybe<Scalars['String']['output']>;
  movie_id?: Maybe<Scalars['String']['output']>;
  platform_type?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondary_slide_action_title?: Maybe<Scalars['String']['output']>;
  secondary_slide_action_url?: Maybe<Scalars['String']['output']>;
  show?: Maybe<Scalars['String']['output']>;
  show_id?: Maybe<Scalars['String']['output']>;
  sizzle_content_id?: Maybe<Scalars['String']['output']>;
  slide_action_title?: Maybe<Scalars['String']['output']>;
  slide_action_url?: Maybe<Scalars['String']['output']>;
  slide_action_url_type?: Maybe<Scalars['String']['output']>;
  slide_content_id?: Maybe<Scalars['String']['output']>;
  slide_title_1?: Maybe<Scalars['String']['output']>;
  slide_title_2?: Maybe<Scalars['String']['output']>;
  slide_weight?: Maybe<Scalars['Int']['output']>;
  subregion?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tune_in_time_override?: Maybe<Scalars['String']['output']>;
  tune_in_time_override_2?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  type_text_field?: Maybe<Array<Scalars['String']['output']>>;
  user_state?: Maybe<Array<Scalars['String']['output']>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
  vudu_buy_link?: Maybe<Scalars['String']['output']>;
};

export type MediaBrowseResponse = {
  __typename?: 'MediaBrowseResponse';
  size?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  videos?: Maybe<Array<Maybe<MediaBrowseVideo>>>;
};

export type MediaBrowseVideo = {
  __typename?: 'MediaBrowseVideo';
  contentId?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  regionalRatings?: Maybe<Array<Maybe<ApiRegionalRating>>>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MediaItem = KeepWatchingItem | LiveItem | MovieItem | ShowItem;

export type MerchandiseContentResponse = {
  __typename?: 'MerchandiseContentResponse';
  carouselId?: Maybe<Scalars['String']['output']>;
  contentSlidesCount?: Maybe<Scalars['Int']['output']>;
  defaultBackground?: Maybe<Scalars['String']['output']>;
  metadataRowDisplayed?: Maybe<Scalars['Boolean']['output']>;
  slideTransitionTime?: Maybe<Scalars['Int']['output']>;
  slides: Array<MerchandiseSlide>;
  tuneInTimeDisplayed?: Maybe<Scalars['Boolean']['output']>;
};

export enum MerchandiseContentType {
  Movie = 'MOVIE',
  Show = 'SHOW'
}

export type MerchandiseSlide = {
  __typename?: 'MerchandiseSlide';
  contentId?: Maybe<Scalars['Int']['output']>;
  contentLogo?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<MerchandiseContentType>;
  desktopBackgroundSrcset?: Maybe<Scalars['String']['output']>;
  imgStandardSrc?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<SlideMetadata>;
  mobileBackgroundSrcset?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
};

export type MetadataResponse = {
  __typename?: 'MetadataResponse';
  seo?: Maybe<SeoContent>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MosaicPageAttributeSourceRecords = {
  __typename?: 'MosaicPageAttributeSourceRecords';
  filterOtherTagged?: Maybe<Scalars['Boolean']['output']>;
  packageCode?: Maybe<Scalars['String']['output']>;
  records?: Maybe<Scalars['JSON']['output']>;
  sortBy?: Maybe<Scalars['String']['output']>;
  sortByOrder?: Maybe<Scalars['String']['output']>;
  tag: Scalars['String']['output'];
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type MosaicPageAttributesResponse = {
  __typename?: 'MosaicPageAttributesResponse';
  /**
   * The raw records each source returned: the host merges them for the sources
   * its documents declare (`mergeRecordsForSources`), the editor shows them raw.
   */
  sources: Array<MosaicPageAttributeSourceRecords>;
};

export type MosaicPageDocumentsResponse = {
  __typename?: 'MosaicPageDocumentsResponse';
  /** Island id -> document (or null) for every island the page references. */
  islands?: Maybe<Scalars['JSON']['output']>;
  /**
   * The page document to render: the blueprint default, or a variant's document
   * when an experiment payload applied cleanly. Null when the surface has none.
   */
  page?: Maybe<Scalars['JSON']['output']>;
  /**
   * The promo the route targets its own variants call with: the CMS `promo_code`
   * of the rendered copy (campaign overlay included), else the request's promo.
   */
  resolvedPromo: Scalars['String']['output'];
  /**
   * The page-attribute records behind every source the resolved documents declare
   * (a variant may add sources the blueprint lacks), for `mergeRecordsForSources`.
   */
  sources: Array<MosaicPageAttributeSourceRecords>;
  /**
   * DirectAB's "experimentKey:variant" list for this request, control included.
   * Empty when a variant's payload was rejected: the default rendered, so no
   * exposure counts for it.
   */
  variantsForTracking: Array<Scalars['String']['output']>;
};

export type Movie = {
  __typename?: 'Movie';
  badgeLabel?: Maybe<Scalars['String']['output']>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentId: Scalars['String']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  firstAvailableDate?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isMovieAvailable?: Maybe<Scalars['Boolean']['output']>;
  movieAssets?: Maybe<MovieAssets>;
  movieContent?: Maybe<ContentCanVideo>;
  pvrModel?: Maybe<Scalars['String']['output']>;
  rating_metadata?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  trailerContent?: Maybe<ContentCanVideo>;
  trailerContentId?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type MovieAssets = {
  __typename?: 'MovieAssets';
  filepath_movie_hero?: Maybe<Scalars['String']['output']>;
  filepath_movie_hero_compact?: Maybe<Scalars['String']['output']>;
  filepath_movie_hero_regular?: Maybe<Scalars['String']['output']>;
  filepath_movie_keep_watching?: Maybe<Scalars['String']['output']>;
  filepath_movie_logo?: Maybe<Scalars['String']['output']>;
  filepath_movie_poster?: Maybe<Scalars['String']['output']>;
  filepath_movie_thumbnail?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_center?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_center_colored?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_compact?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_left?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_regular?: Maybe<Scalars['String']['output']>;
};

export type MovieCarouselItem = CarouselItem & CommonContentFields & {
  __typename?: 'MovieCarouselItem';
  addOns?: Maybe<Scalars['String']['output']>;
  airDate?: Maybe<Scalars['String']['output']>;
  badgeLabel?: Maybe<Scalars['String']['output']>;
  bundleLocked?: Maybe<Scalars['Boolean']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  cmsId?: Maybe<Scalars['String']['output']>;
  contentCANVideo?: Maybe<CanModel>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  ctaActionType?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<Scalars['String']['output']>;
  heroCompact?: Maybe<Scalars['String']['output']>;
  highlightImage?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isContentHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEpisodeLess?: Maybe<Scalars['Boolean']['output']>;
  isHighlightMetadataPartial?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isSeasonLess?: Maybe<Scalars['Boolean']['output']>;
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoCenter?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  movieContent?: Maybe<MovieContent>;
  movieDuration?: Maybe<Scalars['Int']['output']>;
  movieId?: Maybe<Scalars['String']['output']>;
  movieTitle?: Maybe<Scalars['String']['output']>;
  numericLabel?: Maybe<Scalars['Int']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  progressText?: Maybe<Scalars['String']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  runtime?: Maybe<Scalars['Int']['output']>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  showPath?: Maybe<Scalars['String']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbLandscape?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trailerContent?: Maybe<TrailerContent>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type MovieCollectionEntity = {
  __typename?: 'MovieCollectionEntity';
  aliasContentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  badgeLabel?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Brand>;
  brandSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brand_slug?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentId?: Maybe<Scalars['String']['output']>;
  content_id?: Maybe<Scalars['String']['output']>;
  download_metadata?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclude_profile_slugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstAvailableDate?: Maybe<Scalars['Int']['output']>;
  genre_slugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isMovieAvailable?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  movieAssets?: Maybe<MovieAssets>;
  movieAvailable?: Maybe<Scalars['Boolean']['output']>;
  movieContent?: Maybe<MovieContent>;
  rating_metadata?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  region?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sortTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trailerContent?: Maybe<TrailerContent>;
  trailerContentId?: Maybe<Scalars['String']['output']>;
  trailer_content_id?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type MovieContent = {
  __typename?: 'MovieContent';
  _airDate?: Maybe<Scalars['String']['output']>;
  _airDateISO?: Maybe<Scalars['String']['output']>;
  _editDate?: Maybe<Scalars['String']['output']>;
  _expirationDate?: Maybe<Scalars['String']['output']>;
  _firstIngestDate?: Maybe<Scalars['String']['output']>;
  _ingestDate?: Maybe<Scalars['String']['output']>;
  _lastModifiedDate?: Maybe<Scalars['String']['output']>;
  _pubDate?: Maybe<Scalars['String']['output']>;
  _pubDateISO?: Maybe<Scalars['String']['output']>;
  addOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  airDate?: Maybe<Scalars['Int']['output']>;
  amazonESTURL?: Maybe<Scalars['String']['output']>;
  appleWatchListShowKey?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<Scalars['String']['output']>;
  availableForProfileTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbsShowId?: Maybe<Scalars['Int']['output']>;
  childContentId?: Maybe<Scalars['String']['output']>;
  closedCaptionUrl?: Maybe<Scalars['String']['output']>;
  cmsAccountId?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Array<Scalars['String']['output']>>;
  downloadCountrySet?: Maybe<Array<Maybe<DownloadCountrySet>>>;
  duration?: Maybe<Scalars['Int']['output']>;
  editDate?: Maybe<Scalars['Int']['output']>;
  embeddable?: Maybe<Scalars['String']['output']>;
  endCreditsChapterTime?: Maybe<Scalars['String']['output']>;
  episodeNum?: Maybe<Scalars['String']['output']>;
  excludeNielsenTracking?: Maybe<Scalars['Boolean']['output']>;
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['Int']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstIngestDate?: Maybe<Scalars['Int']['output']>;
  fullEpisode?: Maybe<Scalars['Boolean']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  ingestDate?: Maybe<Scalars['Int']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isProductPlacement?: Maybe<Scalars['Boolean']['output']>;
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  itunesESTURL?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['Int']['output']>;
  mediaAvailableDate?: Maybe<Scalars['String']['output']>;
  mediaAvailableDateEpoch?: Maybe<Scalars['Int']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  playbackEvents?: Maybe<PlaybackEvents>;
  playerLocUrl?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryCategory?: Maybe<Scalars['String']['output']>;
  primaryCategoryName?: Maybe<Scalars['String']['output']>;
  pubDate?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  regionalAudioExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  regionalRatings?: Maybe<Array<RegionalRatings>>;
  regionalTextExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  sizzleId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  subscriptionLevel?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailSet?: Maybe<Array<Maybe<ThumbnailSet>>>;
  thumbnailSheetSet?: Maybe<Array<Maybe<ThumbnailSheetSet>>>;
  title?: Maybe<Scalars['String']['output']>;
  tmsprogramID?: Maybe<Scalars['String']['output']>;
  tmsseriesID?: Maybe<Scalars['String']['output']>;
  topLevelCategory?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vTag?: Maybe<Scalars['String']['output']>;
  videoPageUrl?: Maybe<Scalars['String']['output']>;
  videoProperties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MovieData = {
  __typename?: 'MovieData';
  actionValue: Scalars['String']['output'];
  commonContentId: Scalars['String']['output'];
  ctaText: Scalars['String']['output'];
  isMovieAvailable: Scalars['Boolean']['output'];
  movieContentId: Scalars['String']['output'];
  movieId: Scalars['String']['output'];
  movieOriginId: Scalars['String']['output'];
  moviePageURL: Scalars['String']['output'];
  trailerContentId: Scalars['String']['output'];
  trailerPageURL?: Maybe<Scalars['String']['output']>;
};

export type MovieDetail = {
  __typename?: 'MovieDetail';
  /**
   * Raw upstream movie-detail API item, surfaced uncurated for downstream consumers
   * (Smart Tag, MOPS) that need fields TN Web doesn't expose as first-class normalized
   * fields. Mirrors the episodes _apiRaw pattern; single-asset path so no per-list
   * multiplier — one raw blob per movie detail response, same scale as episodeDetail
   * SSR after the apiRawContentId scoping.
   */
  _apiRaw?: Maybe<Scalars['JSON']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  brandUrl?: Maybe<Scalars['String']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Array<Scalars['String']['output']>>;
  genre?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
  movieAssets?: Maybe<MovieAssets>;
  numSeasons?: Maybe<Scalars['Int']['output']>;
  premiereDate?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  pubDate?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionalRatings?: Maybe<Array<RegionalRatings>>;
  resumeTime?: Maybe<Scalars['Int']['output']>;
  seasons?: Maybe<Array<AvailableVideoSeasons>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showEpisodeGuideLink?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type MovieDetailData = {
  __typename?: 'MovieDetailData';
  movie?: Maybe<MovieDetailResponse>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MovieDetailHero = DetailHero & {
  __typename?: 'MovieDetailHero';
  airDate?: Maybe<Scalars['Float']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  brandUrl?: Maybe<Scalars['String']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  cast?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  detailCta?: Maybe<DetailCta>;
  duration?: Maybe<Scalars['Int']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  heroType?: Maybe<HeroType>;
  logo?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  progress?: Maybe<Scalars['Int']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  srcSetLandscape?: Maybe<Scalars['String']['output']>;
  srcSetPortrait?: Maybe<Scalars['String']['output']>;
  standardImgForAllScreens?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type MovieDetailResponse = {
  __typename?: 'MovieDetailResponse';
  callout?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  contentType?: Maybe<Scalars['String']['output']>;
  content_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Array<Scalars['String']['output']>>;
  firstAvailableDate?: Maybe<Scalars['Float']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isMovieAvailable?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  movieAvailable?: Maybe<Scalars['Boolean']['output']>;
  movieContent?: Maybe<MovieContent>;
  movieDuration?: Maybe<Scalars['Int']['output']>;
  originId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbLandscape?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type MovieHomeData = {
  __typename?: 'MovieHomeData';
  carouselConfigs?: Maybe<Array<Config>>;
  hero?: Maybe<DetailHero>;
  movie?: Maybe<MovieDetail>;
};

export type MovieItem = {
  __typename?: 'MovieItem';
  badgeLabel?: Maybe<Scalars['String']['output']>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  contentId: Scalars['String']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  firstAvailableDate?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS: Scalars['Boolean']['output'];
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isMovieAvailable: Scalars['Boolean']['output'];
  movieAssets?: Maybe<MovieAssets>;
  movieContent?: Maybe<MovieContent>;
  pvrModel?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  trailerContent?: Maybe<TrailerContent>;
  trailerContentId?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type MovieParams = {
  billingVendor: Scalars['String']['input'];
  contentId: Scalars['String']['input'];
  includeContentInfo?: InputMaybe<Scalars['Boolean']['input']>;
  includeTrailerInfo?: InputMaybe<Scalars['Boolean']['input']>;
  packageCode: Scalars['String']['input'];
  rows?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  userProfileType: Scalars['String']['input'];
  userRegistrationCountry: Scalars['String']['input'];
  userState: Scalars['String']['input'];
};

export type MovieRecommendation = {
  __typename?: 'MovieRecommendation';
  aliasContentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  castNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentId?: Maybe<Scalars['String']['output']>;
  content_id?: Maybe<Scalars['String']['output']>;
  download_metadata?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclude_profile_slugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstAvailableDate?: Maybe<Scalars['Int']['output']>;
  genre_slugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isMovieAvailable?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  movieAssets?: Maybe<MovieAssets>;
  movieAvailable?: Maybe<Scalars['Boolean']['output']>;
  movieContent?: Maybe<MovieContent>;
  originId?: Maybe<Scalars['Int']['output']>;
  rating_metadata?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recommendationSource?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sortTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trailerContent?: Maybe<TrailerContent>;
  trailerContentId?: Maybe<Scalars['String']['output']>;
  trailer_content_id?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
};

export type MovieResponse = {
  __typename?: 'MovieResponse';
  movie?: Maybe<Movie>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MovieTrendingContent = {
  __typename?: 'MovieTrendingContent';
  aliasContentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  badgeLabel?: Maybe<Scalars['String']['output']>;
  brandSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  castNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentId?: Maybe<Scalars['String']['output']>;
  content_id?: Maybe<Scalars['String']['output']>;
  download_metadata?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exclude_profile_slugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstAvailableDate?: Maybe<Scalars['Int']['output']>;
  genre_slugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isMovieAvailable?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  movieAssets?: Maybe<MovieAssets>;
  movieAvailable?: Maybe<Scalars['Boolean']['output']>;
  movieContent?: Maybe<MovieContent>;
  rating_metadata?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  region?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sortTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trailerContent?: Maybe<TrailerContent>;
  trailerContentId?: Maybe<Scalars['String']['output']>;
  trailer_content_id?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type MultiChannelCollectionCarousel = {
  __typename?: 'MultiChannelCollectionCarousel';
  filePathLogoSelected?: Maybe<Scalars['String']['output']>;
  listings: Array<LiveChannelListing>;
};

export type MultiChannelCollectionCarouselApiResponse = {
  __typename?: 'MultiChannelCollectionCarouselApiResponse';
  displayShowTitle?: Maybe<Scalars['Boolean']['output']>;
  filePathLogo?: Maybe<Scalars['String']['output']>;
  items: Array<UniversalChannelListingItem>;
  rows?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  batchAddMyListItems?: Maybe<MutationResponse>;
  batchRemoveMyListItems?: Maybe<MutationResponse>;
  bindMvpd?: Maybe<BindMvpdResponse>;
  bindPartner?: Maybe<BindPartnerResponse>;
  cancelSave: MutationResponse;
  changePassword?: Maybe<ChangePasswordResponse>;
  createPin?: Maybe<MutationResponse>;
  createProfile?: Maybe<UserProfile>;
  deleteProfile?: Maybe<MutationResponse>;
  disableAccountPin?: Maybe<MutationResponse>;
  disableKidsShortcut?: Maybe<MutationResponse>;
  emailCheckpoint?: Maybe<EmailCheckpointResponse>;
  formRendezvousUpload?: Maybe<CodeActivateSuccessResponse>;
  formSignUpUpload?: Maybe<MutationResponse>;
  identityLogin?: Maybe<IdentityLoginResponse>;
  identityRegister?: Maybe<IdentityRegisterResponse>;
  /**
   * Add or change. One row per profile + target + feedbackType, so resubmitting replaces the
   * stored value and never creates a duplicate — the client sends the new value and nothing else.
   */
  ingestCommunityFeedback: CommunityFeedbackWriteResponse;
  logOut?: Maybe<LogOutResponse>;
  parentalRelogin?: Maybe<MutationResponse>;
  platformRestart?: Maybe<PlatformRestartResponse>;
  /**
   * Clear. The PRD defines a clear as reselecting the option already active, so the client calls
   * this instead of re-sending a value. Repeating is a no-op success; submitting again later
   * creates a new record with a new `feedbackId`.
   */
  removeCommunityFeedback: CommunityFeedbackRemoveResponse;
  removeContinueWatching?: Maybe<MutationResponse>;
  resetForgotPassword?: Maybe<ResetForgotPasswordResponse>;
  saveAccountPin?: Maybe<MutationResponse>;
  sendForgotPasswordLink?: Maybe<SendForgotPasswordLinkResponse>;
  setShows?: Maybe<MutationResponse>;
  setShowsList?: Maybe<MutationResponse>;
  signIn?: Maybe<SignInResponse>;
  signOutAllDevices?: Maybe<MutationResponse>;
  signOutAllDevicesSendEmail?: Maybe<MutationResponse>;
  signOutDevice?: Maybe<MutationResponse>;
  signUp?: Maybe<SignUpResponse>;
  switchProfile?: Maybe<SwitchResponse>;
  toggleMyListStatus?: Maybe<MutationResponse>;
  updateEmail?: Maybe<UpdateEmailResponse>;
  updateOptIn?: Maybe<UpdateOptInResponse>;
  updatePayment?: Maybe<UpdatePaymentResponse>;
  updateProfile?: Maybe<MutationResponse>;
  userRelogin?: Maybe<MutationResponse>;
  verifyEmail?: Maybe<MutationResponse>;
};


export type MutationBatchAddMyListItemsArgs = {
  contentIds: Array<Scalars['ID']['input']>;
  contentType: Scalars['String']['input'];
};


export type MutationBatchRemoveMyListItemsArgs = {
  watchListIds: Array<Scalars['ID']['input']>;
};


export type MutationBindMvpdArgs = {
  fields: BindMvpdFields;
};


export type MutationBindPartnerArgs = {
  fields: BindPartnerFields;
};


export type MutationChangePasswordArgs = {
  password: Scalars['String']['input'];
  passwordConfirm: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationCreatePinArgs = {
  parentalControlInput: ParentalControlInput;
};


export type MutationCreateProfileArgs = {
  profile: ProfileInput;
};


export type MutationDeleteProfileArgs = {
  id: Scalars['String']['input'];
};


export type MutationEmailCheckpointArgs = {
  email: Scalars['String']['input'];
};


export type MutationFormRendezvousUploadArgs = {
  formFields: FormRendezvousFields;
};


export type MutationFormSignUpUploadArgs = {
  formFields: FormSignUpFields;
};


export type MutationIdentityLoginArgs = {
  input: IdentityLoginInput;
};


export type MutationIdentityRegisterArgs = {
  formFields: SignUpFormFields;
};


export type MutationIngestCommunityFeedbackArgs = {
  input: IngestCommunityFeedbackInput;
};


export type MutationLogOutArgs = {
  token: Scalars['String']['input'];
};


export type MutationParentalReloginArgs = {
  password: Scalars['String']['input'];
};


export type MutationPlatformRestartArgs = {
  input: PlatformRestartInput;
};


export type MutationRemoveCommunityFeedbackArgs = {
  input: RemoveCommunityFeedbackInput;
};


export type MutationRemoveContinueWatchingArgs = {
  movieId?: InputMaybe<Scalars['ID']['input']>;
  showId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationResetForgotPasswordArgs = {
  password: Scalars['String']['input'];
  passwordConfirm: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationSaveAccountPinArgs = {
  parentalControlLivetvPinEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pin: Scalars['String']['input'];
  rating: Scalars['String']['input'];
};


export type MutationSendForgotPasswordLinkArgs = {
  email: Scalars['String']['input'];
};


export type MutationSetShowsArgs = {
  ids: Scalars['String']['input'];
};


export type MutationSetShowsListArgs = {
  ids: Scalars['String']['input'];
};


export type MutationSignInArgs = {
  formFields: SignInFormFields;
};


export type MutationSignOutAllDevicesArgs = {
  token: Scalars['String']['input'];
};


export type MutationSignOutDeviceArgs = {
  deviceInfo?: InputMaybe<Array<InputMaybe<InputDeviceInfo>>>;
  token: Scalars['String']['input'];
};


export type MutationSignUpArgs = {
  formFields: SignUpFormFields;
};


export type MutationSwitchProfileArgs = {
  id: Scalars['String']['input'];
};


export type MutationToggleMyListStatusArgs = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  isInWatchlist?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateEmailArgs = {
  formFields: UpdateEmailFormFields;
};


export type MutationUpdateOptInArgs = {
  optIn: Scalars['Boolean']['input'];
};


export type MutationUpdatePaymentArgs = {
  gatewayCode?: InputMaybe<Scalars['String']['input']>;
  resultActionTokenId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationUpdateProfileArgs = {
  id: Scalars['String']['input'];
  profile: ProfileInput;
};


export type MutationUserReloginArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MvpdDispute = {
  __typename?: 'MvpdDispute';
  isDmaInDispute?: Maybe<Scalars['Boolean']['output']>;
  mvpdProvider?: Maybe<Scalars['String']['output']>;
};

export type MvpdLogo = {
  __typename?: 'MvpdLogo';
  displayName: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
};

export type MyListApiParams = {
  __typename?: 'MyListApiParams';
  rows?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type Nav = {
  __typename?: 'Nav';
  globalMenu?: Maybe<GlobalMenu>;
};

export type NavCtaAttributes = {
  __typename?: 'NavCtaAttributes';
  ctaText: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
};

export type NavCtaAttributesResponse = {
  __typename?: 'NavCtaAttributesResponse';
  attributes?: Maybe<NavCtaAttributes>;
  variantsForTracking: Array<Scalars['String']['output']>;
};

export type NavItem = {
  __typename?: 'NavItem';
  href: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<SubNavItem>;
  label: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type NextItem = {
  __typename?: 'NextItem';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channelSlug?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Context>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  isListingLive?: Maybe<Scalars['Boolean']['output']>;
  listingId?: Maybe<Scalars['Int']['output']>;
  logoImage?: Maybe<Scalars['String']['output']>;
  medTime?: Maybe<Scalars['Int']['output']>;
  playbackModeCTA?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rating?: Maybe<Scalars['String']['output']>;
  recommendationSource?: Maybe<Scalars['String']['output']>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  seasons?: Maybe<Scalars['String']['output']>;
  showId?: Maybe<Scalars['Int']['output']>;
  startTimestamp?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NextItemResponse = {
  __typename?: 'NextItemResponse';
  endCardCount?: Maybe<Scalars['Int']['output']>;
  endCardTimer?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Array<Maybe<NextItem>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NextVideoLiveParams = {
  channelSlug: Scalars['String']['input'];
  dma: Scalars['String']['input'];
};

export type NextVideoParams = {
  billingVendor: Scalars['String']['input'];
  /** @deprecated Use nextVideoVODParams.contentId */
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  endCardId?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to type == NEXT_VIDEO when omitted. */
  nextItem?: InputMaybe<Scalars['Boolean']['input']>;
  nextVideoLiveParams?: InputMaybe<NextVideoLiveParams>;
  nextVideoVODParams?: InputMaybe<NextVideoVodParams>;
  packageCode: Scalars['String']['input'];
  platformType: Scalars['String']['input'];
  /** @deprecated No longer sent by current clients */
  rows?: InputMaybe<Scalars['String']['input']>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use nextVideoVODParams.showId */
  showId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  userProfileType: Scalars['String']['input'];
  userRegistrationCountry: Scalars['String']['input'];
  userState: Scalars['String']['input'];
};

export type NextVideoVodParams = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  showId?: InputMaybe<Scalars['String']['input']>;
};

export type NormalizedCouponResponse = {
  __typename?: 'NormalizedCouponResponse';
  amount?: Maybe<Scalars['Float']['output']>;
  appliesForMonths?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  couponString?: Maybe<Scalars['String']['output']>;
  couponType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reducedPrice?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
};

export type OnNowCarousel = {
  __typename?: 'OnNowCarousel';
  channelName?: Maybe<Scalars['String']['output']>;
  currentListing: Array<LiveChannelListing>;
  filePathLogo?: Maybe<Scalars['String']['output']>;
  filePathLogoSelected?: Maybe<Scalars['String']['output']>;
  filepathDefaultBackground?: Maybe<Scalars['String']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  originId?: Maybe<Scalars['String']['output']>;
};

export type OnNowCarouselApiResponse = {
  __typename?: 'OnNowCarouselApiResponse';
  carousel: Array<OnNowCarousel>;
  channel: LiveChannel;
  displayShowTitle?: Maybe<Scalars['Boolean']['output']>;
  filePathLogoSelected?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OverrideUserProfile = {
  __typename?: 'OverrideUserProfile';
  id: Scalars['Float']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isMasterProfile: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  personalizationId?: Maybe<Scalars['String']['output']>;
  profilePic?: Maybe<Scalars['UUID']['output']>;
  profilePicMedium: Scalars['String']['output'];
  profilePicPath: Scalars['String']['output'];
  profilePicSmall: Scalars['String']['output'];
  profileType: ProfileType;
  referenceProfileId?: Maybe<Scalars['Float']['output']>;
  screenTimeLimitEnabled?: Maybe<Scalars['Boolean']['output']>;
  screenTimeLimitSeconds?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type PackageInfo = {
  __typename?: 'PackageInfo';
  billingCadence?: Maybe<Scalars['String']['output']>;
  packageCode?: Maybe<Scalars['String']['output']>;
  packageSource?: Maybe<Scalars['String']['output']>;
  packageSourceType?: Maybe<Scalars['String']['output']>;
  packageStatus?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorUserType?: Maybe<Scalars['String']['output']>;
};

export type PageAttributesResponse = {
  __typename?: 'PageAttributesResponse';
  pageAttributes?: Maybe<Scalars['JSON']['output']>;
  variantsForTracking: Array<Scalars['String']['output']>;
};

export type PagePlanAttr = {
  __typename?: 'PagePlanAttr';
  aaPageHeader?: Maybe<Scalars['String']['output']>;
  aaPageHeaderFreeTrial?: Maybe<Scalars['String']['output']>;
  aaPageSubHeader?: Maybe<Scalars['String']['output']>;
  aaPageSubHeaderExsub?: Maybe<Scalars['String']['output']>;
  aaPapAnnualPlanCheckboxFormat?: Maybe<Scalars['String']['output']>;
  aaPapAnnualPlanCheckboxSingleTierFormat?: Maybe<Scalars['String']['output']>;
  aaPapAnnualPlanCouponCheckboxText?: Maybe<Scalars['String']['output']>;
  aaPapAnnualPlanMonthlyPriceFormat?: Maybe<Scalars['String']['output']>;
  aaPapBundleOptionCta?: Maybe<Scalars['String']['output']>;
  aaPapBundleOptionCtaShowtime?: Maybe<Scalars['String']['output']>;
  aaPapBundleOptionDescription?: Maybe<Scalars['String']['output']>;
  aaPapBundleOptionDescriptionPlanSuppressedShowtime?: Maybe<Scalars['String']['output']>;
  aaPapBundleOptionHeading?: Maybe<Scalars['String']['output']>;
  aaPapBundleOptionHeadingShowtime?: Maybe<Scalars['String']['output']>;
  aaPapButtonText?: Maybe<Scalars['String']['output']>;
  aaPapButtonTextContinue?: Maybe<Scalars['String']['output']>;
  aaPapButtonTextContinueFreeTrial?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem1?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem1Showtime?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem2?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem2Showtime?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem3?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem3Showtime?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem4?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem4Showtime?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem5?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem5Showtime?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem6?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem6Showtime?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem7?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem7Showtime?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem8?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem8Showtime?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem9?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem9Showtime?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem10?: Maybe<Scalars['String']['output']>;
  aaPapCfFeatureListItem10Showtime?: Maybe<Scalars['String']['output']>;
  aaPapCouponPrefix?: Maybe<Scalars['String']['output']>;
  aaPapGiftSubHeadingFormat?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem1?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem2?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem2Showtime?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem3?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem4?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem4Showtime?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem5?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem5Showtime?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem6?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem6Showtime?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem7?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem7Showtime?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem8?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem8Showtime?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem9?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem9Showtime?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem10?: Maybe<Scalars['String']['output']>;
  aaPapLcpFeatureListItem10Showtime?: Maybe<Scalars['String']['output']>;
  aaPapPlanHeadingCf?: Maybe<Scalars['String']['output']>;
  aaPapPlanHeadingCfShowtime?: Maybe<Scalars['String']['output']>;
  aaPapPlanHeadingLcp?: Maybe<Scalars['String']['output']>;
  aaPapPlanHeadingLcpShowtime?: Maybe<Scalars['String']['output']>;
  aaPapPlanPriceFormatWithPercentCoupon?: Maybe<Scalars['String']['output']>;
  aaPapPlanPriceFormatWithTrial?: Maybe<Scalars['String']['output']>;
  aaPapPlansOrderAscending?: Maybe<Scalars['String']['output']>;
  aaPapSubHeading?: Maybe<Scalars['String']['output']>;
  aaPapSubHeadingExSub?: Maybe<Scalars['String']['output']>;
  aaPapTrialCopy?: Maybe<Scalars['String']['output']>;
  aaSaveWithAnAnnualPlan?: Maybe<Scalars['String']['output']>;
  aaSignUpDisclaimer?: Maybe<Scalars['String']['output']>;
  aaStepsHeader?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  continueWithFreeTrial?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  genericId?: Maybe<Scalars['String']['output']>;
  hideShowtimeBundleCta?: Maybe<Scalars['Boolean']['output']>;
  noFreeTrial?: Maybe<Scalars['Boolean']['output']>;
  pageURL?: Maybe<Scalars['String']['output']>;
  papBillingCadenceModalImage?: Maybe<Scalars['String']['output']>;
  planPillCopy?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  winnersRevealDate?: Maybe<Scalars['String']['output']>;
};

export type ParentalControlInput = {
  parentalControlLevel?: InputMaybe<Scalars['String']['input']>;
  parentalControlLivetvPinEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  requirePinSwitchProfileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParentalControlPin = {
  __typename?: 'ParentalControlPIN';
  hasParentalControlPIN?: Maybe<Scalars['Boolean']['output']>;
  hasParentalControlPINLiveTV?: Maybe<Scalars['Boolean']['output']>;
  parentalControlAllowedRatings?: Maybe<Scalars['String']['output']>;
  parentalControlPIN?: Maybe<Scalars['String']['output']>;
  parentalControlRestrictions?: Maybe<Scalars['String']['output']>;
  requirePinToWatchContent?: Maybe<Scalars['Boolean']['output']>;
};

export type ParentalControlRatingLabel = {
  __typename?: 'ParentalControlRatingLabel';
  group: Scalars['String']['output'];
  label: ParentalControlRatingTranslation;
  ratings: Array<Scalars['String']['output']>;
};

export type ParentalControlRatingTranslation = {
  __typename?: 'ParentalControlRatingTranslation';
  fallback: Scalars['String']['output'];
  translationKey: Scalars['String']['output'];
};

export type PaymentGatewayResponse = {
  __typename?: 'PaymentGatewayResponse';
  gateway: Scalars['String']['output'];
  variantsForTracking: Array<Scalars['String']['output']>;
};

export type PlanCampaignAttr = {
  __typename?: 'PlanCampaignAttr';
  aaPapSubheadingNoTrial?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  defaultToAnnual?: Maybe<Scalars['Boolean']['output']>;
  destinationUrl?: Maybe<Scalars['String']['output']>;
  hideShowtimeBundleCta?: Maybe<Scalars['Boolean']['output']>;
  noFreeTrial?: Maybe<Scalars['Boolean']['output']>;
  offer1CouponCode?: Maybe<Scalars['String']['output']>;
  offer1ProductCode?: Maybe<Scalars['String']['output']>;
  offer2CouponCode?: Maybe<Scalars['String']['output']>;
  offer2ProductCode?: Maybe<Scalars['String']['output']>;
  offer3CouponCode?: Maybe<Scalars['String']['output']>;
  offer3ProductCode?: Maybe<Scalars['String']['output']>;
  offer4CouponCode?: Maybe<Scalars['String']['output']>;
  offer4ProductCode?: Maybe<Scalars['String']['output']>;
  pageURL?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  useGenericCampaignExplainerSet?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type PlanPageAttributesResponse = {
  __typename?: 'PlanPageAttributesResponse';
  campaign?: Maybe<PlanCampaignAttr>;
  campaignPageAttributes?: Maybe<CampaignPageAttributesResponse>;
  plansBucket?: Maybe<PagePlanAttr>;
  rawCampaigns?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  rawPagePlans?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  rawUpsellValueProps?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  valuePropItems?: Maybe<Array<Maybe<ValuePropItem>>>;
  variantsForTracking?: Maybe<Array<Scalars['String']['output']>>;
};


export type PlanPageAttributesResponseCampaignPageAttributesArgs = {
  cbscidmt?: InputMaybe<Scalars['String']['input']>;
  clientUserGuid?: InputMaybe<Scalars['String']['input']>;
  flowType?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
};

export type PlansBucket = {
  __typename?: 'PlansBucket';
  currentCadence?: Maybe<Scalars['String']['output']>;
  pageAttributes?: Maybe<PlansBucketPageAttributes>;
  productsByCadence?: Maybe<ProductsByCadence>;
  rowHeaderPosition?: Maybe<Scalars['Int']['output']>;
  valuePropItems?: Maybe<Array<Maybe<ValuePropItem>>>;
};

export type PlansBucketPageAttributes = {
  __typename?: 'PlansBucketPageAttributes';
  aaPapAnnualPlanMonthlyPriceFormat?: Maybe<Scalars['String']['output']>;
  aaPapPlanPriceFormatWithTrial?: Maybe<Scalars['String']['output']>;
  aaPapTrialCopy?: Maybe<Scalars['String']['output']>;
  aaSaveWithAnAnnualPlan?: Maybe<Scalars['String']['output']>;
  aaSignUpDisclaimer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  backgroundDesktop?: Maybe<Scalars['String']['output']>;
  backgroundMobile?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  ctaEvent?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  noFreeTrial?: Maybe<Scalars['Boolean']['output']>;
  planPillCopy?: Maybe<Scalars['String']['output']>;
  subHeading?: Maybe<Scalars['String']['output']>;
};

export type PlatformRestartInput = {
  appVersion: Scalars['String']['input'];
  cmAudienceID?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  lastEventTime: Scalars['String']['input'];
  ptvAppName: Scalars['String']['input'];
  sessionJwt: Scalars['String']['input'];
};

export type PlatformRestartResponse = {
  __typename?: 'PlatformRestartResponse';
  deviceId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  refreshInSec?: Maybe<Scalars['Int']['output']>;
  session?: Maybe<PlatformRestartSession>;
  status?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PlatformRestartSession = {
  __typename?: 'PlatformRestartSession';
  id: Scalars['String']['output'];
  jwt: Scalars['String']['output'];
};

export type PlatformSession = {
  __typename?: 'PlatformSession';
  clientIp?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

export type PlaybackEvents = {
  __typename?: 'PlaybackEvents';
  endCreditChapterTimeMs?: Maybe<Scalars['Int']['output']>;
  openCreditEndTimeMs?: Maybe<Scalars['Int']['output']>;
  openCreditStartTime?: Maybe<Scalars['Int']['output']>;
  previewEndTimeMs?: Maybe<Scalars['Int']['output']>;
  previewStartTimeMs?: Maybe<Scalars['Int']['output']>;
};

export type PositionDetails = {
  __typename?: 'PositionDetails';
  coords: Coordinates;
  isFallback?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type PrefetchData = {
  __typename?: 'PrefetchData';
  useFullUser?: Maybe<UpsellUserStatus>;
};

export type PreselectedCreditCardGatewayResponse = {
  __typename?: 'PreselectedCreditCardGatewayResponse';
  gatewayName?: Maybe<Scalars['String']['output']>;
};

export type PrevNextResponse = {
  __typename?: 'PrevNextResponse';
  nextVideo?: Maybe<PrevNextVideoItem>;
  prevVideo?: Maybe<PrevNextVideoItem>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PrevNextVideoItem = {
  __typename?: 'PrevNextVideoItem';
  contentId?: Maybe<Scalars['String']['output']>;
  downloadCountrySet?: Maybe<Array<Maybe<DownloadCountry>>>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isProductPlacement?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  thumbnailSet?: Maybe<Array<Maybe<Thumbnail>>>;
  thumbnailSheetSet?: Maybe<Array<Maybe<Thumbnail>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PrivacyInfo = {
  cmAudienceID?: InputMaybe<Scalars['String']['input']>;
  gdpr?: InputMaybe<Scalars['String']['input']>;
  gdprConsent?: InputMaybe<Scalars['String']['input']>;
  isClientDNT?: InputMaybe<Scalars['Boolean']['input']>;
  usPrivacy?: InputMaybe<Scalars['String']['input']>;
};

export type ProductResponse = {
  __typename?: 'ProductResponse';
  addOnCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  additionalText?: Maybe<Scalars['String']['output']>;
  addons?: Maybe<Array<Maybe<AddOnResponse>>>;
  afterTrialText?: Maybe<Scalars['String']['output']>;
  allowedMigration?: Maybe<Scalars['Boolean']['output']>;
  billingCadence?: Maybe<Scalars['String']['output']>;
  billingVendor?: Maybe<Scalars['String']['output']>;
  billingVendorProductCode: Scalars['String']['output'];
  couponCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isTestProduct?: Maybe<Scalars['Boolean']['output']>;
  localizedPlanTitle?: Maybe<Scalars['String']['output']>;
  mobileOnly?: Maybe<Scalars['Boolean']['output']>;
  noTrial?: Maybe<Scalars['Boolean']['output']>;
  normalizedCoupon?: Maybe<NormalizedCouponResponse>;
  packageCode?: Maybe<Scalars['String']['output']>;
  planTier?: Maybe<Scalars['String']['output']>;
  planType: Cadence;
  plansOnUpsellCouponSet?: Maybe<Scalars['Boolean']['output']>;
  pluralPlanType?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  productCode?: Maybe<Scalars['String']['output']>;
  productTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  region?: Maybe<Scalars['String']['output']>;
  singularPlanType?: Maybe<Scalars['String']['output']>;
  singularPlanTypeAbbr?: Maybe<Scalars['String']['output']>;
  switchDirection?: Maybe<Scalars['String']['output']>;
  thirdPartyProductCode?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  titleForTracking?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  trial?: Maybe<Scalars['Boolean']['output']>;
  trialInterval?: Maybe<Scalars['Int']['output']>;
  trialUnit?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  vendor_attributes?: Maybe<VendorAttributes>;
};

export type ProductsResponse = {
  __typename?: 'ProductsResponse';
  campaignAttributes?: Maybe<CampaignData>;
  planPageAttributes?: Maybe<PlanPageAttributesResponse>;
  products?: Maybe<Array<Maybe<ProductResponse>>>;
  upsellPageAttributes?: Maybe<UpsellPageAttributeQueryResponse>;
};


export type ProductsResponseUpsellPageAttributesArgs = {
  cbscidmt?: InputMaybe<Scalars['String']['input']>;
  clientUserGuid?: InputMaybe<Scalars['String']['input']>;
  flowType?: InputMaybe<Scalars['String']['input']>;
  ftag?: InputMaybe<Scalars['String']['input']>;
  intcid?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileInput = {
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  profilePic: Scalars['String']['input'];
  profileType: ProfileType;
  requirePinSwitchProfileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileLevel = {
  __typename?: 'ProfileLevel';
  profileType: ProfileType;
  ratingRestrictions: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum ProfileType {
  Adult = 'ADULT',
  All = 'ALL',
  Kids = 'KIDS',
  YoungerKids = 'YOUNGER_KIDS'
}

export type PromotionInfo = {
  __typename?: 'PromotionInfo';
  aboutCopy?: Maybe<Scalars['String']['output']>;
  actionGuid?: Maybe<Scalars['String']['output']>;
  actionTarget?: Maybe<Scalars['String']['output']>;
  actionText?: Maybe<Scalars['String']['output']>;
  actionType?: Maybe<Scalars['String']['output']>;
  actionUrl?: Maybe<Scalars['String']['output']>;
  countdown?: Maybe<Scalars['String']['output']>;
  filepath1x1DefaultImage?: Maybe<Scalars['String']['output']>;
  filepath1x1FocusStateImage?: Maybe<Scalars['String']['output']>;
  filepathAppCompactImage?: Maybe<Scalars['String']['output']>;
  filepathAppRegularImage?: Maybe<Scalars['String']['output']>;
  filepathBackgroundHeroImage?: Maybe<Scalars['String']['output']>;
  filepathDesktopWebImage?: Maybe<Scalars['String']['output']>;
  filepathFocusStatePoster?: Maybe<Scalars['String']['output']>;
  filepathLogoCompactImage?: Maybe<Scalars['String']['output']>;
  filepathLogoRegularImage?: Maybe<Scalars['String']['output']>;
  filepathMobileWebImage?: Maybe<Scalars['String']['output']>;
  filepathOTTImage?: Maybe<Scalars['String']['output']>;
  filepathPromoTileLandscapeImage?: Maybe<Scalars['String']['output']>;
  filepathPromoTilePosterImage?: Maybe<Scalars['String']['output']>;
  linkGuid?: Maybe<Scalars['String']['output']>;
  linkTarget?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkType?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  linkedContentRef?: Maybe<Scalars['String']['output']>;
  linkedContentType?: Maybe<Scalars['String']['output']>;
  listingId?: Maybe<Scalars['String']['output']>;
  lockedCTA?: Maybe<Scalars['String']['output']>;
  promoType?: Maybe<Scalars['String']['output']>;
  showCountdownTimer?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  videoPreview?: Maybe<Scalars['String']['output']>;
};

export type PromotionalSpot = {
  copyText?: InputMaybe<Scalars['String']['input']>;
  deepLinkUrl?: InputMaybe<Scalars['String']['input']>;
  filePathImage?: InputMaybe<Scalars['String']['input']>;
  filepathHighlightBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  filepathHighlightLogoImage?: InputMaybe<Scalars['String']['input']>;
  filepathPromotionalAssetPosterImage?: InputMaybe<Scalars['String']['input']>;
  filepathPromotionalLogoAssetPath?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  linkLine2Text?: InputMaybe<Scalars['String']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  promotionalSpotPath?: InputMaybe<Scalars['String']['input']>;
  spotTitle?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  ABTestVariants?: Maybe<AbTestVariantsResponse>;
  ABTestsVariants?: Maybe<AbTestsVariantsResponse>;
  accountPageAttributes?: Maybe<AccountPageAttributeQueryResponse>;
  allMoviesMock?: Maybe<AllMoviesMockResponse>;
  avatarByUUID?: Maybe<Avatar>;
  avatarGroups?: Maybe<Array<Maybe<AvatarGroup>>>;
  billingInfo?: Maybe<BillingInfoResponse>;
  browseNav?: Maybe<Nav>;
  campaignPageAttributes?: Maybe<CampaignPageAttributesResponse>;
  cancelSavePageAttributes?: Maybe<CancelSavePageAttributesResponse>;
  carousel?: Maybe<Scalars['JSON']['output']>;
  carouselData?: Maybe<CarouselResponse>;
  channelCategories?: Maybe<ChannelCategoriesResponse>;
  channels?: Maybe<ChannelResponse>;
  checkEmail?: Maybe<CheckEmailResponse>;
  cmpConsentToken?: Maybe<CmpConsentTokenResponse>;
  collection?: Maybe<Collection>;
  /**
   * Batched read for the signed-in profile. Every requested target is represented in the
   * response; targets the profile holds nothing for come back with an empty `feedback` list
   * and a null `reaction`.
   */
  communityFeedback: CommunityFeedbackReadResponse;
  compilingPageAttributes?: Maybe<CompilingPageAttributesResponse>;
  concurrency?: Maybe<ConcurrencyResponse>;
  configurator?: Maybe<CastConfigurationResponse>;
  contentHighlightMetadata?: Maybe<ContentHighlightMetadata>;
  ctaAttributes?: Maybe<NavCtaAttributesResponse>;
  currentListing?: Maybe<ChannelListingResponse>;
  dmaInfo?: Maybe<DmaResponse>;
  editEmail?: Maybe<EditEmailResponse>;
  editPassword?: Maybe<EditPasswordResponse>;
  /**
   * Resume position for a single episode, sourced from the show-scoped watch
   * history (/video/show/{showId}/streams/history.json), which returns one entry
   * per watched episode of the show. The resolver returns the entry matching
   * episodeId so the episode detail / VOD player can read its progress without
   * fetching the user's entire history. resumeTime is 0 when there is no userId or
   * no in-progress entry for the episode.
   */
  episodeResumeTime?: Maybe<EpisodeResumeTime>;
  episodesConfig?: Maybe<EpisodesApiResponse>;
  featureFlags?: Maybe<Scalars['JSON']['output']>;
  fms?: Maybe<FmsResponse>;
  fmsInfo?: Maybe<FmsInfo>;
  footerLinks?: Maybe<FooterLinksData>;
  /**
   * Fetches carousel configs for the front door page, mapped to CMS generic buckets.
   *
   * Bucket sources:
   * - custom: first hub carousel row from shows-featured (matches Featured Shows page order)
   * - live: On Now carousel from home configurator
   * - kids: first hub carousel row from the Kids & Family hub
   * - favorites: first default carousel from movies-featured
   * - originals / devices: no carousel
   */
  frontDoor: FrontDoorData;
  /**
   * Fetches CMS page attribute content for the front door page.
   * Returns structured sections (hero, generic buckets, FAQ) from flat CMS records.
   */
  frontDoorContent: FrontDoorContentData;
  fullConfiguration?: Maybe<Scalars['JSON']['output']>;
  /**
   * fullEpisodes for the given show + (optional) season.
   *
   * apiRawContentId: when set to an episode's contentId, the resolver populates
   * Episode._apiRaw on that one episode only and returns null for the rest. Used by
   * the episode detail / player path to surface the raw upstream Pluto item to
   * Smart Tag / MOPS without paying the per-season SSR payload multiplier
   * (~20-25 raw blobs per response).
   */
  fullEpisodes?: Maybe<FullEpisodesData>;
  gameListing?: Maybe<SingleListingResponse>;
  genrePicker?: Maybe<Array<Maybe<Genre>>>;
  getPageAttributes?: Maybe<PageAttributesResponse>;
  getParentalControlPIN?: Maybe<ParentalControlPin>;
  heroData?: Maybe<HeroApiResponse>;
  homeConfig?: Maybe<HomeConfig>;
  isValidParentalControlPIN?: Maybe<Scalars['Boolean']['output']>;
  listing?: Maybe<ListingNormalizedResponse>;
  listings?: Maybe<ListingsResponse>;
  liveStreamInfo?: Maybe<LiveStreamInfoResponse>;
  localPlaybackInfo?: Maybe<DmaResponse>;
  locationResolver?: Maybe<PositionDetails>;
  manageDevicesPageAttributes?: Maybe<ManageDevicesPageAttributesResponse>;
  marqueeData?: Maybe<TransformedMarquee>;
  mediaBrowse?: Maybe<MediaBrowseResponse>;
  merchandiseContentPageAttributes?: Maybe<MerchandiseContentResponse>;
  /**
   * The records of one page-attribute source as the client holds it (a row
   * edited in the editor, or saved to the client override layer, which the
   * server documents do not carry). `cbscidmt` and `promo` target the DirectAB
   * lookup as the request's own did, so a copy experiment buckets the row as it
   * buckets the page; they add no campaign sibling. Null in production.
   */
  mosaicPageAttributeSource?: Maybe<MosaicPageAttributeSourceRecords>;
  /**
   * `cbscidmt`: a campaign id; its `campaign_<id>` records on the untagged sources
   * are appended after the base records as the campaign copy overlay.
   */
  mosaicPageAttributes?: Maybe<MosaicPageAttributesResponse>;
  /**
   * `cbscidmt`: a campaign id; it targets the experiment lookup, picks the
   * campaign page document and appends the `campaign_<id>` records as the
   * campaign overlay. `promo`: the request's promo code, for the experiment
   * lookup only; a CMS `promo_code` on the page copy wins over it, as on the
   * classic page (which derives both from its own query; a resolver cannot).
   * `flowType`: the route's flow (`dtc`, `edu`, `livetv`), for the lookup's
   * audiences; a resolver cannot derive it from its own URL either. `variants`:
   * `false` skips every experiment lookup and reports no exposure, for a response
   * a shared cache will serve to other visitors.
   */
  mosaicPageDocuments?: Maybe<MosaicPageDocumentsResponse>;
  movie?: Maybe<MovieResponse>;
  movieDetail?: Maybe<MovieHomeData>;
  mvpdLogo?: Maybe<MvpdLogo>;
  myListConfig?: Maybe<Array<Maybe<WatchListItem>>>;
  myListIds?: Maybe<Array<Scalars['String']['output']>>;
  nav?: Maybe<Nav>;
  nextItem?: Maybe<NextItemResponse>;
  nextVideo?: Maybe<VideoNextResponse>;
  pageAttributes?: Maybe<Scalars['JSON']['output']>;
  pageAttributesFoundation?: Maybe<Scalars['JSON']['output']>;
  pageAttributesWithUserFoundation?: Maybe<Scalars['JSON']['output']>;
  parentalControlRatings?: Maybe<Array<ParentalControlRatingLabel>>;
  paymentGateway?: Maybe<PaymentGatewayResponse>;
  planPageAttributes?: Maybe<PlanPageAttributesResponse>;
  preselectedCreditCardGateway?: Maybe<PreselectedCreditCardGatewayResponse>;
  prevNextInfo?: Maybe<PrevNextResponse>;
  product?: Maybe<ProductResponse>;
  products?: Maybe<ProductsResponse>;
  profileRatings?: Maybe<Array<Maybe<ProfileLevel>>>;
  ptvStart?: Maybe<StartResponse>;
  redeemCoupon?: Maybe<RedeemCouponResponse>;
  region?: Maybe<Region>;
  regionalConfiguration?: Maybe<Scalars['JSON']['output']>;
  rendezvousCompletePageAttributes?: Maybe<RendezvousCompletePageAttributeQueryResponse>;
  rendezvousPageAttributes?: Maybe<RendezvousPageAttributeQueryResponse>;
  rendezvousSignInOptions?: Maybe<RendezvousSignInOptionsQueryResponse>;
  searchConfig: SearchConfigResponse;
  searchSuggestions: SuggestionsResponse;
  searchVODContent: SearchVodContentResult;
  searchVideoCarousel: SearchVideoCarouselResult;
  seoHreflang?: Maybe<TransformedSeoHreflangResponse>;
  seoMetadata?: Maybe<SeoResponse>;
  seriesHistory?: Maybe<SeriesHistoryResponse>;
  sessionToken?: Maybe<SessionTokenResponse>;
  showHome?: Maybe<ShowHomeData>;
  showPicker?: Maybe<Array<Maybe<Show>>>;
  showSlugById?: Maybe<ShowSlugById>;
  signInPageAttributes?: Maybe<SignInPageAttributeQueryResponse>;
  signUpPageAttributes?: Maybe<SignUpPageAttributeQueryResponse>;
  signedInDevices?: Maybe<DeviceListResponse>;
  stitcherStreamingUrl?: Maybe<StitcherStreamingUrlResponse>;
  streamHistory?: Maybe<StreamHistoryResponse>;
  streamingUrl?: Maybe<StreamingUrlResponse>;
  translations?: Maybe<Scalars['JSON']['output']>;
  upNext?: Maybe<UpNextResponse>;
  upsellPage?: Maybe<UpsellPageResponse>;
  upsellPageAttributes?: Maybe<UpsellPageAttributeQueryResponse>;
  userAccountSettings?: Maybe<UserAccountSettings>;
  userFullProfile?: Maybe<FullUser>;
  userInfo?: Maybe<UserInfo>;
  userProfiles?: Maybe<Array<Maybe<UserProfile>>>;
  userRegion?: Maybe<Scalars['String']['output']>;
  userSession?: Maybe<UserSessionResponse>;
  userSignIn?: Maybe<UserSignInResponse>;
  userStatus?: Maybe<UserStatus>;
  userSubscription?: Maybe<UserSubscriptionResponse>;
  video?: Maybe<VideoResponse>;
  videoInfo?: Maybe<VideoResponse>;
  videoItem?: Maybe<VideoItemData>;
};


export type QueryAbTestVariantsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryAbTestsVariantsArgs = {
  input: AbTestsVariantsInput;
};


export type QueryAccountPageAttributesArgs = {
  tags: Scalars['String']['input'];
  userRegistrationRegion?: InputMaybe<Scalars['String']['input']>;
  userState: Scalars['String']['input'];
};


export type QueryAllMoviesMockArgs = {
  params: AllMoviesMockParams;
};


export type QueryAvatarByUuidArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryAvatarGroupsArgs = {
  profileType: ProfileType;
};


export type QueryBrowseNavArgs = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  extraParams: UserParams;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignPageAttributesArgs = {
  cbscidmt?: InputMaybe<Scalars['String']['input']>;
  clientUserGuid?: InputMaybe<Scalars['String']['input']>;
  flowType?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCarouselArgs = {
  apiUrl: Scalars['String']['input'];
};


export type QueryCarouselDataArgs = {
  carouselParams: CarouselParams;
  token: Scalars['String']['input'];
};


export type QueryChannelCategoriesArgs = {
  params?: InputMaybe<ChannelCategoriesParams>;
};


export type QueryChannelsArgs = {
  params?: InputMaybe<ChannelParams>;
};


export type QueryCheckEmailArgs = {
  formFields: CheckEmailFormFields;
};


export type QueryCollectionArgs = {
  extraParams?: InputMaybe<Scalars['JSON']['input']>;
  isChildCategory?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommunityFeedbackArgs = {
  feedbackType?: InputMaybe<Scalars['String']['input']>;
  targetIds: Array<Scalars['String']['input']>;
  targetType: Scalars['String']['input'];
};


export type QueryConcurrencyArgs = {
  params?: InputMaybe<ConcurrencyParams>;
};


export type QueryContentHighlightMetadataArgs = {
  input: ContentHighlightMetadataInput;
};


export type QueryCtaAttributesArgs = {
  billingCadence?: InputMaybe<Scalars['String']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userState?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCurrentListingArgs = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  dma?: InputMaybe<Scalars['Int']['input']>;
  secondsFromLiveEdge?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryDmaInfoArgs = {
  params: DmaParams;
};


export type QueryEditPasswordArgs = {
  email: Scalars['String']['input'];
};


export type QueryEpisodeResumeTimeArgs = {
  episodeId: Scalars['String']['input'];
  showId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEpisodesConfigArgs = {
  seasonNumber?: InputMaybe<Scalars['String']['input']>;
  showId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFmsArgs = {
  params?: InputMaybe<FmsQueryParams>;
};


export type QueryFooterLinksArgs = {
  hubType: FooterHubType;
};


export type QueryFullConfigurationArgs = {
  region: Scalars['String']['input'];
};


export type QueryFullEpisodesArgs = {
  apiRawContentId?: InputMaybe<Scalars['String']['input']>;
  begin?: InputMaybe<Scalars['Int']['input']>;
  seasonNum?: InputMaybe<Scalars['String']['input']>;
  showId: Scalars['String']['input'];
};


export type QueryGameListingArgs = {
  gameId: Scalars['Int']['input'];
  params?: InputMaybe<GameListingParams>;
};


export type QueryGenrePickerArgs = {
  profileId: Scalars['String']['input'];
};


export type QueryGetPageAttributesArgs = {
  configKey: Scalars['String']['input'];
};


export type QueryHeroDataArgs = {
  token: Scalars['String']['input'];
};


export type QueryHomeConfigArgs = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  extraParams?: InputMaybe<HomeParams>;
};


export type QueryIsValidParentalControlPinArgs = {
  pin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListingArgs = {
  listingId: Scalars['String']['input'];
};


export type QueryListingsArgs = {
  channelSlug?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ListingParams>;
};


export type QueryLiveStreamInfoArgs = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mvpdId?: InputMaybe<Scalars['String']['input']>;
  stationName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocalPlaybackInfoArgs = {
  params: LocalPlaybackParams;
};


export type QueryLocationResolverArgs = {
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarqueeDataArgs = {
  token: Scalars['String']['input'];
};


export type QueryMediaBrowseArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMosaicPageAttributeSourceArgs = {
  cbscidmt?: InputMaybe<Scalars['String']['input']>;
  filterOtherTagged?: InputMaybe<Scalars['Boolean']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortByOrder?: InputMaybe<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  url: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type QueryMosaicPageAttributesArgs = {
  cbscidmt?: InputMaybe<Scalars['String']['input']>;
  islandIds: Array<Scalars['String']['input']>;
};


export type QueryMosaicPageDocumentsArgs = {
  cbscidmt?: InputMaybe<Scalars['String']['input']>;
  flowType?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['String']['input'];
  promo?: InputMaybe<Scalars['String']['input']>;
  variants?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMovieArgs = {
  params?: InputMaybe<MovieParams>;
};


export type QueryMovieDetailArgs = {
  id: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMvpdLogoArgs = {
  adobeId: Scalars['String']['input'];
};


export type QueryMyListConfigArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyListIdsArgs = {
  rows?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNavArgs = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  extraParams: UserParams;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNextItemArgs = {
  contentId: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  sectionId?: InputMaybe<Scalars['String']['input']>;
  showId: Scalars['String']['input'];
};


export type QueryNextVideoArgs = {
  params?: InputMaybe<NextVideoParams>;
};


export type QueryPageAttributesArgs = {
  filterOtherTagged?: InputMaybe<Scalars['Boolean']['input']>;
  includeTagged?: InputMaybe<Scalars['Boolean']['input']>;
  pageUrl: Scalars['String']['input'];
  tags?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
};


export type QueryPageAttributesFoundationArgs = {
  filterOtherTagged?: InputMaybe<Scalars['Boolean']['input']>;
  includeTagged?: InputMaybe<Scalars['Boolean']['input']>;
  pageUrl: Scalars['String']['input'];
  tags?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPageAttributesWithUserFoundationArgs = {
  filterOtherTagged?: InputMaybe<Scalars['Boolean']['input']>;
  includeTagged?: InputMaybe<Scalars['Boolean']['input']>;
  pageUrl: Scalars['String']['input'];
  tags?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentGatewayArgs = {
  region?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlanPageAttributesArgs = {
  cbscidmt?: InputMaybe<Scalars['String']['input']>;
  clientUserGuid?: InputMaybe<Scalars['String']['input']>;
  flowType?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPrevNextInfoArgs = {
  cbsCom: Scalars['String']['input'];
  contentId: Scalars['String']['input'];
  liveContent?: InputMaybe<Scalars['String']['input']>;
  mvpd?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductArgs = {
  productCode: Scalars['String']['input'];
  userRegistrationRegion?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductsArgs = {
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPtvStartArgs = {
  params?: InputMaybe<StartParameters>;
};


export type QueryRedeemCouponArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRegionalConfigurationArgs = {
  region: Scalars['String']['input'];
};


export type QuerySearchConfigArgs = {
  input: SearchConfigInput;
};


export type QuerySearchSuggestionsArgs = {
  input: SearchInput;
};


export type QuerySearchVodContentArgs = {
  input: SearchInput;
};


export type QuerySearchVideoCarouselArgs = {
  input: SearchInput;
};


export type QuerySeoHreflangArgs = {
  isGlobalPage?: InputMaybe<Scalars['Boolean']['input']>;
  pageType: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySeoMetadataArgs = {
  path: Scalars['String']['input'];
};


export type QuerySeriesHistoryArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QuerySessionTokenArgs = {
  params: SessionTokenParams;
};


export type QueryShowHomeArgs = {
  slug: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShowPickerArgs = {
  genreId: Scalars['String']['input'];
  packageCode: Scalars['String']['input'];
  profileId: Scalars['String']['input'];
};


export type QueryShowSlugByIdArgs = {
  id: Scalars['String']['input'];
};


export type QuerySignInPageAttributesArgs = {
  filterOtherTagged?: InputMaybe<Scalars['Boolean']['input']>;
  includeTagged?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortByOrder?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySignUpPageAttributesArgs = {
  filterOtherTagged?: InputMaybe<Scalars['Boolean']['input']>;
  includeTagged?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortByOrder?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStitcherStreamingUrlArgs = {
  contentId: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
};


export type QueryStreamHistoryArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['String']['input'];
};


export type QueryStreamingUrlArgs = {
  params: StreamingUrlParams;
};


export type QueryTranslationsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpNextArgs = {
  channelSlug?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  dma?: InputMaybe<Scalars['String']['input']>;
  endCardId: Scalars['String']['input'];
};


export type QueryUpsellPageArgs = {
  cbscidmt?: InputMaybe<Scalars['String']['input']>;
  flowType?: InputMaybe<Scalars['String']['input']>;
  ftag?: InputMaybe<Scalars['String']['input']>;
  intcid?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpsellPageAttributesArgs = {
  cbscidmt?: InputMaybe<Scalars['String']['input']>;
  clientUserGuid?: InputMaybe<Scalars['String']['input']>;
  flowType?: InputMaybe<Scalars['String']['input']>;
  ftag?: InputMaybe<Scalars['String']['input']>;
  intcid?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserSignInArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type QueryVideoArgs = {
  params?: InputMaybe<VideoParams>;
};


export type QueryVideoInfoArgs = {
  CCRVersion?: InputMaybe<Scalars['String']['input']>;
  CrKey?: InputMaybe<Scalars['String']['input']>;
  DeviceType?: InputMaybe<Scalars['String']['input']>;
  accessToken?: InputMaybe<Scalars['String']['input']>;
  adTrackingType?: InputMaybe<Scalars['String']['input']>;
  cbsCom?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['String']['input'];
  delay?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mvpd?: InputMaybe<Scalars['String']['input']>;
  privacyInfo?: InputMaybe<PrivacyInfo>;
  senderAppName?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  stationName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVideoItemArgs = {
  contentId: Scalars['String']['input'];
  userStatus?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPlanPageAttrArgs = {
  __typename?: 'QueryPlanPageAttrArgs';
  cbscidmt?: Maybe<Scalars['String']['output']>;
  flowType?: Maybe<Scalars['String']['output']>;
  promo?: Maybe<Scalars['String']['output']>;
};

export type RatingGroup = {
  __typename?: 'RatingGroup';
  code?: Maybe<Scalars['String']['output']>;
  ratings?: Maybe<Scalars['String']['output']>;
};

export type RecentChannelsApiResponse = {
  __typename?: 'RecentChannelsApiResponse';
  channels?: Maybe<Array<Maybe<FavoriteChannelItem>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RecommendationApiResponse = {
  __typename?: 'RecommendationApiResponse';
  displayShowTitle?: Maybe<Scalars['Boolean']['output']>;
  response?: Maybe<Array<Maybe<RecommendationItem>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RecommendationContent = {
  __typename?: 'RecommendationContent';
  castNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  continuousPlaybackMode?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  medTime?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<ItemList>;
  movie?: Maybe<MovieRecommendation>;
  playbackModeCTA?: Maybe<Scalars['String']['output']>;
  recommendationSource?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showAbout?: Maybe<Scalars['String']['output']>;
  showAssets?: Maybe<ShowAssets>;
  showId?: Maybe<Scalars['Int']['output']>;
  showSlug?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Int']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  videoStartingPoint?: Maybe<Scalars['String']['output']>;
};

export type RecommendationItem = {
  __typename?: 'RecommendationItem';
  content?: Maybe<RecommendationContent>;
  content_type?: Maybe<Scalars['String']['output']>;
};

export type Recommendations = {
  __typename?: 'Recommendations';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channelSlug?: Maybe<Scalars['String']['output']>;
  contentCANDetails?: Maybe<ContentCanVideo>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  context?: Maybe<CanContext>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTimeStamp?: Maybe<Scalars['Float']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  isListingLive?: Maybe<Scalars['Boolean']['output']>;
  listingId?: Maybe<Scalars['Int']['output']>;
  logoImage?: Maybe<Scalars['String']['output']>;
  medTime?: Maybe<Scalars['Int']['output']>;
  playbackModeCTA?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rating?: Maybe<Scalars['String']['output']>;
  recommendationSource?: Maybe<Scalars['String']['output']>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  seasons?: Maybe<Scalars['String']['output']>;
  showId?: Maybe<Scalars['Int']['output']>;
  startTimestamp?: Maybe<Scalars['Float']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trailerCANDetails?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Region = {
  __typename?: 'Region';
  locale?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type RegionalRating = {
  __typename?: 'RegionalRating';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingIcon?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type RegionalRatings = {
  __typename?: 'RegionalRatings';
  consumerAdvice?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingIcon?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondaryDescriptors?: Maybe<Scalars['String']['output']>;
  subratings?: Maybe<Array<Maybe<Subratings>>>;
};

export type RemoveCommunityFeedbackInput = {
  feedbackType: Scalars['String']['input'];
  targetId: Scalars['String']['input'];
  targetType: Scalars['String']['input'];
};

export type RendezvousCompletePageAttribute = {
  __typename?: 'RendezvousCompletePageAttribute';
  aa_rendezvous_image?: Maybe<Scalars['String']['output']>;
  aa_steps_header?: Maybe<Scalars['String']['output']>;
  completion_message?: Maybe<Scalars['String']['output']>;
};

export type RendezvousCompletePageAttributeQueryResponse = {
  __typename?: 'RendezvousCompletePageAttributeQueryResponse';
  pageAttribute?: Maybe<RendezvousCompletePageAttribute>;
  variantsForTracking: Array<Scalars['String']['output']>;
};

export type RendezvousPageAttributeQueryResponse = {
  __typename?: 'RendezvousPageAttributeQueryResponse';
  aa_rendezvous_image?: Maybe<Scalars['String']['output']>;
  aa_step_header_device_agnostic?: Maybe<Scalars['String']['output']>;
  aa_steps_header?: Maybe<Scalars['String']['output']>;
  cta_form_submit?: Maybe<Scalars['String']['output']>;
  faq_text_with_link?: Maybe<Scalars['String']['output']>;
  generic_error?: Maybe<Scalars['String']['output']>;
  mvpd_dma_dispute_link_comcast?: Maybe<Scalars['String']['output']>;
  mvpd_dma_dispute_link_title_comcast?: Maybe<Scalars['String']['output']>;
  mvpd_dma_dispute_subtitle_comcast?: Maybe<Scalars['String']['output']>;
  mvpd_dma_dispute_title_comcast?: Maybe<Scalars['String']['output']>;
  pageURL?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RendezvousSignInOptionsQueryResponse = {
  __typename?: 'RendezvousSignInOptionsQueryResponse';
  ctaPartner?: Maybe<Scalars['String']['output']>;
  ctaSignIn?: Maybe<Scalars['String']['output']>;
  ctaSignUp?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  showPartnerCta: Scalars['Boolean']['output'];
  subHeading?: Maybe<Scalars['String']['output']>;
};

export type Result = {
  __typename?: 'Result';
  carouselId?: Maybe<Scalars['String']['output']>;
  carouselPEM?: Maybe<Scalars['JSON']['output']>;
  carouselPresentationStyle?: Maybe<Scalars['String']['output']>;
  contentHighlight?: Maybe<Scalars['Boolean']['output']>;
  data: Array<CarouselItem>;
  dataCi?: Maybe<Scalars['String']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includeProfileDropdown?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isTitleDisplayed?: Maybe<Scalars['Boolean']['output']>;
  leftArrow?: Maybe<Scalars['String']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  pagePEM?: Maybe<Scalars['JSON']['output']>;
  pvr_model?: Maybe<Scalars['String']['output']>;
  rank_model?: Maybe<Scalars['String']['output']>;
  recoId?: Maybe<Scalars['String']['output']>;
  rightArrow?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Results = {
  __typename?: 'Results';
  sectionItems?: Maybe<SectionItems>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

export type SearchConfigInput = {
  extraParams?: InputMaybe<Scalars['JSON']['input']>;
};

export type SearchConfigResponse = {
  __typename?: 'SearchConfigResponse';
  config: Array<SearchPageConfig>;
  success?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SearchInput = {
  extraParams?: InputMaybe<Scalars['JSON']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type SearchLiveResponse = {
  __typename?: 'SearchLiveResponse';
  liveEvents?: Maybe<Array<Maybe<LiveEvent>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchPageConfig = {
  __typename?: 'SearchPageConfig';
  apiBaseUrl?: Maybe<Scalars['String']['output']>;
  apiParams?: Maybe<ApiParams>;
  apiUrl?: Maybe<Scalars['String']['output']>;
  carouselId?: Maybe<Scalars['String']['output']>;
  carouselPresentationStyle: Scalars['String']['output'];
  carouselType?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includeVersion?: Maybe<Scalars['Boolean']['output']>;
  isContentHighlightEnabled: Scalars['Boolean']['output'];
  isMarquee?: Maybe<Scalars['Boolean']['output']>;
  isMyList?: Maybe<Scalars['Boolean']['output']>;
  model: Scalars['String']['output'];
  orientation?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  promotionalSpot?: Maybe<Scalars['JSON']['output']>;
  pvrModel?: Maybe<Scalars['String']['output']>;
  rankModel?: Maybe<Scalars['String']['output']>;
  recoId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type SearchResponse = {
  __typename?: 'SearchResponse';
  terms: Array<SearchResult>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  about?: Maybe<Scalars['String']['output']>;
  availableVideoSeasons?: Maybe<Array<AvailableVideoSeason>>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  cms_id?: Maybe<Scalars['Int']['output']>;
  content_id?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  entitlementCodes?: Maybe<Array<Scalars['String']['output']>>;
  genre?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  k?: Maybe<Scalars['String']['output']>;
  movieAssets?: Maybe<MovieAssets>;
  /**
   * Movie document id for `/movies/{id}/` and `GET /movies/{id}.json` (same as configurator `movieContentId`).
   * Prefer this over `cms_id` / `show_id` when the search API returns numeric CMS ids for movies.
   */
  movieContentId?: Maybe<Scalars['String']['output']>;
  movie_content_id?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  platform_type?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  rank_score?: Maybe<Scalars['Int']['output']>;
  regionalRatings?: Maybe<Array<RegionalRating>>;
  requiredAddOns?: Maybe<Array<Scalars['String']['output']>>;
  showAssets?: Maybe<ShowAssets>;
  showId?: Maybe<Scalars['Int']['output']>;
  showPremiereDateStr?: Maybe<Scalars['String']['output']>;
  /** Show slug for series detail URLs when the search API provides it explicitly. */
  showSlug?: Maybe<Scalars['String']['output']>;
  showTitle?: Maybe<Scalars['String']['output']>;
  show_id?: Maybe<Scalars['Int']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  term_type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  tv_age_rating?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type SearchVodContentResult = {
  __typename?: 'SearchVODContentResult';
  data: Array<CarouselItem>;
  pvrModel?: Maybe<Scalars['String']['output']>;
  rankModel?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchVideoCarouselResult = {
  __typename?: 'SearchVideoCarouselResult';
  data: Array<LiveCarouselItem>;
  pvrModel?: Maybe<Scalars['String']['output']>;
  rankModel?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Section = {
  __typename?: 'Section';
  background_hex_color?: Maybe<Scalars['String']['output']>;
  background_image?: Maybe<Scalars['String']['output']>;
  display_seasons?: Maybe<Scalars['Boolean']['output']>;
  gradient_hex_color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  layout_type?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  seasons_default?: Maybe<Scalars['String']['output']>;
  seasons_sort_order?: Maybe<Scalars['String']['output']>;
  sectionItems: SectionItems;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  section_type?: Maybe<Scalars['String']['output']>;
  viewing_window?: Maybe<Scalars['Boolean']['output']>;
};

export type SectionItems = {
  __typename?: 'SectionItems';
  action?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  itemList: Array<ItemList>;
  resultSize?: Maybe<Scalars['Int']['output']>;
};

export type SendForgotPasswordLinkResponse = {
  __typename?: 'SendForgotPasswordLinkResponse';
  success: Scalars['Boolean']['output'];
};

export type SeoContent = {
  __typename?: 'SeoContent';
  all_locales?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created_date?: Maybe<Scalars['Int']['output']>;
  filepath_fb_image?: Maybe<Scalars['String']['output']>;
  filepath_tw_image?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  k?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_social_desc?: Maybe<Scalars['String']['output']>;
  meta_social_title?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  meta_url?: Maybe<Scalars['String']['output']>;
  override_android_deeplink_url?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  show_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SeoHreflangResponse = {
  __typename?: 'SeoHreflangResponse';
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  identifier?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SeoResponse = {
  __typename?: 'SeoResponse';
  description: Scalars['String']['output'];
  facebookImage?: Maybe<Scalars['String']['output']>;
  socialDescription?: Maybe<Scalars['String']['output']>;
  socialTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  twitterImage?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SeriesHistoryResponse = {
  __typename?: 'SeriesHistoryResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
  video?: Maybe<SeriesHistoryVideo>;
};

export type SeriesHistoryVideo = {
  __typename?: 'SeriesHistoryVideo';
  continuousPlaybackMode?: Maybe<Scalars['String']['output']>;
  currentListingsSize?: Maybe<Scalars['Int']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  medTime?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<ContentCanVideo>;
  playbackModeCTA?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showId?: Maybe<Scalars['Int']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
};

export type Session = {
  __typename?: 'Session';
  id?: Maybe<Scalars['String']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
};

export type SessionTokenParams = {
  billingVendor: Scalars['String']['input'];
  contentId: Scalars['String']['input'];
  packageCode: Scalars['String']['input'];
  platformType: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  userProfileType: Scalars['String']['input'];
  userRegistrationCountry: Scalars['String']['input'];
  userState: Scalars['String']['input'];
};

export type SessionTokenResponse = {
  __typename?: 'SessionTokenResponse';
  results?: Maybe<SessionTokenResults>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SessionTokenResults = {
  __typename?: 'SessionTokenResults';
  daiParams?: Maybe<DaiParams>;
  ls_session?: Maybe<Scalars['String']['output']>;
  ruleIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  rulesMatched?: Maybe<Scalars['Boolean']['output']>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Show = {
  __typename?: 'Show';
  id: Scalars['ID']['output'];
  isContentAccessibleInCMS: Scalars['Boolean']['output'];
  thumbnail: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ShowAssets = {
  __typename?: 'ShowAssets';
  filepath_apple_airplay?: Maybe<Scalars['String']['output']>;
  filepath_apple_top_shelf?: Maybe<Scalars['String']['output']>;
  filepath_mobile_endcard?: Maybe<Scalars['String']['output']>;
  filepath_ott_hd_show_image_overhang?: Maybe<Scalars['String']['output']>;
  filepath_partner_brand_logo?: Maybe<Scalars['String']['output']>;
  filepath_show_browse_poster?: Maybe<Scalars['String']['output']>;
  filepath_show_browse_poster_thin?: Maybe<Scalars['String']['output']>;
  filepath_show_description_poster_thin?: Maybe<Scalars['String']['output']>;
  filepath_show_hero_compact?: Maybe<Scalars['String']['output']>;
  filepath_show_hero_landscape?: Maybe<Scalars['String']['output']>;
  filepath_show_hero_portrait?: Maybe<Scalars['String']['output']>;
  filepath_show_hero_regular?: Maybe<Scalars['String']['output']>;
  filepath_show_page_header?: Maybe<Scalars['String']['output']>;
  filepath_show_thumbnail?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_center?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_compact?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_left?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_regular?: Maybe<Scalars['String']['output']>;
  filepath_video_endcard_show_image?: Maybe<Scalars['String']['output']>;
  filepath_video_start_screen?: Maybe<Scalars['String']['output']>;
};

export type ShowAssetsDetailData = {
  __typename?: 'ShowAssetsDetailData';
  filepath_partner_brand_logo?: Maybe<Scalars['String']['output']>;
  filepath_show_browse_poster?: Maybe<Scalars['String']['output']>;
  filepath_show_browse_poster_alt1?: Maybe<Scalars['String']['output']>;
  filepath_show_browse_poster_alt2?: Maybe<Scalars['String']['output']>;
  filepath_show_browse_poster_alt3?: Maybe<Scalars['String']['output']>;
  filepath_show_browse_poster_alt4?: Maybe<Scalars['String']['output']>;
  filepath_show_hero_compact?: Maybe<Scalars['String']['output']>;
  filepath_show_hero_regular?: Maybe<Scalars['String']['output']>;
  filepath_show_page_header?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_center?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_left?: Maybe<Scalars['String']['output']>;
  filepath_title_logo_regular?: Maybe<Scalars['String']['output']>;
  filepath_video_endcard_show_image?: Maybe<Scalars['String']['output']>;
  filepath_video_endcard_show_image_alt1?: Maybe<Scalars['String']['output']>;
  filepath_video_endcard_show_image_alt2?: Maybe<Scalars['String']['output']>;
  filepath_video_endcard_show_image_alt3?: Maybe<Scalars['String']['output']>;
  filepath_video_endcard_show_image_alt4?: Maybe<Scalars['String']['output']>;
};

export type ShowCarouselItem = CarouselItem & CommonContentFields & {
  __typename?: 'ShowCarouselItem';
  addOns?: Maybe<Scalars['String']['output']>;
  airDateISO?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  badgeLabel?: Maybe<Scalars['String']['output']>;
  bundleLocked?: Maybe<Scalars['Boolean']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  contentCANVideo?: Maybe<CanModel>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  ctaActionType?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  episodeId?: Maybe<Scalars['String']['output']>;
  episodeNumber?: Maybe<Scalars['String']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<Scalars['String']['output']>;
  heroCompact?: Maybe<Scalars['String']['output']>;
  highlightImage?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isContentHighlightEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEpisodeLess?: Maybe<Scalars['Boolean']['output']>;
  isHighlightMetadataPartial?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isSeasonLess?: Maybe<Scalars['Boolean']['output']>;
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoCenter?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  numSeasons?: Maybe<Scalars['Int']['output']>;
  numericLabel?: Maybe<Scalars['Int']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  premiereDate?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  progressText?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingBadge?: Maybe<Scalars['String']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  runtime?: Maybe<Scalars['Int']['output']>;
  seasonNumber?: Maybe<Scalars['String']['output']>;
  showId?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  showPath?: Maybe<Scalars['String']['output']>;
  showTitle?: Maybe<Scalars['String']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbLandscape?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type ShowCollectionEntity = {
  __typename?: 'ShowCollectionEntity';
  about?: Maybe<Scalars['String']['output']>;
  availableVideoSeasons?: Maybe<Array<Maybe<AvailableVideoSeasons>>>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  category?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rating?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showAssets?: Maybe<ShowAssets>;
  showId?: Maybe<Scalars['String']['output']>;
  showPath?: Maybe<Scalars['String']['output']>;
  showPremiereDateStr?: Maybe<Scalars['String']['output']>;
  showTitle?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type ShowData = {
  __typename?: 'ShowData';
  episodeData?: Maybe<EpisodeData>;
  seasonsCount?: Maybe<Scalars['Int']['output']>;
  showId: Scalars['String']['output'];
};

export type ShowDataWrapper = {
  __typename?: 'ShowDataWrapper';
  end: Scalars['Int']['output'];
  numFound: Scalars['Int']['output'];
  results: Array<ShowObject>;
  start: Scalars['Int']['output'];
};

export type ShowDetail = {
  __typename?: 'ShowDetail';
  brand?: Maybe<Scalars['String']['output']>;
  brandUrl?: Maybe<Scalars['String']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Per-episode resume positions for the current user, scoped to this show
   * (filtered by canModel.cbsShowId === show_id). Empty when no userId is
   * provided or the user has no in-progress episodes for this show. Sourced
   * from /video/streams/history.json (the read counterpart to Sparrow's
   * progress beacons). Episode pages look up the playing episode's contentId
   * here to resume from the correct position without an extra round trip.
   */
  episodeResumeTimes?: Maybe<Array<EpisodeResumeTime>>;
  genre?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
  numSeasons?: Maybe<Scalars['Int']['output']>;
  premiereDate?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  regionalRatings?: Maybe<Array<RegionalRatings>>;
  resumeTime?: Maybe<Scalars['Int']['output']>;
  seasons?: Maybe<Array<AvailableVideoSeasons>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showAssets?: Maybe<ShowAssetsDetailData>;
  showEpisodeGuideLink?: Maybe<Scalars['Boolean']['output']>;
  showEpisodeId?: Maybe<Scalars['String']['output']>;
  showEpisodeTitle?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type ShowDetailHero = DetailHero & {
  __typename?: 'ShowDetailHero';
  airDate?: Maybe<Scalars['Float']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  brandUrl?: Maybe<Scalars['String']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  cast?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  detailCta?: Maybe<DetailCta>;
  duration?: Maybe<Scalars['Int']['output']>;
  episodeDescription?: Maybe<Scalars['String']['output']>;
  episodeNum?: Maybe<Scalars['String']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  heroType?: Maybe<HeroType>;
  logo?: Maybe<Scalars['String']['output']>;
  numSeasons?: Maybe<Scalars['Int']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  progress?: Maybe<Scalars['Int']['output']>;
  regionalRating?: Maybe<RegionalRatings>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  srcSetLandscape?: Maybe<Scalars['String']['output']>;
  srcSetPortrait?: Maybe<Scalars['String']['output']>;
  standardImgForAllScreens?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type ShowDetailsResponse = {
  __typename?: 'ShowDetailsResponse';
  available_video_seasons?: Maybe<AvailableVideoSeasonsData>;
  brand?: Maybe<BrandItem>;
  show?: Maybe<ShowDataWrapper>;
  showAssets?: Maybe<ShowAssetsDetailData>;
  showMenu?: Maybe<Array<ShowMenuItem>>;
  success: Scalars['Boolean']['output'];
};

export type ShowHomeData = {
  __typename?: 'ShowHomeData';
  carouselConfigs?: Maybe<Array<Config>>;
  hero?: Maybe<DetailHero>;
  show?: Maybe<ShowDetail>;
};

export type ShowHomeItem = {
  __typename?: 'ShowHomeItem';
  about?: Maybe<Scalars['String']['output']>;
  about_long_text_s?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  brand_slug?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  category_id?: Maybe<Scalars['String']['output']>;
  content_type_show_nid?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['Float']['output']>;
  entitlementCodes?: Maybe<Array<Scalars['String']['output']>>;
  filepath_about_show?: Maybe<Scalars['String']['output']>;
  filepath_global_nav_logo?: Maybe<Scalars['String']['output']>;
  filepath_show_connect_img?: Maybe<Scalars['String']['output']>;
  filepath_show_thumbnail?: Maybe<Scalars['String']['output']>;
  filepath_win8_showart_large?: Maybe<Scalars['String']['output']>;
  firstAvailableDate?: Maybe<Scalars['Float']['output']>;
  genreSlugs?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  k: Scalars['String']['output'];
  keywordList?: Maybe<Array<Scalars['String']['output']>>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  link?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  regionalRatings?: Maybe<Array<RegionalRatings>>;
  requiredAddOns?: Maybe<Array<Scalars['String']['output']>>;
  season?: Maybe<Scalars['Int']['output']>;
  showPremiereDateMs?: Maybe<Scalars['Float']['output']>;
  showPremiereDateStr?: Maybe<Scalars['String']['output']>;
  show_id: Scalars['Int']['output'];
  show_thumbnail?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tune_in_time?: Maybe<Scalars['String']['output']>;
  tv_age_rating?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ShowHomeResponse = {
  __typename?: 'ShowHomeResponse';
  available_video_seasons?: Maybe<AvailableVideoSeasonsData>;
  cast?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globalMenu?: Maybe<GlobalMenuData>;
  marquees?: Maybe<Array<MarqueeItem>>;
  showMenu?: Maybe<Array<ShowMenuItem>>;
  shows?: Maybe<Array<ShowHomeItem>>;
  success: Scalars['Boolean']['output'];
};

export type ShowItem = {
  __typename?: 'ShowItem';
  about?: Maybe<Scalars['String']['output']>;
  availableVideoSeasons?: Maybe<Array<AvailableVideoSeasons>>;
  badgeLabel?: Maybe<Scalars['String']['output']>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  firstAvailableDate?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS: Scalars['Boolean']['output'];
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pvrModel?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Scalars['String']['output']>>;
  showAssets?: Maybe<ShowAssets>;
  showId: Scalars['String']['output'];
  showPath?: Maybe<Scalars['String']['output']>;
  showPremiereDateStr?: Maybe<Scalars['String']['output']>;
  showSlug?: Maybe<Scalars['String']['output']>;
  showTitle: Scalars['String']['output'];
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  subVideoStartingPointCTA?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type ShowMenuItem = {
  __typename?: 'ShowMenuItem';
  device_app_id?: Maybe<Scalars['String']['output']>;
  device_app_secret?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  links?: Maybe<Array<ShowMenuLink>>;
  live_date?: Maybe<Scalars['Float']['output']>;
  show_id: Scalars['Int']['output'];
};

export type ShowMenuLink = {
  __typename?: 'ShowMenuLink';
  channel_slug?: Maybe<Scalars['String']['output']>;
  currentListingsSize?: Maybe<Scalars['Int']['output']>;
  hasResultsFromVideoConfig?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  legacyAppletvMenuExpand?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  link_type: Scalars['String']['output'];
  links?: Maybe<Array<ShowMenuLink>>;
  page_type?: Maybe<Scalars['String']['output']>;
  show_menu_id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  videoConfigUniqueName?: Maybe<Scalars['String']['output']>;
};

export type ShowObject = {
  __typename?: 'ShowObject';
  about?: Maybe<Scalars['String']['output']>;
  about_long_text_s?: Maybe<Scalars['String']['output']>;
  all_locales?: Maybe<Array<Scalars['String']['output']>>;
  availableForProfileTypes?: Maybe<Array<Scalars['String']['output']>>;
  brand?: Maybe<Brand>;
  carousel_filepath?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  category_id?: Maybe<Scalars['String']['output']>;
  changed_date?: Maybe<Scalars['Float']['output']>;
  created_date?: Maybe<Scalars['Float']['output']>;
  device_restriction?: Maybe<Scalars['Int']['output']>;
  enable_android_deeplink?: Maybe<Scalars['Boolean']['output']>;
  episode_sorting?: Maybe<Scalars['String']['output']>;
  exclude_profile_slugs?: Maybe<Array<Scalars['String']['output']>>;
  filepath_about_show?: Maybe<Scalars['String']['output']>;
  filepath_apps_showart?: Maybe<Scalars['String']['output']>;
  filepath_global_nav_logo?: Maybe<Scalars['String']['output']>;
  filepath_mobile_showart_large?: Maybe<Scalars['String']['output']>;
  filepath_show_connect_img?: Maybe<Scalars['String']['output']>;
  filepath_show_thumbnail?: Maybe<Scalars['String']['output']>;
  filepath_win8_showart_large?: Maybe<Scalars['String']['output']>;
  first_available_date?: Maybe<Scalars['Float']['output']>;
  genre_slugs?: Maybe<Array<Scalars['String']['output']>>;
  hub_page_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imdb_url?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS: Scalars['Boolean']['output'];
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_show_rainmaker_unit?: Maybe<Scalars['Boolean']['output']>;
  is_video_property?: Maybe<Scalars['Boolean']['output']>;
  k: Scalars['String']['output'];
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  link?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  non_sub_video_starting_point?: Maybe<Scalars['String']['output']>;
  non_sub_video_starting_point_cta?: Maybe<Scalars['String']['output']>;
  origin_id?: Maybe<Scalars['Int']['output']>;
  path_value?: Maybe<Scalars['String']['output']>;
  premium_feature?: Maybe<Array<Scalars['String']['output']>>;
  profile_slugs?: Maybe<Array<Scalars['String']['output']>>;
  region?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Scalars['String']['output']>>;
  season?: Maybe<Scalars['Int']['output']>;
  show_finale_date_str?: Maybe<Scalars['String']['output']>;
  show_id: Scalars['Int']['output'];
  show_logo?: Maybe<Scalars['String']['output']>;
  show_premiere_date_str?: Maybe<Scalars['String']['output']>;
  show_thumbnail?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sortTitle?: Maybe<Scalars['String']['output']>;
  sort_title?: Maybe<Scalars['String']['output']>;
  sub_video_starting_point?: Maybe<Scalars['String']['output']>;
  sub_video_starting_point_cta?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tms_series_id?: Maybe<Scalars['String']['output']>;
  tune_in_time?: Maybe<Scalars['String']['output']>;
  tv_age_rating?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type ShowSlugById = {
  __typename?: 'ShowSlugById';
  slug?: Maybe<Scalars['String']['output']>;
};

export type ShowTimeAttributes = {
  __typename?: 'ShowTimeAttributes';
  ctaEvent?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  logoAlt?: Maybe<Scalars['String']['output']>;
  showTimeBundleLogo?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ShowTrendingContent = {
  __typename?: 'ShowTrendingContent';
  about?: Maybe<Scalars['String']['output']>;
  amlgSource?: Maybe<Scalars['String']['output']>;
  availableSeasonsCount?: Maybe<Scalars['Int']['output']>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  callbacks?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentType?: Maybe<Scalars['String']['output']>;
  entitlementCodes?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rating?: Maybe<Scalars['String']['output']>;
  recoId?: Maybe<Scalars['String']['output']>;
  requiredAddOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showAssets?: Maybe<ShowAssets>;
  showCategory?: Maybe<Scalars['String']['output']>;
  showId?: Maybe<Scalars['String']['output']>;
  showPremiereDateStr?: Maybe<Scalars['String']['output']>;
  showTitle?: Maybe<Scalars['String']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Array<Scalars['String']['output']>>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type SignInFormFields = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe?: InputMaybe<Scalars['Int']['input']>;
};

export type SignInPageAttribute = {
  __typename?: 'SignInPageAttribute';
  aa_steps_header?: Maybe<Scalars['String']['output']>;
  mvpd_connect_cta?: Maybe<Scalars['String']['output']>;
  mvpd_copy_above_connect_cta?: Maybe<Scalars['String']['output']>;
  mvpd_dma_dispute_link_comcast?: Maybe<Scalars['String']['output']>;
  mvpd_dma_dispute_link_title_comcast?: Maybe<Scalars['String']['output']>;
  mvpd_dma_dispute_subtitle_comcast?: Maybe<Scalars['String']['output']>;
  mvpd_dma_dispute_title_comcast?: Maybe<Scalars['String']['output']>;
  pageURL?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SignInPageAttributeQueryResponse = {
  __typename?: 'SignInPageAttributeQueryResponse';
  pageAttributes?: Maybe<Array<Maybe<SignInPageAttribute>>>;
  variantsForTracking: Array<Scalars['String']['output']>;
};

export type SignInResponse = {
  __typename?: 'SignInResponse';
  maxLoginAttempts?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Scalars['String']['output']>>;
  mvpdDispute?: Maybe<MvpdDispute>;
  success: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type SignUpFormFields = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  optIn: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
  requiredAgreement: Scalars['Boolean']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type SignUpPageAttribute = {
  __typename?: 'SignUpPageAttribute';
  aa_sign_up_disclaimer?: Maybe<Scalars['String']['output']>;
  aa_sign_up_optin?: Maybe<Scalars['String']['output']>;
  aa_steps_header?: Maybe<Scalars['String']['output']>;
  currentCountry?: Maybe<Scalars['String']['output']>;
  marketing_optin_checked?: Maybe<Scalars['String']['output']>;
  marketing_optin_copy_1?: Maybe<Scalars['String']['output']>;
  marketing_optin_copy_2?: Maybe<Scalars['String']['output']>;
  marketing_optin_countries_1?: Maybe<Scalars['String']['output']>;
  marketing_optin_countries_2?: Maybe<Scalars['String']['output']>;
  pageURL?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  terms_checkbox_enabled?: Maybe<Scalars['String']['output']>;
  terms_copy?: Maybe<Scalars['String']['output']>;
  terms_copy_with_links?: Maybe<Scalars['String']['output']>;
};

export type SignUpPageAttributeQueryResponse = {
  __typename?: 'SignUpPageAttributeQueryResponse';
  pageAttributes?: Maybe<Array<Maybe<SignUpPageAttribute>>>;
  variantsForTracking: Array<Scalars['String']['output']>;
};

export type SignUpResponse = {
  __typename?: 'SignUpResponse';
  errors?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type SingleListingResponse = {
  __typename?: 'SingleListingResponse';
  channel?: Maybe<Array<Maybe<Channel>>>;
  listing?: Maybe<ChannelListing>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SlideMetadata = {
  __typename?: 'SlideMetadata';
  rating?: Maybe<Scalars['String']['output']>;
  ratingIcon?: Maybe<Scalars['String']['output']>;
  unifiedGenre?: Maybe<Scalars['String']['output']>;
};

export type SpotlightCarouselItem = CarouselItem & {
  __typename?: 'SpotlightCarouselItem';
  animatedBackground?: Maybe<Scalars['String']['output']>;
  aspectRatio?: Maybe<Scalars['String']['output']>;
  badgeLabel?: Maybe<Scalars['String']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  channelName?: Maybe<Scalars['String']['output']>;
  channelOriginId?: Maybe<Scalars['String']['output']>;
  channelSlug?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  ctaActionType?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<MediaItem>>>;
  description?: Maybe<Scalars['String']['output']>;
  endHexColor?: Maybe<Scalars['String']['output']>;
  endTimestamp?: Maybe<Scalars['String']['output']>;
  episodeNumber?: Maybe<Scalars['String']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  itemPEM?: Maybe<Scalars['JSON']['output']>;
  listingContentId?: Maybe<Scalars['String']['output']>;
  listingId?: Maybe<Scalars['String']['output']>;
  logoImage?: Maybe<Scalars['String']['output']>;
  movieDuration?: Maybe<Scalars['Int']['output']>;
  numSeasons?: Maybe<Scalars['Int']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingIcon?: Maybe<Scalars['String']['output']>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  seasonNumber?: Maybe<Scalars['String']['output']>;
  showAssets?: Maybe<ShowAssets>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  showPath?: Maybe<Scalars['String']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  srcSetLandscape?: Maybe<Scalars['String']['output']>;
  srcSetPortrait?: Maybe<Scalars['String']['output']>;
  startHexColor?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['String']['output']>;
  subVideoStartingPointCTA?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbLandscape?: Maybe<Scalars['String']['output']>;
  thumbPortrait?: Maybe<Scalars['String']['output']>;
  tileType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type SpotlightItem = {
  __typename?: 'SpotlightItem';
  content?: Maybe<MediaItem>;
  contentType?: Maybe<Scalars['String']['output']>;
  promotionInfo?: Maybe<PromotionInfo>;
  show?: Maybe<MediaItem>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type StartParameters = {
  cmAudienceID?: InputMaybe<Scalars['String']['input']>;
  constraints?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceMake?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceVersion?: InputMaybe<Scalars['String']['input']>;
  drmCapabilities?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isClientDNT?: InputMaybe<Scalars['Boolean']['input']>;
  legacyRefreshToken?: InputMaybe<Scalars['String']['input']>;
  ptvAppName?: InputMaybe<Scalars['String']['input']>;
  serverSideAds?: InputMaybe<Scalars['Boolean']['input']>;
  updateType?: InputMaybe<Scalars['String']['input']>;
  usPrivacy?: InputMaybe<Scalars['String']['input']>;
};

export type StartResponse = {
  __typename?: 'StartResponse';
  deviceId?: Maybe<Scalars['String']['output']>;
  refreshInSec?: Maybe<Scalars['Int']['output']>;
  session?: Maybe<Session>;
};

export type Stitched = {
  __typename?: 'Stitched';
  paths?: Maybe<Array<Maybe<StitchedPath>>>;
};

export type StitchedPath = {
  __typename?: 'StitchedPath';
  path?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StitcherPath = {
  __typename?: 'StitcherPath';
  path?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StitcherPaths = {
  __typename?: 'StitcherPaths';
  path?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StitcherStreamingUrlResponse = {
  __typename?: 'StitcherStreamingUrlResponse';
  jwt?: Maybe<Scalars['String']['output']>;
  stitcherPaths?: Maybe<StitcherPaths>;
  success?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StreamHistoryResponse = {
  __typename?: 'StreamHistoryResponse';
  allowedToPlayContentOnGivenDeviceBasedOnProduct?: Maybe<Scalars['Boolean']['output']>;
  concurrentStreamCount?: Maybe<Scalars['Int']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  deniedPlaybackReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hasWatched?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  mediaTime?: Maybe<Scalars['Int']['output']>;
  overThreshold?: Maybe<Scalars['Boolean']['output']>;
  parentalControl?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
  userPlanCode?: Maybe<Scalars['String']['output']>;
};

export type StreamingUrlParams = {
  appVersion: Scalars['String']['input'];
  contentId: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  drm: Scalars['String']['input'];
  drmLevel?: InputMaybe<Scalars['String']['input']>;
  streamType: Scalars['String']['input'];
};

export type StreamingUrlResponse = {
  __typename?: 'StreamingUrlResponse';
  downloadKey?: Maybe<Scalars['String']['output']>;
  invalidIp?: Maybe<Scalars['Boolean']['output']>;
  isInVPN?: Maybe<Scalars['Boolean']['output']>;
  lsSession?: Maybe<Scalars['String']['output']>;
  ruleIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  rulesMatched?: Maybe<Scalars['Boolean']['output']>;
  stitcherPaths?: Maybe<Array<StitcherPath>>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SubNavItem = {
  __typename?: 'SubNavItem';
  href: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<SubNavItem>;
  label: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Subratings = {
  __typename?: 'Subratings';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type SuggestionsResponse = {
  __typename?: 'SuggestionsResponse';
  suggestions: Array<AutocompleteSuggestion>;
};

export type SwitchResponse = {
  __typename?: 'SwitchResponse';
  success: Scalars['Boolean']['output'];
  userActiveProfile?: Maybe<UserProfile>;
};

export type Thumbnail = {
  __typename?: 'Thumbnail';
  assetType?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ThumbnailSet = {
  __typename?: 'ThumbnailSet';
  assetType?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ThumbnailSheetSet = {
  __typename?: 'ThumbnailSheetSet';
  assetType?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type TrailerContent = {
  __typename?: 'TrailerContent';
  _airDate?: Maybe<Scalars['String']['output']>;
  _airDateISO?: Maybe<Scalars['String']['output']>;
  _editDate?: Maybe<Scalars['String']['output']>;
  _firstIngestDate?: Maybe<Scalars['String']['output']>;
  _ingestDate?: Maybe<Scalars['String']['output']>;
  _lastModifiedDate?: Maybe<Scalars['String']['output']>;
  _pubDate?: Maybe<Scalars['String']['output']>;
  _pubDateISO?: Maybe<Scalars['String']['output']>;
  addOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  airDate?: Maybe<Scalars['String']['output']>;
  amazonESTURL?: Maybe<Scalars['String']['output']>;
  appleWatchListShowKey?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<Scalars['String']['output']>;
  availableForProfileTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbsShowId?: Maybe<Scalars['String']['output']>;
  childContentId?: Maybe<Scalars['String']['output']>;
  closedCaptionUrl?: Maybe<Scalars['String']['output']>;
  cmsAccountId?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Array<Scalars['String']['output']>>;
  downloadCountrySet?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  duration?: Maybe<Scalars['Int']['output']>;
  editDate?: Maybe<Scalars['String']['output']>;
  embeddable?: Maybe<Scalars['String']['output']>;
  endCreditsChapterTime?: Maybe<Scalars['String']['output']>;
  episodeNum?: Maybe<Scalars['String']['output']>;
  excludeNielsenTracking?: Maybe<Scalars['Boolean']['output']>;
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  firstIngestDate?: Maybe<Scalars['String']['output']>;
  fullEpisode?: Maybe<Scalars['Boolean']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  ingestDate?: Maybe<Scalars['String']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isProductPlacement?: Maybe<Scalars['Boolean']['output']>;
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  itunesESTURL?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['String']['output']>;
  mediaAvailableDate?: Maybe<Scalars['String']['output']>;
  mediaAvailableDateEpoch?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  playbackEvents?: Maybe<PlaybackEvents>;
  playerLocUrl?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryCategory?: Maybe<Scalars['String']['output']>;
  primaryCategoryName?: Maybe<Scalars['String']['output']>;
  pubDate?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  regionalAudioExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  regionalRatings?: Maybe<Array<RegionalRatings>>;
  regionalTextExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  sizzleId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  subscriptionLevel?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailSet?: Maybe<Array<Maybe<ThumbnailSet>>>;
  thumbnailSheetSet?: Maybe<Array<Maybe<ThumbnailSheetSet>>>;
  title?: Maybe<Scalars['String']['output']>;
  tmsprogramID?: Maybe<Scalars['String']['output']>;
  tmsseriesID?: Maybe<Scalars['String']['output']>;
  topLevelCategory?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vTag?: Maybe<Scalars['String']['output']>;
  videoPageUrl?: Maybe<Scalars['String']['output']>;
  videoProperties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TransformedMarquee = {
  __typename?: 'TransformedMarquee';
  data?: Maybe<Array<TransformedMarqueeSlide>>;
  id?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TransformedMarqueeSlide = {
  __typename?: 'TransformedMarqueeSlide';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  castNames?: Maybe<Array<Scalars['String']['output']>>;
  contentType?: Maybe<Scalars['String']['output']>;
  ctaActionType?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTimestamp?: Maybe<Scalars['String']['output']>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  filepathTitleLogoRegular?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isMovieAvailable?: Maybe<Scalars['Boolean']['output']>;
  logoImage?: Maybe<Scalars['String']['output']>;
  movieDuration?: Maybe<Scalars['Int']['output']>;
  movieId?: Maybe<Scalars['String']['output']>;
  numSeasons?: Maybe<Scalars['Int']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingIcon?: Maybe<Scalars['String']['output']>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  seasonNumber?: Maybe<Scalars['Int']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slideDisplayOrder?: Maybe<Scalars['Int']['output']>;
  srcSetLandscape?: Maybe<Scalars['String']['output']>;
  srcSetPortrait?: Maybe<Scalars['String']['output']>;
  standardImgForAllScreens?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['String']['output']>;
  thumbPortrait?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
  tuneInTimeOverride2?: Maybe<Scalars['String']['output']>;
  videoPreviewURL?: Maybe<Scalars['String']['output']>;
};

export type TransformedSeoHreflangResponse = {
  __typename?: 'TransformedSeoHreflangResponse';
  countries?: Maybe<Array<Maybe<HreflangConfigObj>>>;
};

export type Trending = {
  __typename?: 'Trending';
  content?: Maybe<TrendingContent>;
  content_type?: Maybe<Scalars['String']['output']>;
};

export type TrendingContent = MovieTrendingContent | ShowTrendingContent;

export type UniversalChannelListingItem = {
  __typename?: 'UniversalChannelListingItem';
  channelListingData: ChannelListingData;
  commonData: CommonData;
  cta: CarazCta;
  imageAssets: CarazImageAssets;
  movieData?: Maybe<MovieData>;
  showData?: Maybe<ShowData>;
  trackingData?: Maybe<CarazTrackingData>;
};

export type UniversalContentApiResponse = {
  __typename?: 'UniversalContentApiResponse';
  carouselPEM?: Maybe<Scalars['JSON']['output']>;
  collectionName: Scalars['String']['output'];
  collectionPEM?: Maybe<Scalars['JSON']['output']>;
  items?: Maybe<Array<Maybe<UniversalItem>>>;
  pagePEM?: Maybe<Scalars['JSON']['output']>;
  rows: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

export type UniversalCreativeApiResponse = {
  __typename?: 'UniversalCreativeApiResponse';
  items?: Maybe<Array<Maybe<UniversalCreativeItem>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UniversalCreativeItem = {
  __typename?: 'UniversalCreativeItem';
  adData?: Maybe<CreativeAdData>;
  commonData?: Maybe<CreativeCommonData>;
  cta?: Maybe<CreativeCta>;
  imageAssets?: Maybe<CreativeImageAssets>;
  trackingData?: Maybe<CreativeTrackingData>;
};

export type UniversalItem = UniversalChannelListingItem | UniversalMovieItem | UniversalPromotionItem | UniversalShowItem;

export type UniversalMovieItem = {
  __typename?: 'UniversalMovieItem';
  commonData: CommonData;
  cta: CarazCta;
  imageAssets: CarazImageAssets;
  movieData: MovieData;
  trackingData?: Maybe<CarazTrackingData>;
};

export type UniversalPromotionItem = {
  __typename?: 'UniversalPromotionItem';
  channelListingData?: Maybe<ChannelListingData>;
  commonData: CommonData;
  cta: CarazCta;
  imageAssets: CarazImageAssets;
  movieData?: Maybe<MovieData>;
  promoData?: Maybe<CarazPromoData>;
  showData?: Maybe<ShowData>;
  trackingData?: Maybe<CarazTrackingData>;
};

export type UniversalShowItem = {
  __typename?: 'UniversalShowItem';
  commonData: CommonData;
  cta: CarazCta;
  imageAssets: CarazImageAssets;
  showData: ShowData;
  trackingData?: Maybe<CarazTrackingData>;
};

export type UpNextRecommendation = {
  __typename?: 'UpNextRecommendation';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  btnLabel?: Maybe<Scalars['String']['output']>;
  button?: Maybe<UpNextRecommendationButton>;
  castNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channelSlug?: Maybe<Scalars['String']['output']>;
  contentCANDetails?: Maybe<ContentCanVideo>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['Float']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  isListingLive?: Maybe<Scalars['String']['output']>;
  listingId?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  logoImage?: Maybe<Scalars['String']['output']>;
  medTime?: Maybe<Scalars['Int']['output']>;
  mediaWatchNextType?: Maybe<Scalars['String']['output']>;
  playbackModeCTA?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rating?: Maybe<Scalars['String']['output']>;
  recommendationSource?: Maybe<Scalars['String']['output']>;
  releaseYear?: Maybe<Scalars['Int']['output']>;
  seasons?: Maybe<Scalars['String']['output']>;
  showId?: Maybe<Scalars['String']['output']>;
  startTimestamp?: Maybe<Scalars['Float']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<UpNextTracking>;
  trailerCANDetails?: Maybe<ContentCanVideo>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
};

export type UpNextRecommendationButton = {
  __typename?: 'UpNextRecommendationButton';
  label?: Maybe<Scalars['String']['output']>;
  lockIconUrl?: Maybe<Scalars['String']['output']>;
};

export type UpNextResponse = {
  __typename?: 'UpNextResponse';
  endCardCount?: Maybe<Scalars['Int']['output']>;
  endCardTimer?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Array<Maybe<UpNextRecommendation>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UpNextTrackAction = {
  __typename?: 'UpNextTrackAction';
  trackEndCardSelect?: Maybe<UpNextTrackEndCardSelect>;
};

export type UpNextTrackEndCardSelect = {
  __typename?: 'UpNextTrackEndCardSelect';
  PPlusSubscriberBadge?: Maybe<Scalars['Int']['output']>;
};

export type UpNextTracking = {
  __typename?: 'UpNextTracking';
  trackAction?: Maybe<UpNextTrackAction>;
};

export type UpdateEmailFormFields = {
  confirmEmail: Scalars['String']['input'];
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type UpdateEmailResponse = {
  __typename?: 'UpdateEmailResponse';
  errors?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdatePaymentResponse = {
  __typename?: 'UpdatePaymentResponse';
  /** Recurly 3DS action token (threeDSecureActionTokenId) returned when 3DS is required. */
  actionTokenId?: Maybe<Scalars['String']['output']>;
  /**
   * Upstream transaction error code. 'three_d_secure_action_required' signals the client
   * to run the Recurly 3DS challenge and resubmit with resultActionTokenId.
   */
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpsellBucket = {
  __typename?: 'UpsellBucket';
  backgroundDesktop?: Maybe<Scalars['String']['output']>;
  backgroundMobile?: Maybe<Scalars['String']['output']>;
  bucketName?: Maybe<Scalars['String']['output']>;
  carousel?: Maybe<Array<Maybe<UpsellCarousel>>>;
  className?: Maybe<Scalars['String']['output']>;
  ctaEvent?: Maybe<Scalars['String']['output']>;
  ctaHide?: Maybe<Scalars['Boolean']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  ctas?: Maybe<Array<Maybe<UpsellCta>>>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  faq?: Maybe<Array<Maybe<Faq>>>;
  heading?: Maybe<Scalars['String']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  hideCarousel?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoAlt?: Maybe<Scalars['String']['output']>;
  logoDesktop?: Maybe<Scalars['String']['output']>;
  logoMobile?: Maybe<Scalars['String']['output']>;
  logos?: Maybe<Array<Maybe<UpsellLogo>>>;
  position?: Maybe<Scalars['Int']['output']>;
  rowHeaderPosition?: Maybe<Scalars['Int']['output']>;
  showTimeAttributes?: Maybe<ShowTimeAttributes>;
  text?: Maybe<Scalars['String']['output']>;
  trialPeriod?: Maybe<Scalars['String']['output']>;
};

export type UpsellCarousel = {
  __typename?: 'UpsellCarousel';
  alt?: Maybe<Scalars['String']['output']>;
  carousel_image?: Maybe<Scalars['String']['output']>;
  carousel_image_title?: Maybe<Scalars['String']['output']>;
};

export type UpsellCta = {
  __typename?: 'UpsellCta';
  className?: Maybe<Scalars['String']['output']>;
  colorScheme?: Maybe<Scalars['String']['output']>;
  ctaEvent?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  prescribedName?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export type UpsellHeader = {
  __typename?: 'UpsellHeader';
  bannerHide?: Maybe<Scalars['Boolean']['output']>;
  bannerText1?: Maybe<Scalars['String']['output']>;
  bannerText2?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  signInText?: Maybe<Scalars['String']['output']>;
  signInUrl?: Maybe<Scalars['String']['output']>;
};

export type UpsellLogo = {
  __typename?: 'UpsellLogo';
  alt?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpsellPageAttributeQueryResponse = {
  __typename?: 'UpsellPageAttributeQueryResponse';
  faqBucket?: Maybe<UpsellBucket>;
  genericBuckets?: Maybe<Array<Maybe<UpsellBucket>>>;
  header?: Maybe<UpsellHeader>;
  hero?: Maybe<UpsellBucket>;
  plansBucket?: Maybe<PlansBucket>;
  prefetchData?: Maybe<PrefetchData>;
  resolvedPromo?: Maybe<Scalars['String']['output']>;
  rowHeaderTotal?: Maybe<Scalars['Int']['output']>;
  variantsForTracking?: Maybe<Array<Scalars['String']['output']>>;
};

export type UserAccountSettings = {
  __typename?: 'UserAccountSettings';
  address?: Maybe<UserAccountSettingsAddress>;
};

export type UserAccountSettingsAddress = {
  __typename?: 'UserAccountSettingsAddress';
  zip?: Maybe<Scalars['String']['output']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  accountProfiles?: Maybe<Array<Maybe<OverrideUserProfile>>>;
  activeProfile?: Maybe<OverrideUserProfile>;
  activeProfileTracking?: Maybe<ProfileType>;
  ageGroup?: Maybe<Scalars['Int']['output']>;
  allRatings?: Maybe<Scalars['String']['output']>;
  bundleStatusTracking?: Maybe<Scalars['String']['output']>;
  cbsPackageInfo?: Maybe<Array<Maybe<CbsPackageInfo>>>;
  clientCountry?: Maybe<Scalars['String']['output']>;
  dma?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entitlement?: Maybe<Entitlement>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  isLoggedIn?: Maybe<Scalars['Boolean']['output']>;
  isMVPDGhostAccount?: Maybe<Scalars['Boolean']['output']>;
  issuesList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  kidsProfileButton?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maskedEmail?: Maybe<Scalars['String']['output']>;
  nflFullBufferEnabled?: Maybe<Scalars['Boolean']['output']>;
  nflLTSOptIn?: Maybe<Scalars['Boolean']['output']>;
  nflLTSOptInTime?: Maybe<Scalars['Float']['output']>;
  nflOptIn?: Maybe<Scalars['String']['output']>;
  optIn?: Maybe<Scalars['Boolean']['output']>;
  packageStatus?: Maybe<UserPackageStatus>;
  packageStatusTracking?: Maybe<Scalars['String']['output']>;
  parentalControl?: Maybe<Scalars['Boolean']['output']>;
  parentalControlLivetvPinEnabled?: Maybe<Scalars['Boolean']['output']>;
  parentalControlPIN?: Maybe<Scalars['String']['output']>;
  parentalControlRestrictions?: Maybe<Scalars['String']['output']>;
  ppid?: Maybe<Scalars['String']['output']>;
  ratingGroups?: Maybe<Array<Maybe<RatingGroup>>>;
  requirePinSwitchProfileEnabled?: Maybe<Scalars['Boolean']['output']>;
  sha256EmailHash?: Maybe<Scalars['String']['output']>;
  sl?: Maybe<Scalars['String']['output']>;
  touDate?: Maybe<Scalars['Float']['output']>;
  touVersion?: Maybe<Scalars['String']['output']>;
  userEvents?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  userRegistrationCountry?: Maybe<Scalars['String']['output']>;
  userRole?: Maybe<Scalars['String']['output']>;
  userStatus?: Maybe<UserStatus>;
};

export type UserPackageStatus = {
  __typename?: 'UserPackageStatus';
  exsubscriberPackage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subscriberPackage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subscriberTrialPackage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  suspendedPackage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tveSubscriberPackage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorUserType?: Maybe<Scalars['String']['output']>;
};

export type UserParams = {
  billingVendor?: InputMaybe<Scalars['String']['input']>;
  packageCode?: InputMaybe<Scalars['String']['input']>;
  userProfileType?: InputMaybe<Scalars['String']['input']>;
  userRegistrationCountry?: InputMaybe<Scalars['String']['input']>;
  userState?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isMasterProfile: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  personalizationId?: Maybe<Scalars['String']['output']>;
  profilePic?: Maybe<Scalars['UUID']['output']>;
  profilePicMedium: Scalars['String']['output'];
  profilePicPath: Scalars['String']['output'];
  profilePicSmall: Scalars['String']['output'];
  profileType: ProfileType;
  referenceProfileId?: Maybe<Scalars['String']['output']>;
  screenTimeLimitEnabled?: Maybe<Scalars['Boolean']['output']>;
  screenTimeLimitSeconds?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  watchingRestrictions?: Maybe<WatchingRestrictions>;
};

export type UserSession = {
  __typename?: 'UserSession';
  id?: Maybe<Scalars['String']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
};

export type UserSessionResponse = {
  __typename?: 'UserSessionResponse';
  deviceId?: Maybe<Scalars['String']['output']>;
  refreshInSec?: Maybe<Scalars['Int']['output']>;
  session?: Maybe<UserSession>;
};

export type UserSignInResponse = {
  __typename?: 'UserSignInResponse';
  cbsComCookie?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserStatus = {
  __typename?: 'UserStatus';
  ID: Scalars['ID']['output'];
  accountProfiles: Array<UserProfile>;
  activeProfile: UserProfile;
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  hasParentalControlPIN?: Maybe<Scalars['Boolean']['output']>;
  isLoggedIn: Scalars['Boolean']['output'];
  kidsProfileButton: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  parentalControl: Scalars['Boolean']['output'];
  parentalControlPIN?: Maybe<Scalars['String']['output']>;
  requirePinSwitchProfileEnabled?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  activatedAt?: Maybe<Scalars['String']['output']>;
  addOns?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  canceledAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currentPeriodEndsAt?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  pendingSubscription?: Maybe<Scalars['JSON']['output']>;
  planCode?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  unitAmountInCents?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type UserSubscriptionResponse = {
  __typename?: 'UserSubscriptionResponse';
  activeCoupons?: Maybe<Array<ActiveCoupon>>;
  subscription?: Maybe<UserSubscription>;
};

export type ValuePropItem = {
  __typename?: 'ValuePropItem';
  copy: Scalars['String']['output'];
  essentialCopy: Scalars['String']['output'];
  isEssential: Scalars['Boolean']['output'];
  isPremium: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  premiumCopy: Scalars['String']['output'];
  subCopy: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Video = {
  __typename?: 'Video';
  _airDate?: Maybe<Scalars['String']['output']>;
  _airDateISO?: Maybe<Scalars['String']['output']>;
  _editDate?: Maybe<Scalars['String']['output']>;
  _firstIngestDate?: Maybe<Scalars['String']['output']>;
  _ingestDate?: Maybe<Scalars['String']['output']>;
  _lastModifiedDate?: Maybe<Scalars['String']['output']>;
  _pubDate?: Maybe<Scalars['String']['output']>;
  _pubDateISO?: Maybe<Scalars['String']['output']>;
  addOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  airDate?: Maybe<Scalars['Float']['output']>;
  amazonESTURL?: Maybe<Scalars['String']['output']>;
  appleWatchListShowKey?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<Scalars['String']['output']>;
  availableForProfileTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brand?: Maybe<Scalars['String']['output']>;
  brandLogo?: Maybe<Scalars['String']['output']>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbsShowId?: Maybe<Scalars['Int']['output']>;
  channel?: Maybe<VideoChannel>;
  childContentId?: Maybe<Scalars['String']['output']>;
  closedCaptionUrl?: Maybe<Scalars['String']['output']>;
  closed_captions?: Maybe<Scalars['String']['output']>;
  cmsAccountId?: Maybe<Scalars['String']['output']>;
  contentId: Scalars['String']['output'];
  contentLocked?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  daiParams?: Maybe<Scalars['JSON']['output']>;
  daistreamKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  dmaPlaybackUrl?: Maybe<Scalars['String']['output']>;
  downloadCountrySet?: Maybe<Array<Maybe<DownloadCountry>>>;
  duration?: Maybe<Scalars['String']['output']>;
  duration_raw?: Maybe<Scalars['Int']['output']>;
  editDate?: Maybe<Scalars['Float']['output']>;
  embeddable?: Maybe<Scalars['String']['output']>;
  endCreditsChapterTime?: Maybe<Scalars['String']['output']>;
  episodeNum?: Maybe<Scalars['Int']['output']>;
  episodeTitle?: Maybe<Scalars['String']['output']>;
  excludeNielsenTracking?: Maybe<Scalars['Boolean']['output']>;
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  fallback_streaming_url?: Maybe<Scalars['String']['output']>;
  firstIngestDate?: Maybe<Scalars['Float']['output']>;
  fullEpisode?: Maybe<Scalars['Boolean']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  ingestDate?: Maybe<Scalars['Float']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isPaidContent?: Maybe<Scalars['Boolean']['output']>;
  isProductPlacement?: Maybe<Scalars['Boolean']['output']>;
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  is_hls_aes_encrypted?: Maybe<Scalars['Boolean']['output']>;
  itunesESTURL?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['Float']['output']>;
  license_session?: Maybe<Scalars['String']['output']>;
  license_url?: Maybe<Scalars['String']['output']>;
  liveStreamingUrl?: Maybe<Scalars['String']['output']>;
  medTime?: Maybe<Scalars['Int']['output']>;
  mediaAvailableDate?: Maybe<Scalars['String']['output']>;
  mediaAvailableDateEpoch?: Maybe<Scalars['Float']['output']>;
  mediaContentType?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  mpd_url?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  playbackEvents?: Maybe<PlaybackEvents>;
  playerLocUrl?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryCategory?: Maybe<Scalars['String']['output']>;
  primaryCategoryName?: Maybe<Scalars['String']['output']>;
  pubDate?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  regionalAudioExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  regionalRatings?: Maybe<RegionalRating>;
  regionalTextExcludeLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ruleIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rulesMatched?: Maybe<Scalars['Boolean']['output']>;
  seasonNum?: Maybe<Scalars['Int']['output']>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  sizzleId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streamingUrl: Scalars['String']['output'];
  subscriptionLevel?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailSet?: Maybe<Array<Maybe<Thumbnail>>>;
  thumbnailSheetSet?: Maybe<Array<Maybe<Thumbnail>>>;
  title?: Maybe<Scalars['String']['output']>;
  tmsprogramID?: Maybe<Scalars['String']['output']>;
  tmsseriesID?: Maybe<Scalars['String']['output']>;
  topLevelCategory?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vTag?: Maybe<Scalars['String']['output']>;
  videoPageUrl?: Maybe<Scalars['String']['output']>;
  videoProperties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vtag_show?: Maybe<Scalars['String']['output']>;
};

export type VideoChannel = {
  __typename?: 'VideoChannel';
  channelCategorySlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channelTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currentIndex?: Maybe<Scalars['Int']['output']>;
  dma?: Maybe<VideoChannelDma>;
  fallbackEnabled?: Maybe<Scalars['Boolean']['output']>;
  fallbackStreamType?: Maybe<Scalars['String']['output']>;
  fallbackVideoContentId?: Maybe<Scalars['String']['output']>;
  gameStartTimestamp?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isLTSEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMultiCam?: Maybe<Scalars['Boolean']['output']>;
  isOptInRequired?: Maybe<Scalars['Boolean']['output']>;
  listingDuration?: Maybe<Scalars['Int']['output']>;
  listingId?: Maybe<Scalars['Int']['output']>;
  listings?: Maybe<Array<Maybe<ChannelListing>>>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type VideoChannelDma = {
  __typename?: 'VideoChannelDma';
  id?: Maybe<Scalars['String']['output']>;
  playbackUrl?: Maybe<Scalars['String']['output']>;
  stationName?: Maybe<Scalars['String']['output']>;
};

export type VideoConfigResponse = {
  __typename?: 'VideoConfigResponse';
  results?: Maybe<Array<Section>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  videoSectionMetadata?: Maybe<Array<VideoSectionMetadata>>;
};

export type VideoItem = {
  __typename?: 'VideoItem';
  contentId: Scalars['String']['output'];
  streamingUrl: Scalars['String']['output'];
};

export type VideoItemData = {
  __typename?: 'VideoItemData';
  /**
   * Raw upstream Pluto API item from videos/item.json, surfaced uncurated for downstream
   * consumers (Smart Tag, MOPS) that need fields not exposed as first-class normalized fields.
   */
  _apiRaw?: Maybe<Scalars['JSON']['output']>;
  airDateISO?: Maybe<Scalars['String']['output']>;
  /**
   * Cast of this specific episode, from the upstream actors field, in the order the API
   * returns it. Null when the episode has no cast — only a subset of episodes carry one.
   */
  cast?: Maybe<Array<Scalars['String']['output']>>;
  contentId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endCreditChapterTimeMs?: Maybe<Scalars['Int']['output']>;
  episodeNum?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  isEpisodeless?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isSeasonless?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  regionalRating?: Maybe<RegionalRatings>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  thumbnailSet?: Maybe<Array<Maybe<ThumbnailSet>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type VideoModel = {
  __typename?: 'VideoModel';
  _airDate?: Maybe<Scalars['String']['output']>;
  _airDateISO?: Maybe<Scalars['String']['output']>;
  _editDate?: Maybe<Scalars['String']['output']>;
  _expirationDate?: Maybe<Scalars['String']['output']>;
  _firstIngestDate?: Maybe<Scalars['String']['output']>;
  _ingestDate?: Maybe<Scalars['String']['output']>;
  _lastModifiedDate?: Maybe<Scalars['String']['output']>;
  _pubDate?: Maybe<Scalars['String']['output']>;
  _pubDateISO?: Maybe<Scalars['String']['output']>;
  addOns?: Maybe<Array<Scalars['String']['output']>>;
  airDate?: Maybe<Scalars['Float']['output']>;
  amazonESTURL?: Maybe<Scalars['String']['output']>;
  appleWatchListShowKey?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<Scalars['String']['output']>;
  availableForProfileTypes?: Maybe<Array<Scalars['String']['output']>>;
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cbsShowId?: Maybe<Scalars['Int']['output']>;
  closedCaptionUrl?: Maybe<Scalars['String']['output']>;
  cmsAccountId?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  downloadCountrySet?: Maybe<Array<Scalars['String']['output']>>;
  duration?: Maybe<Scalars['Int']['output']>;
  editDate?: Maybe<Scalars['Float']['output']>;
  endCreditsChapterTime?: Maybe<Scalars['String']['output']>;
  episodeNum?: Maybe<Scalars['String']['output']>;
  excludeNielsenTracking?: Maybe<Scalars['Boolean']['output']>;
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['Float']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstIngestDate?: Maybe<Scalars['Float']['output']>;
  fullEpisode?: Maybe<Scalars['Boolean']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  ingestDate?: Maybe<Scalars['Float']['output']>;
  isContentAccessibleInCAN?: Maybe<Scalars['Boolean']['output']>;
  isLive?: Maybe<Scalars['Boolean']['output']>;
  isProductPlacement?: Maybe<Scalars['Boolean']['output']>;
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  itunesESTURL?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['Float']['output']>;
  mediaAvailableDate?: Maybe<Scalars['String']['output']>;
  mediaAvailableDateEpoch?: Maybe<Scalars['Float']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  playbackEvents?: Maybe<PlaybackEvents>;
  playerLocUrl?: Maybe<Scalars['String']['output']>;
  premiumFeatures?: Maybe<Array<Scalars['String']['output']>>;
  primaryCategory?: Maybe<Scalars['String']['output']>;
  primaryCategoryName?: Maybe<Scalars['String']['output']>;
  pubDate?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  regionalAudioExcludeLanguages?: Maybe<Array<Scalars['String']['output']>>;
  regionalRatings?: Maybe<Array<RegionalRatings>>;
  regionalTextExcludeLanguages?: Maybe<Array<Scalars['String']['output']>>;
  seasonNum?: Maybe<Scalars['String']['output']>;
  seriesTitle?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  showPageUrl?: Maybe<Scalars['String']['output']>;
  sizzleId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  subscriptionLevel?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailSet?: Maybe<Array<ThumbnailSet>>;
  thumbnailSheetSet?: Maybe<Array<ThumbnailSet>>;
  title?: Maybe<Scalars['String']['output']>;
  tmsprogramID?: Maybe<Scalars['String']['output']>;
  tmsseriesID?: Maybe<Scalars['String']['output']>;
  topLevelCategory?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vTag?: Maybe<Scalars['String']['output']>;
  videoPageUrl?: Maybe<Scalars['String']['output']>;
  videoProperties?: Maybe<Array<Scalars['String']['output']>>;
};

export type VideoNextResponse = {
  __typename?: 'VideoNextResponse';
  endCardCount?: Maybe<Scalars['Int']['output']>;
  endCardTimer?: Maybe<Scalars['Int']['output']>;
  recommendations?: Maybe<Array<Maybe<Recommendations>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type VideoParams = {
  billingVendor: Scalars['String']['input'];
  contentId: Scalars['String']['input'];
  includeDeeplinkCheck: Scalars['String']['input'];
  packageCode: Scalars['String']['input'];
  platformType: Scalars['String']['input'];
  userProfileType: Scalars['String']['input'];
  userRegistrationCountry: Scalars['String']['input'];
  userState: Scalars['String']['input'];
};

export type VideoResponse = {
  __typename?: 'VideoResponse';
  fms?: Maybe<FmsInfo>;
  platformSession?: Maybe<PlatformSession>;
  query?: Maybe<Scalars['String']['output']>;
  results?: Maybe<VideoResults>;
  success?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<VideoUserInfo>;
  video?: Maybe<Video>;
};

export type VideoResults = {
  __typename?: 'VideoResults';
  action?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  itemList?: Maybe<Array<Maybe<ContentCanVideo>>>;
  resultSize?: Maybe<Scalars['Int']['output']>;
};

export type VideoSectionMetadata = {
  __typename?: 'VideoSectionMetadata';
  displayShowTitle?: Maybe<Scalars['Boolean']['output']>;
  display_seasons?: Maybe<Scalars['Boolean']['output']>;
  seasons_sort_order?: Maybe<Scalars['String']['output']>;
  sectionId?: Maybe<Scalars['Int']['output']>;
  section_type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type VideoUserInfo = {
  __typename?: 'VideoUserInfo';
  billingCadence?: Maybe<Scalars['String']['output']>;
  bundle_status?: Maybe<Scalars['String']['output']>;
  clientCountry?: Maybe<Scalars['String']['output']>;
  dma?: Maybe<Scalars['String']['output']>;
  ge?: Maybe<Scalars['String']['output']>;
  gr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  isAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  localStation?: Maybe<LocalStation>;
  multi_package_tracking?: Maybe<Scalars['String']['output']>;
  nflFullBufferEnabled?: Maybe<Scalars['Boolean']['output']>;
  nflLTSOptIn?: Maybe<Scalars['Boolean']['output']>;
  nflLTSOptInTime?: Maybe<Scalars['Float']['output']>;
  packageCode?: Maybe<Scalars['String']['output']>;
  packageSourceType?: Maybe<Scalars['String']['output']>;
  package_source?: Maybe<Scalars['String']['output']>;
  package_status?: Maybe<Scalars['String']['output']>;
  paramountStreamingId?: Maybe<Scalars['String']['output']>;
  personalizationId?: Maybe<Scalars['String']['output']>;
  ppid?: Maybe<Scalars['String']['output']>;
  profileType?: Maybe<Scalars['String']['output']>;
  profile_id?: Maybe<Scalars['Float']['output']>;
  profile_master?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  reference_profile_id?: Maybe<Scalars['Float']['output']>;
  sb_md?: Maybe<Scalars['JSON']['output']>;
  sl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorUserType?: Maybe<Scalars['String']['output']>;
};

/** VOD content kind used to fetch highlight metadata fields with the appropriate upstream loaders. */
export enum VodContentHighlightKind {
  Movie = 'MOVIE',
  Show = 'SHOW'
}

export type WatchListChannelsApiResponse = {
  __typename?: 'WatchListChannelsApiResponse';
  carousel?: Maybe<Array<Maybe<FavoriteChannelItem>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type WatchListItem = {
  __typename?: 'WatchListItem';
  content?: Maybe<WatchListItemContent>;
  content_type?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uuidId?: Maybe<Scalars['String']['output']>;
  watchListId?: Maybe<Scalars['String']['output']>;
};

export type WatchListItemContent = {
  __typename?: 'WatchListItemContent';
  about?: Maybe<Scalars['String']['output']>;
  amlgSource?: Maybe<Scalars['String']['output']>;
  brandSlug?: Maybe<Scalars['String']['output']>;
  callbacks?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  content_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entitlementCodes?: Maybe<Scalars['String']['output']>;
  filePathLogo?: Maybe<Scalars['String']['output']>;
  filePathLogoSelected?: Maybe<Scalars['String']['output']>;
  filepathDefaultBackground?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isAfterHours?: Maybe<Scalars['Boolean']['output']>;
  isContentAccessibleInCMS?: Maybe<Scalars['Boolean']['output']>;
  isKidsContent?: Maybe<Scalars['Boolean']['output']>;
  isMovieAvailable?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  movieAssets?: Maybe<MovieAssets>;
  rating?: Maybe<Scalars['String']['output']>;
  recold?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  showAssets?: Maybe<ShowAssets>;
  showCategory?: Maybe<Scalars['String']['output']>;
  showId?: Maybe<Scalars['String']['output']>;
  showTitle?: Maybe<Scalars['String']['output']>;
  sizzleContentId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sortTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trailerContentId?: Maybe<Scalars['String']['output']>;
  trailer_content_id?: Maybe<Scalars['String']['output']>;
  tuneInTime?: Maybe<Scalars['String']['output']>;
};

export type WatchingRestrictions = {
  __typename?: 'WatchingRestrictions';
  firstDisallowedRating?: Maybe<Scalars['String']['output']>;
  requirePinToWatchContent?: Maybe<Scalars['Boolean']['output']>;
  requirePinToWatchLiveTv?: Maybe<Scalars['Boolean']['output']>;
};

export type AddOnResponse = {
  __typename?: 'addOnResponse';
  addonPrice?: Maybe<Scalars['Float']['output']>;
  cbsProductId?: Maybe<Scalars['ID']['output']>;
  cbsUserActivationLink?: Maybe<Scalars['String']['output']>;
  cbsUserCallToAction?: Maybe<Scalars['String']['output']>;
  cbsUserMessage?: Maybe<Scalars['String']['output']>;
  cbsUserMessageSummary?: Maybe<Scalars['String']['output']>;
  cbssolrType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internalAddonCode?: Maybe<Scalars['String']['output']>;
  k?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vendorAddonCode?: Maybe<Scalars['String']['output']>;
  vendorLogo?: Maybe<Scalars['String']['output']>;
  vendorUserActivationLink?: Maybe<Scalars['String']['output']>;
  vendorUserCallToAction?: Maybe<Scalars['String']['output']>;
  vendorUserMessage?: Maybe<Scalars['String']['output']>;
};

export type CancelSavePageAttributesResponse = {
  __typename?: 'cancelSavePageAttributesResponse';
  pageAttribute?: Maybe<CancelSavePageAttribute>;
  variantsForTracking: Array<Scalars['String']['output']>;
};

export type CbsPackageInfo = {
  __typename?: 'cbsPackageInfo';
  addOns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  billingCadence?: Maybe<Scalars['String']['output']>;
  billingVendorProductCode?: Maybe<Scalars['String']['output']>;
  cbsPackageId?: Maybe<Scalars['Int']['output']>;
  createdDate?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['Float']['output']>;
  isAdFree?: Maybe<Scalars['Boolean']['output']>;
  isFullAdLoad?: Maybe<Scalars['Boolean']['output']>;
  packageCode?: Maybe<Scalars['String']['output']>;
  packageHoldingState?: Maybe<Scalars['String']['output']>;
  packageSource?: Maybe<Scalars['String']['output']>;
  packageSourceType?: Maybe<Scalars['String']['output']>;
  packageStatus?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  searchKey?: Maybe<Scalars['String']['output']>;
  subscriptionCountry?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['Int']['output']>;
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorSkuFamily?: Maybe<Scalars['String']['output']>;
  vendorSuppliedId?: Maybe<Scalars['String']['output']>;
  vendorUserType?: Maybe<Scalars['String']['output']>;
};

export type ChangePasswordResponse = {
  __typename?: 'changePasswordResponse';
  isReLoginSuccess?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CheckEmailFormFields = {
  email: Scalars['String']['input'];
};

export type CheckEmailResponse = {
  __typename?: 'checkEmailResponse';
  success: Scalars['Boolean']['output'];
};

export type CompilingPageAttributesResponse = {
  __typename?: 'compilingPageAttributesResponse';
  imageLandscape: Scalars['String']['output'];
  imagePortrait: Scalars['String']['output'];
  videoLandscape?: Maybe<Scalars['String']['output']>;
  videoPortrait?: Maybe<Scalars['String']['output']>;
};

export type EditEmailResponse = {
  __typename?: 'editEmailResponse';
  success: Scalars['Boolean']['output'];
};

export type EditPasswordResponse = {
  __typename?: 'editPasswordResponse';
  success: Scalars['Boolean']['output'];
};

export type LiveStreamInfoResponse = {
  __typename?: 'liveStreamInfoResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ManageDevicesPageAttributesResponse = {
  __typename?: 'manageDevicesPageAttributesResponse';
  pageAttribute?: Maybe<ManageDevicesPageAttribute>;
  variantsForTracking: Array<Scalars['String']['output']>;
};

export type ProductsByCadence = {
  __typename?: 'productsByCadence';
  annual?: Maybe<Array<Maybe<ProductResponse>>>;
  monthly?: Maybe<Array<Maybe<ProductResponse>>>;
};

export type RedeemCouponResponse = {
  __typename?: 'redeemCouponResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetForgotPasswordResponse = {
  __typename?: 'resetForgotPasswordResponse';
  success: Scalars['Boolean']['output'];
};

export type Tester = {
  __typename?: 'tester';
  name?: Maybe<Scalars['String']['output']>;
};

export type UpdateOptInResponse = {
  __typename?: 'updateOptInResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsellPageResponse = {
  __typename?: 'upsellPageResponse';
  planPageAttributes?: Maybe<PlanPageAttributesResponse>;
};


export type UpsellPageResponsePlanPageAttributesArgs = {
  cbscidmt?: InputMaybe<Scalars['String']['input']>;
  clientUserGuid?: InputMaybe<Scalars['String']['input']>;
  flowType?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
};

export type UpsellUserStatus = {
  __typename?: 'upsellUserStatus';
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  isExSubscriber?: Maybe<Scalars['Boolean']['output']>;
  isLoggedIn?: Maybe<Scalars['Boolean']['output']>;
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  isSubscriber?: Maybe<Scalars['Boolean']['output']>;
};

export type VendorAttributes = {
  __typename?: 'vendorAttributes';
  currency?: Maybe<Scalars['String']['output']>;
  isTrial?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  trialInterval?: Maybe<Scalars['Int']['output']>;
  trialUnit?: Maybe<Scalars['String']['output']>;
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  ChannelResponse: ( ChannelResponseError ) | ( ChannelResponseMany ) | ( ChannelResponseOne );
  CollectionEntity: ( MovieCollectionEntity ) | ( ShowCollectionEntity );
  MediaItem: ( KeepWatchingItem ) | ( LiveItem ) | ( MovieItem ) | ( ShowItem );
  TrendingContent: ( MovieTrendingContent ) | ( ShowTrendingContent );
  UniversalItem: ( UniversalChannelListingItem ) | ( UniversalMovieItem ) | ( UniversalPromotionItem ) | ( UniversalShowItem );
}>;

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  CarouselItem: ( BrandCarouselItem ) | ( ChannelListingCarouselItem ) | ( CharacterCarouselItem ) | ( CreativeCarouselItem ) | ( HubCarouselItem ) | ( LiveCarouselItem ) | ( LiveShowCarouselItem ) | ( MovieCarouselItem ) | ( ShowCarouselItem ) | ( Omit<SpotlightCarouselItem, 'data'> & { data?: Maybe<Array<Maybe<_RefType['MediaItem']>>> } );
  CommonContentFields: ( ChannelListingCarouselItem ) | ( LiveCarouselItem ) | ( LiveShowCarouselItem ) | ( MovieCarouselItem ) | ( ShowCarouselItem );
  DetailHero: ( LiveDetailHero ) | ( MovieDetailHero ) | ( ShowDetailHero );
}>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  ABTest: ResolverTypeWrapper<AbTest>;
  ABTestVariantsResponse: ResolverTypeWrapper<AbTestVariantsResponse>;
  ABTestsVariantEntry: ResolverTypeWrapper<AbTestsVariantEntry>;
  ABTestsVariantsInput: AbTestsVariantsInput;
  ABTestsVariantsResponse: ResolverTypeWrapper<AbTestsVariantsResponse>;
  AccountPageAttribute: ResolverTypeWrapper<AccountPageAttribute>;
  AccountPageAttributeQueryResponse: ResolverTypeWrapper<AccountPageAttributeQueryResponse>;
  AccountZipStateInfo: ResolverTypeWrapper<AccountZipStateInfo>;
  ActiveCoupon: ResolverTypeWrapper<ActiveCoupon>;
  ActiveCouponCurrency: ResolverTypeWrapper<ActiveCouponCurrency>;
  ActiveCouponDiscount: ResolverTypeWrapper<ActiveCouponDiscount>;
  AllMoviesMockParams: AllMoviesMockParams;
  AllMoviesMockResponse: ResolverTypeWrapper<Omit<AllMoviesMockResponse, 'items'> & { items: Array<ResolversTypes['CarouselItem']> }>;
  ApiParams: ResolverTypeWrapper<ApiParams>;
  ApiRegionalRating: ResolverTypeWrapper<ApiRegionalRating>;
  ApiVideoItem: ResolverTypeWrapper<ApiVideoItem>;
  AssociatedContentVideo: ResolverTypeWrapper<AssociatedContentVideo>;
  AutocompleteSuggestion: ResolverTypeWrapper<AutocompleteSuggestion>;
  AvailableVideoSeason: ResolverTypeWrapper<AvailableVideoSeason>;
  AvailableVideoSeasons: ResolverTypeWrapper<AvailableVideoSeasons>;
  AvailableVideoSeasonsData: ResolverTypeWrapper<AvailableVideoSeasonsData>;
  Avatar: ResolverTypeWrapper<Avatar>;
  AvatarGroup: ResolverTypeWrapper<AvatarGroup>;
  BillingInfoResponse: ResolverTypeWrapper<BillingInfoResponse>;
  BindMvpdFields: BindMvpdFields;
  BindMvpdResponse: ResolverTypeWrapper<BindMvpdResponse>;
  BindPartnerFields: BindPartnerFields;
  BindPartnerResponse: ResolverTypeWrapper<BindPartnerResponse>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Brand: ResolverTypeWrapper<Brand>;
  BrandCarouselItem: ResolverTypeWrapper<BrandCarouselItem>;
  BrandItem: ResolverTypeWrapper<BrandItem>;
  Button: ResolverTypeWrapper<Button>;
  CANContext: ResolverTypeWrapper<CanContext>;
  CacheControlScope: CacheControlScope;
  Cadence: Cadence;
  CampaignData: ResolverTypeWrapper<CampaignData>;
  CampaignPageAttributesResponse: ResolverTypeWrapper<CampaignPageAttributesResponse>;
  CanModel: ResolverTypeWrapper<CanModel>;
  CancelSaveCarouselItem: ResolverTypeWrapper<CancelSaveCarouselItem>;
  CancelSavePageAttribute: ResolverTypeWrapper<CancelSavePageAttribute>;
  CarazCta: ResolverTypeWrapper<CarazCta>;
  CarazImageAssets: ResolverTypeWrapper<CarazImageAssets>;
  CarazPromoData: ResolverTypeWrapper<CarazPromoData>;
  CarazRating: ResolverTypeWrapper<CarazRating>;
  CarazTrackingData: ResolverTypeWrapper<CarazTrackingData>;
  CarouselApiResponse: ResolverTypeWrapper<Omit<CarouselApiResponse, 'AtoZ' | 'carousel' | 'collections' | 'trending'> & { AtoZ?: Maybe<Array<Maybe<ResolversTypes['Trending']>>>, carousel?: Maybe<Array<Maybe<ResolversTypes['MediaItem']>>>, collections?: Maybe<Array<Maybe<ResolversTypes['Collections']>>>, trending?: Maybe<Array<Maybe<ResolversTypes['Trending']>>> }>;
  CarouselInfo: CarouselInfo;
  CarouselItem: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CarouselItem']>;
  CarouselItemTracking: ResolverTypeWrapper<CarouselItemTracking>;
  CarouselParams: CarouselParams;
  CarouselResponse: ResolverTypeWrapper<Omit<CarouselResponse, 'result'> & { result?: Maybe<ResolversTypes['Result']> }>;
  CastApiParams: ResolverTypeWrapper<CastApiParams>;
  CastConfig: ResolverTypeWrapper<CastConfig>;
  CastConfigurationResponse: ResolverTypeWrapper<CastConfigurationResponse>;
  CastItem: ResolverTypeWrapper<CastItem>;
  Channel: ResolverTypeWrapper<Channel>;
  ChannelCategoriesParams: ChannelCategoriesParams;
  ChannelCategoriesResponse: ResolverTypeWrapper<ChannelCategoriesResponse>;
  ChannelCategory: ResolverTypeWrapper<ChannelCategory>;
  ChannelData: ResolverTypeWrapper<ChannelData>;
  ChannelListing: ResolverTypeWrapper<ChannelListing>;
  ChannelListingCarouselItem: ResolverTypeWrapper<ChannelListingCarouselItem>;
  ChannelListingData: ResolverTypeWrapper<ChannelListingData>;
  ChannelListingNormalized: ResolverTypeWrapper<ChannelListingNormalized>;
  ChannelListingResponse: ResolverTypeWrapper<ChannelListingResponse>;
  ChannelParams: ChannelParams;
  ChannelResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ChannelResponse']>;
  ChannelResponseError: ResolverTypeWrapper<ChannelResponseError>;
  ChannelResponseMany: ResolverTypeWrapper<ChannelResponseMany>;
  ChannelResponseOne: ResolverTypeWrapper<ChannelResponseOne>;
  CharacterApiResponse: ResolverTypeWrapper<CharacterApiResponse>;
  CharacterCarouselItem: ResolverTypeWrapper<CharacterCarouselItem>;
  CharacterItem: ResolverTypeWrapper<CharacterItem>;
  CmpConsentTokenResponse: ResolverTypeWrapper<CmpConsentTokenResponse>;
  CodeActivateSuccessResponse: ResolverTypeWrapper<CodeActivateSuccessResponse>;
  Collection: ResolverTypeWrapper<Collection>;
  CollectionApiResponse: ResolverTypeWrapper<CollectionApiResponse>;
  CollectionCarousel: ResolverTypeWrapper<CollectionCarousel>;
  CollectionEntity: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CollectionEntity']>;
  Collections: ResolverTypeWrapper<Omit<Collections, 'collectionEntity'> & { collectionEntity?: Maybe<ResolversTypes['CollectionEntity']> }>;
  CommonApiParams: CommonApiParams;
  CommonContentFields: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CommonContentFields']>;
  CommonData: ResolverTypeWrapper<CommonData>;
  CommunityFeedback: ResolverTypeWrapper<CommunityFeedback>;
  CommunityFeedbackReadResponse: ResolverTypeWrapper<CommunityFeedbackReadResponse>;
  CommunityFeedbackRemoveResponse: ResolverTypeWrapper<CommunityFeedbackRemoveResponse>;
  CommunityFeedbackRemoved: ResolverTypeWrapper<CommunityFeedbackRemoved>;
  CommunityFeedbackTarget: ResolverTypeWrapper<CommunityFeedbackTarget>;
  CommunityFeedbackWriteResponse: ResolverTypeWrapper<CommunityFeedbackWriteResponse>;
  ConcurrencyDeniedPlaybackReason: ResolverTypeWrapper<ConcurrencyDeniedPlaybackReason>;
  ConcurrencyParams: ConcurrencyParams;
  ConcurrencyResponse: ResolverTypeWrapper<ConcurrencyResponse>;
  Config: ResolverTypeWrapper<Config>;
  ContentCANVideo: ResolverTypeWrapper<ContentCanVideo>;
  ContentHighlightMetadata: ResolverTypeWrapper<ContentHighlightMetadata>;
  ContentHighlightMetadataInput: ContentHighlightMetadataInput;
  Context: ResolverTypeWrapper<Context>;
  Coordinates: ResolverTypeWrapper<Coordinates>;
  CreativeAdData: ResolverTypeWrapper<CreativeAdData>;
  CreativeCarouselItem: ResolverTypeWrapper<CreativeCarouselItem>;
  CreativeCommonData: ResolverTypeWrapper<CreativeCommonData>;
  CreativeCta: ResolverTypeWrapper<CreativeCta>;
  CreativeImageAssets: ResolverTypeWrapper<CreativeImageAssets>;
  CreativeTrackingData: ResolverTypeWrapper<CreativeTrackingData>;
  DAIParams: ResolverTypeWrapper<DaiParams>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateTimeISO: ResolverTypeWrapper<Scalars['DateTimeISO']['output']>;
  DebugInfo: ResolverTypeWrapper<DebugInfo>;
  DetailCta: ResolverTypeWrapper<DetailCta>;
  DetailHero: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['DetailHero']>;
  DeviceInfo: ResolverTypeWrapper<DeviceInfo>;
  DeviceListResponse: ResolverTypeWrapper<DeviceListResponse>;
  DmaItem: ResolverTypeWrapper<DmaItem>;
  DmaParams: DmaParams;
  DmaResponse: ResolverTypeWrapper<DmaResponse>;
  DmaTokenDetails: ResolverTypeWrapper<DmaTokenDetails>;
  DownloadCountry: ResolverTypeWrapper<DownloadCountry>;
  DownloadCountrySet: ResolverTypeWrapper<DownloadCountrySet>;
  DrmSession: ResolverTypeWrapper<DrmSession>;
  DynamicPlayResponse: ResolverTypeWrapper<DynamicPlayResponse>;
  DynamicVideoModel: ResolverTypeWrapper<DynamicVideoModel>;
  EmailCheckpointResponse: ResolverTypeWrapper<EmailCheckpointResponse>;
  EmailCheckpointResult: EmailCheckpointResult;
  Entitlement: ResolverTypeWrapper<Entitlement>;
  EntitlementPackageInfo: ResolverTypeWrapper<EntitlementPackageInfo>;
  EntitlementProductInfo: ResolverTypeWrapper<EntitlementProductInfo>;
  Episode: ResolverTypeWrapper<Episode>;
  EpisodeData: ResolverTypeWrapper<EpisodeData>;
  EpisodeResumeTime: ResolverTypeWrapper<EpisodeResumeTime>;
  EpisodesApiResponse: ResolverTypeWrapper<EpisodesApiResponse>;
  FMSQueryParams: FmsQueryParams;
  FMSResponse: ResolverTypeWrapper<FmsResponse>;
  Faq: ResolverTypeWrapper<Faq>;
  FavoriteChannelItem: ResolverTypeWrapper<FavoriteChannelItem>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FmsInfo: ResolverTypeWrapper<FmsInfo>;
  FmsParams: ResolverTypeWrapper<FmsParams>;
  FooterHubType: FooterHubType;
  FooterLink: ResolverTypeWrapper<FooterLink>;
  FooterLinksData: ResolverTypeWrapper<FooterLinksData>;
  FormRendezvousFields: FormRendezvousFields;
  FormSignUpFields: FormSignUpFields;
  FrontDoorBucket: ResolverTypeWrapper<FrontDoorBucket>;
  FrontDoorBucketCarousel: ResolverTypeWrapper<FrontDoorBucketCarousel>;
  FrontDoorCarousel: ResolverTypeWrapper<FrontDoorCarousel>;
  FrontDoorContentData: ResolverTypeWrapper<FrontDoorContentData>;
  FrontDoorCta: ResolverTypeWrapper<FrontDoorCta>;
  FrontDoorData: ResolverTypeWrapper<FrontDoorData>;
  FrontDoorFaqBucket: ResolverTypeWrapper<FrontDoorFaqBucket>;
  FrontDoorFaqItem: ResolverTypeWrapper<FrontDoorFaqItem>;
  FrontDoorHeader: ResolverTypeWrapper<FrontDoorHeader>;
  FrontDoorHero: ResolverTypeWrapper<FrontDoorHero>;
  FrontDoorLogo: ResolverTypeWrapper<FrontDoorLogo>;
  FullEpisodesData: ResolverTypeWrapper<FullEpisodesData>;
  FullUser: ResolverTypeWrapper<FullUser>;
  FullUserStatus: ResolverTypeWrapper<FullUserStatus>;
  GameListingParams: GameListingParams;
  Genre: ResolverTypeWrapper<Genre>;
  GlobalMenu: ResolverTypeWrapper<GlobalMenu>;
  GlobalMenuData: ResolverTypeWrapper<GlobalMenuData>;
  GlobalMenuFooterSection: ResolverTypeWrapper<GlobalMenuFooterSection>;
  GlobalMenuItem: ResolverTypeWrapper<GlobalMenuItem>;
  Hero: ResolverTypeWrapper<HeroRestRaw>;
  HeroApiInfo: HeroApiInfo;
  HeroApiResponse: ResolverTypeWrapper<Omit<HeroApiResponse, 'hero'> & { hero: Array<ResolversTypes['Hero']> }>;
  HeroType: HeroType;
  History: ResolverTypeWrapper<History>;
  HistoryApiResponse: ResolverTypeWrapper<HistoryApiResponse>;
  HomeConfig: ResolverTypeWrapper<HomeConfig>;
  HomeParams: HomeParams;
  HreflangConfigObj: ResolverTypeWrapper<HreflangConfigObj>;
  Hub: ResolverTypeWrapper<Hub>;
  HubCarouselItem: ResolverTypeWrapper<HubCarouselItem>;
  HubItem: ResolverTypeWrapper<HubItem>;
  HubMarquee: ResolverTypeWrapper<HubMarquee>;
  HubMarqueeSlide: ResolverTypeWrapper<HubMarqueeSlide>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  IdentityLoginInput: IdentityLoginInput;
  IdentityLoginResponse: ResolverTypeWrapper<IdentityLoginResponse>;
  IdentityRegisterFieldError: ResolverTypeWrapper<IdentityRegisterFieldError>;
  IdentityRegisterResponse: ResolverTypeWrapper<IdentityRegisterResponse>;
  IngestCommunityFeedbackInput: IngestCommunityFeedbackInput;
  InputDeviceInfo: InputDeviceInfo;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  ItemList: ResolverTypeWrapper<ItemList>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  KeepWatchingItem: ResolverTypeWrapper<KeepWatchingItem>;
  ListingData: ResolverTypeWrapper<ListingData>;
  ListingNormalizedResponse: ResolverTypeWrapper<ListingNormalizedResponse>;
  ListingParams: ListingParams;
  ListingsResponse: ResolverTypeWrapper<ListingsResponse>;
  LiveCarouselApiResponse: ResolverTypeWrapper<LiveCarouselApiResponse>;
  LiveCarouselItem: ResolverTypeWrapper<LiveCarouselItem>;
  LiveChannel: ResolverTypeWrapper<LiveChannel>;
  LiveChannelListing: ResolverTypeWrapper<LiveChannelListing>;
  LiveDetailHero: ResolverTypeWrapper<LiveDetailHero>;
  LiveEvent: ResolverTypeWrapper<LiveEvent>;
  LiveItem: ResolverTypeWrapper<LiveItem>;
  LiveShowCarouselItem: ResolverTypeWrapper<LiveShowCarouselItem>;
  LocalPlaybackParams: LocalPlaybackParams;
  LocalStation: ResolverTypeWrapper<LocalStation>;
  LogOutResponse: ResolverTypeWrapper<LogOutResponse>;
  ManageDevicesPageAttribute: ResolverTypeWrapper<ManageDevicesPageAttribute>;
  MarqueeApiInfo: MarqueeApiInfo;
  MarqueeApiResponse: ResolverTypeWrapper<MarqueeApiResponse>;
  MarqueeContent: ResolverTypeWrapper<Omit<MarqueeContent, 'data'> & { data: Array<ResolversTypes['CarouselItem']> }>;
  MarqueeItem: ResolverTypeWrapper<MarqueeItem>;
  MarqueeMovieAssets: ResolverTypeWrapper<MarqueeMovieAssets>;
  MarqueeShowAssets: ResolverTypeWrapper<MarqueeShowAssets>;
  MarqueeSlide: ResolverTypeWrapper<MarqueeSlide>;
  MediaBrowseResponse: ResolverTypeWrapper<MediaBrowseResponse>;
  MediaBrowseVideo: ResolverTypeWrapper<MediaBrowseVideo>;
  MediaItem: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['MediaItem']>;
  MerchandiseContentResponse: ResolverTypeWrapper<MerchandiseContentResponse>;
  MerchandiseContentType: MerchandiseContentType;
  MerchandiseSlide: ResolverTypeWrapper<MerchandiseSlide>;
  MetadataResponse: ResolverTypeWrapper<MetadataResponse>;
  MosaicPageAttributeSourceRecords: ResolverTypeWrapper<MosaicPageAttributeSourceRecords>;
  MosaicPageAttributesResponse: ResolverTypeWrapper<MosaicPageAttributesResponse>;
  MosaicPageDocumentsResponse: ResolverTypeWrapper<MosaicPageDocumentsResponse>;
  Movie: ResolverTypeWrapper<Movie>;
  MovieAssets: ResolverTypeWrapper<MovieAssets>;
  MovieCarouselItem: ResolverTypeWrapper<MovieCarouselItem>;
  MovieCollectionEntity: ResolverTypeWrapper<MovieCollectionEntity>;
  MovieContent: ResolverTypeWrapper<MovieContent>;
  MovieData: ResolverTypeWrapper<MovieData>;
  MovieDetail: ResolverTypeWrapper<MovieDetail>;
  MovieDetailData: ResolverTypeWrapper<MovieDetailData>;
  MovieDetailHero: ResolverTypeWrapper<MovieDetailHero>;
  MovieDetailResponse: ResolverTypeWrapper<MovieDetailResponse>;
  MovieHomeData: ResolverTypeWrapper<Omit<MovieHomeData, 'hero'> & { hero?: Maybe<ResolversTypes['DetailHero']> }>;
  MovieItem: ResolverTypeWrapper<MovieItem>;
  MovieParams: MovieParams;
  MovieRecommendation: ResolverTypeWrapper<MovieRecommendation>;
  MovieResponse: ResolverTypeWrapper<MovieResponse>;
  MovieTrendingContent: ResolverTypeWrapper<MovieTrendingContent>;
  MultiChannelCollectionCarousel: ResolverTypeWrapper<MultiChannelCollectionCarousel>;
  MultiChannelCollectionCarouselApiResponse: ResolverTypeWrapper<MultiChannelCollectionCarouselApiResponse>;
  Mutation: ResolverTypeWrapper<{}>;
  MutationResponse: ResolverTypeWrapper<MutationResponse>;
  MvpdDispute: ResolverTypeWrapper<MvpdDispute>;
  MvpdLogo: ResolverTypeWrapper<MvpdLogo>;
  MyListApiParams: ResolverTypeWrapper<MyListApiParams>;
  Nav: ResolverTypeWrapper<Nav>;
  NavCtaAttributes: ResolverTypeWrapper<NavCtaAttributes>;
  NavCtaAttributesResponse: ResolverTypeWrapper<NavCtaAttributesResponse>;
  NavItem: ResolverTypeWrapper<NavItem>;
  NextItem: ResolverTypeWrapper<NextItem>;
  NextItemResponse: ResolverTypeWrapper<NextItemResponse>;
  NextVideoLiveParams: NextVideoLiveParams;
  NextVideoParams: NextVideoParams;
  NextVideoVODParams: NextVideoVodParams;
  NormalizedCouponResponse: ResolverTypeWrapper<NormalizedCouponResponse>;
  OnNowCarousel: ResolverTypeWrapper<OnNowCarousel>;
  OnNowCarouselApiResponse: ResolverTypeWrapper<OnNowCarouselApiResponse>;
  OverrideUserProfile: ResolverTypeWrapper<OverrideUserProfile>;
  PackageInfo: ResolverTypeWrapper<PackageInfo>;
  PageAttributesResponse: ResolverTypeWrapper<PageAttributesResponse>;
  PagePlanAttr: ResolverTypeWrapper<PagePlanAttr>;
  ParentalControlInput: ParentalControlInput;
  ParentalControlPIN: ResolverTypeWrapper<ParentalControlPin>;
  ParentalControlRatingLabel: ResolverTypeWrapper<ParentalControlRatingLabel>;
  ParentalControlRatingTranslation: ResolverTypeWrapper<ParentalControlRatingTranslation>;
  PaymentGatewayResponse: ResolverTypeWrapper<PaymentGatewayResponse>;
  PlanCampaignAttr: ResolverTypeWrapper<PlanCampaignAttr>;
  PlanPageAttributesResponse: ResolverTypeWrapper<PlanPageAttributesResponse>;
  PlansBucket: ResolverTypeWrapper<PlansBucket>;
  PlansBucketPageAttributes: ResolverTypeWrapper<PlansBucketPageAttributes>;
  PlatformRestartInput: PlatformRestartInput;
  PlatformRestartResponse: ResolverTypeWrapper<PlatformRestartResponse>;
  PlatformRestartSession: ResolverTypeWrapper<PlatformRestartSession>;
  PlatformSession: ResolverTypeWrapper<PlatformSession>;
  PlaybackEvents: ResolverTypeWrapper<PlaybackEvents>;
  PositionDetails: ResolverTypeWrapper<PositionDetails>;
  PrefetchData: ResolverTypeWrapper<PrefetchData>;
  PreselectedCreditCardGatewayResponse: ResolverTypeWrapper<PreselectedCreditCardGatewayResponse>;
  PrevNextResponse: ResolverTypeWrapper<PrevNextResponse>;
  PrevNextVideoItem: ResolverTypeWrapper<PrevNextVideoItem>;
  PrivacyInfo: PrivacyInfo;
  ProductResponse: ResolverTypeWrapper<ProductResponse>;
  ProductsResponse: ResolverTypeWrapper<ProductsResponse>;
  ProfileInput: ProfileInput;
  ProfileLevel: ResolverTypeWrapper<ProfileLevel>;
  ProfileType: ProfileType;
  PromotionInfo: ResolverTypeWrapper<PromotionInfo>;
  PromotionalSpot: PromotionalSpot;
  Query: ResolverTypeWrapper<{}>;
  QueryPlanPageAttrArgs: ResolverTypeWrapper<QueryPlanPageAttrArgs>;
  RatingGroup: ResolverTypeWrapper<RatingGroup>;
  RecentChannelsApiResponse: ResolverTypeWrapper<RecentChannelsApiResponse>;
  RecommendationApiResponse: ResolverTypeWrapper<RecommendationApiResponse>;
  RecommendationContent: ResolverTypeWrapper<RecommendationContent>;
  RecommendationItem: ResolverTypeWrapper<RecommendationItem>;
  Recommendations: ResolverTypeWrapper<Recommendations>;
  Region: ResolverTypeWrapper<Region>;
  RegionalRating: ResolverTypeWrapper<RegionalRating>;
  RegionalRatings: ResolverTypeWrapper<RegionalRatings>;
  RemoveCommunityFeedbackInput: RemoveCommunityFeedbackInput;
  RendezvousCompletePageAttribute: ResolverTypeWrapper<RendezvousCompletePageAttribute>;
  RendezvousCompletePageAttributeQueryResponse: ResolverTypeWrapper<RendezvousCompletePageAttributeQueryResponse>;
  RendezvousPageAttributeQueryResponse: ResolverTypeWrapper<RendezvousPageAttributeQueryResponse>;
  RendezvousSignInOptionsQueryResponse: ResolverTypeWrapper<RendezvousSignInOptionsQueryResponse>;
  Result: ResolverTypeWrapper<Omit<Result, 'data'> & { data: Array<ResolversTypes['CarouselItem']> }>;
  Results: ResolverTypeWrapper<Results>;
  SearchConfigInput: SearchConfigInput;
  SearchConfigResponse: ResolverTypeWrapper<SearchConfigResponse>;
  SearchInput: SearchInput;
  SearchLiveResponse: ResolverTypeWrapper<SearchLiveResponse>;
  SearchPageConfig: ResolverTypeWrapper<SearchPageConfig>;
  SearchResponse: ResolverTypeWrapper<SearchResponse>;
  SearchResult: ResolverTypeWrapper<SearchResult>;
  SearchVODContentResult: ResolverTypeWrapper<Omit<SearchVodContentResult, 'data'> & { data: Array<ResolversTypes['CarouselItem']> }>;
  SearchVideoCarouselResult: ResolverTypeWrapper<SearchVideoCarouselResult>;
  Section: ResolverTypeWrapper<Section>;
  SectionItems: ResolverTypeWrapper<SectionItems>;
  SendForgotPasswordLinkResponse: ResolverTypeWrapper<SendForgotPasswordLinkResponse>;
  SeoContent: ResolverTypeWrapper<SeoContent>;
  SeoHreflangResponse: ResolverTypeWrapper<SeoHreflangResponse>;
  SeoResponse: ResolverTypeWrapper<SeoResponse>;
  SeriesHistoryResponse: ResolverTypeWrapper<SeriesHistoryResponse>;
  SeriesHistoryVideo: ResolverTypeWrapper<SeriesHistoryVideo>;
  Session: ResolverTypeWrapper<Session>;
  SessionTokenParams: SessionTokenParams;
  SessionTokenResponse: ResolverTypeWrapper<SessionTokenResponse>;
  SessionTokenResults: ResolverTypeWrapper<SessionTokenResults>;
  Show: ResolverTypeWrapper<Show>;
  ShowAssets: ResolverTypeWrapper<ShowAssets>;
  ShowAssetsDetailData: ResolverTypeWrapper<ShowAssetsDetailData>;
  ShowCarouselItem: ResolverTypeWrapper<ShowCarouselItem>;
  ShowCollectionEntity: ResolverTypeWrapper<ShowCollectionEntity>;
  ShowData: ResolverTypeWrapper<ShowData>;
  ShowDataWrapper: ResolverTypeWrapper<ShowDataWrapper>;
  ShowDetail: ResolverTypeWrapper<ShowDetail>;
  ShowDetailHero: ResolverTypeWrapper<ShowDetailHero>;
  ShowDetailsResponse: ResolverTypeWrapper<ShowDetailsResponse>;
  ShowHomeData: ResolverTypeWrapper<Omit<ShowHomeData, 'hero'> & { hero?: Maybe<ResolversTypes['DetailHero']> }>;
  ShowHomeItem: ResolverTypeWrapper<ShowHomeItem>;
  ShowHomeResponse: ResolverTypeWrapper<ShowHomeResponse>;
  ShowItem: ResolverTypeWrapper<ShowItem>;
  ShowMenuItem: ResolverTypeWrapper<ShowMenuItem>;
  ShowMenuLink: ResolverTypeWrapper<ShowMenuLink>;
  ShowObject: ResolverTypeWrapper<ShowObject>;
  ShowSlugById: ResolverTypeWrapper<ShowSlugById>;
  ShowTimeAttributes: ResolverTypeWrapper<ShowTimeAttributes>;
  ShowTrendingContent: ResolverTypeWrapper<ShowTrendingContent>;
  SignInFormFields: SignInFormFields;
  SignInPageAttribute: ResolverTypeWrapper<SignInPageAttribute>;
  SignInPageAttributeQueryResponse: ResolverTypeWrapper<SignInPageAttributeQueryResponse>;
  SignInResponse: ResolverTypeWrapper<SignInResponse>;
  SignUpFormFields: SignUpFormFields;
  SignUpPageAttribute: ResolverTypeWrapper<SignUpPageAttribute>;
  SignUpPageAttributeQueryResponse: ResolverTypeWrapper<SignUpPageAttributeQueryResponse>;
  SignUpResponse: ResolverTypeWrapper<SignUpResponse>;
  SingleListingResponse: ResolverTypeWrapper<SingleListingResponse>;
  SlideMetadata: ResolverTypeWrapper<SlideMetadata>;
  SpotlightCarouselItem: ResolverTypeWrapper<Omit<SpotlightCarouselItem, 'data'> & { data?: Maybe<Array<Maybe<ResolversTypes['MediaItem']>>> }>;
  SpotlightItem: ResolverTypeWrapper<Omit<SpotlightItem, 'content' | 'show'> & { content?: Maybe<ResolversTypes['MediaItem']>, show?: Maybe<ResolversTypes['MediaItem']> }>;
  StartParameters: StartParameters;
  StartResponse: ResolverTypeWrapper<StartResponse>;
  Stitched: ResolverTypeWrapper<Stitched>;
  StitchedPath: ResolverTypeWrapper<StitchedPath>;
  StitcherPath: ResolverTypeWrapper<StitcherPath>;
  StitcherPaths: ResolverTypeWrapper<StitcherPaths>;
  StitcherStreamingUrlResponse: ResolverTypeWrapper<StitcherStreamingUrlResponse>;
  StreamHistoryResponse: ResolverTypeWrapper<StreamHistoryResponse>;
  StreamingUrlParams: StreamingUrlParams;
  StreamingUrlResponse: ResolverTypeWrapper<StreamingUrlResponse>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SubNavItem: ResolverTypeWrapper<SubNavItem>;
  Subratings: ResolverTypeWrapper<Subratings>;
  SuggestionsResponse: ResolverTypeWrapper<SuggestionsResponse>;
  SwitchResponse: ResolverTypeWrapper<SwitchResponse>;
  Thumbnail: ResolverTypeWrapper<Thumbnail>;
  ThumbnailSet: ResolverTypeWrapper<ThumbnailSet>;
  ThumbnailSheetSet: ResolverTypeWrapper<ThumbnailSheetSet>;
  TrailerContent: ResolverTypeWrapper<TrailerContent>;
  TransformedMarquee: ResolverTypeWrapper<TransformedMarquee>;
  TransformedMarqueeSlide: ResolverTypeWrapper<TransformedMarqueeSlide>;
  TransformedSeoHreflangResponse: ResolverTypeWrapper<TransformedSeoHreflangResponse>;
  Trending: ResolverTypeWrapper<Omit<Trending, 'content'> & { content?: Maybe<ResolversTypes['TrendingContent']> }>;
  TrendingContent: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['TrendingContent']>;
  UUID: ResolverTypeWrapper<Scalars['UUID']['output']>;
  UniversalChannelListingItem: ResolverTypeWrapper<UniversalChannelListingItem>;
  UniversalContentApiResponse: ResolverTypeWrapper<Omit<UniversalContentApiResponse, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['UniversalItem']>>> }>;
  UniversalCreativeApiResponse: ResolverTypeWrapper<UniversalCreativeApiResponse>;
  UniversalCreativeItem: ResolverTypeWrapper<UniversalCreativeItem>;
  UniversalItem: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UniversalItem']>;
  UniversalMovieItem: ResolverTypeWrapper<UniversalMovieItem>;
  UniversalPromotionItem: ResolverTypeWrapper<UniversalPromotionItem>;
  UniversalShowItem: ResolverTypeWrapper<UniversalShowItem>;
  UpNextRecommendation: ResolverTypeWrapper<UpNextRecommendation>;
  UpNextRecommendationButton: ResolverTypeWrapper<UpNextRecommendationButton>;
  UpNextResponse: ResolverTypeWrapper<UpNextResponse>;
  UpNextTrackAction: ResolverTypeWrapper<UpNextTrackAction>;
  UpNextTrackEndCardSelect: ResolverTypeWrapper<UpNextTrackEndCardSelect>;
  UpNextTracking: ResolverTypeWrapper<UpNextTracking>;
  UpdateEmailFormFields: UpdateEmailFormFields;
  UpdateEmailResponse: ResolverTypeWrapper<UpdateEmailResponse>;
  UpdatePaymentResponse: ResolverTypeWrapper<UpdatePaymentResponse>;
  UpsellBucket: ResolverTypeWrapper<UpsellBucket>;
  UpsellCarousel: ResolverTypeWrapper<UpsellCarousel>;
  UpsellCta: ResolverTypeWrapper<UpsellCta>;
  UpsellHeader: ResolverTypeWrapper<UpsellHeader>;
  UpsellLogo: ResolverTypeWrapper<UpsellLogo>;
  UpsellPageAttributeQueryResponse: ResolverTypeWrapper<UpsellPageAttributeQueryResponse>;
  UserAccountSettings: ResolverTypeWrapper<UserAccountSettings>;
  UserAccountSettingsAddress: ResolverTypeWrapper<UserAccountSettingsAddress>;
  UserInfo: ResolverTypeWrapper<UserInfo>;
  UserPackageStatus: ResolverTypeWrapper<UserPackageStatus>;
  UserParams: UserParams;
  UserProfile: ResolverTypeWrapper<UserProfile>;
  UserSession: ResolverTypeWrapper<UserSession>;
  UserSessionResponse: ResolverTypeWrapper<UserSessionResponse>;
  UserSignInResponse: ResolverTypeWrapper<UserSignInResponse>;
  UserStatus: ResolverTypeWrapper<UserStatus>;
  UserSubscription: ResolverTypeWrapper<UserSubscription>;
  UserSubscriptionResponse: ResolverTypeWrapper<UserSubscriptionResponse>;
  ValuePropItem: ResolverTypeWrapper<ValuePropItem>;
  Video: ResolverTypeWrapper<Video>;
  VideoChannel: ResolverTypeWrapper<VideoChannel>;
  VideoChannelDma: ResolverTypeWrapper<VideoChannelDma>;
  VideoConfigResponse: ResolverTypeWrapper<VideoConfigResponse>;
  VideoItem: ResolverTypeWrapper<VideoItem>;
  VideoItemData: ResolverTypeWrapper<VideoItemData>;
  VideoModel: ResolverTypeWrapper<VideoModel>;
  VideoNextResponse: ResolverTypeWrapper<VideoNextResponse>;
  VideoParams: VideoParams;
  VideoResponse: ResolverTypeWrapper<VideoResponse>;
  VideoResults: ResolverTypeWrapper<VideoResults>;
  VideoSectionMetadata: ResolverTypeWrapper<VideoSectionMetadata>;
  VideoUserInfo: ResolverTypeWrapper<VideoUserInfo>;
  VodContentHighlightKind: VodContentHighlightKind;
  WatchListChannelsApiResponse: ResolverTypeWrapper<WatchListChannelsApiResponse>;
  WatchListItem: ResolverTypeWrapper<WatchListItem>;
  WatchListItemContent: ResolverTypeWrapper<WatchListItemContent>;
  WatchingRestrictions: ResolverTypeWrapper<WatchingRestrictions>;
  addOnResponse: ResolverTypeWrapper<AddOnResponse>;
  cancelSavePageAttributesResponse: ResolverTypeWrapper<CancelSavePageAttributesResponse>;
  cbsPackageInfo: ResolverTypeWrapper<CbsPackageInfo>;
  changePasswordResponse: ResolverTypeWrapper<ChangePasswordResponse>;
  checkEmailFormFields: CheckEmailFormFields;
  checkEmailResponse: ResolverTypeWrapper<CheckEmailResponse>;
  compilingPageAttributesResponse: ResolverTypeWrapper<CompilingPageAttributesResponse>;
  editEmailResponse: ResolverTypeWrapper<EditEmailResponse>;
  editPasswordResponse: ResolverTypeWrapper<EditPasswordResponse>;
  liveStreamInfoResponse: ResolverTypeWrapper<LiveStreamInfoResponse>;
  manageDevicesPageAttributesResponse: ResolverTypeWrapper<ManageDevicesPageAttributesResponse>;
  productsByCadence: ResolverTypeWrapper<ProductsByCadence>;
  redeemCouponResponse: ResolverTypeWrapper<RedeemCouponResponse>;
  resetForgotPasswordResponse: ResolverTypeWrapper<ResetForgotPasswordResponse>;
  tester: ResolverTypeWrapper<Tester>;
  updateOptInResponse: ResolverTypeWrapper<UpdateOptInResponse>;
  upsellPageResponse: ResolverTypeWrapper<UpsellPageResponse>;
  upsellUserStatus: ResolverTypeWrapper<UpsellUserStatus>;
  vendorAttributes: ResolverTypeWrapper<VendorAttributes>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  ABTest: AbTest;
  ABTestVariantsResponse: AbTestVariantsResponse;
  ABTestsVariantEntry: AbTestsVariantEntry;
  ABTestsVariantsInput: AbTestsVariantsInput;
  ABTestsVariantsResponse: AbTestsVariantsResponse;
  AccountPageAttribute: AccountPageAttribute;
  AccountPageAttributeQueryResponse: AccountPageAttributeQueryResponse;
  AccountZipStateInfo: AccountZipStateInfo;
  ActiveCoupon: ActiveCoupon;
  ActiveCouponCurrency: ActiveCouponCurrency;
  ActiveCouponDiscount: ActiveCouponDiscount;
  AllMoviesMockParams: AllMoviesMockParams;
  AllMoviesMockResponse: Omit<AllMoviesMockResponse, 'items'> & { items: Array<ResolversParentTypes['CarouselItem']> };
  ApiParams: ApiParams;
  ApiRegionalRating: ApiRegionalRating;
  ApiVideoItem: ApiVideoItem;
  AssociatedContentVideo: AssociatedContentVideo;
  AutocompleteSuggestion: AutocompleteSuggestion;
  AvailableVideoSeason: AvailableVideoSeason;
  AvailableVideoSeasons: AvailableVideoSeasons;
  AvailableVideoSeasonsData: AvailableVideoSeasonsData;
  Avatar: Avatar;
  AvatarGroup: AvatarGroup;
  BillingInfoResponse: BillingInfoResponse;
  BindMvpdFields: BindMvpdFields;
  BindMvpdResponse: BindMvpdResponse;
  BindPartnerFields: BindPartnerFields;
  BindPartnerResponse: BindPartnerResponse;
  Boolean: Scalars['Boolean']['output'];
  Brand: Brand;
  BrandCarouselItem: BrandCarouselItem;
  BrandItem: BrandItem;
  Button: Button;
  CANContext: CanContext;
  CampaignData: CampaignData;
  CampaignPageAttributesResponse: CampaignPageAttributesResponse;
  CanModel: CanModel;
  CancelSaveCarouselItem: CancelSaveCarouselItem;
  CancelSavePageAttribute: CancelSavePageAttribute;
  CarazCta: CarazCta;
  CarazImageAssets: CarazImageAssets;
  CarazPromoData: CarazPromoData;
  CarazRating: CarazRating;
  CarazTrackingData: CarazTrackingData;
  CarouselApiResponse: Omit<CarouselApiResponse, 'AtoZ' | 'carousel' | 'collections' | 'trending'> & { AtoZ?: Maybe<Array<Maybe<ResolversParentTypes['Trending']>>>, carousel?: Maybe<Array<Maybe<ResolversParentTypes['MediaItem']>>>, collections?: Maybe<Array<Maybe<ResolversParentTypes['Collections']>>>, trending?: Maybe<Array<Maybe<ResolversParentTypes['Trending']>>> };
  CarouselInfo: CarouselInfo;
  CarouselItem: ResolversInterfaceTypes<ResolversParentTypes>['CarouselItem'];
  CarouselItemTracking: CarouselItemTracking;
  CarouselParams: CarouselParams;
  CarouselResponse: Omit<CarouselResponse, 'result'> & { result?: Maybe<ResolversParentTypes['Result']> };
  CastApiParams: CastApiParams;
  CastConfig: CastConfig;
  CastConfigurationResponse: CastConfigurationResponse;
  CastItem: CastItem;
  Channel: Channel;
  ChannelCategoriesParams: ChannelCategoriesParams;
  ChannelCategoriesResponse: ChannelCategoriesResponse;
  ChannelCategory: ChannelCategory;
  ChannelData: ChannelData;
  ChannelListing: ChannelListing;
  ChannelListingCarouselItem: ChannelListingCarouselItem;
  ChannelListingData: ChannelListingData;
  ChannelListingNormalized: ChannelListingNormalized;
  ChannelListingResponse: ChannelListingResponse;
  ChannelParams: ChannelParams;
  ChannelResponse: ResolversUnionTypes<ResolversParentTypes>['ChannelResponse'];
  ChannelResponseError: ChannelResponseError;
  ChannelResponseMany: ChannelResponseMany;
  ChannelResponseOne: ChannelResponseOne;
  CharacterApiResponse: CharacterApiResponse;
  CharacterCarouselItem: CharacterCarouselItem;
  CharacterItem: CharacterItem;
  CmpConsentTokenResponse: CmpConsentTokenResponse;
  CodeActivateSuccessResponse: CodeActivateSuccessResponse;
  Collection: Collection;
  CollectionApiResponse: CollectionApiResponse;
  CollectionCarousel: CollectionCarousel;
  CollectionEntity: ResolversUnionTypes<ResolversParentTypes>['CollectionEntity'];
  Collections: Omit<Collections, 'collectionEntity'> & { collectionEntity?: Maybe<ResolversParentTypes['CollectionEntity']> };
  CommonApiParams: CommonApiParams;
  CommonContentFields: ResolversInterfaceTypes<ResolversParentTypes>['CommonContentFields'];
  CommonData: CommonData;
  CommunityFeedback: CommunityFeedback;
  CommunityFeedbackReadResponse: CommunityFeedbackReadResponse;
  CommunityFeedbackRemoveResponse: CommunityFeedbackRemoveResponse;
  CommunityFeedbackRemoved: CommunityFeedbackRemoved;
  CommunityFeedbackTarget: CommunityFeedbackTarget;
  CommunityFeedbackWriteResponse: CommunityFeedbackWriteResponse;
  ConcurrencyDeniedPlaybackReason: ConcurrencyDeniedPlaybackReason;
  ConcurrencyParams: ConcurrencyParams;
  ConcurrencyResponse: ConcurrencyResponse;
  Config: Config;
  ContentCANVideo: ContentCanVideo;
  ContentHighlightMetadata: ContentHighlightMetadata;
  ContentHighlightMetadataInput: ContentHighlightMetadataInput;
  Context: Context;
  Coordinates: Coordinates;
  CreativeAdData: CreativeAdData;
  CreativeCarouselItem: CreativeCarouselItem;
  CreativeCommonData: CreativeCommonData;
  CreativeCta: CreativeCta;
  CreativeImageAssets: CreativeImageAssets;
  CreativeTrackingData: CreativeTrackingData;
  DAIParams: DaiParams;
  Date: Scalars['Date']['output'];
  DateTimeISO: Scalars['DateTimeISO']['output'];
  DebugInfo: DebugInfo;
  DetailCta: DetailCta;
  DetailHero: ResolversInterfaceTypes<ResolversParentTypes>['DetailHero'];
  DeviceInfo: DeviceInfo;
  DeviceListResponse: DeviceListResponse;
  DmaItem: DmaItem;
  DmaParams: DmaParams;
  DmaResponse: DmaResponse;
  DmaTokenDetails: DmaTokenDetails;
  DownloadCountry: DownloadCountry;
  DownloadCountrySet: DownloadCountrySet;
  DrmSession: DrmSession;
  DynamicPlayResponse: DynamicPlayResponse;
  DynamicVideoModel: DynamicVideoModel;
  EmailCheckpointResponse: EmailCheckpointResponse;
  Entitlement: Entitlement;
  EntitlementPackageInfo: EntitlementPackageInfo;
  EntitlementProductInfo: EntitlementProductInfo;
  Episode: Episode;
  EpisodeData: EpisodeData;
  EpisodeResumeTime: EpisodeResumeTime;
  EpisodesApiResponse: EpisodesApiResponse;
  FMSQueryParams: FmsQueryParams;
  FMSResponse: FmsResponse;
  Faq: Faq;
  FavoriteChannelItem: FavoriteChannelItem;
  Float: Scalars['Float']['output'];
  FmsInfo: FmsInfo;
  FmsParams: FmsParams;
  FooterLink: FooterLink;
  FooterLinksData: FooterLinksData;
  FormRendezvousFields: FormRendezvousFields;
  FormSignUpFields: FormSignUpFields;
  FrontDoorBucket: FrontDoorBucket;
  FrontDoorBucketCarousel: FrontDoorBucketCarousel;
  FrontDoorCarousel: FrontDoorCarousel;
  FrontDoorContentData: FrontDoorContentData;
  FrontDoorCta: FrontDoorCta;
  FrontDoorData: FrontDoorData;
  FrontDoorFaqBucket: FrontDoorFaqBucket;
  FrontDoorFaqItem: FrontDoorFaqItem;
  FrontDoorHeader: FrontDoorHeader;
  FrontDoorHero: FrontDoorHero;
  FrontDoorLogo: FrontDoorLogo;
  FullEpisodesData: FullEpisodesData;
  FullUser: FullUser;
  FullUserStatus: FullUserStatus;
  GameListingParams: GameListingParams;
  Genre: Genre;
  GlobalMenu: GlobalMenu;
  GlobalMenuData: GlobalMenuData;
  GlobalMenuFooterSection: GlobalMenuFooterSection;
  GlobalMenuItem: GlobalMenuItem;
  Hero: HeroRestRaw;
  HeroApiInfo: HeroApiInfo;
  HeroApiResponse: Omit<HeroApiResponse, 'hero'> & { hero: Array<ResolversParentTypes['Hero']> };
  History: History;
  HistoryApiResponse: HistoryApiResponse;
  HomeConfig: HomeConfig;
  HomeParams: HomeParams;
  HreflangConfigObj: HreflangConfigObj;
  Hub: Hub;
  HubCarouselItem: HubCarouselItem;
  HubItem: HubItem;
  HubMarquee: HubMarquee;
  HubMarqueeSlide: HubMarqueeSlide;
  ID: Scalars['ID']['output'];
  IdentityLoginInput: IdentityLoginInput;
  IdentityLoginResponse: IdentityLoginResponse;
  IdentityRegisterFieldError: IdentityRegisterFieldError;
  IdentityRegisterResponse: IdentityRegisterResponse;
  IngestCommunityFeedbackInput: IngestCommunityFeedbackInput;
  InputDeviceInfo: InputDeviceInfo;
  Int: Scalars['Int']['output'];
  ItemList: ItemList;
  JSON: Scalars['JSON']['output'];
  KeepWatchingItem: KeepWatchingItem;
  ListingData: ListingData;
  ListingNormalizedResponse: ListingNormalizedResponse;
  ListingParams: ListingParams;
  ListingsResponse: ListingsResponse;
  LiveCarouselApiResponse: LiveCarouselApiResponse;
  LiveCarouselItem: LiveCarouselItem;
  LiveChannel: LiveChannel;
  LiveChannelListing: LiveChannelListing;
  LiveDetailHero: LiveDetailHero;
  LiveEvent: LiveEvent;
  LiveItem: LiveItem;
  LiveShowCarouselItem: LiveShowCarouselItem;
  LocalPlaybackParams: LocalPlaybackParams;
  LocalStation: LocalStation;
  LogOutResponse: LogOutResponse;
  ManageDevicesPageAttribute: ManageDevicesPageAttribute;
  MarqueeApiInfo: MarqueeApiInfo;
  MarqueeApiResponse: MarqueeApiResponse;
  MarqueeContent: Omit<MarqueeContent, 'data'> & { data: Array<ResolversParentTypes['CarouselItem']> };
  MarqueeItem: MarqueeItem;
  MarqueeMovieAssets: MarqueeMovieAssets;
  MarqueeShowAssets: MarqueeShowAssets;
  MarqueeSlide: MarqueeSlide;
  MediaBrowseResponse: MediaBrowseResponse;
  MediaBrowseVideo: MediaBrowseVideo;
  MediaItem: ResolversUnionTypes<ResolversParentTypes>['MediaItem'];
  MerchandiseContentResponse: MerchandiseContentResponse;
  MerchandiseSlide: MerchandiseSlide;
  MetadataResponse: MetadataResponse;
  MosaicPageAttributeSourceRecords: MosaicPageAttributeSourceRecords;
  MosaicPageAttributesResponse: MosaicPageAttributesResponse;
  MosaicPageDocumentsResponse: MosaicPageDocumentsResponse;
  Movie: Movie;
  MovieAssets: MovieAssets;
  MovieCarouselItem: MovieCarouselItem;
  MovieCollectionEntity: MovieCollectionEntity;
  MovieContent: MovieContent;
  MovieData: MovieData;
  MovieDetail: MovieDetail;
  MovieDetailData: MovieDetailData;
  MovieDetailHero: MovieDetailHero;
  MovieDetailResponse: MovieDetailResponse;
  MovieHomeData: Omit<MovieHomeData, 'hero'> & { hero?: Maybe<ResolversParentTypes['DetailHero']> };
  MovieItem: MovieItem;
  MovieParams: MovieParams;
  MovieRecommendation: MovieRecommendation;
  MovieResponse: MovieResponse;
  MovieTrendingContent: MovieTrendingContent;
  MultiChannelCollectionCarousel: MultiChannelCollectionCarousel;
  MultiChannelCollectionCarouselApiResponse: MultiChannelCollectionCarouselApiResponse;
  Mutation: {};
  MutationResponse: MutationResponse;
  MvpdDispute: MvpdDispute;
  MvpdLogo: MvpdLogo;
  MyListApiParams: MyListApiParams;
  Nav: Nav;
  NavCtaAttributes: NavCtaAttributes;
  NavCtaAttributesResponse: NavCtaAttributesResponse;
  NavItem: NavItem;
  NextItem: NextItem;
  NextItemResponse: NextItemResponse;
  NextVideoLiveParams: NextVideoLiveParams;
  NextVideoParams: NextVideoParams;
  NextVideoVODParams: NextVideoVodParams;
  NormalizedCouponResponse: NormalizedCouponResponse;
  OnNowCarousel: OnNowCarousel;
  OnNowCarouselApiResponse: OnNowCarouselApiResponse;
  OverrideUserProfile: OverrideUserProfile;
  PackageInfo: PackageInfo;
  PageAttributesResponse: PageAttributesResponse;
  PagePlanAttr: PagePlanAttr;
  ParentalControlInput: ParentalControlInput;
  ParentalControlPIN: ParentalControlPin;
  ParentalControlRatingLabel: ParentalControlRatingLabel;
  ParentalControlRatingTranslation: ParentalControlRatingTranslation;
  PaymentGatewayResponse: PaymentGatewayResponse;
  PlanCampaignAttr: PlanCampaignAttr;
  PlanPageAttributesResponse: PlanPageAttributesResponse;
  PlansBucket: PlansBucket;
  PlansBucketPageAttributes: PlansBucketPageAttributes;
  PlatformRestartInput: PlatformRestartInput;
  PlatformRestartResponse: PlatformRestartResponse;
  PlatformRestartSession: PlatformRestartSession;
  PlatformSession: PlatformSession;
  PlaybackEvents: PlaybackEvents;
  PositionDetails: PositionDetails;
  PrefetchData: PrefetchData;
  PreselectedCreditCardGatewayResponse: PreselectedCreditCardGatewayResponse;
  PrevNextResponse: PrevNextResponse;
  PrevNextVideoItem: PrevNextVideoItem;
  PrivacyInfo: PrivacyInfo;
  ProductResponse: ProductResponse;
  ProductsResponse: ProductsResponse;
  ProfileInput: ProfileInput;
  ProfileLevel: ProfileLevel;
  PromotionInfo: PromotionInfo;
  PromotionalSpot: PromotionalSpot;
  Query: {};
  QueryPlanPageAttrArgs: QueryPlanPageAttrArgs;
  RatingGroup: RatingGroup;
  RecentChannelsApiResponse: RecentChannelsApiResponse;
  RecommendationApiResponse: RecommendationApiResponse;
  RecommendationContent: RecommendationContent;
  RecommendationItem: RecommendationItem;
  Recommendations: Recommendations;
  Region: Region;
  RegionalRating: RegionalRating;
  RegionalRatings: RegionalRatings;
  RemoveCommunityFeedbackInput: RemoveCommunityFeedbackInput;
  RendezvousCompletePageAttribute: RendezvousCompletePageAttribute;
  RendezvousCompletePageAttributeQueryResponse: RendezvousCompletePageAttributeQueryResponse;
  RendezvousPageAttributeQueryResponse: RendezvousPageAttributeQueryResponse;
  RendezvousSignInOptionsQueryResponse: RendezvousSignInOptionsQueryResponse;
  Result: Omit<Result, 'data'> & { data: Array<ResolversParentTypes['CarouselItem']> };
  Results: Results;
  SearchConfigInput: SearchConfigInput;
  SearchConfigResponse: SearchConfigResponse;
  SearchInput: SearchInput;
  SearchLiveResponse: SearchLiveResponse;
  SearchPageConfig: SearchPageConfig;
  SearchResponse: SearchResponse;
  SearchResult: SearchResult;
  SearchVODContentResult: Omit<SearchVodContentResult, 'data'> & { data: Array<ResolversParentTypes['CarouselItem']> };
  SearchVideoCarouselResult: SearchVideoCarouselResult;
  Section: Section;
  SectionItems: SectionItems;
  SendForgotPasswordLinkResponse: SendForgotPasswordLinkResponse;
  SeoContent: SeoContent;
  SeoHreflangResponse: SeoHreflangResponse;
  SeoResponse: SeoResponse;
  SeriesHistoryResponse: SeriesHistoryResponse;
  SeriesHistoryVideo: SeriesHistoryVideo;
  Session: Session;
  SessionTokenParams: SessionTokenParams;
  SessionTokenResponse: SessionTokenResponse;
  SessionTokenResults: SessionTokenResults;
  Show: Show;
  ShowAssets: ShowAssets;
  ShowAssetsDetailData: ShowAssetsDetailData;
  ShowCarouselItem: ShowCarouselItem;
  ShowCollectionEntity: ShowCollectionEntity;
  ShowData: ShowData;
  ShowDataWrapper: ShowDataWrapper;
  ShowDetail: ShowDetail;
  ShowDetailHero: ShowDetailHero;
  ShowDetailsResponse: ShowDetailsResponse;
  ShowHomeData: Omit<ShowHomeData, 'hero'> & { hero?: Maybe<ResolversParentTypes['DetailHero']> };
  ShowHomeItem: ShowHomeItem;
  ShowHomeResponse: ShowHomeResponse;
  ShowItem: ShowItem;
  ShowMenuItem: ShowMenuItem;
  ShowMenuLink: ShowMenuLink;
  ShowObject: ShowObject;
  ShowSlugById: ShowSlugById;
  ShowTimeAttributes: ShowTimeAttributes;
  ShowTrendingContent: ShowTrendingContent;
  SignInFormFields: SignInFormFields;
  SignInPageAttribute: SignInPageAttribute;
  SignInPageAttributeQueryResponse: SignInPageAttributeQueryResponse;
  SignInResponse: SignInResponse;
  SignUpFormFields: SignUpFormFields;
  SignUpPageAttribute: SignUpPageAttribute;
  SignUpPageAttributeQueryResponse: SignUpPageAttributeQueryResponse;
  SignUpResponse: SignUpResponse;
  SingleListingResponse: SingleListingResponse;
  SlideMetadata: SlideMetadata;
  SpotlightCarouselItem: Omit<SpotlightCarouselItem, 'data'> & { data?: Maybe<Array<Maybe<ResolversParentTypes['MediaItem']>>> };
  SpotlightItem: Omit<SpotlightItem, 'content' | 'show'> & { content?: Maybe<ResolversParentTypes['MediaItem']>, show?: Maybe<ResolversParentTypes['MediaItem']> };
  StartParameters: StartParameters;
  StartResponse: StartResponse;
  Stitched: Stitched;
  StitchedPath: StitchedPath;
  StitcherPath: StitcherPath;
  StitcherPaths: StitcherPaths;
  StitcherStreamingUrlResponse: StitcherStreamingUrlResponse;
  StreamHistoryResponse: StreamHistoryResponse;
  StreamingUrlParams: StreamingUrlParams;
  StreamingUrlResponse: StreamingUrlResponse;
  String: Scalars['String']['output'];
  SubNavItem: SubNavItem;
  Subratings: Subratings;
  SuggestionsResponse: SuggestionsResponse;
  SwitchResponse: SwitchResponse;
  Thumbnail: Thumbnail;
  ThumbnailSet: ThumbnailSet;
  ThumbnailSheetSet: ThumbnailSheetSet;
  TrailerContent: TrailerContent;
  TransformedMarquee: TransformedMarquee;
  TransformedMarqueeSlide: TransformedMarqueeSlide;
  TransformedSeoHreflangResponse: TransformedSeoHreflangResponse;
  Trending: Omit<Trending, 'content'> & { content?: Maybe<ResolversParentTypes['TrendingContent']> };
  TrendingContent: ResolversUnionTypes<ResolversParentTypes>['TrendingContent'];
  UUID: Scalars['UUID']['output'];
  UniversalChannelListingItem: UniversalChannelListingItem;
  UniversalContentApiResponse: Omit<UniversalContentApiResponse, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['UniversalItem']>>> };
  UniversalCreativeApiResponse: UniversalCreativeApiResponse;
  UniversalCreativeItem: UniversalCreativeItem;
  UniversalItem: ResolversUnionTypes<ResolversParentTypes>['UniversalItem'];
  UniversalMovieItem: UniversalMovieItem;
  UniversalPromotionItem: UniversalPromotionItem;
  UniversalShowItem: UniversalShowItem;
  UpNextRecommendation: UpNextRecommendation;
  UpNextRecommendationButton: UpNextRecommendationButton;
  UpNextResponse: UpNextResponse;
  UpNextTrackAction: UpNextTrackAction;
  UpNextTrackEndCardSelect: UpNextTrackEndCardSelect;
  UpNextTracking: UpNextTracking;
  UpdateEmailFormFields: UpdateEmailFormFields;
  UpdateEmailResponse: UpdateEmailResponse;
  UpdatePaymentResponse: UpdatePaymentResponse;
  UpsellBucket: UpsellBucket;
  UpsellCarousel: UpsellCarousel;
  UpsellCta: UpsellCta;
  UpsellHeader: UpsellHeader;
  UpsellLogo: UpsellLogo;
  UpsellPageAttributeQueryResponse: UpsellPageAttributeQueryResponse;
  UserAccountSettings: UserAccountSettings;
  UserAccountSettingsAddress: UserAccountSettingsAddress;
  UserInfo: UserInfo;
  UserPackageStatus: UserPackageStatus;
  UserParams: UserParams;
  UserProfile: UserProfile;
  UserSession: UserSession;
  UserSessionResponse: UserSessionResponse;
  UserSignInResponse: UserSignInResponse;
  UserStatus: UserStatus;
  UserSubscription: UserSubscription;
  UserSubscriptionResponse: UserSubscriptionResponse;
  ValuePropItem: ValuePropItem;
  Video: Video;
  VideoChannel: VideoChannel;
  VideoChannelDma: VideoChannelDma;
  VideoConfigResponse: VideoConfigResponse;
  VideoItem: VideoItem;
  VideoItemData: VideoItemData;
  VideoModel: VideoModel;
  VideoNextResponse: VideoNextResponse;
  VideoParams: VideoParams;
  VideoResponse: VideoResponse;
  VideoResults: VideoResults;
  VideoSectionMetadata: VideoSectionMetadata;
  VideoUserInfo: VideoUserInfo;
  WatchListChannelsApiResponse: WatchListChannelsApiResponse;
  WatchListItem: WatchListItem;
  WatchListItemContent: WatchListItemContent;
  WatchingRestrictions: WatchingRestrictions;
  addOnResponse: AddOnResponse;
  cancelSavePageAttributesResponse: CancelSavePageAttributesResponse;
  cbsPackageInfo: CbsPackageInfo;
  changePasswordResponse: ChangePasswordResponse;
  checkEmailFormFields: CheckEmailFormFields;
  checkEmailResponse: CheckEmailResponse;
  compilingPageAttributesResponse: CompilingPageAttributesResponse;
  editEmailResponse: EditEmailResponse;
  editPasswordResponse: EditPasswordResponse;
  liveStreamInfoResponse: LiveStreamInfoResponse;
  manageDevicesPageAttributesResponse: ManageDevicesPageAttributesResponse;
  productsByCadence: ProductsByCadence;
  redeemCouponResponse: RedeemCouponResponse;
  resetForgotPasswordResponse: ResetForgotPasswordResponse;
  tester: Tester;
  updateOptInResponse: UpdateOptInResponse;
  upsellPageResponse: UpsellPageResponse;
  upsellUserStatus: UpsellUserStatus;
  vendorAttributes: VendorAttributes;
}>;

export type CacheControlDirectiveArgs = {
  inheritMaxAge?: Maybe<Scalars['Boolean']['input']>;
  maxAge?: Maybe<Scalars['Int']['input']>;
  scope?: Maybe<CacheControlScope>;
};

export type CacheControlDirectiveResolver<Result, Parent, ContextType = any, Args = CacheControlDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AbTestResolvers<ContextType = any, ParentType extends ResolversParentTypes['ABTest'] = ResolversParentTypes['ABTest']> = ResolversObject<{
  variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variantTestName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  variantValue?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AbTestVariantsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ABTestVariantsResponse'] = ResolversParentTypes['ABTestVariantsResponse']> = ResolversObject<{
  experiments?: Resolver<Array<Maybe<ResolversTypes['ABTest']>>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AbTestsVariantEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ABTestsVariantEntry'] = ResolversParentTypes['ABTestsVariantEntry']> = ResolversObject<{
  variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variantTestName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variantValue?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AbTestsVariantsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ABTestsVariantsResponse'] = ResolversParentTypes['ABTestsVariantsResponse']> = ResolversObject<{
  experiments?: Resolver<Maybe<Array<Maybe<ResolversTypes['ABTestsVariantEntry']>>>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountPageAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPageAttribute'] = ResolversParentTypes['AccountPageAttribute']> = ResolversObject<{
  aa_checkbox_promo_copy_with_no_free_trial_copy_forever?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  aa_order_summary_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coupon_checkbox_disclaimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coupon_legal_cta_disclaimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coupon_redemption_cta_disclaimer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coupon_redemption_multi_cadence_promo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coupon_redemption_single_cadence_promo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coupon_summary_cta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coupon_summary_header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coupon_summary_subheader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountPageAttributeQueryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPageAttributeQueryResponse'] = ResolversParentTypes['AccountPageAttributeQueryResponse']> = ResolversObject<{
  pageAttribute?: Resolver<Maybe<ResolversTypes['AccountPageAttribute']>, ParentType, ContextType>;
  variantsForTracking?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountZipStateInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountZipStateInfo'] = ResolversParentTypes['AccountZipStateInfo']> = ResolversObject<{
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ActiveCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveCoupon'] = ResolversParentTypes['ActiveCoupon']> = ResolversObject<{
  balanceInCents?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['ActiveCouponDiscount']>, ParentType, ContextType>;
  discountPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  freeTrialAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  freeTrialUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  temporalAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  temporalUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ActiveCouponCurrencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveCouponCurrency'] = ResolversParentTypes['ActiveCouponCurrency']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ActiveCouponDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveCouponDiscount'] = ResolversParentTypes['ActiveCouponDiscount']> = ResolversObject<{
  currencies?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActiveCouponCurrency']>>>, ParentType, ContextType>;
  percent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trial?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AllMoviesMockResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllMoviesMockResponse'] = ResolversParentTypes['AllMoviesMockResponse']> = ResolversObject<{
  items?: Resolver<Array<ResolversTypes['CarouselItem']>, ParentType, ContextType>;
  pageNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiParams'] = ResolversParentTypes['ApiParams']> = ResolversObject<{
  _clientRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configUniqueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userProfileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiRegionalRatingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiRegionalRating'] = ResolversParentTypes['ApiRegionalRating']> = ResolversObject<{
  consumerAdvice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disclaimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryDescriptors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subratings?: Resolver<Maybe<Array<Maybe<ResolversTypes['Subratings']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiVideoItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiVideoItem'] = ResolversParentTypes['ApiVideoItem']> = ResolversObject<{
  _airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _editDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _firstIngestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _ingestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _lastModifiedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amazonESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appleWatchListShowKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableForProfileTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsShowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  childContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedCaptionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daistreamKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadCountrySet?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadCountry']>>>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  editDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  embeddable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endCreditsChapterTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludeNielsenTracking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  exclusive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  firstIngestDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fullEpisode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ingestDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProductPlacement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProtected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itunesESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  liveStreamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDateEpoch?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playbackEvents?: Resolver<Maybe<ResolversTypes['PlaybackEvents']>, ParentType, ContextType>;
  playerLocUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  primaryCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryCategoryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalAudioExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApiRegionalRating']>>>, ParentType, ContextType>;
  regionalTextExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamingUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['Thumbnail']>>>, ParentType, ContextType>;
  thumbnailSheetSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['Thumbnail']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsprogramID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsseriesID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topLevelCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoProperties?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssociatedContentVideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssociatedContentVideo'] = ResolversParentTypes['AssociatedContentVideo']> = ResolversObject<{
  actors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVodAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  originalContentDurationInSecs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originalReleaseYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AutocompleteSuggestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutocompleteSuggestion'] = ResolversParentTypes['AutocompleteSuggestion']> = ResolversObject<{
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  index?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AvailableVideoSeasonResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableVideoSeason'] = ResolversParentTypes['AvailableVideoSeason']> = ResolversObject<{
  clipsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  delayCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  premiumCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seasonFinaleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonFinaleDateEpoch?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonPremiereDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonPremiereDateEpoch?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AvailableVideoSeasonsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableVideoSeasons'] = ResolversParentTypes['AvailableVideoSeasons']> = ResolversObject<{
  clipsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  delayCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  premiumCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seasonFinaleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonFinaleDateEpoch?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonPremiereDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonPremiereDateEpoch?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AvailableVideoSeasonsDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableVideoSeasonsData'] = ResolversParentTypes['AvailableVideoSeasonsData']> = ResolversObject<{
  itemList?: Resolver<Maybe<Array<ResolversTypes['AvailableVideoSeasons']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AvatarResolvers<ContextType = any, ParentType extends ResolversParentTypes['Avatar'] = ResolversParentTypes['Avatar']> = ResolversObject<{
  availableProfileTypes?: Resolver<Array<Maybe<ResolversTypes['ProfileType']>>, ParentType, ContextType>;
  avatarMedium?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  avatarSmall?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filepath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AvatarGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvatarGroup'] = ResolversParentTypes['AvatarGroup']> = ResolversObject<{
  avatars?: Resolver<Array<ResolversTypes['Avatar']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BillingInfoResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingInfoResponse'] = ResolversParentTypes['BillingInfoResponse']> = ResolversObject<{
  billingInfo?: Resolver<Maybe<ResolversTypes['AccountZipStateInfo']>, ParentType, ContextType>;
  recurlyInstance?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BindMvpdResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BindMvpdResponse'] = ResolversParentTypes['BindMvpdResponse']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BindPartnerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BindPartnerResponse'] = ResolversParentTypes['BindPartnerResponse']> = ResolversObject<{
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrandResolvers<ContextType = any, ParentType extends ResolversParentTypes['Brand'] = ResolversParentTypes['Brand']> = ResolversObject<{
  applyGradient?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endHexColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoHover?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathAnimatedBackground?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathAppHero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathAppHeroPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathDefaultHero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathDefaultHeroPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathGradient?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogoCompactApp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogoCompactWeb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogoOtt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogoRegularApp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogoRegularWeb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hubSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isHideFromBrandCarousel?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPlayerAttributionVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startHexColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrandCarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandCarouselItem'] = ResolversParentTypes['BrandCarouselItem']> = ResolversObject<{
  animatedBackground?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endHexColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  logoImage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startHexColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrandItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrandItem'] = ResolversParentTypes['BrandItem']> = ResolversObject<{
  applyGradient?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endHexColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoHover?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathAnimatedBackground?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathAppHero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathAppHeroPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathDefaultHero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathDefaultHeroPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathGradient?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filepathLogoCompactApp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogoCompactWeb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogoOtt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogoRegularApp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogoRegularWeb?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hubSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isHideFromBrandCarousel?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPlayerAttributionVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startHexColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ButtonResolvers<ContextType = any, ParentType extends ResolversParentTypes['Button'] = ResolversParentTypes['Button']> = ResolversObject<{
  episode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  play?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  season?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CanContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['CANContext'] = ResolversParentTypes['CANContext']> = ResolversObject<{
  displayText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CampaignDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignData'] = ResolversParentTypes['CampaignData']> = ResolversObject<{
  CouponOfferCode1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CouponOfferCode2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CouponOfferCode3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CouponOfferCode4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ProductOfferCode1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ProductOfferCode2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ProductOfferCode3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ProductOfferCode4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CampaignPageAttributesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampaignPageAttributesResponse'] = ResolversParentTypes['CampaignPageAttributesResponse']> = ResolversObject<{
  campaignAttributes?: Resolver<Maybe<ResolversTypes['CampaignData']>, ParentType, ContextType>;
  planPageAttributes?: Resolver<Maybe<ResolversTypes['PlanPageAttributesResponse']>, ParentType, ContextType>;
  products?: Resolver<Maybe<ResolversTypes['ProductsResponse']>, ParentType, ContextType, Partial<CampaignPageAttributesResponseProductsArgs>>;
  variantsForTracking?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CanModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['CanModel'] = ResolversParentTypes['CanModel']> = ResolversObject<{
  _airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _editDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _expirationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _firstIngestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _ingestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _lastModifiedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amazonESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appleWatchListShowKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableForProfileTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsShowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  childContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedCaptionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadCountrySet?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadCountrySet']>>>, ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  editDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  embeddable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endCreditsChapterTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludeNielsenTracking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  exclusive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  expired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstIngestDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fullEpisode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ingestDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProductPlacement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProtected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itunesESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mediaAvailableDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDateEpoch?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playbackEvents?: Resolver<Maybe<ResolversTypes['PlaybackEvents']>, ParentType, ContextType>;
  playerLocUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  primaryCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryCategoryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalAudioExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<Maybe<ResolversTypes['RegionalRatings']>>>, ParentType, ContextType>;
  regionalTextExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['ThumbnailSet']>>>, ParentType, ContextType>;
  thumbnailSheetSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['ThumbnailSheetSet']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsprogramID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsseriesID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topLevelCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoProperties?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CancelSaveCarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelSaveCarouselItem'] = ResolversParentTypes['CancelSaveCarouselItem']> = ResolversObject<{
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileTracking?: Resolver<Maybe<ResolversTypes['CarouselItemTracking']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CancelSavePageAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelSavePageAttribute'] = ResolversParentTypes['CancelSavePageAttribute']> = ResolversObject<{
  carouselTitles?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  carousels?: Resolver<Maybe<Array<Maybe<Array<Maybe<ResolversTypes['CancelSaveCarouselItem']>>>>>, ParentType, ContextType>;
  web_cancel_save_back_to_account_cta_text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  web_cancel_save_cancel_cta_text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  web_cancel_save_carousel_header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  web_cancel_save_header?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  web_cancel_save_legal_copy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  web_cancel_save_subheader1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CarazCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['CarazCta'] = ResolversParentTypes['CarazCta']> = ResolversObject<{
  ctaActionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ctaActionValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ctaText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CarazImageAssetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CarazImageAssets'] = ResolversParentTypes['CarazImageAssets']> = ResolversObject<{
  brandLogoImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroCompactImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroMiniImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroRegularImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageHeaderImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  posterImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleLogoCenterImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleLogoCompactImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleLogoLeftImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CarazPromoDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CarazPromoData'] = ResolversParentTypes['CarazPromoData']> = ResolversObject<{
  linkedContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveCTAActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveCTAText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promoListingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promoType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CarazRatingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CarazRating'] = ResolversParentTypes['CarazRating']> = ResolversObject<{
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CarazTrackingDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CarazTrackingData'] = ResolversParentTypes['CarazTrackingData']> = ResolversObject<{
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  pvrModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CarouselApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CarouselApiResponse'] = ResolversParentTypes['CarouselApiResponse']> = ResolversObject<{
  AtoZ?: Resolver<Maybe<Array<Maybe<ResolversTypes['Trending']>>>, ParentType, ContextType>;
  brands?: Resolver<Array<ResolversTypes['BrandItem']>, ParentType, ContextType>;
  carousel?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaItem']>>>, ParentType, ContextType>;
  carouselPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  carouselPresentationStyle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  collections?: Resolver<Maybe<Array<Maybe<ResolversTypes['Collections']>>>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  displayShowTitle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pagePEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  pvrModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  section?: Resolver<Maybe<Array<Maybe<ResolversTypes['Section']>>>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  surrogateKeys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  trending?: Resolver<Maybe<Array<Maybe<ResolversTypes['Trending']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CarouselItem'] = ResolversParentTypes['CarouselItem']> = ResolversObject<{
  __resolveType: TypeResolveFn<'BrandCarouselItem' | 'ChannelListingCarouselItem' | 'CharacterCarouselItem' | 'CreativeCarouselItem' | 'HubCarouselItem' | 'LiveCarouselItem' | 'LiveShowCarouselItem' | 'MovieCarouselItem' | 'ShowCarouselItem' | 'SpotlightCarouselItem', ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type CarouselItemTrackingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CarouselItemTracking'] = ResolversParentTypes['CarouselItemTracking']> = ResolversObject<{
  carouselContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isHighlightEnabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  posColNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  posRowNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showSeriesId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showSeriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CarouselResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CarouselResponse'] = ResolversParentTypes['CarouselResponse']> = ResolversObject<{
  result?: Resolver<Maybe<ResolversTypes['Result']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CastApiParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CastApiParams'] = ResolversParentTypes['CastApiParams']> = ResolversObject<{
  _clientRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profileId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CastConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['CastConfig'] = ResolversParentTypes['CastConfig']> = ResolversObject<{
  apiBaseUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apiParams?: Resolver<Maybe<ResolversTypes['CastApiParams']>, ParentType, ContextType>;
  apiUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselPresentationStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  promotionalSpot?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rankModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CastConfigurationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CastConfigurationResponse'] = ResolversParentTypes['CastConfigurationResponse']> = ResolversObject<{
  config?: Resolver<Maybe<Array<Maybe<ResolversTypes['CastConfig']>>>, ParentType, ContextType>;
  hash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CastItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CastItem'] = ResolversParentTypes['CastItem']> = ResolversObject<{
  bio_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  character_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  k?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  show_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelResolvers<ContextType = any, ParentType extends ResolversParentTypes['Channel'] = ResolversParentTypes['Channel']> = ResolversObject<{
  assetURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['Brand']>, ParentType, ContextType>;
  callSignId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  channelCategorySlugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentListing?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChannelListing']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayMetadata?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  displayStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dma?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  entitlementCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  filePathLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathSmallLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathSmallLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathDefaultBackground?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathFallbackImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLiveEndCardImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathPromoThumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLTSEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocalPlaybackChannel?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMultiCam?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOptinRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  local?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  originId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prgSvcId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  promoContentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  promoContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promoTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  resolvedfilePathLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedfilePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedfilepathDefaultBackground?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedfilepathFallbackImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortTheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stitched?: Resolver<Maybe<ResolversTypes['Stitched']>, ParentType, ContextType>;
  streamType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenExpirationTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalNumberOfCurrentListings?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalNumberOfUpcomingListings?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  upcomingListing?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChannelListing']>>>, ParentType, ContextType>;
  videoContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelCategoriesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelCategoriesResponse'] = ResolversParentTypes['ChannelCategoriesResponse']> = ResolversObject<{
  channelCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChannelCategory']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelCategory'] = ResolversParentTypes['ChannelCategory']> = ResolversObject<{
  cbsPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelData'] = ResolversParentTypes['ChannelData']> = ResolversObject<{
  channelDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelOriginId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelListingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelListing'] = ResolversParentTypes['ChannelListing']> = ResolversObject<{
  alternateStreamLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alternativeContentCANVideos?: Resolver<Maybe<Array<Maybe<ResolversTypes['ContentCANVideo']>>>, ParentType, ContextType>;
  alternativeVideoContentIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  associatedContentVideo?: Resolver<Maybe<ResolversTypes['ContentCANVideo']>, ParentType, ContextType>;
  channelSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  contentCANVideo?: Resolver<Maybe<ResolversTypes['ContentCANVideo']>, ParentType, ContextType>;
  contentImageUrls?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dma?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  durationMins?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  entityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fallbackEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fallbackStreamType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fallbackVideContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathThumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathFallbackImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathMovieThumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathVideoEndcardShowImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gameEndTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  gameId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gameStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLTSEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isListingLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVodAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  modalContentImageUrls?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  movieId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalAirDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  originalAirDateFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provideType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ptvId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedfilePathThumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  streamEndTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamEndTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  streamStartTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  streamType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsProgramId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsSeriesId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelListingCarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelListingCarouselItem'] = ResolversParentTypes['ChannelListingCarouselItem']> = ResolversObject<{
  addOns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bundleLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelOriginId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentCANVideo?: Resolver<Maybe<ResolversTypes['CanModel']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  durationMins?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlightImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isChannelLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOnNow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVodAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoCenter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numericLabel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  progressText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingBadge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  releaseYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  runtime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scheduleBadgeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamEndTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  streamStartTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelListingDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelListingData'] = ResolversParentTypes['ChannelListingData']> = ResolversObject<{
  channelData?: Resolver<ResolversTypes['ChannelData'], ParentType, ContextType>;
  listingData?: Resolver<ResolversTypes['ListingData'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelListingNormalizedResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelListingNormalized'] = ResolversParentTypes['ChannelListingNormalized']> = ResolversObject<{
  channelName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  channelOriginId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  channelSlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentImageUrls?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  episodeNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  genre?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isListingLive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isShow?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isVodAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  movieId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seasonNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showSeriesId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thumbLandscape?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vodContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watchlistContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelListingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelListingResponse'] = ResolversParentTypes['ChannelListingResponse']> = ResolversObject<{
  channel?: Resolver<Maybe<Array<Maybe<ResolversTypes['Channel']>>>, ParentType, ContextType>;
  listing?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChannelListing']>>>, ParentType, ContextType>;
  previousListings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChannelListing']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelResponse'] = ResolversParentTypes['ChannelResponse']> = ResolversObject<{
  __resolveType: TypeResolveFn<'ChannelResponseError' | 'ChannelResponseMany' | 'ChannelResponseOne', ParentType, ContextType>;
}>;

export type ChannelResponseErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelResponseError'] = ResolversParentTypes['ChannelResponseError']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelResponseManyResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelResponseMany'] = ResolversParentTypes['ChannelResponseMany']> = ResolversObject<{
  channels?: Resolver<Maybe<Array<Maybe<ResolversTypes['Channel']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChannelResponseOneResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelResponseOne'] = ResolversParentTypes['ChannelResponseOne']> = ResolversObject<{
  channel?: Resolver<Maybe<ResolversTypes['Channel']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CharacterApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CharacterApiResponse'] = ResolversParentTypes['CharacterApiResponse']> = ResolversObject<{
  changedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  characterCarouselId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  characterCarouselItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['CharacterItem']>>>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayShowTitle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  excludeProfileSlugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  parentCharacterCarouselId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeTextField?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CharacterCarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CharacterCarouselItem'] = ResolversParentTypes['CharacterCarouselItem']> = ResolversObject<{
  backgroundImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  characterImage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CharacterItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CharacterItem'] = ResolversParentTypes['CharacterItem']> = ResolversObject<{
  characterCarouselId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  characterCarouselItemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  characterId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  characterTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  filepathBackgroundRoundedImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathBackgroundStraightEdgedImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathBackgroundTallImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathCharacterImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hubSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pathValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CmpConsentTokenResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CmpConsentTokenResponse'] = ResolversParentTypes['CmpConsentTokenResponse']> = ResolversObject<{
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CodeActivateSuccessResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CodeActivateSuccessResponse'] = ResolversParentTypes['CodeActivateSuccessResponse']> = ResolversObject<{
  activationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activationScreen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['DeviceInfo']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Collection'] = ResolversParentTypes['Collection']> = ResolversObject<{
  heroToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hubCarousels?: Resolver<Maybe<Array<Maybe<ResolversTypes['CollectionCarousel']>>>, ParentType, ContextType>;
  hubId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hubSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveOnDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marqueeToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userState?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CollectionApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CollectionApiResponse'] = ResolversParentTypes['CollectionApiResponse']> = ResolversObject<{
  hub?: Resolver<Maybe<ResolversTypes['Hub']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CollectionCarouselResolvers<ContextType = any, ParentType extends ResolversParentTypes['CollectionCarousel'] = ResolversParentTypes['CollectionCarousel']> = ResolversObject<{
  carouselId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselPresentationStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayTitle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CollectionEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['CollectionEntity'] = ResolversParentTypes['CollectionEntity']> = ResolversObject<{
  __resolveType: TypeResolveFn<'MovieCollectionEntity' | 'ShowCollectionEntity', ParentType, ContextType>;
}>;

export type CollectionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Collections'] = ResolversParentTypes['Collections']> = ResolversObject<{
  collectionEntity?: Resolver<Maybe<ResolversTypes['CollectionEntity']>, ParentType, ContextType>;
  collectionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CommonContentFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommonContentFields'] = ResolversParentTypes['CommonContentFields']> = ResolversObject<{
  __resolveType: TypeResolveFn<'ChannelListingCarouselItem' | 'LiveCarouselItem' | 'LiveShowCarouselItem' | 'MovieCarouselItem' | 'ShowCarouselItem', ParentType, ContextType>;
  addOns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bundleLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  contentCANVideo?: Resolver<Maybe<ResolversTypes['CanModel']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlightImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoCenter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numericLabel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  progressText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  runtime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type CommonDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommonData'] = ResolversParentTypes['CommonData']> = ResolversObject<{
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  genre?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isContentLocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  itemType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['CarazRating'], ParentType, ContextType>;
  releaseYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tuneInText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoPreviewURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CommunityFeedbackResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunityFeedback'] = ResolversParentTypes['CommunityFeedback']> = ResolversObject<{
  feedbackId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feedbackType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CommunityFeedbackReadResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunityFeedbackReadResponse'] = ResolversParentTypes['CommunityFeedbackReadResponse']> = ResolversObject<{
  feedback?: Resolver<Array<ResolversTypes['CommunityFeedbackTarget']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CommunityFeedbackRemoveResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunityFeedbackRemoveResponse'] = ResolversParentTypes['CommunityFeedbackRemoveResponse']> = ResolversObject<{
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  removed?: Resolver<Maybe<ResolversTypes['CommunityFeedbackRemoved']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CommunityFeedbackRemovedResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunityFeedbackRemoved'] = ResolversParentTypes['CommunityFeedbackRemoved']> = ResolversObject<{
  feedbackType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CommunityFeedbackTargetResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunityFeedbackTarget'] = ResolversParentTypes['CommunityFeedbackTarget']> = ResolversObject<{
  feedback?: Resolver<Array<ResolversTypes['CommunityFeedback']>, ParentType, ContextType>;
  reaction?: Resolver<Maybe<ResolversTypes['CommunityFeedback']>, ParentType, ContextType>;
  targetId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CommunityFeedbackWriteResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunityFeedbackWriteResponse'] = ResolversParentTypes['CommunityFeedbackWriteResponse']> = ResolversObject<{
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['CommunityFeedback']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConcurrencyDeniedPlaybackReasonResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConcurrencyDeniedPlaybackReason'] = ResolversParentTypes['ConcurrencyDeniedPlaybackReason']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eligibleForUpsell?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  paymentSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConcurrencyResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConcurrencyResponse'] = ResolversParentTypes['ConcurrencyResponse']> = ResolversObject<{
  concurrentStreamCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deniedPlaybackReason?: Resolver<Maybe<ResolversTypes['ConcurrencyDeniedPlaybackReason']>, ParentType, ContextType>;
  overThreshold?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['Config'] = ResolversParentTypes['Config']> = ResolversObject<{
  apiBaseUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apiParams?: Resolver<Maybe<ResolversTypes['ApiParams']>, ParentType, ContextType>;
  apiUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselPresentationStyle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carouselType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayTitle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  includeVersion?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMarquee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMyList?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotionalSpot?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  promotionalTile?: Resolver<Maybe<ResolversTypes['HubCarouselItem']>, ParentType, ContextType>;
  pvrModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rankModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContentCanVideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentCANVideo'] = ResolversParentTypes['ContentCANVideo']> = ResolversObject<{
  _airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _editDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _firstIngestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _ingestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _lastModifiedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  addOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amazonESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appleWatchListShowKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableForProfileTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsShowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  childContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedCaptionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daiStreamKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daistreamKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadCountrySet?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadCountry']>>>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  editDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  embeddable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endCreditsChapterTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludeNielsenTracking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  exclusive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  firstIngestDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fullEpisode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ingestDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProductPlacement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProtected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVodAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itunesESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  liveStreamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDateEpoch?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playbackEvents?: Resolver<Maybe<ResolversTypes['PlaybackEvents']>, ParentType, ContextType>;
  playerLocUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  primaryCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryCategoryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalAudioExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApiRegionalRating']>>>, ParentType, ContextType>;
  regionalTextExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamingUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['Thumbnail']>>>, ParentType, ContextType>;
  thumbnailSheetSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['Thumbnail']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsProgramID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsprogramID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsseriesID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topLevelCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topLevelCatgeory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailerContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoProperties?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContentHighlightMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentHighlightMetadata'] = ResolversParentTypes['ContentHighlightMetadata']> = ResolversObject<{
  airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numSeasons?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  premiereDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  tvAgeRating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['Context'] = ResolversParentTypes['Context']> = ResolversObject<{
  displayText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CoordinatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Coordinates'] = ResolversParentTypes['Coordinates']> = ResolversObject<{
  latitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  longitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreativeAdDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreativeAdData'] = ResolversParentTypes['CreativeAdData']> = ResolversObject<{
  adFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advertiserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creativeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreativeCarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreativeCarouselItem'] = ResolversParentTypes['CreativeCarouselItem']> = ResolversObject<{
  adFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advertiserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clickPixels?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creativeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  impressionPixels?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  linkedId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreativeCommonDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreativeCommonData'] = ResolversParentTypes['CreativeCommonData']> = ResolversObject<{
  itemId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreativeCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreativeCta'] = ResolversParentTypes['CreativeCta']> = ResolversObject<{
  ctaActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaActionValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreativeImageAssetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreativeImageAssets'] = ResolversParentTypes['CreativeImageAssets']> = ResolversObject<{
  bannerAdImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreativeTrackingDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreativeTrackingData'] = ResolversParentTypes['CreativeTrackingData']> = ResolversObject<{
  clickPixels?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  impressionPixels?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DaiParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DAIParams'] = ResolversParentTypes['DAIParams']> = ResolversObject<{
  adTagParameters?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  daiExcl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeIsoScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTimeISO'], any> {
  name: 'DateTimeISO';
}

export type DebugInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DebugInfo'] = ResolversParentTypes['DebugInfo']> = ResolversObject<{
  ipAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isNFLEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DetailCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['DetailCta'] = ResolversParentTypes['DetailCta']> = ResolversObject<{
  actionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actionValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DetailHeroResolvers<ContextType = any, ParentType extends ResolversParentTypes['DetailHero'] = ResolversParentTypes['DetailHero']> = ResolversObject<{
  __resolveType: TypeResolveFn<'LiveDetailHero' | 'MovieDetailHero' | 'ShowDetailHero', ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  brandLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cast?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detailCta?: Resolver<Maybe<ResolversTypes['DetailCta']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroType?: Resolver<Maybe<ResolversTypes['HeroType']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  srcSetLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srcSetPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  standardImgForAllScreens?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type DeviceInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceInfo'] = ResolversParentTypes['DeviceInfo']> = ResolversObject<{
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cookieHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ecid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isCurrentDevice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMasterProfile?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastLogin?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  lastLoginMillis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profileId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  profilePic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePicPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePicSmall?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceProfileId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subregion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeviceListResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceListResponse'] = ResolversParentTypes['DeviceListResponse']> = ResolversObject<{
  loginDeviceInfoList?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeviceInfo']>>>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DmaItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DmaItem'] = ResolversParentTypes['DmaItem']> = ResolversObject<{
  baseChannelId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callSign?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callSignId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dma?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dmaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenDetails?: Resolver<Maybe<ResolversTypes['DmaTokenDetails']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DmaResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DmaResponse'] = ResolversParentTypes['DmaResponse']> = ResolversObject<{
  debugInfo?: Resolver<Maybe<ResolversTypes['DebugInfo']>, ParentType, ContextType>;
  dmas?: Resolver<Maybe<Array<Maybe<ResolversTypes['DmaItem']>>>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DmaTokenDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DmaTokenDetails'] = ResolversParentTypes['DmaTokenDetails']> = ResolversObject<{
  playback_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  syncBackAuth_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  syncBackToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenExpirationTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadCountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['DownloadCountry'] = ResolversParentTypes['DownloadCountry']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadCountrySetResolvers<ContextType = any, ParentType extends ResolversParentTypes['DownloadCountrySet'] = ResolversParentTypes['DownloadCountrySet']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DrmSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DrmSession'] = ResolversParentTypes['DrmSession']> = ResolversObject<{
  daiParams?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  ls_session?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rulesMatched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  streamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DynamicPlayResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DynamicPlayResponse'] = ResolversParentTypes['DynamicPlayResponse']> = ResolversObject<{
  dynamicVideoModel?: Resolver<Maybe<ResolversTypes['DynamicVideoModel']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  watchedAnEpisode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DynamicVideoModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['DynamicVideoModel'] = ResolversParentTypes['DynamicVideoModel']> = ResolversObject<{
  continuousPlaybackMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentListingsSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  listings?: Resolver<Maybe<Array<ResolversTypes['LiveChannelListing']>>, ParentType, ContextType>;
  medTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['VideoModel']>, ParentType, ContextType>;
  playbackModeCTA?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssets']>, ParentType, ContextType>;
  showId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoStartingPoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watchedAnEpisode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EmailCheckpointResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailCheckpointResponse'] = ResolversParentTypes['EmailCheckpointResponse']> = ResolversObject<{
  result?: Resolver<ResolversTypes['EmailCheckpointResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EntitlementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Entitlement'] = ResolversParentTypes['Entitlement']> = ResolversObject<{
  addOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  multiPackageTracking?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageInfo?: Resolver<Maybe<ResolversTypes['EntitlementPackageInfo']>, ParentType, ContextType>;
  productInfo?: Resolver<Maybe<ResolversTypes['EntitlementProductInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EntitlementPackageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntitlementPackageInfo'] = ResolversParentTypes['EntitlementPackageInfo']> = ResolversObject<{
  adFree?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  packageCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  packageSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorUserType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EntitlementProductInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntitlementProductInfo'] = ResolversParentTypes['EntitlementProductInfo']> = ResolversObject<{
  billingCadence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EpisodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Episode'] = ResolversParentTypes['Episode']> = ResolversObject<{
  _apiRaw?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isEpisodeless?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSeasonless?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EpisodeDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['EpisodeData'] = ResolversParentTypes['EpisodeData']> = ResolversObject<{
  episodeAirDate?: Resolver<ResolversTypes['DateTimeISO'], ParentType, ContextType>;
  episodeContentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  episodeDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  episodeNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  episodeTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seasonNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EpisodeResumeTimeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EpisodeResumeTime'] = ResolversParentTypes['EpisodeResumeTime']> = ResolversObject<{
  contentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resumeTime?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EpisodesApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EpisodesApiResponse'] = ResolversParentTypes['EpisodesApiResponse']> = ResolversObject<{
  results?: Resolver<Maybe<Array<ResolversTypes['Results']>>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FmsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['FMSResponse'] = ResolversParentTypes['FMSResponse']> = ResolversObject<{
  fmsResponse?: Resolver<Maybe<ResolversTypes['FmsInfo']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FaqResolvers<ContextType = any, ParentType extends ResolversParentTypes['Faq'] = ResolversParentTypes['Faq']> = ResolversObject<{
  ctaEvent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faqLinkTarget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faqLinkText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faqLinkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faqQuestion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faqQuestionHide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FavoriteChannelItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['FavoriteChannelItem'] = ResolversParentTypes['FavoriteChannelItem']> = ResolversObject<{
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentListing?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveChannelListing']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathFeaturedChannelImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathDefaultBackground?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  originId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FmsInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['FmsInfo'] = ResolversParentTypes['FmsInfo']> = ResolversObject<{
  fms_id_ttl?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fms_params?: Resolver<Maybe<ResolversTypes['FmsParams']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FmsParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FmsParams'] = ResolversParentTypes['FmsParams']> = ResolversObject<{
  _fw_3P_UID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _fw_vcid2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fms_bididtype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fms_connectid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fms_emailhash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fms_hh_ramp_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fms_ramp_envelope?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fms_ramp_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fms_ruleid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fms_subscriberid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fms_uid2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fms_userid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fms_vcid2type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imafw__fw_3P_UID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imafw__fw_vcid2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imafw_fms_bididtype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imafw_fms_emailhash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imafw_fms_hh_ramp_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imafw_fms_ramp_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imafw_fms_ruleid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imafw_fms_subscriberid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imafw_fms_userid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imafw_fms_vcid2type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FooterLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['FooterLink'] = ResolversParentTypes['FooterLink']> = ResolversObject<{
  href?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FooterLinksDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FooterLinksData'] = ResolversParentTypes['FooterLinksData']> = ResolversObject<{
  hubType?: Resolver<ResolversTypes['FooterHubType'], ParentType, ContextType>;
  links?: Resolver<Array<ResolversTypes['FooterLink']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FrontDoorBucketResolvers<ContextType = any, ParentType extends ResolversParentTypes['FrontDoorBucket'] = ResolversParentTypes['FrontDoorBucket']> = ResolversObject<{
  backgroundDesktop?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bucketName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ctaHide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logoDesktop?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logos?: Resolver<Array<ResolversTypes['FrontDoorLogo']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowHeaderPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FrontDoorBucketCarouselResolvers<ContextType = any, ParentType extends ResolversParentTypes['FrontDoorBucketCarousel'] = ResolversParentTypes['FrontDoorBucketCarousel']> = ResolversObject<{
  bucketName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carousel?: Resolver<Maybe<ResolversTypes['FrontDoorCarousel']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FrontDoorCarouselResolvers<ContextType = any, ParentType extends ResolversParentTypes['FrontDoorCarousel'] = ResolversParentTypes['FrontDoorCarousel']> = ResolversObject<{
  carouselId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carouselPresentationStyle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carouselType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayTitle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  includeVersion?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FrontDoorContentDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FrontDoorContentData'] = ResolversParentTypes['FrontDoorContentData']> = ResolversObject<{
  faqBucket?: Resolver<Maybe<ResolversTypes['FrontDoorFaqBucket']>, ParentType, ContextType>;
  genericBuckets?: Resolver<Array<ResolversTypes['FrontDoorBucket']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['FrontDoorHeader']>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['FrontDoorHero']>, ParentType, ContextType>;
  rowHeaderTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FrontDoorCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['FrontDoorCta'] = ResolversParentTypes['FrontDoorCta']> = ResolversObject<{
  className?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  colorScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaEvent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FrontDoorDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FrontDoorData'] = ResolversParentTypes['FrontDoorData']> = ResolversObject<{
  bucketCarousels?: Resolver<Array<ResolversTypes['FrontDoorBucketCarousel']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FrontDoorFaqBucketResolvers<ContextType = any, ParentType extends ResolversParentTypes['FrontDoorFaqBucket'] = ResolversParentTypes['FrontDoorFaqBucket']> = ResolversObject<{
  backgroundDesktop?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bucketName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ctas?: Resolver<Array<ResolversTypes['FrontDoorCta']>, ParentType, ContextType>;
  faqItems?: Resolver<Array<ResolversTypes['FrontDoorFaqItem']>, ParentType, ContextType>;
  heading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowHeaderPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FrontDoorFaqItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['FrontDoorFaqItem'] = ResolversParentTypes['FrontDoorFaqItem']> = ResolversObject<{
  faqLinkTarget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faqLinkText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faqLinkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faqQuestion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  faqQuestionHide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FrontDoorHeaderResolvers<ContextType = any, ParentType extends ResolversParentTypes['FrontDoorHeader'] = ResolversParentTypes['FrontDoorHeader']> = ResolversObject<{
  bannerHide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  bannerText1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bannerText2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signInText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signInUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FrontDoorHeroResolvers<ContextType = any, ParentType extends ResolversParentTypes['FrontDoorHero'] = ResolversParentTypes['FrontDoorHero']> = ResolversObject<{
  backgroundDesktop?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctas?: Resolver<Array<ResolversTypes['FrontDoorCta']>, ParentType, ContextType>;
  disclaimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoAlt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowHeaderPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FrontDoorLogoResolvers<ContextType = any, ParentType extends ResolversParentTypes['FrontDoorLogo'] = ResolversParentTypes['FrontDoorLogo']> = ResolversObject<{
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FullEpisodesDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FullEpisodesData'] = ResolversParentTypes['FullEpisodesData']> = ResolversObject<{
  availableSeasonNums?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  episodes?: Resolver<Maybe<Array<ResolversTypes['Episode']>>, ParentType, ContextType>;
  hasMore?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FullUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['FullUser'] = ResolversParentTypes['FullUser']> = ResolversObject<{
  accountProfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserProfile']>>>, ParentType, ContextType>;
  activeProfile?: Resolver<Maybe<ResolversTypes['UserProfile']>, ParentType, ContextType>;
  adsRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ageGroup?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  allRatings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bundleStatusTracking?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsPackageInfo?: Resolver<Maybe<Array<Maybe<ResolversTypes['PackageInfo']>>>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entitlement?: Resolver<Maybe<ResolversTypes['Entitlement']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLoggedIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  kidsProfileButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nflLTSOptIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nflLTSOptInTime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  optIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  packageStatusTracking?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paramountStreamingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentalControl?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  parentalControlLivetvPinEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  parentalControlPIN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentalControlRestrictions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ppid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requirePinSwitchProfileEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sha256EmailHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userRegistrationCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userStatus?: Resolver<Maybe<ResolversTypes['FullUserStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FullUserStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['FullUserStatus'] = ResolversParentTypes['FullUserStatus']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenreResolvers<ContextType = any, ParentType extends ResolversParentTypes['Genre'] = ResolversParentTypes['Genre']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GlobalMenuResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalMenu'] = ResolversParentTypes['GlobalMenu']> = ResolversObject<{
  footerNav?: Resolver<Array<ResolversTypes['NavItem']>, ParentType, ContextType>;
  movieBrowseNav?: Resolver<Maybe<Array<ResolversTypes['NavItem']>>, ParentType, ContextType>;
  showBrowseNav?: Resolver<Maybe<Array<ResolversTypes['NavItem']>>, ParentType, ContextType>;
  topNav?: Resolver<Array<ResolversTypes['NavItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GlobalMenuDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalMenuData'] = ResolversParentTypes['GlobalMenuData']> = ResolversObject<{
  footer?: Resolver<Maybe<Array<ResolversTypes['GlobalMenuFooterSection']>>, ParentType, ContextType>;
  hub_browse?: Resolver<Maybe<Array<ResolversTypes['GlobalMenuItem']>>, ParentType, ContextType>;
  movie_browse?: Resolver<Maybe<Array<ResolversTypes['GlobalMenuItem']>>, ParentType, ContextType>;
  pre_search?: Resolver<Maybe<Array<ResolversTypes['GlobalMenuItem']>>, ParentType, ContextType>;
  show_browse?: Resolver<Maybe<Array<ResolversTypes['GlobalMenuItem']>>, ParentType, ContextType>;
  top_nav?: Resolver<Maybe<Array<ResolversTypes['GlobalMenuItem']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GlobalMenuFooterSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalMenuFooterSection'] = ResolversParentTypes['GlobalMenuFooterSection']> = ResolversObject<{
  globalMenu?: Resolver<Maybe<Array<ResolversTypes['GlobalMenuItem']>>, ParentType, ContextType>;
  global_menu_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  link_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GlobalMenuItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalMenuItem'] = ResolversParentTypes['GlobalMenuItem']> = ResolversObject<{
  global_menu_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  link_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HeroResolvers<ContextType = any, ParentType extends ResolversParentTypes['Hero'] = ResolversParentTypes['Hero']> = ResolversObject<{
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  landscapeSrcSet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portraitSrcSet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  standardRegularImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HeroApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['HeroApiResponse'] = ResolversParentTypes['HeroApiResponse']> = ResolversObject<{
  hero?: Resolver<Array<ResolversTypes['Hero']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['History'] = ResolversParentTypes['History']> = ResolversObject<{
  canModel?: Resolver<ResolversTypes['CanModel'], ParentType, ContextType>;
  contentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasWatched?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  medTime?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unifiedGenre?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HistoryApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['HistoryApiResponse'] = ResolversParentTypes['HistoryApiResponse']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  history?: Resolver<Array<ResolversTypes['History']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  totalCountInHistory?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HomeConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeConfig'] = ResolversParentTypes['HomeConfig']> = ResolversObject<{
  config?: Resolver<Array<ResolversTypes['Config']>, ParentType, ContextType>;
  hash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HreflangConfigObjResolvers<ContextType = any, ParentType extends ResolversParentTypes['HreflangConfigObj'] = ResolversParentTypes['HreflangConfigObj']> = ResolversObject<{
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HubResolvers<ContextType = any, ParentType extends ResolversParentTypes['Hub'] = ResolversParentTypes['Hub']> = ResolversObject<{
  hubId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hubItems?: Resolver<Array<ResolversTypes['HubItem']>, ParentType, ContextType>;
  hubSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveOnDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userState?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HubCarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['HubCarouselItem'] = ResolversParentTypes['HubCarouselItem']> = ResolversObject<{
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HubItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['HubItem'] = ResolversParentTypes['HubItem']> = ResolversObject<{
  carouselPresentationStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  entityUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HubMarqueeResolvers<ContextType = any, ParentType extends ResolversParentTypes['HubMarquee'] = ResolversParentTypes['HubMarquee']> = ResolversObject<{
  amazonBuyLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  autorotate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  changedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  configType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deviceAppId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceAppSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itunesBuyLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  k?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profileSlugs?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  slideNids?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  slides?: Resolver<Array<ResolversTypes['HubMarqueeSlide']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeTextField?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vuduBuyLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HubMarqueeSlideResolvers<ContextType = any, ParentType extends ResolversParentTypes['HubMarqueeSlide'] = ResolversParentTypes['HubMarqueeSlide']> = ResolversObject<{
  allLocales?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  allSubregions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  altTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amazonBuyLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appsActionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appsSlideCopy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appsTarget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingVendorList?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  changedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  classicTrailerContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  entitlementCodes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  episodeTitle1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeTitle2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathHeroLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathHeroPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathPartnerBrandLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathPoster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathSlideCompact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathSlideRegular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathTitleLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathTitleLogoCompact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathTitleLogoRegular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isUpsell?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  itunesBuyLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  k?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movie?: Resolver<Maybe<ResolversTypes['MovieItem']>, ParentType, ContextType>;
  movieId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  platformType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondarySlideActionTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondarySlideActionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show?: Resolver<Maybe<ResolversTypes['ShowItem']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slideActionTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slideActionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slideActionUrlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slideContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slideTitle1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slideTitle2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slideWeight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subregion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tagline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTimeOverride?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTimeOverride2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeTextField?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  upsell?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userState?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vuduBuyLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdentityLoginResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityLoginResponse'] = ResolversParentTypes['IdentityLoginResponse']> = ResolversObject<{
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdentityRegisterFieldErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityRegisterFieldError'] = ResolversParentTypes['IdentityRegisterFieldError']> = ResolversObject<{
  field?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdentityRegisterResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityRegisterResponse'] = ResolversParentTypes['IdentityRegisterResponse']> = ResolversObject<{
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldErrors?: Resolver<Maybe<Array<ResolversTypes['IdentityRegisterFieldError']>>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ItemListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ItemList'] = ResolversParentTypes['ItemList']> = ResolversObject<{
  _airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _editDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _expirationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _firstIngestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _ingestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _lastModifiedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amazonESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appleWatchListShowKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableForProfileTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  availableVideoSeasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['AvailableVideoSeasons']>>>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsShowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  childContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedCaptionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadCountrySet?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadCountrySet']>>>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  editDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  embeddable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endCreditsChapterTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludeNielsenTracking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  exclusive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstIngestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullEpisode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ingestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProductPlacement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProtected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itunesESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDateEpoch?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieAssets?: Resolver<Maybe<ResolversTypes['MovieAssets']>, ParentType, ContextType>;
  movieTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playbackEvents?: Resolver<Maybe<ResolversTypes['PlaybackEvents']>, ParentType, ContextType>;
  playerLocUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  primaryCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryCategoryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalAudioExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<Maybe<ResolversTypes['RegionalRatings']>>>, ParentType, ContextType>;
  regionalTextExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showAbout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssets']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPremiereDateStr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['ThumbnailSet']>>>, ParentType, ContextType>;
  thumbnailSheetSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['ThumbnailSheetSet']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsprogramID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsseriesID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topLevelCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailerContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoProperties?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type KeepWatchingItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeepWatchingItem'] = ResolversParentTypes['KeepWatchingItem']> = ResolversObject<{
  contentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentEpisodeCANModel?: Resolver<Maybe<ResolversTypes['CanModel']>, ParentType, ContextType>;
  entitlementCodes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMovieAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  medTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  movieAssets?: Resolver<Maybe<ResolversTypes['MovieAssets']>, ParentType, ContextType>;
  movieId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  movieTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssets']>, ParentType, ContextType>;
  showId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  showPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListingDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListingData'] = ResolversParentTypes['ListingData']> = ResolversObject<{
  durationMins?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  gameEndTimestamp?: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  gameStartTimestamp?: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  isListingLive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isVodAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  linkedId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  streamEndTimestamp?: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  streamStartTimestamp?: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  streamType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListingNormalizedResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListingNormalizedResponse'] = ResolversParentTypes['ListingNormalizedResponse']> = ResolversObject<{
  listing?: Resolver<Maybe<ResolversTypes['ChannelListingNormalized']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListingsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListingsResponse'] = ResolversParentTypes['ListingsResponse']> = ResolversObject<{
  channel?: Resolver<Maybe<Array<Maybe<ResolversTypes['Channel']>>>, ParentType, ContextType>;
  listing?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChannelListing']>>>, ParentType, ContextType>;
  previousListings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChannelListing']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LiveCarouselApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveCarouselApiResponse'] = ResolversParentTypes['LiveCarouselApiResponse']> = ResolversObject<{
  channel?: Resolver<ResolversTypes['LiveChannel'], ParentType, ContextType>;
  displayShowTitle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  filePathLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LiveCarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveCarouselItem'] = ResolversParentTypes['LiveCarouselItem']> = ResolversObject<{
  addOns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bundleLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelOriginId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentCANVideo?: Resolver<Maybe<ResolversTypes['CanModel']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  durationMins?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gameEndTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  gameStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroCompact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlightImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isChannelLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEpisodeLess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOnNow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSeasonLess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVodAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoCenter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numericLabel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  progressText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingBadge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  releaseYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  runtime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scheduleBadgeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamEndTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  streamStartTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LiveChannelResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveChannel'] = ResolversParentTypes['LiveChannel']> = ResolversObject<{
  brand?: Resolver<Maybe<ResolversTypes['Brand']>, ParentType, ContextType>;
  cbsPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  channelCategorySlugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentListing?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveChannelListing']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayMetadata?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dma?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  entitlementCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  filePathFeaturedChannelImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathSmallLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathSmallLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathDefaultBackground?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathFallbackImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLiveEndCardImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathPromoThumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroCompact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLTSEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMultiCam?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOptinRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  local?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logoCenter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prgSvcId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  promoContentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  promoContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promoTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalNumberOfCurrentListings?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalNumberOfUpcomingListings?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  upcomingListing?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveChannelListing']>>>, ParentType, ContextType>;
  videoContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LiveChannelListingResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveChannelListing'] = ResolversParentTypes['LiveChannelListing']> = ResolversObject<{
  addOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  associatedContentVideo?: Resolver<Maybe<ResolversTypes['AssociatedContentVideo']>, ParentType, ContextType>;
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentCANVideo?: Resolver<Maybe<ResolversTypes['CanModel']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  durationMins?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  entityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathThumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathPageHeader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gameEndTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  gameStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isListingLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  seasonNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  streamEndTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamEndTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  streamStartTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LiveDetailHeroResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveDetailHero'] = ResolversParentTypes['LiveDetailHero']> = ResolversObject<{
  airDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  brandLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cast?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detailCta?: Resolver<Maybe<ResolversTypes['DetailCta']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroType?: Resolver<Maybe<ResolversTypes['HeroType']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  listingDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  srcSetLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srcSetPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  standardImgForAllScreens?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LiveEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEvent'] = ResolversParentTypes['LiveEvent']> = ResolversObject<{
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelOriginId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  durationMins?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fallbackEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fallbackStreamType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fallbackVideoContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathThumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathFallbackImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isListingLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocal?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  listingId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  seasonNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LiveItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveItem'] = ResolversParentTypes['LiveItem']> = ResolversObject<{
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  channelName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  channelSlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentCANVideo?: Resolver<Maybe<ResolversTypes['CanModel']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  durationMins?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endTimestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  episodeNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoSelected?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filePathThumb?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gameEndTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  gameStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEpisodeLess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isListingLive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSeasonLess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numericLabel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  poster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  progressText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  runtime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scheduleBadgeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  showPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  streamEndTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamEndTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  streamStartTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  streamTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LiveShowCarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveShowCarouselItem'] = ResolversParentTypes['LiveShowCarouselItem']> = ResolversObject<{
  addOns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bundleLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelOriginId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentCANVideo?: Resolver<Maybe<ResolversTypes['CanModel']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  durationMins?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gameEndTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  gameStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlightImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isChannelLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEpisodeLess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOnNow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSeasonLess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVodAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoCenter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numericLabel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  progressText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingBadge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  releaseYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  runtime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scheduleBadgeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamEndTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  streamStartTimeFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocalStationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalStation'] = ResolversParentTypes['LocalStation']> = ResolversObject<{
  callSignId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LogOutResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogOutResponse'] = ResolversParentTypes['LogOutResponse']> = ResolversObject<{
  errors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLoggedIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ManageDevicesPageAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManageDevicesPageAttribute'] = ResolversParentTypes['ManageDevicesPageAttribute']> = ResolversObject<{
  web_manage_devices_active_subheader1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  web_manage_devices_active_subheader2?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  web_manage_devices_handheld?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  web_manage_devices_header?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  web_manage_devices_ott?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  web_manage_devices_subheader1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  web_manage_devices_subheader2?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarqueeApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarqueeApiResponse'] = ResolversParentTypes['MarqueeApiResponse']> = ResolversObject<{
  hubMarquee?: Resolver<Maybe<ResolversTypes['HubMarquee']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarqueeContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarqueeContent'] = ResolversParentTypes['MarqueeContent']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['CarouselItem']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarqueeItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarqueeItem'] = ResolversParentTypes['MarqueeItem']> = ResolversObject<{
  amazonBuyLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  autorotate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  changedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  configType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deviceAppId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceAppSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  itunesBuyLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  k?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profileSlugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  slideNids?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  slides?: Resolver<Maybe<Array<ResolversTypes['HubMarqueeSlide']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeTextField?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vuduBuyLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarqueeMovieAssetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarqueeMovieAssets'] = ResolversParentTypes['MarqueeMovieAssets']> = ResolversObject<{
  filepathBrandLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathMovieHero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathMovieHeroCompact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathMovieHeroRegular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathMovieKeepWatching?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathMovieLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathMoviePoster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathTitleLogoCompact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathTitleLogoLeft?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathTitleLogoRegular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarqueeShowAssetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarqueeShowAssets'] = ResolversParentTypes['MarqueeShowAssets']> = ResolversObject<{
  filepathPartnerBrandLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathShowBrowsePoster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathShowHeroCompact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathShowHeroRegular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathShowPageHeader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathTitleLogoCenter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathTitleLogoLeft?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathTitleLogoRegular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathVideoEndcardShowImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarqueeSlideResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarqueeSlide'] = ResolversParentTypes['MarqueeSlide']> = ResolversObject<{
  allSubregions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  all_locales?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  alt_tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amazon_buy_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apps_action_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apps_slide_copy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apps_target?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingVendorList?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand_slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  changed_date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  classic_trailer_content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copy_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  entitlement_codes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  episode_title_1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episode_title_2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathPoster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_hero_landscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_hero_portrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_partner_brand_logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_slide_compact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_slide_regular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_compact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_regular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isUpsell?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  itunes_buy_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  k?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movie?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movie_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platform_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondary_slide_action_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondary_slide_action_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzle_content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slide_action_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slide_action_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slide_action_url_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slide_content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slide_title_1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slide_title_2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slide_weight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subregion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tagline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tune_in_time_override?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tune_in_time_override_2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type_text_field?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  user_state?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vudu_buy_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaBrowseResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaBrowseResponse'] = ResolversParentTypes['MediaBrowseResponse']> = ResolversObject<{
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  videos?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaBrowseVideo']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaBrowseVideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaBrowseVideo'] = ResolversParentTypes['MediaBrowseVideo']> = ResolversObject<{
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApiRegionalRating']>>>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaItem'] = ResolversParentTypes['MediaItem']> = ResolversObject<{
  __resolveType: TypeResolveFn<'KeepWatchingItem' | 'LiveItem' | 'MovieItem' | 'ShowItem', ParentType, ContextType>;
}>;

export type MerchandiseContentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchandiseContentResponse'] = ResolversParentTypes['MerchandiseContentResponse']> = ResolversObject<{
  carouselId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentSlidesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  defaultBackground?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadataRowDisplayed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  slideTransitionTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  slides?: Resolver<Array<ResolversTypes['MerchandiseSlide']>, ParentType, ContextType>;
  tuneInTimeDisplayed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchandiseSlideResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchandiseSlide'] = ResolversParentTypes['MerchandiseSlide']> = ResolversObject<{
  contentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contentLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['MerchandiseContentType']>, ParentType, ContextType>;
  desktopBackgroundSrcset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imgStandardSrc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['SlideMetadata']>, ParentType, ContextType>;
  mobileBackgroundSrcset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MetadataResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetadataResponse'] = ResolversParentTypes['MetadataResponse']> = ResolversObject<{
  seo?: Resolver<Maybe<ResolversTypes['SeoContent']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MosaicPageAttributeSourceRecordsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MosaicPageAttributeSourceRecords'] = ResolversParentTypes['MosaicPageAttributeSourceRecords']> = ResolversObject<{
  filterOtherTagged?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  packageCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  records?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  sortBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortByOrder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MosaicPageAttributesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MosaicPageAttributesResponse'] = ResolversParentTypes['MosaicPageAttributesResponse']> = ResolversObject<{
  sources?: Resolver<Array<ResolversTypes['MosaicPageAttributeSourceRecords']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MosaicPageDocumentsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MosaicPageDocumentsResponse'] = ResolversParentTypes['MosaicPageDocumentsResponse']> = ResolversObject<{
  islands?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  resolvedPromo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sources?: Resolver<Array<ResolversTypes['MosaicPageAttributeSourceRecords']>, ParentType, ContextType>;
  variantsForTracking?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieResolvers<ContextType = any, ParentType extends ResolversParentTypes['Movie'] = ResolversParentTypes['Movie']> = ResolversObject<{
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  contentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstAvailableDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMovieAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  movieAssets?: Resolver<Maybe<ResolversTypes['MovieAssets']>, ParentType, ContextType>;
  movieContent?: Resolver<Maybe<ResolversTypes['ContentCANVideo']>, ParentType, ContextType>;
  pvrModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating_metadata?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailerContent?: Resolver<Maybe<ResolversTypes['ContentCANVideo']>, ParentType, ContextType>;
  trailerContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieAssetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieAssets'] = ResolversParentTypes['MovieAssets']> = ResolversObject<{
  filepath_movie_hero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_movie_hero_compact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_movie_hero_regular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_movie_keep_watching?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_movie_logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_movie_poster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_movie_thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_center?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_center_colored?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_compact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_left?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_regular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieCarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieCarouselItem'] = ResolversParentTypes['MovieCarouselItem']> = ResolversObject<{
  addOns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bundleLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  cmsId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentCANVideo?: Resolver<Maybe<ResolversTypes['CanModel']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroCompact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlightImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEpisodeLess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isHighlightMetadataPartial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSeasonLess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoCenter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieContent?: Resolver<Maybe<ResolversTypes['MovieContent']>, ParentType, ContextType>;
  movieDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  movieId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numericLabel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  progressText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  runtime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailerContent?: Resolver<Maybe<ResolversTypes['TrailerContent']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieCollectionEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieCollectionEntity'] = ResolversParentTypes['MovieCollectionEntity']> = ResolversObject<{
  aliasContentIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['Brand']>, ParentType, ContextType>;
  brandSlugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  brand_slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  download_metadata?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  exclude_profile_slugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  firstAvailableDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  genre_slugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMovieAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieAssets?: Resolver<Maybe<ResolversTypes['MovieAssets']>, ParentType, ContextType>;
  movieAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  movieContent?: Resolver<Maybe<ResolversTypes['MovieContent']>, ParentType, ContextType>;
  rating_metadata?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailerContent?: Resolver<Maybe<ResolversTypes['TrailerContent']>, ParentType, ContextType>;
  trailerContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailer_content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieContent'] = ResolversParentTypes['MovieContent']> = ResolversObject<{
  _airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _editDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _expirationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _firstIngestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _ingestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _lastModifiedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amazonESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appleWatchListShowKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableForProfileTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsShowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  childContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedCaptionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  directors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  downloadCountrySet?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadCountrySet']>>>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  editDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  embeddable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endCreditsChapterTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludeNielsenTracking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  exclusive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  expired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstIngestDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fullEpisode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ingestDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProductPlacement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProtected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itunesESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mediaAvailableDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDateEpoch?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playbackEvents?: Resolver<Maybe<ResolversTypes['PlaybackEvents']>, ParentType, ContextType>;
  playerLocUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  primaryCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryCategoryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalAudioExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<ResolversTypes['RegionalRatings']>>, ParentType, ContextType>;
  regionalTextExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['ThumbnailSet']>>>, ParentType, ContextType>;
  thumbnailSheetSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['ThumbnailSheetSet']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsprogramID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsseriesID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topLevelCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoProperties?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieData'] = ResolversParentTypes['MovieData']> = ResolversObject<{
  actionValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commonContentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ctaText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isMovieAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  movieContentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  movieId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  movieOriginId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  moviePageURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trailerContentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trailerPageURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieDetail'] = ResolversParentTypes['MovieDetail']> = ResolversObject<{
  _apiRaw?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  directors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieAssets?: Resolver<Maybe<ResolversTypes['MovieAssets']>, ParentType, ContextType>;
  numSeasons?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  premiereDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  pubDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<ResolversTypes['RegionalRatings']>>, ParentType, ContextType>;
  resumeTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seasons?: Resolver<Maybe<Array<ResolversTypes['AvailableVideoSeasons']>>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showEpisodeGuideLink?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieDetailDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieDetailData'] = ResolversParentTypes['MovieDetailData']> = ResolversObject<{
  movie?: Resolver<Maybe<ResolversTypes['MovieDetailResponse']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieDetailHeroResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieDetailHero'] = ResolversParentTypes['MovieDetailHero']> = ResolversObject<{
  airDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  brandLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cast?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detailCta?: Resolver<Maybe<ResolversTypes['DetailCta']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroType?: Resolver<Maybe<ResolversTypes['HeroType']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  srcSetLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srcSetPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  standardImgForAllScreens?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieDetailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieDetailResponse'] = ResolversParentTypes['MovieDetailResponse']> = ResolversObject<{
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  directors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  firstAvailableDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMovieAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  movieContent?: Resolver<Maybe<ResolversTypes['MovieContent']>, ParentType, ContextType>;
  movieDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieHomeDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieHomeData'] = ResolversParentTypes['MovieHomeData']> = ResolversObject<{
  carouselConfigs?: Resolver<Maybe<Array<ResolversTypes['Config']>>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['DetailHero']>, ParentType, ContextType>;
  movie?: Resolver<Maybe<ResolversTypes['MovieDetail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieItem'] = ResolversParentTypes['MovieItem']> = ResolversObject<{
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  contentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstAvailableDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMovieAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  movieAssets?: Resolver<Maybe<ResolversTypes['MovieAssets']>, ParentType, ContextType>;
  movieContent?: Resolver<Maybe<ResolversTypes['MovieContent']>, ParentType, ContextType>;
  pvrModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trailerContent?: Resolver<Maybe<ResolversTypes['TrailerContent']>, ParentType, ContextType>;
  trailerContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieRecommendationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieRecommendation'] = ResolversParentTypes['MovieRecommendation']> = ResolversObject<{
  aliasContentIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  download_metadata?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  exclude_profile_slugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  firstAvailableDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  genre_slugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMovieAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieAssets?: Resolver<Maybe<ResolversTypes['MovieAssets']>, ParentType, ContextType>;
  movieAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  movieContent?: Resolver<Maybe<ResolversTypes['MovieContent']>, ParentType, ContextType>;
  originId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rating_metadata?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  recommendationSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailerContent?: Resolver<Maybe<ResolversTypes['TrailerContent']>, ParentType, ContextType>;
  trailerContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailer_content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieResponse'] = ResolversParentTypes['MovieResponse']> = ResolversObject<{
  movie?: Resolver<Maybe<ResolversTypes['Movie']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MovieTrendingContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MovieTrendingContent'] = ResolversParentTypes['MovieTrendingContent']> = ResolversObject<{
  aliasContentIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  download_metadata?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  exclude_profile_slugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  firstAvailableDate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  genre_slugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMovieAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieAssets?: Resolver<Maybe<ResolversTypes['MovieAssets']>, ParentType, ContextType>;
  movieAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  movieContent?: Resolver<Maybe<ResolversTypes['MovieContent']>, ParentType, ContextType>;
  rating_metadata?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailerContent?: Resolver<Maybe<ResolversTypes['TrailerContent']>, ParentType, ContextType>;
  trailerContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailer_content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MultiChannelCollectionCarouselResolvers<ContextType = any, ParentType extends ResolversParentTypes['MultiChannelCollectionCarousel'] = ResolversParentTypes['MultiChannelCollectionCarousel']> = ResolversObject<{
  filePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listings?: Resolver<Array<ResolversTypes['LiveChannelListing']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MultiChannelCollectionCarouselApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MultiChannelCollectionCarouselApiResponse'] = ResolversParentTypes['MultiChannelCollectionCarouselApiResponse']> = ResolversObject<{
  displayShowTitle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  filePathLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['UniversalChannelListingItem']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  batchAddMyListItems?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationBatchAddMyListItemsArgs, 'contentIds' | 'contentType'>>;
  batchRemoveMyListItems?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationBatchRemoveMyListItemsArgs, 'watchListIds'>>;
  bindMvpd?: Resolver<Maybe<ResolversTypes['BindMvpdResponse']>, ParentType, ContextType, RequireFields<MutationBindMvpdArgs, 'fields'>>;
  bindPartner?: Resolver<Maybe<ResolversTypes['BindPartnerResponse']>, ParentType, ContextType, RequireFields<MutationBindPartnerArgs, 'fields'>>;
  cancelSave?: Resolver<ResolversTypes['MutationResponse'], ParentType, ContextType>;
  changePassword?: Resolver<Maybe<ResolversTypes['changePasswordResponse']>, ParentType, ContextType, RequireFields<MutationChangePasswordArgs, 'password' | 'passwordConfirm' | 'token'>>;
  createPin?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationCreatePinArgs, 'parentalControlInput'>>;
  createProfile?: Resolver<Maybe<ResolversTypes['UserProfile']>, ParentType, ContextType, RequireFields<MutationCreateProfileArgs, 'profile'>>;
  deleteProfile?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationDeleteProfileArgs, 'id'>>;
  disableAccountPin?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType>;
  disableKidsShortcut?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType>;
  emailCheckpoint?: Resolver<Maybe<ResolversTypes['EmailCheckpointResponse']>, ParentType, ContextType, RequireFields<MutationEmailCheckpointArgs, 'email'>>;
  formRendezvousUpload?: Resolver<Maybe<ResolversTypes['CodeActivateSuccessResponse']>, ParentType, ContextType, RequireFields<MutationFormRendezvousUploadArgs, 'formFields'>>;
  formSignUpUpload?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationFormSignUpUploadArgs, 'formFields'>>;
  identityLogin?: Resolver<Maybe<ResolversTypes['IdentityLoginResponse']>, ParentType, ContextType, RequireFields<MutationIdentityLoginArgs, 'input'>>;
  identityRegister?: Resolver<Maybe<ResolversTypes['IdentityRegisterResponse']>, ParentType, ContextType, RequireFields<MutationIdentityRegisterArgs, 'formFields'>>;
  ingestCommunityFeedback?: Resolver<ResolversTypes['CommunityFeedbackWriteResponse'], ParentType, ContextType, RequireFields<MutationIngestCommunityFeedbackArgs, 'input'>>;
  logOut?: Resolver<Maybe<ResolversTypes['LogOutResponse']>, ParentType, ContextType, RequireFields<MutationLogOutArgs, 'token'>>;
  parentalRelogin?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationParentalReloginArgs, 'password'>>;
  platformRestart?: Resolver<Maybe<ResolversTypes['PlatformRestartResponse']>, ParentType, ContextType, RequireFields<MutationPlatformRestartArgs, 'input'>>;
  removeCommunityFeedback?: Resolver<ResolversTypes['CommunityFeedbackRemoveResponse'], ParentType, ContextType, RequireFields<MutationRemoveCommunityFeedbackArgs, 'input'>>;
  removeContinueWatching?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, Partial<MutationRemoveContinueWatchingArgs>>;
  resetForgotPassword?: Resolver<Maybe<ResolversTypes['resetForgotPasswordResponse']>, ParentType, ContextType, RequireFields<MutationResetForgotPasswordArgs, 'password' | 'passwordConfirm' | 'token'>>;
  saveAccountPin?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationSaveAccountPinArgs, 'pin' | 'rating'>>;
  sendForgotPasswordLink?: Resolver<Maybe<ResolversTypes['SendForgotPasswordLinkResponse']>, ParentType, ContextType, RequireFields<MutationSendForgotPasswordLinkArgs, 'email'>>;
  setShows?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationSetShowsArgs, 'ids'>>;
  setShowsList?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationSetShowsListArgs, 'ids'>>;
  signIn?: Resolver<Maybe<ResolversTypes['SignInResponse']>, ParentType, ContextType, RequireFields<MutationSignInArgs, 'formFields'>>;
  signOutAllDevices?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationSignOutAllDevicesArgs, 'token'>>;
  signOutAllDevicesSendEmail?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType>;
  signOutDevice?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationSignOutDeviceArgs, 'token'>>;
  signUp?: Resolver<Maybe<ResolversTypes['SignUpResponse']>, ParentType, ContextType, RequireFields<MutationSignUpArgs, 'formFields'>>;
  switchProfile?: Resolver<Maybe<ResolversTypes['SwitchResponse']>, ParentType, ContextType, RequireFields<MutationSwitchProfileArgs, 'id'>>;
  toggleMyListStatus?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, Partial<MutationToggleMyListStatusArgs>>;
  updateEmail?: Resolver<Maybe<ResolversTypes['UpdateEmailResponse']>, ParentType, ContextType, RequireFields<MutationUpdateEmailArgs, 'formFields'>>;
  updateOptIn?: Resolver<Maybe<ResolversTypes['updateOptInResponse']>, ParentType, ContextType, RequireFields<MutationUpdateOptInArgs, 'optIn'>>;
  updatePayment?: Resolver<Maybe<ResolversTypes['UpdatePaymentResponse']>, ParentType, ContextType, RequireFields<MutationUpdatePaymentArgs, 'token'>>;
  updateProfile?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationUpdateProfileArgs, 'id' | 'profile'>>;
  userRelogin?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, Partial<MutationUserReloginArgs>>;
  verifyEmail?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType>;
}>;

export type MutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MutationResponse'] = ResolversParentTypes['MutationResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MvpdDisputeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MvpdDispute'] = ResolversParentTypes['MvpdDispute']> = ResolversObject<{
  isDmaInDispute?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mvpdProvider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MvpdLogoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MvpdLogo'] = ResolversParentTypes['MvpdLogo']> = ResolversObject<{
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MyListApiParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyListApiParams'] = ResolversParentTypes['MyListApiParams']> = ResolversObject<{
  rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NavResolvers<ContextType = any, ParentType extends ResolversParentTypes['Nav'] = ResolversParentTypes['Nav']> = ResolversObject<{
  globalMenu?: Resolver<Maybe<ResolversTypes['GlobalMenu']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NavCtaAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NavCtaAttributes'] = ResolversParentTypes['NavCtaAttributes']> = ResolversObject<{
  ctaText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ctaUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NavCtaAttributesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['NavCtaAttributesResponse'] = ResolversParentTypes['NavCtaAttributesResponse']> = ResolversObject<{
  attributes?: Resolver<Maybe<ResolversTypes['NavCtaAttributes']>, ParentType, ContextType>;
  variantsForTracking?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NavItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['NavItem'] = ResolversParentTypes['NavItem']> = ResolversObject<{
  href?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SubNavItem']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NextItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['NextItem'] = ResolversParentTypes['NextItem']> = ResolversObject<{
  backgroundImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  channelSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['Context']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isListingLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  listingId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  logoImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  playbackModeCTA?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendationSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  releaseYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seasons?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NextItemResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['NextItemResponse'] = ResolversParentTypes['NextItemResponse']> = ResolversObject<{
  endCardCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endCardTimer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['NextItem']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NormalizedCouponResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalizedCouponResponse'] = ResolversParentTypes['NormalizedCouponResponse']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  appliesForMonths?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponString?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reducedPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OnNowCarouselResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnNowCarousel'] = ResolversParentTypes['OnNowCarousel']> = ResolversObject<{
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentListing?: Resolver<Array<ResolversTypes['LiveChannelListing']>, ParentType, ContextType>;
  filePathLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathDefaultBackground?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  originId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OnNowCarouselApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnNowCarouselApiResponse'] = ResolversParentTypes['OnNowCarouselApiResponse']> = ResolversObject<{
  carousel?: Resolver<Array<ResolversTypes['OnNowCarousel']>, ParentType, ContextType>;
  channel?: Resolver<ResolversTypes['LiveChannel'], ParentType, ContextType>;
  displayShowTitle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  filePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OverrideUserProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['OverrideUserProfile'] = ResolversParentTypes['OverrideUserProfile']> = ResolversObject<{
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMasterProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personalizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePic?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  profilePicMedium?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePicPath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePicSmall?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileType?: Resolver<ResolversTypes['ProfileType'], ParentType, ContextType>;
  referenceProfileId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  screenTimeLimitEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  screenTimeLimitSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PackageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PackageInfo'] = ResolversParentTypes['PackageInfo']> = ResolversObject<{
  billingCadence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageSourceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorUserType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageAttributesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageAttributesResponse'] = ResolversParentTypes['PageAttributesResponse']> = ResolversObject<{
  pageAttributes?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  variantsForTracking?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PagePlanAttrResolvers<ContextType = any, ParentType extends ResolversParentTypes['PagePlanAttr'] = ResolversParentTypes['PagePlanAttr']> = ResolversObject<{
  aaPageHeader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPageHeaderFreeTrial?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPageSubHeader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPageSubHeaderExsub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapAnnualPlanCheckboxFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapAnnualPlanCheckboxSingleTierFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapAnnualPlanCouponCheckboxText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapAnnualPlanMonthlyPriceFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapBundleOptionCta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapBundleOptionCtaShowtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapBundleOptionDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapBundleOptionDescriptionPlanSuppressedShowtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapBundleOptionHeading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapBundleOptionHeadingShowtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapButtonText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapButtonTextContinue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapButtonTextContinueFreeTrial?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem1Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem2Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem3Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem4Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem5?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem5Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem6?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem6Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem7?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem7Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem8?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem8Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem9?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem9Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem10?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCfFeatureListItem10Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapCouponPrefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapGiftSubHeadingFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem2Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem4Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem5?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem5Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem6?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem6Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem7?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem7Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem8?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem8Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem9?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem9Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem10?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapLcpFeatureListItem10Showtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapPlanHeadingCf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapPlanHeadingCfShowtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapPlanHeadingLcp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapPlanHeadingLcpShowtime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapPlanPriceFormatWithPercentCoupon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapPlanPriceFormatWithTrial?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapPlansOrderAscending?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapSubHeading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapSubHeadingExSub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapTrialCopy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaSaveWithAnAnnualPlan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaSignUpDisclaimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaStepsHeader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  campaignId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  continueWithFreeTrial?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genericId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hideShowtimeBundleCta?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  noFreeTrial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pageURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  papBillingCadenceModalImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planPillCopy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  winnersRevealDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ParentalControlPinResolvers<ContextType = any, ParentType extends ResolversParentTypes['ParentalControlPIN'] = ResolversParentTypes['ParentalControlPIN']> = ResolversObject<{
  hasParentalControlPIN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasParentalControlPINLiveTV?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  parentalControlAllowedRatings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentalControlPIN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentalControlRestrictions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requirePinToWatchContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ParentalControlRatingLabelResolvers<ContextType = any, ParentType extends ResolversParentTypes['ParentalControlRatingLabel'] = ResolversParentTypes['ParentalControlRatingLabel']> = ResolversObject<{
  group?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['ParentalControlRatingTranslation'], ParentType, ContextType>;
  ratings?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ParentalControlRatingTranslationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ParentalControlRatingTranslation'] = ResolversParentTypes['ParentalControlRatingTranslation']> = ResolversObject<{
  fallback?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  translationKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentGatewayResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentGatewayResponse'] = ResolversParentTypes['PaymentGatewayResponse']> = ResolversObject<{
  gateway?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  variantsForTracking?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlanCampaignAttrResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanCampaignAttr'] = ResolversParentTypes['PlanCampaignAttr']> = ResolversObject<{
  aaPapSubheadingNoTrial?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  campaignId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultToAnnual?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  destinationUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hideShowtimeBundleCta?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  noFreeTrial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  offer1CouponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offer1ProductCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offer2CouponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offer2ProductCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offer3CouponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offer3ProductCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offer4CouponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offer4ProductCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  useGenericCampaignExplainerSet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlanPageAttributesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanPageAttributesResponse'] = ResolversParentTypes['PlanPageAttributesResponse']> = ResolversObject<{
  campaign?: Resolver<Maybe<ResolversTypes['PlanCampaignAttr']>, ParentType, ContextType>;
  campaignPageAttributes?: Resolver<Maybe<ResolversTypes['CampaignPageAttributesResponse']>, ParentType, ContextType, Partial<PlanPageAttributesResponseCampaignPageAttributesArgs>>;
  plansBucket?: Resolver<Maybe<ResolversTypes['PagePlanAttr']>, ParentType, ContextType>;
  rawCampaigns?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  rawPagePlans?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  rawUpsellValueProps?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  valuePropItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValuePropItem']>>>, ParentType, ContextType>;
  variantsForTracking?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlansBucketResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlansBucket'] = ResolversParentTypes['PlansBucket']> = ResolversObject<{
  currentCadence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageAttributes?: Resolver<Maybe<ResolversTypes['PlansBucketPageAttributes']>, ParentType, ContextType>;
  productsByCadence?: Resolver<Maybe<ResolversTypes['productsByCadence']>, ParentType, ContextType>;
  rowHeaderPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  valuePropItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValuePropItem']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlansBucketPageAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlansBucketPageAttributes'] = ResolversParentTypes['PlansBucketPageAttributes']> = ResolversObject<{
  aaPapAnnualPlanMonthlyPriceFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapPlanPriceFormatWithTrial?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaPapTrialCopy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaSaveWithAnAnnualPlan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aaSignUpDisclaimer?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  backgroundDesktop?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaEvent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noFreeTrial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  planPillCopy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subHeading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlatformRestartResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformRestartResponse'] = ResolversParentTypes['PlatformRestartResponse']> = ResolversObject<{
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refreshInSec?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  session?: Resolver<Maybe<ResolversTypes['PlatformRestartSession']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlatformRestartSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformRestartSession'] = ResolversParentTypes['PlatformRestartSession']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jwt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlatformSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformSession'] = ResolversParentTypes['PlatformSession']> = ResolversObject<{
  clientIp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlaybackEventsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaybackEvents'] = ResolversParentTypes['PlaybackEvents']> = ResolversObject<{
  endCreditChapterTimeMs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  openCreditEndTimeMs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  openCreditStartTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  previewEndTimeMs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  previewStartTimeMs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PositionDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PositionDetails'] = ResolversParentTypes['PositionDetails']> = ResolversObject<{
  coords?: Resolver<ResolversTypes['Coordinates'], ParentType, ContextType>;
  isFallback?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PrefetchDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrefetchData'] = ResolversParentTypes['PrefetchData']> = ResolversObject<{
  useFullUser?: Resolver<Maybe<ResolversTypes['upsellUserStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PreselectedCreditCardGatewayResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreselectedCreditCardGatewayResponse'] = ResolversParentTypes['PreselectedCreditCardGatewayResponse']> = ResolversObject<{
  gatewayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PrevNextResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrevNextResponse'] = ResolversParentTypes['PrevNextResponse']> = ResolversObject<{
  nextVideo?: Resolver<Maybe<ResolversTypes['PrevNextVideoItem']>, ParentType, ContextType>;
  prevVideo?: Resolver<Maybe<ResolversTypes['PrevNextVideoItem']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PrevNextVideoItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrevNextVideoItem'] = ResolversParentTypes['PrevNextVideoItem']> = ResolversObject<{
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadCountrySet?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadCountry']>>>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProductPlacement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['Thumbnail']>>>, ParentType, ContextType>;
  thumbnailSheetSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['Thumbnail']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductResponse'] = ResolversParentTypes['ProductResponse']> = ResolversObject<{
  addOnCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  additionalText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addons?: Resolver<Maybe<Array<Maybe<ResolversTypes['addOnResponse']>>>, ParentType, ContextType>;
  afterTrialText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allowedMigration?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  billingCadence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingVendor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingVendorProductCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  couponCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isTestProduct?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  localizedPlanTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileOnly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  noTrial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  normalizedCoupon?: Resolver<Maybe<ResolversTypes['NormalizedCouponResponse']>, ParentType, ContextType>;
  packageCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planTier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planType?: Resolver<ResolversTypes['Cadence'], ParentType, ContextType>;
  plansOnUpsellCouponSet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pluralPlanType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  productCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productTags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  singularPlanType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  singularPlanTypeAbbr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  switchDirection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thirdPartyProductCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  titleForTracking?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  trialInterval?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trialUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  vendor_attributes?: Resolver<Maybe<ResolversTypes['vendorAttributes']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductsResponse'] = ResolversParentTypes['ProductsResponse']> = ResolversObject<{
  campaignAttributes?: Resolver<Maybe<ResolversTypes['CampaignData']>, ParentType, ContextType>;
  planPageAttributes?: Resolver<Maybe<ResolversTypes['PlanPageAttributesResponse']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductResponse']>>>, ParentType, ContextType>;
  upsellPageAttributes?: Resolver<Maybe<ResolversTypes['UpsellPageAttributeQueryResponse']>, ParentType, ContextType, Partial<ProductsResponseUpsellPageAttributesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProfileLevelResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileLevel'] = ResolversParentTypes['ProfileLevel']> = ResolversObject<{
  profileType?: Resolver<ResolversTypes['ProfileType'], ParentType, ContextType>;
  ratingRestrictions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PromotionInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionInfo'] = ResolversParentTypes['PromotionInfo']> = ResolversObject<{
  aboutCopy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actionGuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actionTarget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actionText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countdown?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath1x1DefaultImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath1x1FocusStateImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathAppCompactImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathAppRegularImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathBackgroundHeroImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathDesktopWebImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathFocusStatePoster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogoCompactImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathLogoRegularImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathMobileWebImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathOTTImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathPromoTileLandscapeImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathPromoTilePosterImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkGuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkTarget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedContentRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lockedCTA?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promoType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showCountdownTimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  ABTestVariants?: Resolver<Maybe<ResolversTypes['ABTestVariantsResponse']>, ParentType, ContextType, RequireFields<QueryAbTestVariantsArgs, 'userId'>>;
  ABTestsVariants?: Resolver<Maybe<ResolversTypes['ABTestsVariantsResponse']>, ParentType, ContextType, RequireFields<QueryAbTestsVariantsArgs, 'input'>>;
  accountPageAttributes?: Resolver<Maybe<ResolversTypes['AccountPageAttributeQueryResponse']>, ParentType, ContextType, RequireFields<QueryAccountPageAttributesArgs, 'tags' | 'userState'>>;
  allMoviesMock?: Resolver<Maybe<ResolversTypes['AllMoviesMockResponse']>, ParentType, ContextType, RequireFields<QueryAllMoviesMockArgs, 'params'>>;
  avatarByUUID?: Resolver<Maybe<ResolversTypes['Avatar']>, ParentType, ContextType, RequireFields<QueryAvatarByUuidArgs, 'uuid'>>;
  avatarGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['AvatarGroup']>>>, ParentType, ContextType, RequireFields<QueryAvatarGroupsArgs, 'profileType'>>;
  billingInfo?: Resolver<Maybe<ResolversTypes['BillingInfoResponse']>, ParentType, ContextType>;
  browseNav?: Resolver<Maybe<ResolversTypes['Nav']>, ParentType, ContextType, RequireFields<QueryBrowseNavArgs, 'extraParams'>>;
  campaignPageAttributes?: Resolver<Maybe<ResolversTypes['CampaignPageAttributesResponse']>, ParentType, ContextType, Partial<QueryCampaignPageAttributesArgs>>;
  cancelSavePageAttributes?: Resolver<Maybe<ResolversTypes['cancelSavePageAttributesResponse']>, ParentType, ContextType>;
  carousel?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryCarouselArgs, 'apiUrl'>>;
  carouselData?: Resolver<Maybe<ResolversTypes['CarouselResponse']>, ParentType, ContextType, RequireFields<QueryCarouselDataArgs, 'carouselParams' | 'token'>>;
  channelCategories?: Resolver<Maybe<ResolversTypes['ChannelCategoriesResponse']>, ParentType, ContextType, Partial<QueryChannelCategoriesArgs>>;
  channels?: Resolver<Maybe<ResolversTypes['ChannelResponse']>, ParentType, ContextType, Partial<QueryChannelsArgs>>;
  checkEmail?: Resolver<Maybe<ResolversTypes['checkEmailResponse']>, ParentType, ContextType, RequireFields<QueryCheckEmailArgs, 'formFields'>>;
  cmpConsentToken?: Resolver<Maybe<ResolversTypes['CmpConsentTokenResponse']>, ParentType, ContextType>;
  collection?: Resolver<Maybe<ResolversTypes['Collection']>, ParentType, ContextType, Partial<QueryCollectionArgs>>;
  communityFeedback?: Resolver<ResolversTypes['CommunityFeedbackReadResponse'], ParentType, ContextType, RequireFields<QueryCommunityFeedbackArgs, 'targetIds' | 'targetType'>>;
  compilingPageAttributes?: Resolver<Maybe<ResolversTypes['compilingPageAttributesResponse']>, ParentType, ContextType>;
  concurrency?: Resolver<Maybe<ResolversTypes['ConcurrencyResponse']>, ParentType, ContextType, Partial<QueryConcurrencyArgs>>;
  configurator?: Resolver<Maybe<ResolversTypes['CastConfigurationResponse']>, ParentType, ContextType>;
  contentHighlightMetadata?: Resolver<Maybe<ResolversTypes['ContentHighlightMetadata']>, ParentType, ContextType, RequireFields<QueryContentHighlightMetadataArgs, 'input'>>;
  ctaAttributes?: Resolver<Maybe<ResolversTypes['NavCtaAttributesResponse']>, ParentType, ContextType, Partial<QueryCtaAttributesArgs>>;
  currentListing?: Resolver<Maybe<ResolversTypes['ChannelListingResponse']>, ParentType, ContextType, RequireFields<QueryCurrentListingArgs, 'slug'>>;
  dmaInfo?: Resolver<Maybe<ResolversTypes['DmaResponse']>, ParentType, ContextType, RequireFields<QueryDmaInfoArgs, 'params'>>;
  editEmail?: Resolver<Maybe<ResolversTypes['editEmailResponse']>, ParentType, ContextType>;
  editPassword?: Resolver<Maybe<ResolversTypes['editPasswordResponse']>, ParentType, ContextType, RequireFields<QueryEditPasswordArgs, 'email'>>;
  episodeResumeTime?: Resolver<Maybe<ResolversTypes['EpisodeResumeTime']>, ParentType, ContextType, RequireFields<QueryEpisodeResumeTimeArgs, 'episodeId' | 'showId'>>;
  episodesConfig?: Resolver<Maybe<ResolversTypes['EpisodesApiResponse']>, ParentType, ContextType, Partial<QueryEpisodesConfigArgs>>;
  featureFlags?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  fms?: Resolver<Maybe<ResolversTypes['FMSResponse']>, ParentType, ContextType, Partial<QueryFmsArgs>>;
  fmsInfo?: Resolver<Maybe<ResolversTypes['FmsInfo']>, ParentType, ContextType>;
  footerLinks?: Resolver<Maybe<ResolversTypes['FooterLinksData']>, ParentType, ContextType, RequireFields<QueryFooterLinksArgs, 'hubType'>>;
  frontDoor?: Resolver<ResolversTypes['FrontDoorData'], ParentType, ContextType>;
  frontDoorContent?: Resolver<ResolversTypes['FrontDoorContentData'], ParentType, ContextType>;
  fullConfiguration?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryFullConfigurationArgs, 'region'>>;
  fullEpisodes?: Resolver<Maybe<ResolversTypes['FullEpisodesData']>, ParentType, ContextType, RequireFields<QueryFullEpisodesArgs, 'showId'>>;
  gameListing?: Resolver<Maybe<ResolversTypes['SingleListingResponse']>, ParentType, ContextType, RequireFields<QueryGameListingArgs, 'gameId'>>;
  genrePicker?: Resolver<Maybe<Array<Maybe<ResolversTypes['Genre']>>>, ParentType, ContextType, RequireFields<QueryGenrePickerArgs, 'profileId'>>;
  getPageAttributes?: Resolver<Maybe<ResolversTypes['PageAttributesResponse']>, ParentType, ContextType, RequireFields<QueryGetPageAttributesArgs, 'configKey'>>;
  getParentalControlPIN?: Resolver<Maybe<ResolversTypes['ParentalControlPIN']>, ParentType, ContextType>;
  heroData?: Resolver<Maybe<ResolversTypes['HeroApiResponse']>, ParentType, ContextType, RequireFields<QueryHeroDataArgs, 'token'>>;
  homeConfig?: Resolver<Maybe<ResolversTypes['HomeConfig']>, ParentType, ContextType, Partial<QueryHomeConfigArgs>>;
  isValidParentalControlPIN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<QueryIsValidParentalControlPinArgs>>;
  listing?: Resolver<Maybe<ResolversTypes['ListingNormalizedResponse']>, ParentType, ContextType, RequireFields<QueryListingArgs, 'listingId'>>;
  listings?: Resolver<Maybe<ResolversTypes['ListingsResponse']>, ParentType, ContextType, Partial<QueryListingsArgs>>;
  liveStreamInfo?: Resolver<Maybe<ResolversTypes['liveStreamInfoResponse']>, ParentType, ContextType, Partial<QueryLiveStreamInfoArgs>>;
  localPlaybackInfo?: Resolver<Maybe<ResolversTypes['DmaResponse']>, ParentType, ContextType, RequireFields<QueryLocalPlaybackInfoArgs, 'params'>>;
  locationResolver?: Resolver<Maybe<ResolversTypes['PositionDetails']>, ParentType, ContextType, Partial<QueryLocationResolverArgs>>;
  manageDevicesPageAttributes?: Resolver<Maybe<ResolversTypes['manageDevicesPageAttributesResponse']>, ParentType, ContextType>;
  marqueeData?: Resolver<Maybe<ResolversTypes['TransformedMarquee']>, ParentType, ContextType, RequireFields<QueryMarqueeDataArgs, 'token'>>;
  mediaBrowse?: Resolver<Maybe<ResolversTypes['MediaBrowseResponse']>, ParentType, ContextType, Partial<QueryMediaBrowseArgs>>;
  merchandiseContentPageAttributes?: Resolver<Maybe<ResolversTypes['MerchandiseContentResponse']>, ParentType, ContextType>;
  mosaicPageAttributeSource?: Resolver<Maybe<ResolversTypes['MosaicPageAttributeSourceRecords']>, ParentType, ContextType, RequireFields<QueryMosaicPageAttributeSourceArgs, 'tag' | 'url' | 'version'>>;
  mosaicPageAttributes?: Resolver<Maybe<ResolversTypes['MosaicPageAttributesResponse']>, ParentType, ContextType, RequireFields<QueryMosaicPageAttributesArgs, 'islandIds'>>;
  mosaicPageDocuments?: Resolver<Maybe<ResolversTypes['MosaicPageDocumentsResponse']>, ParentType, ContextType, RequireFields<QueryMosaicPageDocumentsArgs, 'pageId'>>;
  movie?: Resolver<Maybe<ResolversTypes['MovieResponse']>, ParentType, ContextType, Partial<QueryMovieArgs>>;
  movieDetail?: Resolver<Maybe<ResolversTypes['MovieHomeData']>, ParentType, ContextType, RequireFields<QueryMovieDetailArgs, 'id'>>;
  mvpdLogo?: Resolver<Maybe<ResolversTypes['MvpdLogo']>, ParentType, ContextType, RequireFields<QueryMvpdLogoArgs, 'adobeId'>>;
  myListConfig?: Resolver<Maybe<Array<Maybe<ResolversTypes['WatchListItem']>>>, ParentType, ContextType, Partial<QueryMyListConfigArgs>>;
  myListIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType, Partial<QueryMyListIdsArgs>>;
  nav?: Resolver<Maybe<ResolversTypes['Nav']>, ParentType, ContextType, RequireFields<QueryNavArgs, 'extraParams'>>;
  nextItem?: Resolver<Maybe<ResolversTypes['NextItemResponse']>, ParentType, ContextType, RequireFields<QueryNextItemArgs, 'contentId' | 'contentType' | 'showId'>>;
  nextVideo?: Resolver<Maybe<ResolversTypes['VideoNextResponse']>, ParentType, ContextType, Partial<QueryNextVideoArgs>>;
  pageAttributes?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryPageAttributesArgs, 'pageUrl' | 'version'>>;
  pageAttributesFoundation?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryPageAttributesFoundationArgs, 'pageUrl'>>;
  pageAttributesWithUserFoundation?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryPageAttributesWithUserFoundationArgs, 'pageUrl'>>;
  parentalControlRatings?: Resolver<Maybe<Array<ResolversTypes['ParentalControlRatingLabel']>>, ParentType, ContextType>;
  paymentGateway?: Resolver<Maybe<ResolversTypes['PaymentGatewayResponse']>, ParentType, ContextType, Partial<QueryPaymentGatewayArgs>>;
  planPageAttributes?: Resolver<Maybe<ResolversTypes['PlanPageAttributesResponse']>, ParentType, ContextType, Partial<QueryPlanPageAttributesArgs>>;
  preselectedCreditCardGateway?: Resolver<Maybe<ResolversTypes['PreselectedCreditCardGatewayResponse']>, ParentType, ContextType>;
  prevNextInfo?: Resolver<Maybe<ResolversTypes['PrevNextResponse']>, ParentType, ContextType, RequireFields<QueryPrevNextInfoArgs, 'cbsCom' | 'contentId'>>;
  product?: Resolver<Maybe<ResolversTypes['ProductResponse']>, ParentType, ContextType, RequireFields<QueryProductArgs, 'productCode'>>;
  products?: Resolver<Maybe<ResolversTypes['ProductsResponse']>, ParentType, ContextType, Partial<QueryProductsArgs>>;
  profileRatings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProfileLevel']>>>, ParentType, ContextType>;
  ptvStart?: Resolver<Maybe<ResolversTypes['StartResponse']>, ParentType, ContextType, Partial<QueryPtvStartArgs>>;
  redeemCoupon?: Resolver<Maybe<ResolversTypes['redeemCouponResponse']>, ParentType, ContextType, Partial<QueryRedeemCouponArgs>>;
  region?: Resolver<Maybe<ResolversTypes['Region']>, ParentType, ContextType>;
  regionalConfiguration?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryRegionalConfigurationArgs, 'region'>>;
  rendezvousCompletePageAttributes?: Resolver<Maybe<ResolversTypes['RendezvousCompletePageAttributeQueryResponse']>, ParentType, ContextType>;
  rendezvousPageAttributes?: Resolver<Maybe<ResolversTypes['RendezvousPageAttributeQueryResponse']>, ParentType, ContextType>;
  rendezvousSignInOptions?: Resolver<Maybe<ResolversTypes['RendezvousSignInOptionsQueryResponse']>, ParentType, ContextType>;
  searchConfig?: Resolver<ResolversTypes['SearchConfigResponse'], ParentType, ContextType, RequireFields<QuerySearchConfigArgs, 'input'>>;
  searchSuggestions?: Resolver<ResolversTypes['SuggestionsResponse'], ParentType, ContextType, RequireFields<QuerySearchSuggestionsArgs, 'input'>>;
  searchVODContent?: Resolver<ResolversTypes['SearchVODContentResult'], ParentType, ContextType, RequireFields<QuerySearchVodContentArgs, 'input'>>;
  searchVideoCarousel?: Resolver<ResolversTypes['SearchVideoCarouselResult'], ParentType, ContextType, RequireFields<QuerySearchVideoCarouselArgs, 'input'>>;
  seoHreflang?: Resolver<Maybe<ResolversTypes['TransformedSeoHreflangResponse']>, ParentType, ContextType, RequireFields<QuerySeoHreflangArgs, 'isGlobalPage' | 'pageType'>>;
  seoMetadata?: Resolver<Maybe<ResolversTypes['SeoResponse']>, ParentType, ContextType, RequireFields<QuerySeoMetadataArgs, 'path'>>;
  seriesHistory?: Resolver<Maybe<ResolversTypes['SeriesHistoryResponse']>, ParentType, ContextType, RequireFields<QuerySeriesHistoryArgs, 'slug'>>;
  sessionToken?: Resolver<Maybe<ResolversTypes['SessionTokenResponse']>, ParentType, ContextType, RequireFields<QuerySessionTokenArgs, 'params'>>;
  showHome?: Resolver<Maybe<ResolversTypes['ShowHomeData']>, ParentType, ContextType, RequireFields<QueryShowHomeArgs, 'slug'>>;
  showPicker?: Resolver<Maybe<Array<Maybe<ResolversTypes['Show']>>>, ParentType, ContextType, RequireFields<QueryShowPickerArgs, 'genreId' | 'packageCode' | 'profileId'>>;
  showSlugById?: Resolver<Maybe<ResolversTypes['ShowSlugById']>, ParentType, ContextType, RequireFields<QueryShowSlugByIdArgs, 'id'>>;
  signInPageAttributes?: Resolver<Maybe<ResolversTypes['SignInPageAttributeQueryResponse']>, ParentType, ContextType, Partial<QuerySignInPageAttributesArgs>>;
  signUpPageAttributes?: Resolver<Maybe<ResolversTypes['SignUpPageAttributeQueryResponse']>, ParentType, ContextType, Partial<QuerySignUpPageAttributesArgs>>;
  signedInDevices?: Resolver<Maybe<ResolversTypes['DeviceListResponse']>, ParentType, ContextType>;
  stitcherStreamingUrl?: Resolver<Maybe<ResolversTypes['StitcherStreamingUrlResponse']>, ParentType, ContextType, RequireFields<QueryStitcherStreamingUrlArgs, 'contentId' | 'contentType'>>;
  streamHistory?: Resolver<Maybe<ResolversTypes['StreamHistoryResponse']>, ParentType, ContextType, RequireFields<QueryStreamHistoryArgs, 'contentId'>>;
  streamingUrl?: Resolver<Maybe<ResolversTypes['StreamingUrlResponse']>, ParentType, ContextType, RequireFields<QueryStreamingUrlArgs, 'params'>>;
  translations?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, Partial<QueryTranslationsArgs>>;
  upNext?: Resolver<Maybe<ResolversTypes['UpNextResponse']>, ParentType, ContextType, RequireFields<QueryUpNextArgs, 'contentType' | 'endCardId'>>;
  upsellPage?: Resolver<Maybe<ResolversTypes['upsellPageResponse']>, ParentType, ContextType, Partial<QueryUpsellPageArgs>>;
  upsellPageAttributes?: Resolver<Maybe<ResolversTypes['UpsellPageAttributeQueryResponse']>, ParentType, ContextType, Partial<QueryUpsellPageAttributesArgs>>;
  userAccountSettings?: Resolver<Maybe<ResolversTypes['UserAccountSettings']>, ParentType, ContextType>;
  userFullProfile?: Resolver<Maybe<ResolversTypes['FullUser']>, ParentType, ContextType>;
  userInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  userProfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserProfile']>>>, ParentType, ContextType>;
  userRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userSession?: Resolver<Maybe<ResolversTypes['UserSessionResponse']>, ParentType, ContextType>;
  userSignIn?: Resolver<Maybe<ResolversTypes['UserSignInResponse']>, ParentType, ContextType, RequireFields<QueryUserSignInArgs, 'password' | 'username'>>;
  userStatus?: Resolver<Maybe<ResolversTypes['UserStatus']>, ParentType, ContextType>;
  userSubscription?: Resolver<Maybe<ResolversTypes['UserSubscriptionResponse']>, ParentType, ContextType>;
  video?: Resolver<Maybe<ResolversTypes['VideoResponse']>, ParentType, ContextType, Partial<QueryVideoArgs>>;
  videoInfo?: Resolver<Maybe<ResolversTypes['VideoResponse']>, ParentType, ContextType, RequireFields<QueryVideoInfoArgs, 'contentId'>>;
  videoItem?: Resolver<Maybe<ResolversTypes['VideoItemData']>, ParentType, ContextType, RequireFields<QueryVideoItemArgs, 'contentId'>>;
}>;

export type QueryPlanPageAttrArgsResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryPlanPageAttrArgs'] = ResolversParentTypes['QueryPlanPageAttrArgs']> = ResolversObject<{
  cbscidmt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flowType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RatingGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['RatingGroup'] = ResolversParentTypes['RatingGroup']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RecentChannelsApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecentChannelsApiResponse'] = ResolversParentTypes['RecentChannelsApiResponse']> = ResolversObject<{
  channels?: Resolver<Maybe<Array<Maybe<ResolversTypes['FavoriteChannelItem']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RecommendationApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecommendationApiResponse'] = ResolversParentTypes['RecommendationApiResponse']> = ResolversObject<{
  displayShowTitle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  response?: Resolver<Maybe<Array<Maybe<ResolversTypes['RecommendationItem']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RecommendationContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecommendationContent'] = ResolversParentTypes['RecommendationContent']> = ResolversObject<{
  castNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  continuousPlaybackMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  medTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['ItemList']>, ParentType, ContextType>;
  movie?: Resolver<Maybe<ResolversTypes['MovieRecommendation']>, ParentType, ContextType>;
  playbackModeCTA?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendationSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  showAbout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssets']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  videoStartingPoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RecommendationItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecommendationItem'] = ResolversParentTypes['RecommendationItem']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['RecommendationContent']>, ParentType, ContextType>;
  content_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RecommendationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Recommendations'] = ResolversParentTypes['Recommendations']> = ResolversObject<{
  backgroundImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  channelSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentCANDetails?: Resolver<Maybe<ResolversTypes['ContentCANVideo']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['CANContext']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTimeStamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isListingLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  listingId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  logoImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  playbackModeCTA?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendationSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  releaseYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seasons?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailerCANDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RegionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Region'] = ResolversParentTypes['Region']> = ResolversObject<{
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RegionalRatingResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegionalRating'] = ResolversParentTypes['RegionalRating']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RegionalRatingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegionalRatings'] = ResolversParentTypes['RegionalRatings']> = ResolversObject<{
  consumerAdvice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disclaimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryDescriptors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subratings?: Resolver<Maybe<Array<Maybe<ResolversTypes['Subratings']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RendezvousCompletePageAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RendezvousCompletePageAttribute'] = ResolversParentTypes['RendezvousCompletePageAttribute']> = ResolversObject<{
  aa_rendezvous_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aa_steps_header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completion_message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RendezvousCompletePageAttributeQueryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RendezvousCompletePageAttributeQueryResponse'] = ResolversParentTypes['RendezvousCompletePageAttributeQueryResponse']> = ResolversObject<{
  pageAttribute?: Resolver<Maybe<ResolversTypes['RendezvousCompletePageAttribute']>, ParentType, ContextType>;
  variantsForTracking?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RendezvousPageAttributeQueryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RendezvousPageAttributeQueryResponse'] = ResolversParentTypes['RendezvousPageAttributeQueryResponse']> = ResolversObject<{
  aa_rendezvous_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aa_step_header_device_agnostic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aa_steps_header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cta_form_submit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faq_text_with_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generic_error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mvpd_dma_dispute_link_comcast?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mvpd_dma_dispute_link_title_comcast?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mvpd_dma_dispute_subtitle_comcast?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mvpd_dma_dispute_title_comcast?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RendezvousSignInOptionsQueryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RendezvousSignInOptionsQueryResponse'] = ResolversParentTypes['RendezvousSignInOptionsQueryResponse']> = ResolversObject<{
  ctaPartner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaSignIn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaSignUp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPartnerCta?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  subHeading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['Result'] = ResolversParentTypes['Result']> = ResolversObject<{
  carouselId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  carouselPresentationStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentHighlight?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  data?: Resolver<Array<ResolversTypes['CarouselItem']>, ParentType, ContextType>;
  dataCi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasMore?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  includeProfileDropdown?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTitleDisplayed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  leftArrow?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pagePEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  pvr_model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rank_model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rightArrow?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Results'] = ResolversParentTypes['Results']> = ResolversObject<{
  sectionItems?: Resolver<Maybe<ResolversTypes['SectionItems']>, ParentType, ContextType>;
  sectionTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchConfigResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchConfigResponse'] = ResolversParentTypes['SearchConfigResponse']> = ResolversObject<{
  config?: Resolver<Array<ResolversTypes['SearchPageConfig']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchLiveResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchLiveResponse'] = ResolversParentTypes['SearchLiveResponse']> = ResolversObject<{
  liveEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEvent']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchPageConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchPageConfig'] = ResolversParentTypes['SearchPageConfig']> = ResolversObject<{
  apiBaseUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apiParams?: Resolver<Maybe<ResolversTypes['ApiParams']>, ParentType, ContextType>;
  apiUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carouselPresentationStyle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carouselType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  includeVersion?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMarquee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMyList?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotionalSpot?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  pvrModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rankModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchResponse'] = ResolversParentTypes['SearchResponse']> = ResolversObject<{
  terms?: Resolver<Array<ResolversTypes['SearchResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchResult'] = ResolversParentTypes['SearchResult']> = ResolversObject<{
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableVideoSeasons?: Resolver<Maybe<Array<ResolversTypes['AvailableVideoSeason']>>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  cms_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  entitlementCodes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  k?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieAssets?: Resolver<Maybe<ResolversTypes['MovieAssets']>, ParentType, ContextType>;
  movieContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movie_content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platform_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  rank_score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<ResolversTypes['RegionalRating']>>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssets']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showPremiereDateStr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  term_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tv_age_rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchVodContentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchVODContentResult'] = ResolversParentTypes['SearchVODContentResult']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['CarouselItem']>, ParentType, ContextType>;
  pvrModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rankModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchVideoCarouselResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchVideoCarouselResult'] = ResolversParentTypes['SearchVideoCarouselResult']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['LiveCarouselItem']>, ParentType, ContextType>;
  pvrModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rankModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Section'] = ResolversParentTypes['Section']> = ResolversObject<{
  background_hex_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  background_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_seasons?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  gradient_hex_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  layout_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasons_default?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasons_sort_order?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sectionItems?: Resolver<ResolversTypes['SectionItems'], ParentType, ContextType>;
  sectionTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  section_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewing_window?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SectionItemsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SectionItems'] = ResolversParentTypes['SectionItems']> = ResolversObject<{
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemList?: Resolver<Array<ResolversTypes['ItemList']>, ParentType, ContextType>;
  resultSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendForgotPasswordLinkResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendForgotPasswordLinkResponse'] = ResolversParentTypes['SendForgotPasswordLinkResponse']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SeoContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeoContent'] = ResolversParentTypes['SeoContent']> = ResolversObject<{
  all_locales?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  created_date?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  filepath_fb_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_tw_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  k?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_social_desc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_social_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  override_android_deeplink_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SeoHreflangResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeoHreflangResponse'] = ResolversParentTypes['SeoHreflangResponse']> = ResolversObject<{
  countries?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SeoResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeoResponse'] = ResolversParentTypes['SeoResponse']> = ResolversObject<{
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  facebookImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  socialDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  socialTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  twitterImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SeriesHistoryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeriesHistoryResponse'] = ResolversParentTypes['SeriesHistoryResponse']> = ResolversObject<{
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  video?: Resolver<Maybe<ResolversTypes['SeriesHistoryVideo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SeriesHistoryVideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeriesHistoryVideo'] = ResolversParentTypes['SeriesHistoryVideo']> = ResolversObject<{
  continuousPlaybackMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentListingsSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  medTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['ContentCANVideo']>, ParentType, ContextType>;
  playbackModeCTA?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Session'] = ResolversParentTypes['Session']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SessionTokenResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SessionTokenResponse'] = ResolversParentTypes['SessionTokenResponse']> = ResolversObject<{
  results?: Resolver<Maybe<ResolversTypes['SessionTokenResults']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SessionTokenResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SessionTokenResults'] = ResolversParentTypes['SessionTokenResults']> = ResolversObject<{
  daiParams?: Resolver<Maybe<ResolversTypes['DAIParams']>, ParentType, ContextType>;
  ls_session?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ruleIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  rulesMatched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  streamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowResolvers<ContextType = any, ParentType extends ResolversParentTypes['Show'] = ResolversParentTypes['Show']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowAssetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowAssets'] = ResolversParentTypes['ShowAssets']> = ResolversObject<{
  filepath_apple_airplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_apple_top_shelf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_mobile_endcard?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_ott_hd_show_image_overhang?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_partner_brand_logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_browse_poster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_browse_poster_thin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_description_poster_thin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_hero_compact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_hero_landscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_hero_portrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_hero_regular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_page_header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_center?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_compact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_left?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_regular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_video_endcard_show_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_video_start_screen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowAssetsDetailDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowAssetsDetailData'] = ResolversParentTypes['ShowAssetsDetailData']> = ResolversObject<{
  filepath_partner_brand_logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_browse_poster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_browse_poster_alt1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_browse_poster_alt2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_browse_poster_alt3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_browse_poster_alt4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_hero_compact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_hero_regular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_page_header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_center?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_left?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_title_logo_regular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_video_endcard_show_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_video_endcard_show_image_alt1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_video_endcard_show_image_alt2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_video_endcard_show_image_alt3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_video_endcard_show_image_alt4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowCarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowCarouselItem'] = ResolversParentTypes['ShowCarouselItem']> = ResolversObject<{
  addOns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bundleLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  contentCANVideo?: Resolver<Maybe<ResolversTypes['CanModel']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroCompact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highlightImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentHighlightEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEpisodeLess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isHighlightMetadataPartial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSeasonLess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoCenter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numSeasons?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numericLabel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poster?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiereDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  progressText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingBadge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  runtime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seasonNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowCollectionEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowCollectionEntity'] = ResolversParentTypes['ShowCollectionEntity']> = ResolversObject<{
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableVideoSeasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['AvailableVideoSeasons']>>>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssets']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPremiereDateStr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowData'] = ResolversParentTypes['ShowData']> = ResolversObject<{
  episodeData?: Resolver<Maybe<ResolversTypes['EpisodeData']>, ParentType, ContextType>;
  seasonsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowDataWrapperResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowDataWrapper'] = ResolversParentTypes['ShowDataWrapper']> = ResolversObject<{
  end?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numFound?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  results?: Resolver<Array<ResolversTypes['ShowObject']>, ParentType, ContextType>;
  start?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowDetail'] = ResolversParentTypes['ShowDetail']> = ResolversObject<{
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeResumeTimes?: Resolver<Maybe<Array<ResolversTypes['EpisodeResumeTime']>>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numSeasons?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  premiereDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<ResolversTypes['RegionalRatings']>>, ParentType, ContextType>;
  resumeTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seasons?: Resolver<Maybe<Array<ResolversTypes['AvailableVideoSeasons']>>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssetsDetailData']>, ParentType, ContextType>;
  showEpisodeGuideLink?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showEpisodeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showEpisodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowDetailHeroResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowDetailHero'] = ResolversParentTypes['ShowDetailHero']> = ResolversObject<{
  airDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  brandLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cast?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detailCta?: Resolver<Maybe<ResolversTypes['DetailCta']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroType?: Resolver<Maybe<ResolversTypes['HeroType']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numSeasons?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srcSetLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srcSetPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  standardImgForAllScreens?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowDetailsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowDetailsResponse'] = ResolversParentTypes['ShowDetailsResponse']> = ResolversObject<{
  available_video_seasons?: Resolver<Maybe<ResolversTypes['AvailableVideoSeasonsData']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['BrandItem']>, ParentType, ContextType>;
  show?: Resolver<Maybe<ResolversTypes['ShowDataWrapper']>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssetsDetailData']>, ParentType, ContextType>;
  showMenu?: Resolver<Maybe<Array<ResolversTypes['ShowMenuItem']>>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowHomeDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowHomeData'] = ResolversParentTypes['ShowHomeData']> = ResolversObject<{
  carouselConfigs?: Resolver<Maybe<Array<ResolversTypes['Config']>>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['DetailHero']>, ParentType, ContextType>;
  show?: Resolver<Maybe<ResolversTypes['ShowDetail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowHomeItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowHomeItem'] = ResolversParentTypes['ShowHomeItem']> = ResolversObject<{
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  about_long_text_s?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand_slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content_type_show_nid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  entitlementCodes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  filepath_about_show?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_global_nav_logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_connect_img?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_win8_showart_large?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstAvailableDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  genreSlugs?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  k?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  keywordList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  keywords?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<ResolversTypes['RegionalRatings']>>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  season?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showPremiereDateMs?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  showPremiereDateStr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  show_thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tune_in_time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tv_age_rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowHomeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowHomeResponse'] = ResolversParentTypes['ShowHomeResponse']> = ResolversObject<{
  available_video_seasons?: Resolver<Maybe<ResolversTypes['AvailableVideoSeasonsData']>, ParentType, ContextType>;
  cast?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  globalMenu?: Resolver<Maybe<ResolversTypes['GlobalMenuData']>, ParentType, ContextType>;
  marquees?: Resolver<Maybe<Array<ResolversTypes['MarqueeItem']>>, ParentType, ContextType>;
  showMenu?: Resolver<Maybe<Array<ResolversTypes['ShowMenuItem']>>, ParentType, ContextType>;
  shows?: Resolver<Maybe<Array<ResolversTypes['ShowHomeItem']>>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowItem'] = ResolversParentTypes['ShowItem']> = ResolversObject<{
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableVideoSeasons?: Resolver<Maybe<Array<ResolversTypes['AvailableVideoSeasons']>>, ParentType, ContextType>;
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstAvailableDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  pvrModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssets']>, ParentType, ContextType>;
  showId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  showPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPremiereDateStr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subVideoStartingPointCTA?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowMenuItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowMenuItem'] = ResolversParentTypes['ShowMenuItem']> = ResolversObject<{
  device_app_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  device_app_secret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  links?: Resolver<Maybe<Array<ResolversTypes['ShowMenuLink']>>, ParentType, ContextType>;
  live_date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  show_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowMenuLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowMenuLink'] = ResolversParentTypes['ShowMenuLink']> = ResolversObject<{
  channel_slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentListingsSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hasResultsFromVideoConfig?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  legacyAppletvMenuExpand?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  link?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  link_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  links?: Resolver<Maybe<Array<ResolversTypes['ShowMenuLink']>>, ParentType, ContextType>;
  page_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show_menu_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoConfigUniqueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowObjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowObject'] = ResolversParentTypes['ShowObject']> = ResolversObject<{
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  about_long_text_s?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  all_locales?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  availableForProfileTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['Brand']>, ParentType, ContextType>;
  carousel_filepath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  changed_date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  created_date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  device_restriction?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  enable_android_deeplink?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  episode_sorting?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exclude_profile_slugs?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  filepath_about_show?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_apps_showart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_global_nav_logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_mobile_showart_large?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_connect_img?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_show_thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath_win8_showart_large?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  first_available_date?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  genre_slugs?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  hub_page_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  imdb_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_hidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_show_rainmaker_unit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_video_property?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  k?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  keywords?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  non_sub_video_starting_point?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  non_sub_video_starting_point_cta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origin_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  path_value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premium_feature?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  profile_slugs?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  season?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  show_finale_date_str?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  show_logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show_premiere_date_str?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  show_thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sub_video_starting_point?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sub_video_starting_point_cta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tms_series_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tune_in_time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tv_age_rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowSlugByIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowSlugById'] = ResolversParentTypes['ShowSlugById']> = ResolversObject<{
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowTimeAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowTimeAttributes'] = ResolversParentTypes['ShowTimeAttributes']> = ResolversObject<{
  ctaEvent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoAlt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showTimeBundleLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowTrendingContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowTrendingContent'] = ResolversParentTypes['ShowTrendingContent']> = ResolversObject<{
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amlgSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableSeasonsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callbacks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entitlementCodes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiredAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssets']>, ParentType, ContextType>;
  showCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPremiereDateStr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SignInPageAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignInPageAttribute'] = ResolversParentTypes['SignInPageAttribute']> = ResolversObject<{
  aa_steps_header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mvpd_connect_cta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mvpd_copy_above_connect_cta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mvpd_dma_dispute_link_comcast?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mvpd_dma_dispute_link_title_comcast?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mvpd_dma_dispute_subtitle_comcast?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mvpd_dma_dispute_title_comcast?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SignInPageAttributeQueryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignInPageAttributeQueryResponse'] = ResolversParentTypes['SignInPageAttributeQueryResponse']> = ResolversObject<{
  pageAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['SignInPageAttribute']>>>, ParentType, ContextType>;
  variantsForTracking?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SignInResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignInResponse'] = ResolversParentTypes['SignInResponse']> = ResolversObject<{
  maxLoginAttempts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messages?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  mvpdDispute?: Resolver<Maybe<ResolversTypes['MvpdDispute']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SignUpPageAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignUpPageAttribute'] = ResolversParentTypes['SignUpPageAttribute']> = ResolversObject<{
  aa_sign_up_disclaimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aa_sign_up_optin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aa_steps_header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketing_optin_checked?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketing_optin_copy_1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketing_optin_copy_2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketing_optin_countries_1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketing_optin_countries_2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  terms_checkbox_enabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  terms_copy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  terms_copy_with_links?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SignUpPageAttributeQueryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignUpPageAttributeQueryResponse'] = ResolversParentTypes['SignUpPageAttributeQueryResponse']> = ResolversObject<{
  pageAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['SignUpPageAttribute']>>>, ParentType, ContextType>;
  variantsForTracking?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SignUpResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignUpResponse'] = ResolversParentTypes['SignUpResponse']> = ResolversObject<{
  errors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SingleListingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleListingResponse'] = ResolversParentTypes['SingleListingResponse']> = ResolversObject<{
  channel?: Resolver<Maybe<Array<Maybe<ResolversTypes['Channel']>>>, ParentType, ContextType>;
  listing?: Resolver<Maybe<ResolversTypes['ChannelListing']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SlideMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SlideMetadata'] = ResolversParentTypes['SlideMetadata']> = ResolversObject<{
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unifiedGenre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SpotlightCarouselItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpotlightCarouselItem'] = ResolversParentTypes['SpotlightCarouselItem']> = ResolversObject<{
  animatedBackground?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aspectRatio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelOriginId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaItem']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endHexColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itemPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  listingContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numSeasons?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  releaseYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seasonNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssets']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srcSetLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srcSetPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startHexColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subVideoStartingPointCTA?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SpotlightItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpotlightItem'] = ResolversParentTypes['SpotlightItem']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['MediaItem']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotionInfo?: Resolver<Maybe<ResolversTypes['PromotionInfo']>, ParentType, ContextType>;
  show?: Resolver<Maybe<ResolversTypes['MediaItem']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StartResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StartResponse'] = ResolversParentTypes['StartResponse']> = ResolversObject<{
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refreshInSec?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  session?: Resolver<Maybe<ResolversTypes['Session']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StitchedResolvers<ContextType = any, ParentType extends ResolversParentTypes['Stitched'] = ResolversParentTypes['Stitched']> = ResolversObject<{
  paths?: Resolver<Maybe<Array<Maybe<ResolversTypes['StitchedPath']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StitchedPathResolvers<ContextType = any, ParentType extends ResolversParentTypes['StitchedPath'] = ResolversParentTypes['StitchedPath']> = ResolversObject<{
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StitcherPathResolvers<ContextType = any, ParentType extends ResolversParentTypes['StitcherPath'] = ResolversParentTypes['StitcherPath']> = ResolversObject<{
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StitcherPathsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StitcherPaths'] = ResolversParentTypes['StitcherPaths']> = ResolversObject<{
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StitcherStreamingUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StitcherStreamingUrlResponse'] = ResolversParentTypes['StitcherStreamingUrlResponse']> = ResolversObject<{
  jwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stitcherPaths?: Resolver<Maybe<ResolversTypes['StitcherPaths']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StreamHistoryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StreamHistoryResponse'] = ResolversParentTypes['StreamHistoryResponse']> = ResolversObject<{
  allowedToPlayContentOnGivenDeviceBasedOnProduct?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  concurrentStreamCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deniedPlaybackReasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  hasWatched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  overThreshold?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  parentalControl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userPlanCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StreamingUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StreamingUrlResponse'] = ResolversParentTypes['StreamingUrlResponse']> = ResolversObject<{
  downloadKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invalidIp?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isInVPN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lsSession?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ruleIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  rulesMatched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stitcherPaths?: Resolver<Maybe<Array<ResolversTypes['StitcherPath']>>, ParentType, ContextType>;
  streamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubNavItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubNavItem'] = ResolversParentTypes['SubNavItem']> = ResolversObject<{
  href?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SubNavItem']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubratingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subratings'] = ResolversParentTypes['Subratings']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SuggestionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestionsResponse'] = ResolversParentTypes['SuggestionsResponse']> = ResolversObject<{
  suggestions?: Resolver<Array<ResolversTypes['AutocompleteSuggestion']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SwitchResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwitchResponse'] = ResolversParentTypes['SwitchResponse']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userActiveProfile?: Resolver<Maybe<ResolversTypes['UserProfile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ThumbnailResolvers<ContextType = any, ParentType extends ResolversParentTypes['Thumbnail'] = ResolversParentTypes['Thumbnail']> = ResolversObject<{
  assetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ThumbnailSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThumbnailSet'] = ResolversParentTypes['ThumbnailSet']> = ResolversObject<{
  assetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ThumbnailSheetSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThumbnailSheetSet'] = ResolversParentTypes['ThumbnailSheetSet']> = ResolversObject<{
  assetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrailerContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrailerContent'] = ResolversParentTypes['TrailerContent']> = ResolversObject<{
  _airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _editDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _firstIngestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _ingestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _lastModifiedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amazonESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appleWatchListShowKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableForProfileTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsShowId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  childContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedCaptionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  directors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  downloadCountrySet?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  editDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  embeddable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endCreditsChapterTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludeNielsenTracking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  exclusive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  firstIngestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullEpisode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ingestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProductPlacement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProtected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itunesESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDateEpoch?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playbackEvents?: Resolver<Maybe<ResolversTypes['PlaybackEvents']>, ParentType, ContextType>;
  playerLocUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  primaryCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryCategoryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalAudioExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<ResolversTypes['RegionalRatings']>>, ParentType, ContextType>;
  regionalTextExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['ThumbnailSet']>>>, ParentType, ContextType>;
  thumbnailSheetSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['ThumbnailSheetSet']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsprogramID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsseriesID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topLevelCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoProperties?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransformedMarqueeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransformedMarquee'] = ResolversParentTypes['TransformedMarquee']> = ResolversObject<{
  data?: Resolver<Maybe<Array<ResolversTypes['TransformedMarqueeSlide']>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransformedMarqueeSlideResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransformedMarqueeSlide'] = ResolversParentTypes['TransformedMarqueeSlide']> = ResolversObject<{
  backgroundImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathTitleLogoRegular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMovieAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logoImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  movieId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numSeasons?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  releaseYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seasonNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slideDisplayOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  srcSetLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srcSetPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  standardImgForAllScreens?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTimeOverride2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPreviewURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransformedSeoHreflangResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransformedSeoHreflangResponse'] = ResolversParentTypes['TransformedSeoHreflangResponse']> = ResolversObject<{
  countries?: Resolver<Maybe<Array<Maybe<ResolversTypes['HreflangConfigObj']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrendingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Trending'] = ResolversParentTypes['Trending']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['TrendingContent']>, ParentType, ContextType>;
  content_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrendingContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrendingContent'] = ResolversParentTypes['TrendingContent']> = ResolversObject<{
  __resolveType: TypeResolveFn<'MovieTrendingContent' | 'ShowTrendingContent', ParentType, ContextType>;
}>;

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID';
}

export type UniversalChannelListingItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalChannelListingItem'] = ResolversParentTypes['UniversalChannelListingItem']> = ResolversObject<{
  channelListingData?: Resolver<ResolversTypes['ChannelListingData'], ParentType, ContextType>;
  commonData?: Resolver<ResolversTypes['CommonData'], ParentType, ContextType>;
  cta?: Resolver<ResolversTypes['CarazCta'], ParentType, ContextType>;
  imageAssets?: Resolver<ResolversTypes['CarazImageAssets'], ParentType, ContextType>;
  movieData?: Resolver<Maybe<ResolversTypes['MovieData']>, ParentType, ContextType>;
  showData?: Resolver<Maybe<ResolversTypes['ShowData']>, ParentType, ContextType>;
  trackingData?: Resolver<Maybe<ResolversTypes['CarazTrackingData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UniversalContentApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalContentApiResponse'] = ResolversParentTypes['UniversalContentApiResponse']> = ResolversObject<{
  carouselPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  collectionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  collectionPEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversalItem']>>>, ParentType, ContextType>;
  pagePEM?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skipped?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UniversalCreativeApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalCreativeApiResponse'] = ResolversParentTypes['UniversalCreativeApiResponse']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversalCreativeItem']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UniversalCreativeItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalCreativeItem'] = ResolversParentTypes['UniversalCreativeItem']> = ResolversObject<{
  adData?: Resolver<Maybe<ResolversTypes['CreativeAdData']>, ParentType, ContextType>;
  commonData?: Resolver<Maybe<ResolversTypes['CreativeCommonData']>, ParentType, ContextType>;
  cta?: Resolver<Maybe<ResolversTypes['CreativeCta']>, ParentType, ContextType>;
  imageAssets?: Resolver<Maybe<ResolversTypes['CreativeImageAssets']>, ParentType, ContextType>;
  trackingData?: Resolver<Maybe<ResolversTypes['CreativeTrackingData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UniversalItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalItem'] = ResolversParentTypes['UniversalItem']> = ResolversObject<{
  __resolveType: TypeResolveFn<'UniversalChannelListingItem' | 'UniversalMovieItem' | 'UniversalPromotionItem' | 'UniversalShowItem', ParentType, ContextType>;
}>;

export type UniversalMovieItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalMovieItem'] = ResolversParentTypes['UniversalMovieItem']> = ResolversObject<{
  commonData?: Resolver<ResolversTypes['CommonData'], ParentType, ContextType>;
  cta?: Resolver<ResolversTypes['CarazCta'], ParentType, ContextType>;
  imageAssets?: Resolver<ResolversTypes['CarazImageAssets'], ParentType, ContextType>;
  movieData?: Resolver<ResolversTypes['MovieData'], ParentType, ContextType>;
  trackingData?: Resolver<Maybe<ResolversTypes['CarazTrackingData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UniversalPromotionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalPromotionItem'] = ResolversParentTypes['UniversalPromotionItem']> = ResolversObject<{
  channelListingData?: Resolver<Maybe<ResolversTypes['ChannelListingData']>, ParentType, ContextType>;
  commonData?: Resolver<ResolversTypes['CommonData'], ParentType, ContextType>;
  cta?: Resolver<ResolversTypes['CarazCta'], ParentType, ContextType>;
  imageAssets?: Resolver<ResolversTypes['CarazImageAssets'], ParentType, ContextType>;
  movieData?: Resolver<Maybe<ResolversTypes['MovieData']>, ParentType, ContextType>;
  promoData?: Resolver<Maybe<ResolversTypes['CarazPromoData']>, ParentType, ContextType>;
  showData?: Resolver<Maybe<ResolversTypes['ShowData']>, ParentType, ContextType>;
  trackingData?: Resolver<Maybe<ResolversTypes['CarazTrackingData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UniversalShowItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversalShowItem'] = ResolversParentTypes['UniversalShowItem']> = ResolversObject<{
  commonData?: Resolver<ResolversTypes['CommonData'], ParentType, ContextType>;
  cta?: Resolver<ResolversTypes['CarazCta'], ParentType, ContextType>;
  imageAssets?: Resolver<ResolversTypes['CarazImageAssets'], ParentType, ContextType>;
  showData?: Resolver<ResolversTypes['ShowData'], ParentType, ContextType>;
  trackingData?: Resolver<Maybe<ResolversTypes['CarazTrackingData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpNextRecommendationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpNextRecommendation'] = ResolversParentTypes['UpNextRecommendation']> = ResolversObject<{
  backgroundImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  btnLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  button?: Resolver<Maybe<ResolversTypes['UpNextRecommendationButton']>, ParentType, ContextType>;
  castNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  channelSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentCANDetails?: Resolver<Maybe<ResolversTypes['ContentCANVideo']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isListingLive?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logoImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mediaWatchNextType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playbackModeCTA?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendationSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  releaseYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seasons?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tracking?: Resolver<Maybe<ResolversTypes['UpNextTracking']>, ParentType, ContextType>;
  trailerCANDetails?: Resolver<Maybe<ResolversTypes['ContentCANVideo']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpNextRecommendationButtonResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpNextRecommendationButton'] = ResolversParentTypes['UpNextRecommendationButton']> = ResolversObject<{
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lockIconUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpNextResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpNextResponse'] = ResolversParentTypes['UpNextResponse']> = ResolversObject<{
  endCardCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endCardTimer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['UpNextRecommendation']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpNextTrackActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpNextTrackAction'] = ResolversParentTypes['UpNextTrackAction']> = ResolversObject<{
  trackEndCardSelect?: Resolver<Maybe<ResolversTypes['UpNextTrackEndCardSelect']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpNextTrackEndCardSelectResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpNextTrackEndCardSelect'] = ResolversParentTypes['UpNextTrackEndCardSelect']> = ResolversObject<{
  PPlusSubscriberBadge?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpNextTrackingResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpNextTracking'] = ResolversParentTypes['UpNextTracking']> = ResolversObject<{
  trackAction?: Resolver<Maybe<ResolversTypes['UpNextTrackAction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateEmailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateEmailResponse'] = ResolversParentTypes['UpdateEmailResponse']> = ResolversObject<{
  errors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdatePaymentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePaymentResponse'] = ResolversParentTypes['UpdatePaymentResponse']> = ResolversObject<{
  actionTokenId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsellBucketResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsellBucket'] = ResolversParentTypes['UpsellBucket']> = ResolversObject<{
  backgroundDesktop?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bucketName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carousel?: Resolver<Maybe<Array<Maybe<ResolversTypes['UpsellCarousel']>>>, ParentType, ContextType>;
  className?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaEvent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaHide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctas?: Resolver<Maybe<Array<Maybe<ResolversTypes['UpsellCta']>>>, ParentType, ContextType>;
  disclaimer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faq?: Resolver<Maybe<Array<Maybe<ResolversTypes['Faq']>>>, ParentType, ContextType>;
  heading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hideCarousel?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoAlt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoDesktop?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logos?: Resolver<Maybe<Array<Maybe<ResolversTypes['UpsellLogo']>>>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rowHeaderPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  showTimeAttributes?: Resolver<Maybe<ResolversTypes['ShowTimeAttributes']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trialPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsellCarouselResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsellCarousel'] = ResolversParentTypes['UpsellCarousel']> = ResolversObject<{
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carousel_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carousel_image_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsellCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsellCta'] = ResolversParentTypes['UpsellCta']> = ResolversObject<{
  className?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  colorScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaEvent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prescribedName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsellHeaderResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsellHeader'] = ResolversParentTypes['UpsellHeader']> = ResolversObject<{
  bannerHide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  bannerText1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bannerText2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ctaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signInText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signInUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsellLogoResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsellLogo'] = ResolversParentTypes['UpsellLogo']> = ResolversObject<{
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsellPageAttributeQueryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsellPageAttributeQueryResponse'] = ResolversParentTypes['UpsellPageAttributeQueryResponse']> = ResolversObject<{
  faqBucket?: Resolver<Maybe<ResolversTypes['UpsellBucket']>, ParentType, ContextType>;
  genericBuckets?: Resolver<Maybe<Array<Maybe<ResolversTypes['UpsellBucket']>>>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['UpsellHeader']>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['UpsellBucket']>, ParentType, ContextType>;
  plansBucket?: Resolver<Maybe<ResolversTypes['PlansBucket']>, ParentType, ContextType>;
  prefetchData?: Resolver<Maybe<ResolversTypes['PrefetchData']>, ParentType, ContextType>;
  resolvedPromo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowHeaderTotal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  variantsForTracking?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserAccountSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAccountSettings'] = ResolversParentTypes['UserAccountSettings']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['UserAccountSettingsAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserAccountSettingsAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAccountSettingsAddress'] = ResolversParentTypes['UserAccountSettingsAddress']> = ResolversObject<{
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserInfo'] = ResolversParentTypes['UserInfo']> = ResolversObject<{
  accountProfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['OverrideUserProfile']>>>, ParentType, ContextType>;
  activeProfile?: Resolver<Maybe<ResolversTypes['OverrideUserProfile']>, ParentType, ContextType>;
  activeProfileTracking?: Resolver<Maybe<ResolversTypes['ProfileType']>, ParentType, ContextType>;
  ageGroup?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  allRatings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bundleStatusTracking?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsPackageInfo?: Resolver<Maybe<Array<Maybe<ResolversTypes['cbsPackageInfo']>>>, ParentType, ContextType>;
  clientCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dma?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entitlement?: Resolver<Maybe<ResolversTypes['Entitlement']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLoggedIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMVPDGhostAccount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  issuesList?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  kidsProfileButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maskedEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nflFullBufferEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nflLTSOptIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nflLTSOptInTime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nflOptIn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  optIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  packageStatus?: Resolver<Maybe<ResolversTypes['UserPackageStatus']>, ParentType, ContextType>;
  packageStatusTracking?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentalControl?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  parentalControlLivetvPinEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  parentalControlPIN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentalControlRestrictions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ppid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['RatingGroup']>>>, ParentType, ContextType>;
  requirePinSwitchProfileEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sha256EmailHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  touDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  touVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userEvents?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userRegistrationCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userStatus?: Resolver<Maybe<ResolversTypes['UserStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserPackageStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPackageStatus'] = ResolversParentTypes['UserPackageStatus']> = ResolversObject<{
  exsubscriberPackage?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  subscriberPackage?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  subscriberTrialPackage?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  suspendedPackage?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  tveSubscriberPackage?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  vendorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorUserType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserProfile'] = ResolversParentTypes['UserProfile']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMasterProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personalizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePic?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  profilePicMedium?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePicPath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePicSmall?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileType?: Resolver<ResolversTypes['ProfileType'], ParentType, ContextType>;
  referenceProfileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  screenTimeLimitEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  screenTimeLimitSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  watchingRestrictions?: Resolver<Maybe<ResolversTypes['WatchingRestrictions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSession'] = ResolversParentTypes['UserSession']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserSessionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSessionResponse'] = ResolversParentTypes['UserSessionResponse']> = ResolversObject<{
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refreshInSec?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  session?: Resolver<Maybe<ResolversTypes['UserSession']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserSignInResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSignInResponse'] = ResolversParentTypes['UserSignInResponse']> = ResolversObject<{
  cbsComCookie?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserStatus'] = ResolversParentTypes['UserStatus']> = ResolversObject<{
  ID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  accountProfiles?: Resolver<Array<ResolversTypes['UserProfile']>, ParentType, ContextType>;
  activeProfile?: Resolver<ResolversTypes['UserProfile'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasParentalControlPIN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLoggedIn?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kidsProfileButton?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parentalControl?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  parentalControlPIN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requirePinSwitchProfileEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscription'] = ResolversParentTypes['UserSubscription']> = ResolversObject<{
  activatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  canceledAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentPeriodEndsAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pendingSubscription?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  planCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitAmountInCents?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserSubscriptionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionResponse'] = ResolversParentTypes['UserSubscriptionResponse']> = ResolversObject<{
  activeCoupons?: Resolver<Maybe<Array<ResolversTypes['ActiveCoupon']>>, ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['UserSubscription']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ValuePropItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValuePropItem'] = ResolversParentTypes['ValuePropItem']> = ResolversObject<{
  copy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  essentialCopy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEssential?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPremium?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  premiumCopy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subCopy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['Video'] = ResolversParentTypes['Video']> = ResolversObject<{
  _airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _editDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _firstIngestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _ingestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _lastModifiedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amazonESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appleWatchListShowKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableForProfileTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsShowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  channel?: Resolver<Maybe<ResolversTypes['VideoChannel']>, ParentType, ContextType>;
  childContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedCaptionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closed_captions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentLocked?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daiParams?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  daistreamKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dmaPlaybackUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadCountrySet?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadCountry']>>>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration_raw?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  editDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  embeddable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endCreditsChapterTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludeNielsenTracking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  exclusive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fallback_streaming_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstIngestDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fullEpisode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ingestDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPaidContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProductPlacement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProtected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_hls_aes_encrypted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itunesESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  license_session?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  license_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveStreamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mediaAvailableDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDateEpoch?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mediaContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mpd_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playbackEvents?: Resolver<Maybe<ResolversTypes['PlaybackEvents']>, ParentType, ContextType>;
  playerLocUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  primaryCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryCategoryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalAudioExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<ResolversTypes['RegionalRating']>, ParentType, ContextType>;
  regionalTextExcludeLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ruleIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  rulesMatched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamingUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['Thumbnail']>>>, ParentType, ContextType>;
  thumbnailSheetSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['Thumbnail']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsprogramID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsseriesID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topLevelCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoProperties?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  vtag_show?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoChannelResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoChannel'] = ResolversParentTypes['VideoChannel']> = ResolversObject<{
  channelCategorySlugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  channelTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  currentIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dma?: Resolver<Maybe<ResolversTypes['VideoChannelDma']>, ParentType, ContextType>;
  fallbackEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fallbackStreamType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fallbackVideoContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gameStartTimestamp?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isLTSEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMultiCam?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOptInRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  listingDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  listingId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  listings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChannelListing']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoChannelDmaResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoChannelDma'] = ResolversParentTypes['VideoChannelDma']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playbackUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoConfigResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoConfigResponse'] = ResolversParentTypes['VideoConfigResponse']> = ResolversObject<{
  results?: Resolver<Maybe<Array<ResolversTypes['Section']>>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  videoSectionMetadata?: Resolver<Maybe<Array<ResolversTypes['VideoSectionMetadata']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoItem'] = ResolversParentTypes['VideoItem']> = ResolversObject<{
  contentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamingUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoItemDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoItemData'] = ResolversParentTypes['VideoItemData']> = ResolversObject<{
  _apiRaw?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cast?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endCreditChapterTimeMs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  episodeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isEpisodeless?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSeasonless?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  regionalRating?: Resolver<Maybe<ResolversTypes['RegionalRatings']>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['ThumbnailSet']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoModel'] = ResolversParentTypes['VideoModel']> = ResolversObject<{
  _airDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _airDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _editDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _expirationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _firstIngestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _ingestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _lastModifiedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  _pubDateISO?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addOns?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  airDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amazonESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appleWatchListShowKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableForProfileTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsShowId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  closedCaptionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadCountrySet?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  editDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  endCreditsChapterTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  episodeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludeNielsenTracking?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  exclusive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  expired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstIngestDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fullEpisode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ingestDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isContentAccessibleInCAN?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProductPlacement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isProtected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itunesESTURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mediaAvailableDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaAvailableDateEpoch?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mediaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  playbackEvents?: Resolver<Maybe<ResolversTypes['PlaybackEvents']>, ParentType, ContextType>;
  playerLocUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premiumFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  primaryCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryCategoryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionalAudioExcludeLanguages?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  regionalRatings?: Resolver<Maybe<Array<ResolversTypes['RegionalRatings']>>, ParentType, ContextType>;
  regionalTextExcludeLanguages?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  seasonNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailSet?: Resolver<Maybe<Array<ResolversTypes['ThumbnailSet']>>, ParentType, ContextType>;
  thumbnailSheetSet?: Resolver<Maybe<Array<ResolversTypes['ThumbnailSet']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsprogramID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tmsseriesID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topLevelCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoProperties?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoNextResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoNextResponse'] = ResolversParentTypes['VideoNextResponse']> = ResolversObject<{
  endCardCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endCardTimer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Recommendations']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipped?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoResponse'] = ResolversParentTypes['VideoResponse']> = ResolversObject<{
  fms?: Resolver<Maybe<ResolversTypes['FmsInfo']>, ParentType, ContextType>;
  platformSession?: Resolver<Maybe<ResolversTypes['PlatformSession']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  results?: Resolver<Maybe<ResolversTypes['VideoResults']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['VideoUserInfo']>, ParentType, ContextType>;
  video?: Resolver<Maybe<ResolversTypes['Video']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoResults'] = ResolversParentTypes['VideoResults']> = ResolversObject<{
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemList?: Resolver<Maybe<Array<Maybe<ResolversTypes['ContentCANVideo']>>>, ParentType, ContextType>;
  resultSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoSectionMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoSectionMetadata'] = ResolversParentTypes['VideoSectionMetadata']> = ResolversObject<{
  displayShowTitle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  display_seasons?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  seasons_sort_order?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sectionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  section_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VideoUserInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoUserInfo'] = ResolversParentTypes['VideoUserInfo']> = ResolversObject<{
  billingCadence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bundle_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dma?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAuthenticated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  localStation?: Resolver<Maybe<ResolversTypes['LocalStation']>, ParentType, ContextType>;
  multi_package_tracking?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nflFullBufferEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nflLTSOptIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nflLTSOptInTime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  packageCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageSourceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  package_source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  package_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paramountStreamingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personalizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ppid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile_master?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference_profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sb_md?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  sl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sub_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorUserType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WatchListChannelsApiResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchListChannelsApiResponse'] = ResolversParentTypes['WatchListChannelsApiResponse']> = ResolversObject<{
  carousel?: Resolver<Maybe<Array<Maybe<ResolversTypes['FavoriteChannelItem']>>>, ParentType, ContextType>;
  rows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WatchListItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchListItem'] = ResolversParentTypes['WatchListItem']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['WatchListItemContent']>, ParentType, ContextType>;
  content_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watchListId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WatchListItemContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchListItemContent'] = ResolversParentTypes['WatchListItemContent']> = ResolversObject<{
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amlgSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callbacks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entitlementCodes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filePathLogoSelected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepathDefaultBackground?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAfterHours?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isContentAccessibleInCMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKidsContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMovieAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  movieAssets?: Resolver<Maybe<ResolversTypes['MovieAssets']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recold?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showAssets?: Resolver<Maybe<ResolversTypes['ShowAssets']>, ParentType, ContextType>;
  showCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizzleContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailerContentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trailer_content_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tuneInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WatchingRestrictionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WatchingRestrictions'] = ResolversParentTypes['WatchingRestrictions']> = ResolversObject<{
  firstDisallowedRating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requirePinToWatchContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  requirePinToWatchLiveTv?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddOnResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['addOnResponse'] = ResolversParentTypes['addOnResponse']> = ResolversObject<{
  addonPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cbsProductId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  cbsUserActivationLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsUserCallToAction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsUserMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsUserMessageSummary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbssolrType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  internalAddonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  k?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorAddonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorUserActivationLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorUserCallToAction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorUserMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CancelSavePageAttributesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['cancelSavePageAttributesResponse'] = ResolversParentTypes['cancelSavePageAttributesResponse']> = ResolversObject<{
  pageAttribute?: Resolver<Maybe<ResolversTypes['CancelSavePageAttribute']>, ParentType, ContextType>;
  variantsForTracking?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CbsPackageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['cbsPackageInfo'] = ResolversParentTypes['cbsPackageInfo']> = ResolversObject<{
  addOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  billingCadence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingVendorProductCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cbsPackageId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAdFree?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFullAdLoad?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  packageCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageHoldingState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageSourceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  planType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productTags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  searchKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tier?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vendorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorSkuFamily?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorSuppliedId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorUserType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChangePasswordResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['changePasswordResponse'] = ResolversParentTypes['changePasswordResponse']> = ResolversObject<{
  isReLoginSuccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CheckEmailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkEmailResponse'] = ResolversParentTypes['checkEmailResponse']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompilingPageAttributesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['compilingPageAttributesResponse'] = ResolversParentTypes['compilingPageAttributesResponse']> = ResolversObject<{
  imageLandscape?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imagePortrait?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoLandscape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPortrait?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EditEmailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['editEmailResponse'] = ResolversParentTypes['editEmailResponse']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EditPasswordResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['editPasswordResponse'] = ResolversParentTypes['editPasswordResponse']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LiveStreamInfoResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['liveStreamInfoResponse'] = ResolversParentTypes['liveStreamInfoResponse']> = ResolversObject<{
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ManageDevicesPageAttributesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['manageDevicesPageAttributesResponse'] = ResolversParentTypes['manageDevicesPageAttributesResponse']> = ResolversObject<{
  pageAttribute?: Resolver<Maybe<ResolversTypes['ManageDevicesPageAttribute']>, ParentType, ContextType>;
  variantsForTracking?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductsByCadenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['productsByCadence'] = ResolversParentTypes['productsByCadence']> = ResolversObject<{
  annual?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductResponse']>>>, ParentType, ContextType>;
  monthly?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductResponse']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RedeemCouponResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['redeemCouponResponse'] = ResolversParentTypes['redeemCouponResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ResetForgotPasswordResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['resetForgotPasswordResponse'] = ResolversParentTypes['resetForgotPasswordResponse']> = ResolversObject<{
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TesterResolvers<ContextType = any, ParentType extends ResolversParentTypes['tester'] = ResolversParentTypes['tester']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateOptInResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['updateOptInResponse'] = ResolversParentTypes['updateOptInResponse']> = ResolversObject<{
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsellPageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['upsellPageResponse'] = ResolversParentTypes['upsellPageResponse']> = ResolversObject<{
  planPageAttributes?: Resolver<Maybe<ResolversTypes['PlanPageAttributesResponse']>, ParentType, ContextType, Partial<UpsellPageResponsePlanPageAttributesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsellUserStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['upsellUserStatus'] = ResolversParentTypes['upsellUserStatus']> = ResolversObject<{
  isAnonymous?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isExSubscriber?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLoggedIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRegistered?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSubscriber?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VendorAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['vendorAttributes'] = ResolversParentTypes['vendorAttributes']> = ResolversObject<{
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isTrial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  trialInterval?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trialUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  ABTest?: AbTestResolvers<ContextType>;
  ABTestVariantsResponse?: AbTestVariantsResponseResolvers<ContextType>;
  ABTestsVariantEntry?: AbTestsVariantEntryResolvers<ContextType>;
  ABTestsVariantsResponse?: AbTestsVariantsResponseResolvers<ContextType>;
  AccountPageAttribute?: AccountPageAttributeResolvers<ContextType>;
  AccountPageAttributeQueryResponse?: AccountPageAttributeQueryResponseResolvers<ContextType>;
  AccountZipStateInfo?: AccountZipStateInfoResolvers<ContextType>;
  ActiveCoupon?: ActiveCouponResolvers<ContextType>;
  ActiveCouponCurrency?: ActiveCouponCurrencyResolvers<ContextType>;
  ActiveCouponDiscount?: ActiveCouponDiscountResolvers<ContextType>;
  AllMoviesMockResponse?: AllMoviesMockResponseResolvers<ContextType>;
  ApiParams?: ApiParamsResolvers<ContextType>;
  ApiRegionalRating?: ApiRegionalRatingResolvers<ContextType>;
  ApiVideoItem?: ApiVideoItemResolvers<ContextType>;
  AssociatedContentVideo?: AssociatedContentVideoResolvers<ContextType>;
  AutocompleteSuggestion?: AutocompleteSuggestionResolvers<ContextType>;
  AvailableVideoSeason?: AvailableVideoSeasonResolvers<ContextType>;
  AvailableVideoSeasons?: AvailableVideoSeasonsResolvers<ContextType>;
  AvailableVideoSeasonsData?: AvailableVideoSeasonsDataResolvers<ContextType>;
  Avatar?: AvatarResolvers<ContextType>;
  AvatarGroup?: AvatarGroupResolvers<ContextType>;
  BillingInfoResponse?: BillingInfoResponseResolvers<ContextType>;
  BindMvpdResponse?: BindMvpdResponseResolvers<ContextType>;
  BindPartnerResponse?: BindPartnerResponseResolvers<ContextType>;
  Brand?: BrandResolvers<ContextType>;
  BrandCarouselItem?: BrandCarouselItemResolvers<ContextType>;
  BrandItem?: BrandItemResolvers<ContextType>;
  Button?: ButtonResolvers<ContextType>;
  CANContext?: CanContextResolvers<ContextType>;
  CampaignData?: CampaignDataResolvers<ContextType>;
  CampaignPageAttributesResponse?: CampaignPageAttributesResponseResolvers<ContextType>;
  CanModel?: CanModelResolvers<ContextType>;
  CancelSaveCarouselItem?: CancelSaveCarouselItemResolvers<ContextType>;
  CancelSavePageAttribute?: CancelSavePageAttributeResolvers<ContextType>;
  CarazCta?: CarazCtaResolvers<ContextType>;
  CarazImageAssets?: CarazImageAssetsResolvers<ContextType>;
  CarazPromoData?: CarazPromoDataResolvers<ContextType>;
  CarazRating?: CarazRatingResolvers<ContextType>;
  CarazTrackingData?: CarazTrackingDataResolvers<ContextType>;
  CarouselApiResponse?: CarouselApiResponseResolvers<ContextType>;
  CarouselItem?: CarouselItemResolvers<ContextType>;
  CarouselItemTracking?: CarouselItemTrackingResolvers<ContextType>;
  CarouselResponse?: CarouselResponseResolvers<ContextType>;
  CastApiParams?: CastApiParamsResolvers<ContextType>;
  CastConfig?: CastConfigResolvers<ContextType>;
  CastConfigurationResponse?: CastConfigurationResponseResolvers<ContextType>;
  CastItem?: CastItemResolvers<ContextType>;
  Channel?: ChannelResolvers<ContextType>;
  ChannelCategoriesResponse?: ChannelCategoriesResponseResolvers<ContextType>;
  ChannelCategory?: ChannelCategoryResolvers<ContextType>;
  ChannelData?: ChannelDataResolvers<ContextType>;
  ChannelListing?: ChannelListingResolvers<ContextType>;
  ChannelListingCarouselItem?: ChannelListingCarouselItemResolvers<ContextType>;
  ChannelListingData?: ChannelListingDataResolvers<ContextType>;
  ChannelListingNormalized?: ChannelListingNormalizedResolvers<ContextType>;
  ChannelListingResponse?: ChannelListingResponseResolvers<ContextType>;
  ChannelResponse?: ChannelResponseResolvers<ContextType>;
  ChannelResponseError?: ChannelResponseErrorResolvers<ContextType>;
  ChannelResponseMany?: ChannelResponseManyResolvers<ContextType>;
  ChannelResponseOne?: ChannelResponseOneResolvers<ContextType>;
  CharacterApiResponse?: CharacterApiResponseResolvers<ContextType>;
  CharacterCarouselItem?: CharacterCarouselItemResolvers<ContextType>;
  CharacterItem?: CharacterItemResolvers<ContextType>;
  CmpConsentTokenResponse?: CmpConsentTokenResponseResolvers<ContextType>;
  CodeActivateSuccessResponse?: CodeActivateSuccessResponseResolvers<ContextType>;
  Collection?: CollectionResolvers<ContextType>;
  CollectionApiResponse?: CollectionApiResponseResolvers<ContextType>;
  CollectionCarousel?: CollectionCarouselResolvers<ContextType>;
  CollectionEntity?: CollectionEntityResolvers<ContextType>;
  Collections?: CollectionsResolvers<ContextType>;
  CommonContentFields?: CommonContentFieldsResolvers<ContextType>;
  CommonData?: CommonDataResolvers<ContextType>;
  CommunityFeedback?: CommunityFeedbackResolvers<ContextType>;
  CommunityFeedbackReadResponse?: CommunityFeedbackReadResponseResolvers<ContextType>;
  CommunityFeedbackRemoveResponse?: CommunityFeedbackRemoveResponseResolvers<ContextType>;
  CommunityFeedbackRemoved?: CommunityFeedbackRemovedResolvers<ContextType>;
  CommunityFeedbackTarget?: CommunityFeedbackTargetResolvers<ContextType>;
  CommunityFeedbackWriteResponse?: CommunityFeedbackWriteResponseResolvers<ContextType>;
  ConcurrencyDeniedPlaybackReason?: ConcurrencyDeniedPlaybackReasonResolvers<ContextType>;
  ConcurrencyResponse?: ConcurrencyResponseResolvers<ContextType>;
  Config?: ConfigResolvers<ContextType>;
  ContentCANVideo?: ContentCanVideoResolvers<ContextType>;
  ContentHighlightMetadata?: ContentHighlightMetadataResolvers<ContextType>;
  Context?: ContextResolvers<ContextType>;
  Coordinates?: CoordinatesResolvers<ContextType>;
  CreativeAdData?: CreativeAdDataResolvers<ContextType>;
  CreativeCarouselItem?: CreativeCarouselItemResolvers<ContextType>;
  CreativeCommonData?: CreativeCommonDataResolvers<ContextType>;
  CreativeCta?: CreativeCtaResolvers<ContextType>;
  CreativeImageAssets?: CreativeImageAssetsResolvers<ContextType>;
  CreativeTrackingData?: CreativeTrackingDataResolvers<ContextType>;
  DAIParams?: DaiParamsResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTimeISO?: GraphQLScalarType;
  DebugInfo?: DebugInfoResolvers<ContextType>;
  DetailCta?: DetailCtaResolvers<ContextType>;
  DetailHero?: DetailHeroResolvers<ContextType>;
  DeviceInfo?: DeviceInfoResolvers<ContextType>;
  DeviceListResponse?: DeviceListResponseResolvers<ContextType>;
  DmaItem?: DmaItemResolvers<ContextType>;
  DmaResponse?: DmaResponseResolvers<ContextType>;
  DmaTokenDetails?: DmaTokenDetailsResolvers<ContextType>;
  DownloadCountry?: DownloadCountryResolvers<ContextType>;
  DownloadCountrySet?: DownloadCountrySetResolvers<ContextType>;
  DrmSession?: DrmSessionResolvers<ContextType>;
  DynamicPlayResponse?: DynamicPlayResponseResolvers<ContextType>;
  DynamicVideoModel?: DynamicVideoModelResolvers<ContextType>;
  EmailCheckpointResponse?: EmailCheckpointResponseResolvers<ContextType>;
  Entitlement?: EntitlementResolvers<ContextType>;
  EntitlementPackageInfo?: EntitlementPackageInfoResolvers<ContextType>;
  EntitlementProductInfo?: EntitlementProductInfoResolvers<ContextType>;
  Episode?: EpisodeResolvers<ContextType>;
  EpisodeData?: EpisodeDataResolvers<ContextType>;
  EpisodeResumeTime?: EpisodeResumeTimeResolvers<ContextType>;
  EpisodesApiResponse?: EpisodesApiResponseResolvers<ContextType>;
  FMSResponse?: FmsResponseResolvers<ContextType>;
  Faq?: FaqResolvers<ContextType>;
  FavoriteChannelItem?: FavoriteChannelItemResolvers<ContextType>;
  FmsInfo?: FmsInfoResolvers<ContextType>;
  FmsParams?: FmsParamsResolvers<ContextType>;
  FooterLink?: FooterLinkResolvers<ContextType>;
  FooterLinksData?: FooterLinksDataResolvers<ContextType>;
  FrontDoorBucket?: FrontDoorBucketResolvers<ContextType>;
  FrontDoorBucketCarousel?: FrontDoorBucketCarouselResolvers<ContextType>;
  FrontDoorCarousel?: FrontDoorCarouselResolvers<ContextType>;
  FrontDoorContentData?: FrontDoorContentDataResolvers<ContextType>;
  FrontDoorCta?: FrontDoorCtaResolvers<ContextType>;
  FrontDoorData?: FrontDoorDataResolvers<ContextType>;
  FrontDoorFaqBucket?: FrontDoorFaqBucketResolvers<ContextType>;
  FrontDoorFaqItem?: FrontDoorFaqItemResolvers<ContextType>;
  FrontDoorHeader?: FrontDoorHeaderResolvers<ContextType>;
  FrontDoorHero?: FrontDoorHeroResolvers<ContextType>;
  FrontDoorLogo?: FrontDoorLogoResolvers<ContextType>;
  FullEpisodesData?: FullEpisodesDataResolvers<ContextType>;
  FullUser?: FullUserResolvers<ContextType>;
  FullUserStatus?: FullUserStatusResolvers<ContextType>;
  Genre?: GenreResolvers<ContextType>;
  GlobalMenu?: GlobalMenuResolvers<ContextType>;
  GlobalMenuData?: GlobalMenuDataResolvers<ContextType>;
  GlobalMenuFooterSection?: GlobalMenuFooterSectionResolvers<ContextType>;
  GlobalMenuItem?: GlobalMenuItemResolvers<ContextType>;
  Hero?: HeroResolvers<ContextType>;
  HeroApiResponse?: HeroApiResponseResolvers<ContextType>;
  History?: HistoryResolvers<ContextType>;
  HistoryApiResponse?: HistoryApiResponseResolvers<ContextType>;
  HomeConfig?: HomeConfigResolvers<ContextType>;
  HreflangConfigObj?: HreflangConfigObjResolvers<ContextType>;
  Hub?: HubResolvers<ContextType>;
  HubCarouselItem?: HubCarouselItemResolvers<ContextType>;
  HubItem?: HubItemResolvers<ContextType>;
  HubMarquee?: HubMarqueeResolvers<ContextType>;
  HubMarqueeSlide?: HubMarqueeSlideResolvers<ContextType>;
  IdentityLoginResponse?: IdentityLoginResponseResolvers<ContextType>;
  IdentityRegisterFieldError?: IdentityRegisterFieldErrorResolvers<ContextType>;
  IdentityRegisterResponse?: IdentityRegisterResponseResolvers<ContextType>;
  ItemList?: ItemListResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  KeepWatchingItem?: KeepWatchingItemResolvers<ContextType>;
  ListingData?: ListingDataResolvers<ContextType>;
  ListingNormalizedResponse?: ListingNormalizedResponseResolvers<ContextType>;
  ListingsResponse?: ListingsResponseResolvers<ContextType>;
  LiveCarouselApiResponse?: LiveCarouselApiResponseResolvers<ContextType>;
  LiveCarouselItem?: LiveCarouselItemResolvers<ContextType>;
  LiveChannel?: LiveChannelResolvers<ContextType>;
  LiveChannelListing?: LiveChannelListingResolvers<ContextType>;
  LiveDetailHero?: LiveDetailHeroResolvers<ContextType>;
  LiveEvent?: LiveEventResolvers<ContextType>;
  LiveItem?: LiveItemResolvers<ContextType>;
  LiveShowCarouselItem?: LiveShowCarouselItemResolvers<ContextType>;
  LocalStation?: LocalStationResolvers<ContextType>;
  LogOutResponse?: LogOutResponseResolvers<ContextType>;
  ManageDevicesPageAttribute?: ManageDevicesPageAttributeResolvers<ContextType>;
  MarqueeApiResponse?: MarqueeApiResponseResolvers<ContextType>;
  MarqueeContent?: MarqueeContentResolvers<ContextType>;
  MarqueeItem?: MarqueeItemResolvers<ContextType>;
  MarqueeMovieAssets?: MarqueeMovieAssetsResolvers<ContextType>;
  MarqueeShowAssets?: MarqueeShowAssetsResolvers<ContextType>;
  MarqueeSlide?: MarqueeSlideResolvers<ContextType>;
  MediaBrowseResponse?: MediaBrowseResponseResolvers<ContextType>;
  MediaBrowseVideo?: MediaBrowseVideoResolvers<ContextType>;
  MediaItem?: MediaItemResolvers<ContextType>;
  MerchandiseContentResponse?: MerchandiseContentResponseResolvers<ContextType>;
  MerchandiseSlide?: MerchandiseSlideResolvers<ContextType>;
  MetadataResponse?: MetadataResponseResolvers<ContextType>;
  MosaicPageAttributeSourceRecords?: MosaicPageAttributeSourceRecordsResolvers<ContextType>;
  MosaicPageAttributesResponse?: MosaicPageAttributesResponseResolvers<ContextType>;
  MosaicPageDocumentsResponse?: MosaicPageDocumentsResponseResolvers<ContextType>;
  Movie?: MovieResolvers<ContextType>;
  MovieAssets?: MovieAssetsResolvers<ContextType>;
  MovieCarouselItem?: MovieCarouselItemResolvers<ContextType>;
  MovieCollectionEntity?: MovieCollectionEntityResolvers<ContextType>;
  MovieContent?: MovieContentResolvers<ContextType>;
  MovieData?: MovieDataResolvers<ContextType>;
  MovieDetail?: MovieDetailResolvers<ContextType>;
  MovieDetailData?: MovieDetailDataResolvers<ContextType>;
  MovieDetailHero?: MovieDetailHeroResolvers<ContextType>;
  MovieDetailResponse?: MovieDetailResponseResolvers<ContextType>;
  MovieHomeData?: MovieHomeDataResolvers<ContextType>;
  MovieItem?: MovieItemResolvers<ContextType>;
  MovieRecommendation?: MovieRecommendationResolvers<ContextType>;
  MovieResponse?: MovieResponseResolvers<ContextType>;
  MovieTrendingContent?: MovieTrendingContentResolvers<ContextType>;
  MultiChannelCollectionCarousel?: MultiChannelCollectionCarouselResolvers<ContextType>;
  MultiChannelCollectionCarouselApiResponse?: MultiChannelCollectionCarouselApiResponseResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  MutationResponse?: MutationResponseResolvers<ContextType>;
  MvpdDispute?: MvpdDisputeResolvers<ContextType>;
  MvpdLogo?: MvpdLogoResolvers<ContextType>;
  MyListApiParams?: MyListApiParamsResolvers<ContextType>;
  Nav?: NavResolvers<ContextType>;
  NavCtaAttributes?: NavCtaAttributesResolvers<ContextType>;
  NavCtaAttributesResponse?: NavCtaAttributesResponseResolvers<ContextType>;
  NavItem?: NavItemResolvers<ContextType>;
  NextItem?: NextItemResolvers<ContextType>;
  NextItemResponse?: NextItemResponseResolvers<ContextType>;
  NormalizedCouponResponse?: NormalizedCouponResponseResolvers<ContextType>;
  OnNowCarousel?: OnNowCarouselResolvers<ContextType>;
  OnNowCarouselApiResponse?: OnNowCarouselApiResponseResolvers<ContextType>;
  OverrideUserProfile?: OverrideUserProfileResolvers<ContextType>;
  PackageInfo?: PackageInfoResolvers<ContextType>;
  PageAttributesResponse?: PageAttributesResponseResolvers<ContextType>;
  PagePlanAttr?: PagePlanAttrResolvers<ContextType>;
  ParentalControlPIN?: ParentalControlPinResolvers<ContextType>;
  ParentalControlRatingLabel?: ParentalControlRatingLabelResolvers<ContextType>;
  ParentalControlRatingTranslation?: ParentalControlRatingTranslationResolvers<ContextType>;
  PaymentGatewayResponse?: PaymentGatewayResponseResolvers<ContextType>;
  PlanCampaignAttr?: PlanCampaignAttrResolvers<ContextType>;
  PlanPageAttributesResponse?: PlanPageAttributesResponseResolvers<ContextType>;
  PlansBucket?: PlansBucketResolvers<ContextType>;
  PlansBucketPageAttributes?: PlansBucketPageAttributesResolvers<ContextType>;
  PlatformRestartResponse?: PlatformRestartResponseResolvers<ContextType>;
  PlatformRestartSession?: PlatformRestartSessionResolvers<ContextType>;
  PlatformSession?: PlatformSessionResolvers<ContextType>;
  PlaybackEvents?: PlaybackEventsResolvers<ContextType>;
  PositionDetails?: PositionDetailsResolvers<ContextType>;
  PrefetchData?: PrefetchDataResolvers<ContextType>;
  PreselectedCreditCardGatewayResponse?: PreselectedCreditCardGatewayResponseResolvers<ContextType>;
  PrevNextResponse?: PrevNextResponseResolvers<ContextType>;
  PrevNextVideoItem?: PrevNextVideoItemResolvers<ContextType>;
  ProductResponse?: ProductResponseResolvers<ContextType>;
  ProductsResponse?: ProductsResponseResolvers<ContextType>;
  ProfileLevel?: ProfileLevelResolvers<ContextType>;
  PromotionInfo?: PromotionInfoResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QueryPlanPageAttrArgs?: QueryPlanPageAttrArgsResolvers<ContextType>;
  RatingGroup?: RatingGroupResolvers<ContextType>;
  RecentChannelsApiResponse?: RecentChannelsApiResponseResolvers<ContextType>;
  RecommendationApiResponse?: RecommendationApiResponseResolvers<ContextType>;
  RecommendationContent?: RecommendationContentResolvers<ContextType>;
  RecommendationItem?: RecommendationItemResolvers<ContextType>;
  Recommendations?: RecommendationsResolvers<ContextType>;
  Region?: RegionResolvers<ContextType>;
  RegionalRating?: RegionalRatingResolvers<ContextType>;
  RegionalRatings?: RegionalRatingsResolvers<ContextType>;
  RendezvousCompletePageAttribute?: RendezvousCompletePageAttributeResolvers<ContextType>;
  RendezvousCompletePageAttributeQueryResponse?: RendezvousCompletePageAttributeQueryResponseResolvers<ContextType>;
  RendezvousPageAttributeQueryResponse?: RendezvousPageAttributeQueryResponseResolvers<ContextType>;
  RendezvousSignInOptionsQueryResponse?: RendezvousSignInOptionsQueryResponseResolvers<ContextType>;
  Result?: ResultResolvers<ContextType>;
  Results?: ResultsResolvers<ContextType>;
  SearchConfigResponse?: SearchConfigResponseResolvers<ContextType>;
  SearchLiveResponse?: SearchLiveResponseResolvers<ContextType>;
  SearchPageConfig?: SearchPageConfigResolvers<ContextType>;
  SearchResponse?: SearchResponseResolvers<ContextType>;
  SearchResult?: SearchResultResolvers<ContextType>;
  SearchVODContentResult?: SearchVodContentResultResolvers<ContextType>;
  SearchVideoCarouselResult?: SearchVideoCarouselResultResolvers<ContextType>;
  Section?: SectionResolvers<ContextType>;
  SectionItems?: SectionItemsResolvers<ContextType>;
  SendForgotPasswordLinkResponse?: SendForgotPasswordLinkResponseResolvers<ContextType>;
  SeoContent?: SeoContentResolvers<ContextType>;
  SeoHreflangResponse?: SeoHreflangResponseResolvers<ContextType>;
  SeoResponse?: SeoResponseResolvers<ContextType>;
  SeriesHistoryResponse?: SeriesHistoryResponseResolvers<ContextType>;
  SeriesHistoryVideo?: SeriesHistoryVideoResolvers<ContextType>;
  Session?: SessionResolvers<ContextType>;
  SessionTokenResponse?: SessionTokenResponseResolvers<ContextType>;
  SessionTokenResults?: SessionTokenResultsResolvers<ContextType>;
  Show?: ShowResolvers<ContextType>;
  ShowAssets?: ShowAssetsResolvers<ContextType>;
  ShowAssetsDetailData?: ShowAssetsDetailDataResolvers<ContextType>;
  ShowCarouselItem?: ShowCarouselItemResolvers<ContextType>;
  ShowCollectionEntity?: ShowCollectionEntityResolvers<ContextType>;
  ShowData?: ShowDataResolvers<ContextType>;
  ShowDataWrapper?: ShowDataWrapperResolvers<ContextType>;
  ShowDetail?: ShowDetailResolvers<ContextType>;
  ShowDetailHero?: ShowDetailHeroResolvers<ContextType>;
  ShowDetailsResponse?: ShowDetailsResponseResolvers<ContextType>;
  ShowHomeData?: ShowHomeDataResolvers<ContextType>;
  ShowHomeItem?: ShowHomeItemResolvers<ContextType>;
  ShowHomeResponse?: ShowHomeResponseResolvers<ContextType>;
  ShowItem?: ShowItemResolvers<ContextType>;
  ShowMenuItem?: ShowMenuItemResolvers<ContextType>;
  ShowMenuLink?: ShowMenuLinkResolvers<ContextType>;
  ShowObject?: ShowObjectResolvers<ContextType>;
  ShowSlugById?: ShowSlugByIdResolvers<ContextType>;
  ShowTimeAttributes?: ShowTimeAttributesResolvers<ContextType>;
  ShowTrendingContent?: ShowTrendingContentResolvers<ContextType>;
  SignInPageAttribute?: SignInPageAttributeResolvers<ContextType>;
  SignInPageAttributeQueryResponse?: SignInPageAttributeQueryResponseResolvers<ContextType>;
  SignInResponse?: SignInResponseResolvers<ContextType>;
  SignUpPageAttribute?: SignUpPageAttributeResolvers<ContextType>;
  SignUpPageAttributeQueryResponse?: SignUpPageAttributeQueryResponseResolvers<ContextType>;
  SignUpResponse?: SignUpResponseResolvers<ContextType>;
  SingleListingResponse?: SingleListingResponseResolvers<ContextType>;
  SlideMetadata?: SlideMetadataResolvers<ContextType>;
  SpotlightCarouselItem?: SpotlightCarouselItemResolvers<ContextType>;
  SpotlightItem?: SpotlightItemResolvers<ContextType>;
  StartResponse?: StartResponseResolvers<ContextType>;
  Stitched?: StitchedResolvers<ContextType>;
  StitchedPath?: StitchedPathResolvers<ContextType>;
  StitcherPath?: StitcherPathResolvers<ContextType>;
  StitcherPaths?: StitcherPathsResolvers<ContextType>;
  StitcherStreamingUrlResponse?: StitcherStreamingUrlResponseResolvers<ContextType>;
  StreamHistoryResponse?: StreamHistoryResponseResolvers<ContextType>;
  StreamingUrlResponse?: StreamingUrlResponseResolvers<ContextType>;
  SubNavItem?: SubNavItemResolvers<ContextType>;
  Subratings?: SubratingsResolvers<ContextType>;
  SuggestionsResponse?: SuggestionsResponseResolvers<ContextType>;
  SwitchResponse?: SwitchResponseResolvers<ContextType>;
  Thumbnail?: ThumbnailResolvers<ContextType>;
  ThumbnailSet?: ThumbnailSetResolvers<ContextType>;
  ThumbnailSheetSet?: ThumbnailSheetSetResolvers<ContextType>;
  TrailerContent?: TrailerContentResolvers<ContextType>;
  TransformedMarquee?: TransformedMarqueeResolvers<ContextType>;
  TransformedMarqueeSlide?: TransformedMarqueeSlideResolvers<ContextType>;
  TransformedSeoHreflangResponse?: TransformedSeoHreflangResponseResolvers<ContextType>;
  Trending?: TrendingResolvers<ContextType>;
  TrendingContent?: TrendingContentResolvers<ContextType>;
  UUID?: GraphQLScalarType;
  UniversalChannelListingItem?: UniversalChannelListingItemResolvers<ContextType>;
  UniversalContentApiResponse?: UniversalContentApiResponseResolvers<ContextType>;
  UniversalCreativeApiResponse?: UniversalCreativeApiResponseResolvers<ContextType>;
  UniversalCreativeItem?: UniversalCreativeItemResolvers<ContextType>;
  UniversalItem?: UniversalItemResolvers<ContextType>;
  UniversalMovieItem?: UniversalMovieItemResolvers<ContextType>;
  UniversalPromotionItem?: UniversalPromotionItemResolvers<ContextType>;
  UniversalShowItem?: UniversalShowItemResolvers<ContextType>;
  UpNextRecommendation?: UpNextRecommendationResolvers<ContextType>;
  UpNextRecommendationButton?: UpNextRecommendationButtonResolvers<ContextType>;
  UpNextResponse?: UpNextResponseResolvers<ContextType>;
  UpNextTrackAction?: UpNextTrackActionResolvers<ContextType>;
  UpNextTrackEndCardSelect?: UpNextTrackEndCardSelectResolvers<ContextType>;
  UpNextTracking?: UpNextTrackingResolvers<ContextType>;
  UpdateEmailResponse?: UpdateEmailResponseResolvers<ContextType>;
  UpdatePaymentResponse?: UpdatePaymentResponseResolvers<ContextType>;
  UpsellBucket?: UpsellBucketResolvers<ContextType>;
  UpsellCarousel?: UpsellCarouselResolvers<ContextType>;
  UpsellCta?: UpsellCtaResolvers<ContextType>;
  UpsellHeader?: UpsellHeaderResolvers<ContextType>;
  UpsellLogo?: UpsellLogoResolvers<ContextType>;
  UpsellPageAttributeQueryResponse?: UpsellPageAttributeQueryResponseResolvers<ContextType>;
  UserAccountSettings?: UserAccountSettingsResolvers<ContextType>;
  UserAccountSettingsAddress?: UserAccountSettingsAddressResolvers<ContextType>;
  UserInfo?: UserInfoResolvers<ContextType>;
  UserPackageStatus?: UserPackageStatusResolvers<ContextType>;
  UserProfile?: UserProfileResolvers<ContextType>;
  UserSession?: UserSessionResolvers<ContextType>;
  UserSessionResponse?: UserSessionResponseResolvers<ContextType>;
  UserSignInResponse?: UserSignInResponseResolvers<ContextType>;
  UserStatus?: UserStatusResolvers<ContextType>;
  UserSubscription?: UserSubscriptionResolvers<ContextType>;
  UserSubscriptionResponse?: UserSubscriptionResponseResolvers<ContextType>;
  ValuePropItem?: ValuePropItemResolvers<ContextType>;
  Video?: VideoResolvers<ContextType>;
  VideoChannel?: VideoChannelResolvers<ContextType>;
  VideoChannelDma?: VideoChannelDmaResolvers<ContextType>;
  VideoConfigResponse?: VideoConfigResponseResolvers<ContextType>;
  VideoItem?: VideoItemResolvers<ContextType>;
  VideoItemData?: VideoItemDataResolvers<ContextType>;
  VideoModel?: VideoModelResolvers<ContextType>;
  VideoNextResponse?: VideoNextResponseResolvers<ContextType>;
  VideoResponse?: VideoResponseResolvers<ContextType>;
  VideoResults?: VideoResultsResolvers<ContextType>;
  VideoSectionMetadata?: VideoSectionMetadataResolvers<ContextType>;
  VideoUserInfo?: VideoUserInfoResolvers<ContextType>;
  WatchListChannelsApiResponse?: WatchListChannelsApiResponseResolvers<ContextType>;
  WatchListItem?: WatchListItemResolvers<ContextType>;
  WatchListItemContent?: WatchListItemContentResolvers<ContextType>;
  WatchingRestrictions?: WatchingRestrictionsResolvers<ContextType>;
  addOnResponse?: AddOnResponseResolvers<ContextType>;
  cancelSavePageAttributesResponse?: CancelSavePageAttributesResponseResolvers<ContextType>;
  cbsPackageInfo?: CbsPackageInfoResolvers<ContextType>;
  changePasswordResponse?: ChangePasswordResponseResolvers<ContextType>;
  checkEmailResponse?: CheckEmailResponseResolvers<ContextType>;
  compilingPageAttributesResponse?: CompilingPageAttributesResponseResolvers<ContextType>;
  editEmailResponse?: EditEmailResponseResolvers<ContextType>;
  editPasswordResponse?: EditPasswordResponseResolvers<ContextType>;
  liveStreamInfoResponse?: LiveStreamInfoResponseResolvers<ContextType>;
  manageDevicesPageAttributesResponse?: ManageDevicesPageAttributesResponseResolvers<ContextType>;
  productsByCadence?: ProductsByCadenceResolvers<ContextType>;
  redeemCouponResponse?: RedeemCouponResponseResolvers<ContextType>;
  resetForgotPasswordResponse?: ResetForgotPasswordResponseResolvers<ContextType>;
  tester?: TesterResolvers<ContextType>;
  updateOptInResponse?: UpdateOptInResponseResolvers<ContextType>;
  upsellPageResponse?: UpsellPageResponseResolvers<ContextType>;
  upsellUserStatus?: UpsellUserStatusResolvers<ContextType>;
  vendorAttributes?: VendorAttributesResolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = any> = ResolversObject<{
  cacheControl?: CacheControlDirectiveResolver<any, any, ContextType>;
}>;
